{
  "app": {
    "name": "SilexGIS"
  },
  "iconButtons": {
    "delete": "Delete",
    "download": "Download",
    "moveUp": "Move up",
    "moveDown": "Move down"
  },
  "nav": {
    "map": "Map",
    "map3d": "3D view",
    "dashboard": "Dashboard",
    "caves": "Caves",
    "features": "Features",
    "geodata": "Geodata",
    "gallery": "Photographs",
    "albums": "Albums",
    "photoLibrary": "Photo library",
    "cabinets": "Cabinets",
    "uploads": "Uploads",
    "review": "Uploads awaiting review",
    "trips": "Trip logs",
    "audit": "Audit",
    "cavingGroups": "Caving groups",
    "cavers": "Cavers",
    "settings": "Settings",
    "messaging": "Messaging",
    "templates": "Message texts",
    "permissionGroups": "Permission groups",
    "users": "Accounts",
    "featureSets": "Feature sets",
    "documentTypes": "Document kinds",
    "featureTypes": "Feature kinds",
    "relationTypes": "Link relations",
    "tripTypes": "Trip purposes",
    "participantRoles": "Trip roles",
    "campRosterRoles": "Camp roles",
    "reportTemplates": "Report layouts",
    "termRules": "Detection rules",
    "terrain": "Terrain",
    "expeditions": "Camps",
    "notificationHealth": "Message delivery",
    "calendar": "Calendar",
    "events": "Events",
    "checklists": "Checklists",
    "groups": {
      "cadastre": "Cadastre",
      "statistics": "Statistics",
      "library": "Library",
      "activity": "Activity",
      "people": "People",
      "admin": "Administration",
      "config": "Configuration",
      "tools": "Tools"
    },
    "workAreas": "Work areas",
    "coordinateConverter": "Coordinate converter",
    "speologie": "Cave catalogue",
    "registryDistribution": "Distributions",
    "registryCorrelation": "Correlations",
    "tripImport": "Import trips",
    "speleolocImport": "Import a recording",
    "registryRegions": "Regions",
    "registryCategories": "Categories",
    "publishedTrips": "Published trips"
  },
  "terrain": {
    "title": "Terrain",
    "noBuilds": "No elevation surface has been built for this installation yet.",
    "noBuildsHint": "Draw a rectangle above and start the first one.",
    "intro": "Draw a rectangle, say where its elevation data comes from, and the installation builds the ground the 3D scene draws.",
    "area": {
      "draw": "Draw rectangle",
      "clear": "Clear rectangle",
      "hint": "Drag a rectangle on the map to say which ground this build covers.",
      "chosen": "West, south, east, north: {{extent}} — {{area}} square degrees."
    },
    "depthBands": {
      "coarse": "Level {{depth}}: a broad shape of the landscape. Quick to build and small on disk, but a hillside reads as one slope.",
      "coverage": "Level {{depth}}: as much detail as the thirty-metre coverage this application obtains actually holds. This is the working default.",
      "fine": "Level {{depth}}: finer than obtained coverage. Worth asking for only where rasters of a few metres cover the rectangle.",
      "survey": "Level {{depth}}: what half-metre survey data earns. Each level roughly quadruples both the tiles written and the time taken."
    },
    "heightDatums": {
      "orthometric": "Above sea level",
      "ellipsoidal": "Above the ellipsoid"
    },
    "form": {
      "title": "New build",
      "area": "Area",
      "areaRequired": "Draw the rectangle this build covers.",
      "areaTooLarge": "That rectangle is larger than this installation builds in one go. Build it as several smaller areas.",
      "sources": "Where the elevation data comes from",
      "fetchCoverage": "Obtain coverage for this rectangle",
      "fetchCoverageHint": "Thirty-metre elevation data covering the whole land surface, fetched by the application. Sea returns nothing, which is a normal answer rather than a failure.",
      "upload": "Rasters from this computer",
      "uploadHint": "Drop elevation rasters here, or click to choose them.",
      "uploadFormats": "Accepted: {{formats}}. Up to 512 MB each — anything larger belongs in a directory on the server.",
      "rasterTooLarge": "That file is larger than 512 MB. Put it in a directory on the server instead.",
      "uploadsPending": "These files have not arrived yet, so a build started now would be made without them: {{files}}. Wait for them, or take them off the list.",
      "directory": "Directory on the server",
      "directoryHint": "A directory the operator has listed as readable, or one below it. Everything in it that looks like an elevation raster is read.",
      "directoryPlaceholder": "Choose or type a directory",
      "attribution": "Credit",
      "attributionHint": "Who the data belongs to. It is written into the published surface, so a build must never carry a credit that is not its own.",
      "attributionRequired": "Say who the rasters you supplied belong to.",
      "licence": "Licence",
      "depth": "Depth",
      "depthCapped": "Nothing here can fill those levels.",
      "depthCappedDetail": "This build is made only from the thirty-metre coverage the application obtains, which runs out of detail around level 13. Deeper levels are not refused and not reported: the surface simply stops offering them, and nothing afterwards says so. Add finer rasters, or choose a shallower depth.",
      "heights": "Heights",
      "heightDatum": "Heights are measured from",
      "heightDatumHint": "What the numbers in these rasters mean. Getting it wrong lifts or drops the whole surface by tens of metres.",
      "geoidHeight": "Geoid height (m)",
      "geoidHeightHint": "How far the local sea-level surface sits above the ellipsoid here. Used only for ellipsoidal heights.",
      "start": "Start build",
      "started": "The build has been queued.",
      "bakeService": "Turning that data into tiles needs a service of its own, which a plain installation does not run. If this one does not, the build stops at that step and this page then says what to type to enable it; everything before that step still happens.",
      "extend": "Extend a finished build",
      "extendNone": "No — mesh a new pyramid",
      "extendHint": "Add the new rasters to a build that is already baked instead of meshing the whole region again. The new build starts from a copy of that build’s tiles and costs only what is added; the base stays as it is.",
      "extendOption": "{{id}} · level {{depth}} · {{area}}",
      "extendLocked": "This build extends another, so its depth (level {{depth}}) and its heights are the base’s and cannot be changed; coverage is not obtained again unless asked for."
    },
    "statuses": {
      "queued": "Queued",
      "running": "Running",
      "succeeded": "Finished",
      "failed": "Failed"
    },
    "cancelStates": {
      "cancelling": "Being cancelled",
      "cancelled": "Cancelled"
    },
    "phases": {
      "pending": "Waiting its turn — nothing has started yet.",
      "fetch": "Obtain",
      "prepare": "Prepare",
      "bake": "Bake",
      "validate": "Check",
      "publish": "Publish"
    },
    "sourceKinds": {
      "fetched": "Obtained coverage",
      "uploaded": "Uploaded raster",
      "serverDirectory": "Directory on the server"
    },
    "list": {
      "title": "Builds",
      "state": "State",
      "current": "Being drawn",
      "area": "Area",
      "depth": "Depth",
      "depthAsked": "asked for {{depth}}",
      "depthShortfall": "The tiles go down to level {{achieved}}, not the {{requested}} that was asked for: the elevation data has no more detail to give below that.",
      "when": "Submitted",
      "size": "On disk",
      "sizeHint": "Everything the build left behind on disk: the published tiles and the converted rasters kept beside them. The line beneath is the tiles alone, which is all a viewer is served.",
      "sizePyramid": "{{size}} of tiles",
      "sizeUnknown": "nothing yet",
      "actions": "Actions",
      "activate": "Draw this",
      "activated": "The scene now draws this build.",
      "stop": "Stop drawing",
      "stopped": "The scene draws bare ground again.",
      "delete": "Delete",
      "deleteConfirm": "Remove this build and the {{size}} it is keeping on disk for {{area}}?",
      "cancel": "Call off",
      "cancelConfirm": "Call off this build? What it has already obtained and prepared is kept, so it can be run again later from where it stopped.",
      "cancelled": "The build was called off.",
      "cancelAsked": "The build will stop at the first point it can; until then it is shown as being cancelled.",
      "retry": "Run again",
      "retried": "The build is queued again and will carry on from where it stopped."
    },
    "detail": {
      "title": "This build",
      "sources": "Made from",
      "noSources": "Nothing has been recorded for this build yet.",
      "failed": "This build stopped before it finished.",
      "cancelled": "This build was called off.",
      "cancelling": "This build is being cancelled. It stops at the first point it can — between two files, or, while tiles are being made, once the tile maker has said it stopped.",
      "log": "What the tool said",
      "noLog": "Nothing has been said yet."
    },
    "worker": {
      "title": "This installation has nothing that can turn rasters into tiles",
      "body": "Obtaining elevation data and preparing it work as they are. Making tiles out of it needs a service of its own, which a plain installation does not start: its image is well over a gigabyte, and an installation that never builds terrain should not have to hold it.",
      "setting": "In the environment file beside the deployment's compose files:",
      "command": "Then, from that same directory:",
      "resumes": "Everything before this step still happened, and what the build obtained and prepared is still on disk under it. Once the service is running, press Run again on the stopped build: it carries on from the step it stopped at, without obtaining or preparing anything a second time."
    },
    "bakeLimits": {
      "memoryNote": "Memory decides how fine the terrain can be. The tile maker uses half of its own container's memory — 8 GB unless this installation sets SILEXGIS_TERRAIN_WORKER_MEMORY — and when that is not enough it does not fail: it makes coarser terrain than was asked for. A build that ran short stops and says so, and the setting can then be raised.",
      "degradedTitle": "The tile maker ran short of memory, so the terrain would have been coarser than asked for",
      "degradedBody": "Coarser means less detail: slopes and valleys drawn from fewer, larger triangles than the level this build asked for, with nothing on the map saying so. The tiles it made were therefore discarded. The tile maker uses half of its container's memory and has no other setting for it, so give the container more — the tool itself recommends 32g for large areas.",
      "degradedSetting": "In the environment file beside the deployment's compose files:",
      "degradedCommand": "Then apply it from that same directory and press Run again on this build; what it obtained and prepared is kept:",
      "timedOutTitle": "Time limit reached after {{ran}} h (limit {{limit}} h)",
      "timedOutTitleBare": "Time limit reached",
      "timedOutBody": "The bake was stopped and the tiles it had made were discarded. A bake that stopped making progress ends this way, and so does a large area that simply needed longer. To allow longer, set this in the environment file (in seconds; 86400 is a day), restart the application, and press Run again — what the build obtained and prepared is kept:",
      "secondsHelpTitle": "How long is that in seconds?",
      "secondsHelp": "1 hour = 3600\n12 hours = 43200 (the default)\n1 day = 86400\n2 days = 172800\n1 week = 604800 (the longest allowed)"
    },
    "problems": {
      "notFound": "That build is no longer here.",
      "forbidden": "You are not allowed to do that.",
      "alreadyBuilding": "That area is already being built. Wait for it to finish.",
      "noSources": "A build has to be made from something: either obtain the coverage of the rectangle, or supply rasters of your own.",
      "sourceInvalid": "One of those rasters is not one this installation is holding. Send it again.",
      "directoryUnavailable": "That directory cannot be read from: it is not there, or it is not one this installation may read.",
      "noRoots": "This installation reads rasters from no directory on the server.",
      "rasterUnsupported": "That file is not an elevation raster this installation reads.",
      "rasterSizeInvalid": "That file is empty, or larger than an upload may be.",
      "rasterUnplaceable": "An elevation tile says where it is only by what it is called, in the form N45E024.hgt for the square whose corner is 45°N 24°E. That file's name does not say which square it covers, so nothing can place it on the earth. Rename it to the square it covers, or send it in a format that carries its own position.",
      "extentInvalid": "That rectangle is not a rectangle on the Earth. Draw it again.",
      "extentTooLarge": "That rectangle is larger than this installation builds in one go. Build it as several smaller areas.",
      "depthInvalid": "That depth is outside what this installation builds.",
      "notPublished": "That build has no surface to draw. Its tiles were either never read back and found whole, or they are no longer where terrain is served from.",
      "active": "That build is the terrain the scene is drawing. Choose other terrain, or stop drawing this one, before removing it.",
      "running": "That build has not finished. Its files are being written right now, so it can be removed once it has stopped, whichever way it stops.",
      "notCancellable": "That build has already stopped, so there is nothing to call off.",
      "notRetryable": "Only a build that has stopped can be run again. This one is still queued or running, or it finished.",
      "bakeStopping": "That build was called off while its tiles were being made, and the tile maker has not yet said it stopped. It answers as soon as the terrain worker is running; run the build again after that.",
      "derivativeBuildNotFound": "That build is no longer here, or has nothing to draw the ground from.",
      "derivativeBuildNotFinished": "That build has not finished, so there is no elevation to draw the ground from yet.",
      "derivativeNotFound": "That picture is no longer here.",
      "derivativeNotReady": "That picture is not finished yet, so there is nothing to fetch.",
      "baseNotFound": "The build to extend no longer exists.",
      "baseUnchecked": "The build to extend never had its tiles read back and found whole, so there is nothing known-good to add to.",
      "baseNotPublished": "The build to extend has no tiles where terrain is served from any more. Start a fresh build over the whole area instead.",
      "baseDepthDiffers": "An extension is built to the depth of the build it extends; the addition cannot re-mesh the tiles already there at another one.",
      "baseDatumDiffers": "An extension measures its heights the way the build it extends does; two datums in one pyramid meet in a step along the join.",
      "beingExtended": "Another build that extends this one has not finished and still reads its tiles. Remove it once that build has stopped."
    },
    "derivatives": {
      "title": "Ground pictures",
      "hint": "Shaded relief, steepness and facing, computed from an elevation build.",
      "stale": "Out of date",
      "staleHints": {
        "elevationReplaced": "Computed from elevation this installation no longer serves. It is still drawn, but it will not agree with the heights beneath it.",
        "methodRevised": "Computed before the way this kind of picture is worked out was corrected. It is still drawn, but it is not what the ground would give today. Ask for the same picture again and it is computed afresh."
      },
      "totalSize": "{{size}} on disk",
      "statuses": {
        "queued": "Queued",
        "computing": "Computing",
        "ready": "Ready",
        "failed": "Failed"
      },
      "kinds": {
        "hillshade": "Shaded relief",
        "slope": "Steepness",
        "aspect": "Facing",
        "ruggednessIndex": "Ruggedness",
        "positionIndex": "Topographic position",
        "roughness": "Roughness",
        "colourRelief": "Coloured relief",
        "contours": "Contour lines"
      }
    },
    "derivativeForm": {
      "title": "Derived pictures",
      "intro": "A picture of the ground computed from a finished build: shaded relief, steepness, facing, ruggedness, topographic position, roughness, a coloured relief or contour lines. Everybody who may read terrain then finds it in the map's layer list.",
      "needsExecute": "Asking for a picture needs the right to execute on terrain, which this account does not hold. The register below is still yours to read.",
      "noBuilds": "No finished build to draw from. A picture is computed from a build that has run to the end.",
      "build": "Build",
      "buildPlaceholder": "Choose a finished build",
      "buildRequired": "Choose the build to draw the picture from.",
      "buildCurrent": "being drawn",
      "kind": "Picture",
      "name": "Name",
      "nameHint": "What the layer list calls it.",
      "nameRequired": "Give the picture a name.",
      "nameTooLong": "A name is at most {{max}} characters.",
      "lighting": "Light",
      "lightingHint": "Under a single light every slope facing away from it is flat black, and a doline in that shadow is invisible. Four lights keep it readable.",
      "lightings": {
        "single": "One light",
        "multidirectional": "Four lights"
      },
      "azimuth": "Light from (°)",
      "azimuthHint": "Clockwise from north. The north-west is the convention: lit from where the morning sun actually stands, most readers see valleys as ridges.",
      "azimuthInvalid": "The light's direction is measured clockwise from north, from 0 up to 360.",
      "altitude": "Light height (°)",
      "altitudeInvalid": "The light stands above the horizon, so its height is above 0 and at most 90.",
      "zFactor": "Height exaggeration",
      "zFactorHint": "Multiplies every height before the picture is computed. Past a few times, a gentle landscape is a wall of saturated pixels.",
      "zFactorInvalid": "Height exaggeration is a number above zero and no more than {{max}}.",
      "surfaceFit": "Slope arithmetic",
      "surfaceFitHint": "Horn weights all eight neighbours and suits real, noisy elevation. Zevenbergen–Thorne uses the four cardinal ones: sharper on clean surfaces, noisier on anything sampled from photographs.",
      "surfaceFits": {
        "horn": "Horn (eight neighbours)",
        "zevenbergenThorne": "Zevenbergen–Thorne (four neighbours)"
      },
      "slopeUnit": "Steepness as",
      "slopeUnits": {
        "degrees": "Degrees from horizontal",
        "percent": "Rise over run, as a percentage"
      },
      "ruggednessFit": "Ruggedness definition",
      "ruggednessFitHint": "Riley's is the one published ruggedness classes are stated against. Wilson's gives different numbers, so the two are never comparable.",
      "ruggednessFits": {
        "riley": "Riley (root mean square of the differences)",
        "wilson": "Wilson (mean of the absolute differences)"
      },
      "contourInterval": "A line every (m)",
      "contourIntervalHint": "Metres of height between one line and the next, counted from sea level. Every fifth line is drawn heavier. The lines are a picture: nothing can be measured along one or selected.",
      "contourIntervalInvalid": "Contour lines are spaced from {{min}} to {{max}} metres of height apart.",
      "computeEdges": "Compute the outermost cells from the neighbours they have",
      "computeEdgesHint": "Off, every raster of the build meets its neighbour with a hairline gap. On, the edge is slightly wrong — by less than a missing line is.",
      "colourRamp": "Colour ramp",
      "colourRampHint": "A colour at each height, in metres; the ground between two heights is painted with the blend. At least two stops, no two at one height.",
      "stopElevation": "Height (m)",
      "stopColour": "Colour",
      "addStop": "Add a stop",
      "removeStop": "Remove this stop",
      "rampProblems": {
        "tooShort": "A colour relief needs at least two heights to put colours between.",
        "heightMissing": "Every stop on a colour ramp sits at a real height.",
        "duplicate": "No two stops on a colour ramp sit at the same height."
      },
      "submit": "Request picture",
      "requested": "The picture has been queued. It appears in the register below, and in the map's layer list once it is ready."
    },
    "derivativeList": {
      "title": "Register of derived pictures",
      "empty": "No picture of the ground has been computed yet.",
      "emptyHint": "Ask for one above, from a finished build.",
      "picture": "Picture",
      "parameters": "Parameters",
      "build": "From build",
      "buildGone": "a build no longer listed",
      "state": "State",
      "size": "On disk",
      "sizeHint": "The computed rasters, one per raster of the build.",
      "created": "Requested",
      "actions": "Actions",
      "delete": "Delete",
      "deleteConfirm": "Remove this picture and the {{size}} it is keeping on disk?",
      "params": {
        "azimuth": "light from {{degrees}}°",
        "altitude": "{{degrees}}° up",
        "zFactor": "heights ×{{factor}}",
        "stops": "{{count}} colour stops",
        "interval": "a line every {{metres}} m",
        "edgesOff": "edges left blank"
      }
    },
    "configured": {
      "title": "A terrain address in this installation's configuration overrides the chosen build",
      "body": "The configuration names a terrain address of its own, and it wins: the scene draws that pyramid, not the build chosen here ({{build}}…). The chosen build is drawn only once the setting below is removed from the installation's configuration and the application restarted.",
      "setting": "The setting to remove:"
    },
    "credit": {
      "title": "The terrain being drawn carries no credit",
      "configuredBody": "The scene draws a terrain address named in this installation's configuration, and the configuration states no credit for it. Elevation data almost always has to be credited — Copernicus and most other free models require it — and what is stated in the setting below is what the scene shows beside the ground.",
      "setting": "The setting that states it:",
      "buildBody": "The scene draws a build ({{build}}…) that records no credit: none of the sources it was made from declared one. Elevation data almost always has to be credited. The credit is given for each source when a build is started, and it cannot be added to a finished build — start a build over the same ground with its sources credited, and choose that one."
    }
  },
  "dashboard": {
    "title": "Dashboard",
    "openOnStart": "Open on start",
    "counts": {
      "caves": "Caves",
      "features": "Features",
      "trips": "Trip logs",
      "geodata": "Geodata files"
    },
    "recentActivity": "Recent activity",
    "quickActions": "Quick actions",
    "myViews": "My saved views",
    "importFile": "Import file",
    "noActivity": "Nothing has been added yet.",
    "loadFailed": "The dashboard could not be loaded.",
    "noViews": "No saved views yet.",
    "untitled": "Untitled",
    "kind": {
      "cave": "Cave",
      "tripLog": "Trip log",
      "feature": "Feature",
      "caveEntrance": "Cave entrance",
      "centerline": "Centerline",
      "expedition": "Camp"
    },
    "comingUp": "Coming up",
    "comingUpFailed": "Your trips could not be loaded.",
    "noComingUp": "Nothing coming up. A trip appears here once somebody invites you to one or puts you on the party.",
    "allMyTrips": "All my trips"
  },
  "auth": {
    "email": "Email",
    "password": "Password",
    "signIn": "Sign in",
    "signOut": "Sign out",
    "invalidCredentials": "Invalid email or password.",
    "lockedOut": "Account temporarily locked. Try again later.",
    "signingIn": "Signing you in…",
    "mfaRequired": "Enter your second-factor code.",
    "mfaInvalid": "The two-factor code is not valid.",
    "mfaCode": "Two-factor code",
    "or": "or",
    "signInWith": "Sign in with {{provider}}",
    "externalFailed": "External sign-in did not complete. Please try again or use your password.",
    "serverUnreachable": "Cannot reach the server",
    "serverUnreachableHint": "Sign-in could not be started. Check that the server is running, then try again.",
    "mfaMethod": "Send the code by",
    "mfaMethod_authenticator": "Authenticator",
    "mfaMethod_email": "Email",
    "mfaMethod_sms": "Text message",
    "mfaResend": "Send the code again",
    "mfaCodeSent": "Code sent to {{destination}}.",
    "mfaSendFailed": "The code could not be sent. Try another method.",
    "mfaResendTooSoon": "A code was just sent. Wait a moment before asking for another.",
    "mfaUseRecovery": "Use a recovery code instead",
    "mfaUseMethod": "Use a code instead",
    "mfaRecoveryOnly": "None of your second-factor methods can be used right now. Enter a recovery code.",
    "mfaPendingExpired": "The sign-in waited too long for its code. Start again.",
    "mfaStartAgain": "Start signing in again",
    "recoveryCode": "Recovery code",
    "emailNotConfirmed": "Confirm your email address before signing in.",
    "resendConfirmation": "Send the confirmation email again",
    "confirmationResent": "If that address has an account, a confirmation email is on its way.",
    "passwordChangedSignIn": "Your password was changed and you were signed out everywhere. Sign in with the new password.",
    "confirmEmailTitle": "Confirm your address",
    "confirmEmailWorking": "Confirming your address",
    "confirmEmailDone": "Your address is confirmed. You can sign in now.",
    "confirmEmailFailed": "This link is invalid or has expired. Ask for a new one from the sign-in page.",
    "resetPasswordTitle": "Choose a new password",
    "resetPasswordSubmit": "Set password",
    "resetPasswordDone": "Your password has been changed.",
    "resetPasswordRejected": "That password was rejected. Use at least 10 characters.",
    "resetLinkInvalid": "This reset link is invalid or has expired.",
    "newPassword": "New password",
    "confirmPassword": "Repeat password",
    "passwordsDiffer": "The two passwords do not match.",
    "passwordTooShort": "Use at least 10 characters.",
    "invitePasswordTitle": "Choose your password",
    "invitePasswordIntro": "An account has been opened for you. Choose the password you will sign in with.",
    "invitePasswordDone": "Your password is set. You can sign in now.",
    "testLogins": {
      "title": "Test installation",
      "hint": "Anyone may try this installation with the demo accounts below. The data here is public and is reset regularly.",
      "about": "What this account may do",
      "roleAdministrator": "Administrator",
      "roleEditor": "Editor",
      "roleViewer": "Viewer",
      "permsAdministrator": "Full control of the installation: sees and edits everything, including exact locations of protected caves, user accounts, permission groups and settings.",
      "permsEditor": "Creates and edits content — caves, surface features, trip logs, documents, saved views — but cannot manage users or permissions, and exact locations of protected caves stay hidden.",
      "permsViewer": "The signed-in baseline: browses what is shared with all accounts and keeps saved views and checklists of its own, without editing shared content or seeing protected locations."
    }
  },
  "common": {
    "loading": "Loading…",
    "language": "Language",
    "save": "Save",
    "ok": "OK",
    "cancel": "Cancel",
    "edit": "Edit",
    "back": "Back",
    "continue": "Continue",
    "saved": "Saved.",
    "saveFailed": "The operation failed. Please try again.",
    "deleteFailed": "The deletion failed. Please try again.",
    "languageSaveFailed": "The language changed here, but could not be saved to your account. Messages sent to you may still arrive in the previous language.",
    "deleted": "Deleted.",
    "export": "Export",
    "retry": "Retry",
    "conflict": "Someone else changed this since you loaded it. Reload and reapply your changes.",
    "loadFailed": "Could not load this. Please try again.",
    "close": "Close",
    "reset": "Reset",
    "clearAnswer": "Clear answer",
    "configure": "Configure"
  },
  "notFoundPage": {
    "title": "No page at this address",
    "description": "The address may be mistyped, or the page it named has moved or gone. Nothing was changed by coming here.",
    "home": "Go to the start page"
  },
  "errorBoundary": {
    "title": "Something went wrong on this screen",
    "description": "The page stopped rendering. Reloading usually gets it back.",
    "reload": "Reload the page"
  },
  "map": {
    "baseLayers": "Base layers",
    "tileOverlays": "Overlay maps",
    "activeOverlays": "Map layers",
    "declutterLabels": "Thin out crowded labels",
    "declutterLabelsHint": "Names that would overlap give way to each other. Markers are always drawn — only their labels compete for space.",
    "changeBaseLayer": "Change the base map",
    "entrances": "Cave entrances",
    "searchPlaceholder": "Search features, trips or places…",
    "caves": "Caves",
    "places": "Places",
    "zoomTo": "Zoom to",
    "openCave": "Open cave",
    "approximate": "Approximate location — exact coordinates are protected.",
    "noSelection": "Click a feature on the map to see details.",
    "surfaceFeatures": "Surface features",
    "geofiles": "Imported files",
    "rasterMaps": "Raster maps",
    "centerlines": "Cave centerlines",
    "showPanel": "Show panel",
    "hidePanel": "Hide panel",
    "layersTitle": "Layers",
    "detailsTitle": "Details",
    "tabSelection": "Selection",
    "tabInView": "In view",
    "selectedCount": "{{count}} selected",
    "zoomToSelected": "Zoom to selected",
    "zoomInForEntrances": "Zoom in to list individual entrances.",
    "nothingInView": "Nothing loaded in the current view.",
    "locateMe": "Show my location",
    "geolocationFailed": "Could not determine your location.",
    "clusterTitle": "{{count}} entrances in this area",
    "zoomHere": "Zoom here",
    "approximateShort": "approx.",
    "swipeCompare": "Compare raster with the map beneath (swipe)",
    "hideChrome": "Hide map toolbars",
    "showChrome": "Show map toolbars",
    "showScene3d": "Show the 3D scene beside the map",
    "hideScene3d": "Hide the 3D scene",
    "unsavedEdits": "{{count}} unsaved edits",
    "contextAdd": "Add feature",
    "contextNewCave": "New cave here",
    "contextNewEntrance": "New entrance here",
    "contextCopyCoords": "Copy coordinates",
    "coordsCopied": "Coordinates copied.",
    "heatmap": "Entrance heatmap",
    "karstIndex": {
      "layer": "Karstification index (areas)",
      "loading": "Reading the areas in view…",
      "shown": "Areas in view: {{count}}.",
      "failed": "The karstification index could not be read. Moving the map asks again.",
      "refused": {
        "window": "This view cannot be asked about. Move the map to ask again.",
        "other": "The karstification index was refused for this view."
      }
    },
    "karstLegend": {
      "band": "{{from}} – {{to}}",
      "bandAbove": "more than {{from}}",
      "scheme": {
        "relative": "Bands relative to this view",
        "fixed": "Fixed bands, the same in every view"
      },
      "unit": {
        "density": "Caves per km²",
        "kernel": "Caves per km², smoothed"
      },
      "hot": "Hot spot (z ≥ {{z}})",
      "cold": "Cold spot (z ≤ −{{z}})",
      "noCaves": "No caves are counted in this view.",
      "noAreas": "No karst areas or massifs to show in this view.",
      "truncated": "Some areas in this view are not shown: one view carries at most {{max}}. Zoom in to see them all."
    },
    "karstDensity": {
      "layer": "Cave density (grid)",
      "reading": "What the cells show",
      "bands": {
        "label": "Bands",
        "relative": "Relative to view",
        "fixed": "Fixed"
      },
      "mode": {
        "density": "Caves per km²",
        "kernel": "Smoothed",
        "hotSpot": "Hot and cold spots"
      },
      "cell": "Cells of {{metres}} m (the finest published here is {{floor}} m).",
      "loading": "Reading the grid…",
      "failed": "The density grid could not be read. Moving the map asks again.",
      "refused": {
        "tooWide": "This view is too wide for the density grid even at its coarsest cell. Zoom in to see it.",
        "tooFine": "The grid was asked for cells finer than this installation publishes.",
        "window": "This view cannot be asked about. Move the map to ask again.",
        "other": "The density grid was refused for this view."
      }
    },
    "baseOpacity": "Opacity of {{name}}",
    "photos": "Geotagged photos",
    "photosCutShort": "Not every photo is shown here — zoom in to see the rest.",
    "tripsLayer": "Trip logs",
    "tripsShown": "{{count}} trip(s) drawn",
    "tripsLoading": "Loading trips…",
    "tripsFailed": "The trips could not be loaded. Panning the map tries again.",
    "tripsTruncated": "Only the first {{count}} trips in this window are drawn — narrow the dates or the filters to see the rest.",
    "tripsUnlocated": "{{count}} trip(s) in this window have no location and are not on the map.",
    "tripsFilterUnapplied": "{{count}} filter(s) from the trip list are not ones this layer can ask about, so the map shows more than the list did.",
    "tripsFrom": "From",
    "tripsTo": "To",
    "tripsTypeFilter": "Any trip type",
    "tripsFilterHint": "A trip is drawn where it says it went, else where its party met, else at a cave it names. A cave you may read but not locate exactly places nothing.",
    "centerlinesWithheld": "{{count}} more centerline(s) not shown at this zoom — zoom in to load them.",
    "centerlinesWithheldNotice": "{{count}} survey line(s) hidden at this zoom — zoom in or open the layer panel",
    "centerlineDetailOn": "Showing full survey detail, including splays.",
    "centerlineSkeletonOn": "Showing passage outlines; wall shots appear when you zoom in.",
    "centerlineDetailZoom": "Detail from zoom",
    "centerlineMaxPaths": "Line budget",
    "centerlineLimitsHint": "Leave empty to follow this installation's defaults. Higher detail costs more to draw.",
    "features": "Features",
    "locationWithheld": "Location withheld — exact geometry is protected.",
    "closestApproach": "Closest approach",
    "overburdenHighlight": "Overburden reading",
    "georeferencedMaps": "Georeferenced maps",
    "popup": {
      "photo": "Photo",
      "photoNamed": "Photo {{name}}",
      "geofilePoint": "Point from an imported file",
      "geofilePointNamed": "Point from an imported file: {{name}}",
      "libraryPhoto": "Photograph from {{library}}",
      "libraryPhotoUnnamed": "Photograph from a photo library"
    },
    "scaleInvalid": "Type a scale such as 1:25000 or 25000.",
    "overviewMap": "Overview map"
  },
  "dialog": {
    "dockToSide": "Dock to the side of the map",
    "floatAsDialog": "Float as a dialog"
  },
  "caveRegistry": {
    "unreadableLink": "The filter in this link could not be read, so every cave is shown. Ask whoever sent it for a fresh link.",
    "regionPlaceholder": "Region",
    "lengthPlaceholder": "Length (m): 300, >300, 300..500",
    "filterRefused": "This filter could not be run with your access. Change or clear the controls above.",
    "savedUnreadable": "That saved filter cannot be read with your access, so it was not applied.",
    "savedNotAboutCaves": "That saved filter is not about caves.",
    "saved": "Saved as “{{name}}”.",
    "applySaved": "Apply a saved filter…",
    "noSaved": "No saved filters yet",
    "saveAs": "Save as filter…",
    "manage": "Saved filters",
    "forget": "Stop naming this saved filter",
    "active": "Saved filter: {{name}}",
    "activeUnavailable": "Saved filter not available to you",
    "changed": "changed since",
    "extra": "This filter also has conditions these controls do not show ({{count}}). They still narrow the list.",
    "clearExtra": "Remove them",
    "editExtra": "Edit them",
    "advanced": "Advanced filter…",
    "advancedTitle": "Advanced filter",
    "saveTitle": "Save these conditions as a filter"
  },
  "listFilters": {
    "savedUnreadable": "That saved filter cannot be read with your access, so it was not applied.",
    "saved": "Saved as “{{name}}”.",
    "applySaved": "Apply a saved filter…",
    "noSaved": "No saved filters yet",
    "saveAs": "Save as filter…",
    "manage": "Saved filters",
    "forget": "Stop naming this saved filter",
    "active": "Saved filter: {{name}}",
    "activeUnavailable": "Saved filter not available to you",
    "changed": "changed since",
    "extra": "This filter also has conditions these controls do not show ({{count}}). They still narrow the list.",
    "clearExtra": "Remove them",
    "saveTitle": "Save these conditions as a filter"
  },
  "featureList": {
    "unreadableLink": "The filter in this link could not be read, so every feature is shown. Ask whoever sent it for a fresh link.",
    "filterRefused": "This filter could not be run with your access. Change or clear the controls above.",
    "savedNotAboutFeatures": "That saved filter is not about features.",
    "searchLabel": "Search features by name",
    "kindLabel": "Kind of feature",
    "typeLabel": "Feature type",
    "categoryLabel": "Feature category",
    "tagLabel": "Tag"
  },
  "tableMap": {
    "showOnMap": "Show these on the map",
    "listInView": "List the caves in view",
    "savedFilterNotListable": "The map's saved filter cannot be read here, so the caves in view cannot be listed by it.",
    "inMapWindow": "Only caves in the map's view",
    "clearWindow": "Show caves everywhere",
    "unreadableWindow": "The link named a map view that is not a valid area, so the list shows caves everywhere.",
    "highlightLayer": "Row pointed at in a list"
  },
  "workingSet": {
    "selectAll": "Select all found ({{count}}) on the map",
    "tookAll": "Selected on the map: {{count}}.",
    "tookFirst": "Selected the first {{taken}} of {{total}} on the map — that is as many as a selection holds.",
    "firstOf": "The first {{taken}} of {{total}} found by the list.",
    "failed": "The list could not be read again, so nothing was selected.",
    "saveAsFilter": "Save as a filter…",
    "saveTitle": "Save the selection as a filter",
    "saveHint": "What is saved is the filter that found this selection, not the objects in it: run later, it finds whatever matches then, as you are allowed to see it."
  },
  "savedFilters": {
    "title": "Saved filters",
    "intro": "A saved filter is a question you keep. Sharing one with a caving group, or with everyone signed in, lets them ask it; each of them is answered with what they themselves may see.",
    "toRegistry": "Cave registry",
    "empty": "No saved filters. Save one from the cave registry.",
    "name": "Name",
    "description": "Description",
    "nothingToSave": "There are no conditions to save — set at least one first.",
    "asks": "Asks for",
    "cannotShow": "Cannot be shown",
    "photographFilter": "Photographs",
    "noScreenToOpen": "This screen has no list to open that kind of filter in. Apply it from the screen it was made on.",
    "audience": "Who can use it",
    "private": "Only me",
    "someGroup": "A caving group",
    "author": "Saved by",
    "byYou": "You",
    "someMember": "A club member",
    "sharedWith": "Members of {{name}}",
    "authenticated": "Everyone signed in",
    "explain": {
      "private": "Only you can see this filter.",
      "cavingGroup": "Members of {{name}} can use it — it shows each of them only what they can already see.",
      "authenticated": "Everyone signed in can use it — it shows each of them only what they can already see."
    },
    "changeDefault": "Change your default",
    "state": "State",
    "states": {
      "ready": "Ready",
      "stale": "Out of date",
      "unreadable": "Cannot be read"
    },
    "staleHint": "A type or tag this filter names has since been removed, so that condition matches nothing.",
    "unreadableHint": "This filter asks something you cannot ask with your access, or was written in a form this version cannot read.",
    "open": "Open in the cave registry",
    "edit": "Rename, describe or share",
    "delete": "Delete",
    "deleteConfirm": "Delete this saved filter? Nobody it was shared with will be able to use it.",
    "notAvailable": "not available to you",
    "otherClubs": "Other clubs — you may not be allowed to share with these",
    "groupNotAllowed": "You may not share filters with this club. Choose one of your own clubs, Only me or Everyone signed in.",
    "parts": {
      "search": "Name contains “{{text}}”",
      "region": "Region contains “{{text}}”",
      "length": "Surveyed length {{comparison}}",
      "caveType": "Type: {{name}}",
      "tag": "Tag: {{name}}",
      "more": "{{count}} more conditions"
    }
  },
  "caves": {
    "title": "Caves",
    "newCave": "New cave",
    "editCave": "Edit cave",
    "name": "Name",
    "type": "Type",
    "region": "Region",
    "surveyedLength": "Length (m)",
    "depth": "Depth (m)",
    "entrances": "Entrances",
    "visibility": "Visibility",
    "identificationCode": "Code",
    "searchPlaceholder": "Search name or toponym…",
    "allTypes": "All types",
    "edit": "Edit",
    "delete": "Delete",
    "deleteConfirm": "Delete this cave?",
    "deleteRestorable": "Its entrances go with it. Nothing is removed: it can be restored, with them, from Deleted caves and features.",
    "openIn3d": "Open in 3D",
    "sections": {
      "identification": "Identification",
      "localization": "Localization",
      "geology": "Geology",
      "morphometry": "Morphometry",
      "status": "Status",
      "discovery": "Discovery",
      "access": "Access",
      "clubFields": "Club fields"
    },
    "fields": {
      "otherToponyms": "Other toponyms",
      "description": "Description",
      "website": "Website",
      "hydrographicBasin": "Hydrographic basin",
      "valley": "Valley",
      "tributaryRiver": "Tributary river",
      "closestAddress": "Closest address",
      "landRegistryNumber": "Land registry no.",
      "locationNotes": "Location notes",
      "rockType": "Rock type",
      "rockAge": "Rock age",
      "surveyedLength": "Surveyed length (m)",
      "estimatedLength": "Estimated length (m)",
      "realExtension": "Real extension (m)",
      "projectedExtension": "Projected extension (m)",
      "positiveDepth": "Positive depth (m)",
      "negativeDepth": "Negative depth (m)",
      "potentialDepth": "Potential depth (m)",
      "altitude": "Altitude (m)",
      "volume": "Volume (m³)",
      "area": "Area (m²)",
      "ramificationIndex": "Ramification index",
      "caveAge": "Cave age",
      "explorationStatus": "Exploration status",
      "protectionClass": "Protection class",
      "isShowCave": "Show cave",
      "showCaveLength": "Show-cave length (m)",
      "discoveryDate": "Discovery date",
      "discoverer": "Discoverer",
      "locationProtected": "Protected location",
      "locationProtectedHint": "Exact coordinates and precise-location fields are hidden from users without explicit permission."
    },
    "visibilityValues": {
      "private": "Private",
      "cavingGroup": "Caving group",
      "authenticated": "Authenticated users",
      "public": "Public"
    },
    "explorationValues": {
      "unknown": "Unknown",
      "ongoing": "Ongoing",
      "finished": "Finished",
      "abandoned": "Abandoned"
    },
    "summary": {
      "entrances": "{{count}} entrances",
      "centerlines": "{{count}} centerlines",
      "surveyModels": "{{count}} 3D models",
      "attachments": "{{count}} attachments",
      "tripLogs": "{{count}} trip logs"
    },
    "tripLogsEmpty": "No trip logs name this cave.",
    "depthPlaces": {
      "title": "This cave's named places",
      "help": "A depth on its own is not a place: turning one into a position means looking for the nearest station, and that cannot tell which of several stations near each other is the place people mean. Declare it once here and every report of that depth lands where you say — typed, corrected or imported — and the name becomes something a caver can report by instead of a number. A place can also be named without a depth — a hall or a junction the club's list of the cave names — with a few words beside the name if one depth does not say enough; such a place is listed and published with the cave's places, and no reported depth is ever placed by it.",
      "declare": "Declare a place",
      "depth": "Depth",
      "noDepth": "No depth",
      "atDepth": "at {{depth}} m",
      "atStation": "at station {{station}}, without a depth",
      "note": "Note",
      "landmark": "Named on the drawing",
      "landmarkTag": "On the drawing",
      "labelRequiredWithoutDepth": "A place without a depth needs a name: without either it declares nothing.",
      "metres": "{{depth}} m",
      "station": "Station",
      "place": "Place name",
      "none": "This cave declares nothing yet, so every depth reported in it lands on whichever station is nearest.",
      "stationRequired": "Say which station this place is.",
      "saved": "Declared.",
      "saveFailed": "That could not be saved.",
      "stationNameless": "That station has no name in the survey file, only the number the file wrote it at, and the next export of the survey gives that number to another station. Declare the depth at a station that has a name.",
      "oldKept": "Declared {{now}}, but the declaration {{old}} could not be withdrawn, so the place is now declared twice. Withdraw the one {{old}} by hand.",
      "stationNotInSurvey": "Not in the current survey",
      "stationNotInSurveyHelp": "A place marked “Not in the current survey” names a station this cave's current survey does not hold, so the declaration is not followed there: a report of that depth lands on the nearest station instead. Correct the station's name, or check which survey is the cave's current one.",
      "withdraw": "Withdraw",
      "withdrawConfirm": "Withdraw the declaration for {{depth}} m? Reports already recorded keep the station they were given; new ones will fall back to the nearest station.",
      "withdrawNamedConfirm": "Withdraw the name “{{label}}” for station {{station}}? No reported depth is placed by it; it only leaves the cave's list of places.",
      "unnamed": "Unnamed"
    }
  },
  "entrances": {
    "add": "Add entrance",
    "edit": "Edit entrance",
    "deleteConfirm": "Delete this entrance?",
    "deleteRestorable": "Nothing is removed. It can be restored from Deleted caves and features.",
    "coordinates": "Coordinates",
    "showOnMap": "Show on map",
    "showOnMapApproximate": "Show on map — this position is approximate",
    "longitude": "Longitude",
    "latitude": "Latitude",
    "main": "Main",
    "positionQuality": "Position quality",
    "positionBlurred": "You may not see this entrance’s exact position, so what is shown is rounded to a grid. The position, altitude and position quality are therefore read-only — the server keeps the recorded values and would discard anything entered here. Everything else on this form saves normally.",
    "qualityValues": {
      "unknown": "Unknown",
      "gps": "GPS",
      "map": "From map",
      "estimated": "Estimated"
    },
    "surveyedAt": "Surveyed"
  },
  "features": {
    "title": "Features",
    "name": "Name",
    "type": "Type",
    "geometry": "Geometry",
    "visibility": "Visibility",
    "description": "Description",
    "updatedAt": "Updated",
    "unnamed": "Unnamed",
    "linkedCave": "Linked cave",
    "linkedCavePlaceholder": "Search caves…",
    "typedProperties": "Properties",
    "newFeature": "New feature",
    "editFeature": "Edit feature",
    "edit": "Edit",
    "delete": "Delete",
    "deleteConfirm": "Delete this feature? Contained features are deleted with it.",
    "deleteRestorable": "Nothing is removed. It can be restored, with what it contains, from Deleted caves and features.",
    "deleted": {
      "link": "Deleted caves and features",
      "title": "Deleted caves and features",
      "intro": "The deletions you may undo, most recent first. Deleting a cave takes its entrances with it, and deleting an area takes what it contains: each is one row here, and restoring it brings back everything that went with it. Something deleted before the cave or area containing it was is listed once that is back.",
      "empty": "Nothing here. A cave, entrance or feature you delete is listed on this page.",
      "loadFailed": "The deleted caves and features could not be loaded.",
      "columns": {
        "name": "Name",
        "kind": "Kind",
        "deletedAt": "Deleted",
        "took": "Deleted with it"
      },
      "tookEntranceOne": "1 entrance",
      "tookEntrances": "{{count}} entrances",
      "tookOtherOne": "1 other object",
      "tookOthers": "{{count}} other objects",
      "tookNothing": "—",
      "restore": "Restore",
      "restoreConfirm": "Restore this?",
      "restoreConfirmDetail": "It returns with everything that was deleted along with it, and opens once it is back.",
      "restored": "It is back.",
      "containerDeletedNamed": "It is inside {{name}}, which is deleted. Restore that first.",
      "containerDeleted": "It is inside something that is deleted, which has to be restored first.",
      "gone": "That is no longer among the deleted ones.",
      "forbidden": "You may not restore that."
    },
    "showOnMap": "Show on map",
    "searchPlaceholder": "Search by name…",
    "allTypes": "All types",
    "geometryTypes": {
      "Point": "Point",
      "LineString": "Line",
      "Polygon": "Polygon",
      "MultiPoint": "Multi-point",
      "MultiLineString": "Multi-line",
      "MultiPolygon": "Multi-polygon"
    },
    "kind": "Kind",
    "allKinds": "All kinds",
    "kinds": {
      "generic": "Feature",
      "cave": "Cave",
      "caveEntrance": "Entrance",
      "centerline": "Centerline"
    },
    "category": "Category",
    "allCategories": "All categories",
    "categories": {
      "surface": "Surface",
      "underground": "Underground",
      "area": "Area",
      "structure": "Structure"
    },
    "locationWithheld": "Location withheld",
    "locationProtected": "Protected location",
    "open": "Open",
    "openTypedPage": "Open full page",
    "summary": "Summary",
    "entranceCount": "Entrances",
    "isDefault": "Default",
    "hierarchy": "Hierarchy",
    "parent": "Parent",
    "parents": "Parents",
    "noParents": "No parents",
    "editParents": "Edit parents",
    "parentFixed": "An entrance or a centreline sits under its own cave and nowhere else. To protect it, protect its cave, or put the cave under the protected area.",
    "parentFixedNote": "An entrance or a centreline sits under its own cave and nowhere else, so its parent cannot be changed here. To protect it, protect its cave, or put the cave under the protected area.",
    "addParent": "Add parent…",
    "parentSearchPlaceholder": "Search features…",
    "primary": "Primary",
    "children": "Contained features",
    "noChildren": "No contained features",
    "links": "Related features",
    "editLinks": "Edit links",
    "addLink": "Add",
    "linkKind": "Link kind",
    "linkTarget": "Linked feature",
    "linkNote": "Note",
    "noLinks": "No links",
    "incoming": "Incoming link",
    "outgoing": "Outgoing link",
    "inaccessible": "Not accessible"
  },
  "attachments": {
    "locationRemoved": "Location removed",
    "locationRemovedHint": "The copy you are given is the full-size picture with its location data taken out. The stored file keeps it for those who may see it.",
    "locationRemovedDownload": "Downloads a copy with its location data taken out.",
    "inDeviceDefaultSet": "Include in the phones' default download",
    "inDeviceDefaultSetHint": "A phone that asks for the usual files fetches this one. Phones only fetch it if the caver chooses to, and only if its holder may read it.",
    "originalWithheld": "You may not download the original of this photo: it records where it was taken, and you do not have the right to place what it shows.",
    "title": "Photos & documents",
    "photos": "Photos",
    "documents": "Documents",
    "reportDocument": "Report document",
    "uploadReport": "Click or drag the completed report document here",
    "noReport": "No report document uploaded yet.",
    "uploadPrompt": "Click or drag photos and documents here to attach them",
    "deleteConfirm": "Remove this attachment? The file stays available to its uploader.",
    "empty": "No photos or documents yet.",
    "versions": "Versions",
    "uploadVersion": "Upload new version",
    "currentVersion": "current",
    "noVersions": "No versions yet.",
    "deleteVersionConfirm": "Delete this version? Its content is removed permanently.",
    "details": "Details",
    "caption": "Caption",
    "role": "Role",
    "documentDate": "Document date",
    "tooLarge": "This file is larger than the {{max}} allowed for uploads.",
    "roles": {
      "photoEntrance": "Entrance photo",
      "photoInterior": "Interior photo",
      "photoSurface": "Surface photo",
      "document": "Document",
      "report": "Report document",
      "map2d": "2D map",
      "surveyData": "Survey data",
      "other": "Other"
    },
    "makePrimary": "Use as the headline picture",
    "clearPrimary": "Stop using as the headline picture"
  },
  "documents": {
    "deletion": {
      "delete": "Delete",
      "confirm": "Delete this document?",
      "restorableFor": "Nothing is removed: it disappears from every list, search and link, and can be restored from Deleted documents for {{period}}.",
      "restorable": "Nothing is removed: it disappears from every list, search and link, and can be restored from Deleted documents.",
      "done": "The document is deleted.",
      "forbidden": "You may not delete that document.",
      "inUse": "A survey archive entry, survey model, georeferenced map or geofile is built on this document. Remove that first.",
      "notFoundHint": "If it was deleted, it may still be among the deleted documents.",
      "link": "Deleted documents",
      "title": "Deleted documents",
      "intro": "The deleted documents you may put back. A restored document returns whole: with its versions, remarks, links and filing.",
      "introWindow": "A deleted document is kept for {{period}} and then removed for good.",
      "introKept": "This installation keeps deleted documents until an administrator decides otherwise.",
      "empty": "Nothing here. A document you delete is listed on this page.",
      "loadFailed": "The deleted documents could not be loaded.",
      "columns": {
        "title": "Document",
        "deletedAt": "Deleted",
        "deletedBy": "Deleted by",
        "removed": "Removed for good"
      },
      "removedIn": "in {{period}}",
      "removedToday": "within a day",
      "kept": "Not scheduled",
      "restore": "Restore",
      "restoreConfirm": "Restore this document?",
      "restoreConfirmDetail": "It returns with everything it had, and opens once it is back. Nobody is notified.",
      "restored": "The document is back.",
      "windowPassed": "That document was deleted too long ago to be restored.",
      "gone": "That document is no longer among the deleted ones.",
      "restoreForbidden": "You may not restore that document."
    },
    "language": "Language",
    "languageUnknown": "Not known",
    "languages": {
      "ro": "Romanian",
      "en": "English"
    },
    "metadata": "Document properties",
    "title": "Title",
    "type": "Document kind",
    "noType": "No kind chosen",
    "visibility": "Who may read it",
    "cavingGroup": "Caving group",
    "pickCavingGroup": "Choose a caving group",
    "bindingForbidden": "You cannot bind a document to a caving group you do not belong to.",
    "metadataInvalid": "The details do not match what this document kind allows.",
    "cabinets": "Filed in",
    "pickCabinets": "Not filed anywhere",
    "filingMovesAccess": "A document can sit in several cabinets; each one an access rule names reaches it.",
    "notFiled": "Not filed in any cabinet.",
    "open": "Open the document",
    "download": "Download",
    "format": "Format",
    "size": "Size",
    "version": "Version",
    "author": "Author",
    "updated": "Last changed",
    "viewer": {
      "title": "The document",
      "notDisplayable": "Nothing here can show this format yet. Download the file to open it in something that can.",
      "conversionPending": "This document is being prepared for reading here. Download it in the meantime, or come back shortly.",
      "conversionUnavailable": "This installation cannot lay out office documents, so there are no pages to show. The file itself is fine — download it to open it in a word processor.",
      "conversionDeferred": "The readable copy of this document could not be made just now — the service that makes them did not answer. Nothing is wrong with the file; download it, or ask an administrator to run the conversion sweep.",
      "conversionFailed": "This document could not be laid out for reading here. Download it to open it in a word processor.",
      "pageAlt": "Page {{number}}",
      "pageFailed": "This page could not be drawn. The rest of the document may still read; the file itself is unchanged and can be downloaded.",
      "pdfFailed": "This document could not be laid out here. The file itself is unchanged — download it to open it in a PDF reader.",
      "pdfSelectHint": "Select text on the page to copy it, or to point a link at the passage.",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "pageOf": "Page {{number}} of {{count}}",
      "previousPage": "Previous page",
      "nextPage": "Next page",
      "mediaFailed": "This recording will not play here — its format is not one this browser knows, or the recording is longer than the link that fetches it stays valid. Download it to play it in something else.",
      "textFailed": "This document's text could not be loaded.",
      "textTruncated": "Only the first {{kilobytes}} kB are shown here. Download the file to read the rest."
    },
    "comments": {
      "title": "Discussion",
      "empty": "Nothing has been said about this document yet.",
      "placeholder": "Write a remark about this document",
      "replyPlaceholder": "Write a reply",
      "body": "Remark",
      "post": "Post",
      "reply": "Reply",
      "edit": "Edit",
      "delete": "Delete",
      "edited": "edited",
      "deleteConfirm": "Delete this remark? Its replies go with it."
    },
    "text": "Text",
    "textStates": {
      "notApplicable": "This kind of file holds no text to read.",
      "pending": "Reading the text…",
      "extracted": "The text has been read.",
      "noText": "This document has no text layer: it is pictures of pages, so there are no words in it to read.",
      "failed": "The text could not be read.",
      "unsupported": "Nothing here can read this format's text yet."
    }
  },
  "cabinets": {
    "title": "Cabinets",
    "empty": "No cabinets yet.",
    "pickOne": "Choose a cabinet to see what is filed in it.",
    "new": "New",
    "edit": "Edit cabinet",
    "name": "Name",
    "description": "Description",
    "parent": "Sits inside",
    "noParent": "At the top level",
    "size": "Size",
    "includeSubtree": "Include cabinets inside",
    "includeSubtreeHint": "List documents filed anywhere below this cabinet, not only directly in it.",
    "filingMovesAccess": "Access rules can be scoped to a cabinet, so filing a document here — or taking it out — changes who can read it.",
    "noDocuments": "Nothing filed here that you may read.",
    "fileElsewhere": "File elsewhere",
    "fileElsewhereHint": "A document can sit in several cabinets at once; each one a rule names reaches it.",
    "pickCabinet": "Choose a cabinet",
    "unfileConfirm": "Take this document out of this cabinet?",
    "deleteConfirm": "Delete this cabinet?",
    "inUse": "Rules still point at this cabinet; remove them first.",
    "notEmpty": "The cabinet still holds cabinets or documents.",
    "holdsDeleted": "The cabinet still holds deleted documents. Restore them from Deleted documents and unfile them first.",
    "nameTaken": "A cabinet with this name already sits here.",
    "cycle": "A cabinet cannot be moved inside itself.",
    "tooDeep": "The filing tree cannot go this deep.",
    "filingForbidden": "You cannot file this document here.",
    "unfiled": "Not filed",
    "unfiledHint": "Everything you have added that is not in a cabinet yet. Filing it is a later decision — select what belongs together and file it in one go.",
    "unfiledEmpty": "Nothing waiting to be filed.",
    "defaults": "What lands here",
    "defaultsHint": "Applied to whatever is uploaded into this cabinet. Left empty, the answer comes from the cabinet above.",
    "defaultType": "Document kind",
    "defaultVisibility": "Who can read it",
    "defaultInherit": "Same as the cabinet above",
    "defaultTags": "Tags",
    "defaultTagsHint": "Applied to everything filed here",
    "requiredMetadata": "Metadata expected here",
    "requiredMetadataHint": "A checklist, not a rule: uploads are never refused for missing these, but documents that do not carry them are marked.",
    "expectsMetadata": "Documents here are expected to carry: {{keys}}",
    "missingMetadata": "Still missing: {{keys}}",
    "incomplete": "Incomplete",
    "selected": "{{count}} selected",
    "copyTo": "Also file in…",
    "moveTo": "Move to…",
    "copyHint": "A document can sit in several cabinets at once, so this adds a cabinet rather than moving anything.",
    "moveHint": "Files them in the new cabinet and takes them out of this one.",
    "bulkFiled": "{{count}} filed.",
    "bulkPartly": "{{filed}} filed; {{refused}} could not be."
  },
  "review": {
    "queueTitle": "Uploads awaiting review",
    "queueExplain": "Uploads from accounts that are under review wait here. Nothing in them has been written yet: what you accept is written then, and what you turn down never is.",
    "wholeView": "Waiting changes are shown here in full, including the exact positions of protected caves and pictures of caves you could not otherwise open.",
    "queueEmpty": "Nothing is waiting for review.",
    "forbidden": "You may not review uploads.",
    "uploader": "Sent by",
    "unknownUploader": "Unknown account",
    "heldAt": "Waiting since",
    "contents": "What it holds",
    "waiting": "Waiting",
    "heldBytes": "Held files",
    "decidedBy": "Decided by",
    "backToQueue": "Back to uploads awaiting review",
    "batchTitle": "Upload under review",
    "batchNotFound": "This upload is not waiting for review, or you may not see it.",
    "batchNote": "Note from the reviewer: {{note}}",
    "ownBatch": "This is your own upload. A reviewer decides it; you can read what is waiting and what was decided.",
    "readOnly": "You may read this upload but not decide it.",
    "mine": {
      "title": "Your uploads under review",
      "explain": "Your account is held for review: what you send in waits for a reviewer, and is written only when they accept it. Here is where each upload stands.",
      "sentAt": "Sent",
      "decidedAt": "Decided",
      "decidedBy": "by {{name}}",
      "outcome": "{{waiting}} waiting of {{total}}",
      "note": "Note from the reviewer",
      "open": "Open"
    },
    "source": {
      "label": "Source",
      "vectorFile": "File import (vector file)",
      "photos": "File import (photos)",
      "deviceSync": "Phone",
      "externalCatalogue": "File import (catalogue)",
      "tripCsv": "File import (trip sheet)",
      "speleolocArchive": "File import (SpeleoLoc archive)"
    },
    "state": {
      "label": "State",
      "notHeld": "Not held",
      "pending": "Waiting",
      "accepted": "Accepted",
      "partlyAccepted": "Partly accepted",
      "rejected": "Rejected"
    },
    "decision": {
      "pending": "Waiting",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "superseded": "Replaced by a newer upload",
      "failed": "Could not be written"
    },
    "candidate": {
      "line": "Line",
      "action": "Decision",
      "name": "Name",
      "caveTypeCode": "Cave type",
      "createTrip": "Create a trip",
      "yes": "Yes",
      "no": "No",
      "actions": {
        "create": "Create",
        "attach": "Attach to an existing place",
        "skip": "Skip",
        "update": "Update",
        "record": "Record"
      }
    },
    "needsOther_one": "Also depends on {{count}} line of another upload.",
    "needsOther": "Also depends on {{count}} lines of other uploads.",
    "pullInOther": "Some of these lines depend on lines of other uploads, which are decided together with them if they still wait.",
    "acceptAllWhole": "Accept all takes every waiting line whole; to choose fields, accept the line on its own.",
    "stoppedRest_one": "Stopped here: {{count}} more selected line is still waiting.",
    "stoppedRest": "Stopped here: {{count}} more selected lines are still waiting.",
    "section": {
      "none": "Other",
      "rows": "Places",
      "people": "Phone users",
      "documents": "Photos and documents",
      "documentLinks": "Links",
      "tripRecordings": "Recordings",
      "tripPoints": "Scans",
      "rasterMaps": "Raster maps",
      "rasterPins": "Map pins",
      "placeStations": "Places' stations",
      "vectorFile": "Vector file",
      "photos": "Photos",
      "tripSheet": "Trip sheet",
      "catalogue": "Catalogue caves",
      "speleolocArchive": "Archive",
      "keptRecording": "Kept recording"
    },
    "act": {
      "create": "New",
      "update": "Change",
      "delete": "Removal",
      "describe": "Description"
    },
    "field": {
      "label": "Field",
      "name": "Name",
      "description": "Description",
      "properties": "Properties",
      "position": "Position",
      "kind": "Kind",
      "type": "Type",
      "altitude": "Altitude",
      "title": "Title",
      "file": "New file",
      "log": "Log",
      "times": "Start and end",
      "cave": "Cave",
      "notes": "Notes",
      "place": "Place",
      "time": "Time of the scan",
      "mapType": "Map type",
      "sortOrder": "Order",
      "caveArea": "Part of the cave"
    },
    "current": "Now",
    "proposed": "Proposed",
    "unchanged": "same",
    "acceptField": "Accept {{field}}",
    "acceptedFields": "Accepted: {{fields}}",
    "changedSince": "Changed since the phone read it",
    "needs": "Needs: {{names}}",
    "lineNote": "Note: {{note}}",
    "untitled": "Untitled",
    "groupOther": "Not on a cave",
    "groupHiddenCave": "A cave you may not see",
    "positionWithheld": "The position of this place is withheld from you, so it is not compared.",
    "positionNotShown": "not shown",
    "positionShape": "a shape",
    "altitudeValue": "{{value}} m",
    "mainEntrance": "main entrance",
    "removalExplain": "The phone asks to remove this place.",
    "proposalHidden": "What this line proposes is not shown to you.",
    "noPreviewHeld": "The file is kept on the server until the line is decided.",
    "mapTypes": {
      "planView": "Plan view",
      "projectedProfile": "Projected profile",
      "extendedProfile": "Extended profile",
      "other": "Other"
    },
    "currentWithheld": "Not shown to you",
    "currentPicture": "The picture it has now",
    "pictureAlt": "Picture of {{name}}",
    "pictureFailed": "The picture could not be shown.",
    "timeRange": "{{start}} to {{end}}",
    "noDetail": "Nothing more to show for this line.",
    "file": "File",
    "size": "Size",
    "capturedAt": "Taken",
    "role": "Role",
    "caption": "Caption",
    "username": "User name",
    "linkedToCaver": "Linked to a caver in the directory.",
    "log": "Log",
    "startedAt": "Started",
    "endedAt": "Ended",
    "points": "Scans",
    "scannedAt": "Scanned",
    "notes": "Notes",
    "mapType": "Map type",
    "pin": "Pin",
    "pinNotShown": "The place of this pin is not shown to you.",
    "station": "Station",
    "splay": "Splay from the station (m east, north, up)",
    "stationNotShown": "The station of this place is not shown to you.",
    "accept": "Accept",
    "reject": "Reject",
    "acceptAfterAll": "Accept after all",
    "acceptAll": "Accept all",
    "rejectAll": "Reject all",
    "rejectAllTitle": "Reject everything that is waiting?",
    "rejectAllExplain": "Nothing of this upload is written. The uploader is told, with your note.",
    "select": "Select",
    "selectAllWaiting": "All waiting lines",
    "selectNone": "None",
    "selectKind": "All of one kind: {{kind}}",
    "selectGroup": "Select every waiting line under this cave",
    "selectLine": "Select {{name}}",
    "acceptSelected": "Accept selected ({{count}})",
    "rejectSelected": "Reject selected ({{count}})",
    "noteLabel": "Note to the uploader (optional, sent with the next decision)",
    "notePlaceholder": "Why, or what to do instead",
    "showDecided": "Show lines already decided",
    "waitingOfTotal": "{{waiting}} waiting of {{total}} lines",
    "noLines": "This upload has no lines.",
    "showDetails": "Show details of {{name}}",
    "hideDetails": "Hide details of {{name}}",
    "decided": "Decision recorded.",
    "pullInTitle": "This also accepts what it needs",
    "pullInExplain": "These lines are waiting and the ones you picked depend on them, so they are accepted first:",
    "cascadeTitle": "This also rejects what depends on it",
    "cascadeExplain": "These lines are waiting and depend on the ones you picked, so they are rejected with them:",
    "changedSinceTitle": "Some places changed after the phone read them",
    "changedSinceExplain": "Somebody changed these places on the server after the phone sent its version. You can write the phone's accepted fields over the current version, or reject them. Nothing has been decided yet.",
    "writeOver": "Write over the current version",
    "rejectThese": "Reject these",
    "problem": {
      "generic": "The decision could not be made.",
      "review_not_pending": "Something this decision reaches was decided already, or can no longer be changed. The page is showing the latest.",
      "review_own_batch": "Uploads are decided by somebody other than the account that sent them.",
      "review_batch_not_found": "This upload is not waiting for review, or you may not see it.",
      "review_item_not_found": "This line is not there any more.",
      "review_fields_unsupported": "Only a change to a place can be accepted field by field.",
      "review_source_unsupported": "This kind of upload cannot be decided by this server yet."
    }
  },
  "uploads": {
    "title": "Upload",
    "titleInto": "Upload into {{cabinet}}",
    "upload": "Upload",
    "dropFiles": "Drop files here, or click to choose them",
    "chooseFolder": "Choose a folder",
    "label": "Name this batch",
    "labelHint": "Optional. Everything uploaded together can be found again by this name.",
    "tag": "Tag everything with",
    "tagHint": "Optional. The tag is created if it does not exist yet.",
    "expandArchives": "Expand ZIP archives on the server, keeping their folders",
    "limitsTitle": "Before you start",
    "limitMaxSize": "Largest file accepted: {{size}}",
    "limitRemaining": "Room left for you: {{size}}",
    "limitAccepted": "Accepted types: {{types}}",
    "limitAcceptsAnything": "Any file type is accepted.",
    "limitRefused": "Not accepted: {{types}}",
    "expectsMetadata": "Documents filed here are expected to carry:",
    "summary": "{{stored}} of {{total}} stored · {{skipped}} skipped · {{failed}} failed",
    "retryFailed": "Retry {{count}} failed",
    "duplicateTitle": "This file is already here",
    "duplicateKnown": "A document with exactly these contents is already stored. Store this copy as well?",
    "duplicateUnknown": "These contents are already stored. Store this copy as well?",
    "duplicateStoreAnyway": "Store anyway",
    "duplicateSkip": "Skip it",
    "batches": "Uploads",
    "batchesEmpty": "Nothing has been uploaded in a batch yet.",
    "batchSource": "From",
    "batchSourceValues": {
      "interactive": "Browser",
      "archive": "Archive",
      "serverDirectory": "Server directory",
      "surveyUpload": "Field device"
    },
    "batchStatus": "Status",
    "batchStatusValues": {
      "open": "Open",
      "running": "Running",
      "completed": "Finished",
      "failed": "Failed"
    },
    "batchCounts": "{{stored}} stored · {{skipped}} skipped · {{failed}} failed",
    "batchReport": "Report",
    "importDirectory": "Import from a server directory",
    "importDirectoryHint": "Copies files the server can already reach, without sending them over the network. Folders become cabinets.",
    "importPath": "Directory",
    "importRoots": "This installation may import from:",
    "importNoRoots": "No import directories are configured, so this is switched off. An operator sets SILEXGIS__FILES__IMPORTROOTS when they deploy the installation.",
    "importStarted": "The import has started; its report fills in as it runs.",
    "reason": {
      "duplicate": "Already stored",
      "tooLarge": "Larger than this installation accepts",
      "typeNotAccepted": "This file type is not accepted",
      "quotaExceeded": "Not enough room left",
      "empty": "The file is empty",
      "pathRefused": "This folder path cannot be filed",
      "filingRefused": "You may not file into that cabinet",
      "unreadable": "The file could not be read",
      "failed": "Upload failed"
    },
    "batchStarted": "Uploaded"
  },
  "gallery": {
    "filter": {
      "advanced": "Conditions…",
      "advancedTitle": "Photograph conditions",
      "on": "on",
      "applySaved": "Apply a saved gallery view…",
      "noSaved": "No saved photograph filters yet",
      "saveAs": "Save as view…",
      "manage": "Saved filters",
      "forget": "Stop naming this saved view",
      "active": "Saved view: {{name}}",
      "activeUnavailable": "Saved view not available to you",
      "changed": "changed since",
      "saveTitle": "Save these conditions as a gallery view",
      "saved": "Saved as “{{name}}”.",
      "savedUnreadable": "That saved filter cannot be read with your access, so it was not applied.",
      "savedNotAboutPhotographs": "That saved filter is not about photographs.",
      "unreadableLink": "The conditions in this link could not be read, so they were left out. Ask whoever sent it for a fresh link.",
      "refused": "These conditions could not be applied. Change them, or stop naming the saved view.",
      "unsavedControls": "A saved view keeps the search, the tag, the dates and the conditions. The photographer, the album, “without a position” and what a link opened the gallery on — a cave, a trip, a camp, a map extent — are not kept, and are set afresh each time."
    },
    "title": "Photographs",
    "publicTitle": "Gallery",
    "albums": "Albums",
    "album": "Album",
    "newAlbum": "New album",
    "editAlbum": "Edit album",
    "albumTitle": "Title",
    "noAlbums": "No albums yet.",
    "albumCount": "{{count}} photographs",
    "empty": "No photographs match.",
    "publicEmpty": "Nothing has been published yet.",
    "search": "Search captions and places",
    "photographer": "Photographer",
    "place": "Place",
    "licence": "Licence",
    "facts": "About this photograph",
    "download": "Download the original",
    "previous": "Previous",
    "next": "Next",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "select": "Select",
    "selected": "{{count}} selected",
    "rotate": "Rotate",
    "rotated": "{{count}} rotated.",
    "addToAlbum": "Add to album…",
    "addedToAlbum": "{{count}} added.",
    "deleted": "{{count}} deleted.",
    "deleteConfirm": "Delete these photographs?",
    "deleteHint": "They leave every listing at once and can be restored for a while afterwards.",
    "deleteAlbumConfirm": "Delete this album?",
    "deleteAlbumHint": "The photographs in it are not deleted.",
    "bulkPartly": "{{changed}} changed; {{refused}} could not be.",
    "unplaced": "Without a position",
    "placed": "Position",
    "mapExtent": "Showing photographs inside the map extent you came from.",
    "mapExtentCutShort": "Not every photo in this map extent is listed here — it holds more than one search can carry. Zoom in on the map to see the rest.",
    "shareTitle": "Share link",
    "shareOnce": "Copy it now — the link is shown once and cannot be recovered afterwards. Revoke and mint a new one if it is lost.",
    "revokeConfirm": "Revoke this album’s share link?",
    "linkNotFound": "This link does not open anything. It may have been revoked.",
    "licences": {
      "cc0": "Public domain (CC0)",
      "cc-by": "CC BY",
      "cc-by-sa": "CC BY-SA",
      "cc-by-nc": "CC BY-NC",
      "cc-by-nc-sa": "CC BY-NC-SA",
      "cc-by-nd": "CC BY-ND",
      "cc-by-nc-nd": "CC BY-NC-ND",
      "all-rights-reserved": "All rights reserved"
    },
    "delete": "Delete",
    "editCredit": "Credit and licence",
    "caption": "Caption",
    "fromRoster": "A caver",
    "someoneElse": "Somebody else",
    "photographerName": "The photographer's name",
    "licenceUnsaid": "Nobody has said",
    "inPublicGallery": "Show in the public gallery",
    "inPublicGalleryHint": "Puts this photograph on the page anyone can reach without signing in. Separate from who may read it here.",
    "published": "Published to the public gallery.",
    "unpublished": "Withdrawn from the public gallery.",
    "moveEarlier": "Move earlier",
    "moveLater": "Move later",
    "makeCover": "Use as the cover",
    "removeFromAlbum": "Take out of the album",
    "removedFromAlbum": "Taken out of the album.",
    "openInGallery": "Open in the gallery",
    "arrangeHint": "Drag a photograph onto the place you want it, or move it with the arrows.",
    "albumEmpty": "Nothing in this album yet. Add photographs from the gallery.",
    "albumPartial": "Showing the first {{shown}} of {{total}} photographs. Arranging applies to these."
  },
  "geodata": {
    "title": "Geodata",
    "name": "Name",
    "format": "Format",
    "status": "Status",
    "features": "Features",
    "edit": "Edit geofile",
    "deleteConfirm": "Delete this geofile and its imported features?",
    "showOnMap": "Show on map",
    "exportList": "Export the listed files",
    "exportListFailed": "The list could not be exported. A very large selection is refused rather than cut short: narrow the filter and export in parts.",
    "searchPlaceholder": "Search by name…",
    "uploadPrompt": "Click or drag vector files here to upload",
    "uploadHint": "GPX, KML, KMZ, GeoJSON, zipped shapefile, CSV with coordinate columns, WKT — imported in the background.",
    "uploadQueued": "{{name}} uploaded — import queued.",
    "uploadFailed": "Upload failed. Check the file format and try again.",
    "statusValues": {
      "uploaded": "Queued",
      "importing": "Importing…",
      "imported": "Imported",
      "failed": "Failed"
    },
    "tabVector": "Vector files",
    "tabRaster": "Raster maps",
    "mapKind": "Kind",
    "editRaster": "Edit raster map",
    "deleteRasterConfirm": "Delete this raster map entry?",
    "rasterUploadPrompt": "Click or drag georeferenced GeoTIFFs here to upload",
    "rasterUploadHint": "Converted to Cloud-Optimized GeoTIFF in the background.",
    "defaultOpacity": "Default opacity (0–1)",
    "attribution": "Attribution",
    "mapKinds": {
      "geological": "Geological",
      "topographic": "Topographic",
      "tourist": "Tourist",
      "caveMap": "Cave map",
      "other": "Other"
    },
    "rasterStatusValues": {
      "uploaded": "Queued",
      "processing": "Processing…",
      "ready": "Ready",
      "failed": "Failed"
    },
    "tabImports": "Imports"
  },
  "mapEdit": {
    "featureType": "Feature type",
    "draw": "Draw",
    "modify": "Modify (drag vertices; Alt+click deletes)",
    "translate": "Move geometry",
    "snap": "Snap to visible features",
    "snapShort": "Snap",
    "undo": "Undo",
    "redo": "Redo",
    "measureDistance": "Measure distance",
    "measureArea": "Measure area",
    "discard": "Discard edits",
    "finishDrawing": "Finish",
    "finishDrawingHint": "Place more points before finishing this shape.",
    "removeLastPoint": "Point",
    "deleteVertex": "Delete vertex",
    "deleteVertexHint": "Tap a vertex on the map first, then Delete vertex.",
    "pickFeatureType": "Pick a feature type",
    "pinType": "Pin to toolbar",
    "unpinType": "Unpin from toolbar",
    "clickToMeasure": "Click to measure",
    "continueLine": "Click to continue the line — double-click to finish",
    "continueArea": "Click to continue the area — double-click to finish",
    "newCaveHere": "New cave here (click the map)",
    "newEntranceHere": "New entrance here (click the map)",
    "entranceType": "Entrance type",
    "locationProtected": "Protect the exact location",
    "pickCaveForEntrance": "Pick the cave this entrance belongs to.",
    "groups": {
      "point": "Points",
      "line": "Lines",
      "polygon": "Areas",
      "any": "Other"
    },
    "shapes": {
      "Point": "Marker",
      "LineString": "Line",
      "Polygon": "Outline"
    },
    "selectionNotEditable": "You may not change the selected feature"
  },
  "trips": {
    "title": "Trip logs",
    "titleField": "Title",
    "openTrip": "Open trip log",
    "new": "New trip log",
    "edit": "Edit trip log",
    "notFound": "No such trip",
    "notFoundDetail": "Either it is not there, or it is not yours to read. This page cannot tell the two apart, and does not try.",
    "tabReport": "Report",
    "tabLinks": "Links",
    "tabPhotos": "Photographs",
    "tabFiles": "Files",
    "tabHistory": "History",
    "tabInvitations": "Who is coming",
    "invitations": {
      "title": "Who is coming",
      "invite": "Ask",
      "invitePlaceholder": "Somebody the club knows",
      "signUp": "Sign me up",
      "signUpHint": "Nobody has asked you yet, but anybody who may read this can put themselves down as coming, in the order they say so.",
      "invited": "Added to the list.",
      "pickFromDirectory": "Choose somebody from the list of suggestions. A person is asked by their entry in the club's records, not by a name typed here — a name nobody can resolve would be a name nobody can tell.",
      "empty": "Nobody has been asked on this trip yet.",
      "emptyWithheld": "Everybody on this trip's list is somebody you may not be told about.",
      "unavailable": "This trip's list could not be read.",
      "limit": "{{attending}} of {{max}} places taken, {{waiting}} waiting.",
      "noLimit": "{{attending}} coming. This trip sets no limit on how many.",
      "place": "#{{place}}",
      "attending": "On the trip",
      "waiting": "Waiting",
      "selected": "Picked",
      "select": "Pick this person for the trip",
      "deselect": "Put this person back in the order",
      "notePlaceholder": "A word about it",
      "removeConfirm": "Take this person off the list entirely, answer and all?",
      "promote": "Write these people onto the trip",
      "promoteConfirm": "Write everybody holding a place onto the trip's list of people? Nobody is told: everybody written in was told when they were asked.",
      "promoted": "{{promoted}} written onto the trip, {{alreadyNamed}} already named on it.",
      "promoteTooEarly": "The trip has not happened yet, so there is nobody to write onto it.",
      "rosterChangedMeanwhile": "Somebody else changed who is on this trip at the same moment, so nobody was written onto it. Reload the trip and write these people onto it again.",
      "concurrentAnswer": "Somebody wrote about this person at the same moment. The list has been read again — repeat the change if it is still wanted.",
      "caverUnknown": "The club's records hold nobody by that name.",
      "selectNotAttending": "Only somebody who has said they are coming can be picked for the trip.",
      "noteInvalid": "That note is too long to store.",
      "withheld": "{{count}} on the list, not shown to you",
      "withheldDetail": "Somebody is on this trip's list whom you may not be told about. They are counted here so the numbers beside the list add up, and named nowhere.",
      "responseValues": {
        "pending": "Not answered",
        "yes": "Coming",
        "no": "Not coming",
        "maybe": "Maybe"
      }
    },
    "type": "Trip type",
    "typeValues": {
      "exploration": "Exploration",
      "survey": "Survey / mapping",
      "maintenance": "Maintenance / rigging",
      "training": "Training",
      "tourism": "Tourism / visit",
      "rescue": "Rescue",
      "science": "Science",
      "other": "Other"
    },
    "participantRoleValues": {
      "participant": "Participant",
      "proposer": "Proposer",
      "leader": "Leader",
      "driver": "Driver",
      "surveyor": "Surveyor",
      "photographer": "Photographer",
      "trainee": "Trainee",
      "instructor": "Instructor",
      "callout_contact": "Callout contact"
    },
    "date": "Date",
    "dates": "Dates",
    "entryTime": "Entry time",
    "exitTime": "Exit time",
    "duration": "Underground time",
    "location": "Location",
    "organizingClub": "Organizing club",
    "caves": "Caves",
    "cavesWithheld": "{{count}} not shown to you",
    "cavesWithheldDetail": "This trip names caves you may not open, or whose position you may not be told — they are counted here rather than listed, because naming one would be as good as showing it.",
    "participants": "Participants",
    "participantName": "Participant name",
    "participantRequired": "Enter a name",
    "participantTracked": "Somebody taken off the roster has reports on this trip's tracking, and it is still running. Close the tracking first, or keep them on the trip.",
    "rosterChangedMeanwhile": "Somebody else changed who is on this trip at the same moment, so this save was not written. Reload the trip and save again.",
    "participantRole": "Role",
    "participantNote": "Note",
    "participantDetails": "Role, times and note",
    "removeParticipant": "Remove from this trip",
    "participantTimesHint": "Left blank, the trip's own times apply.",
    "addParticipant": "Add participant",
    "proposers": "Proposed by",
    "proposerName": "Proposer name",
    "addProposer": "Add proposer",
    "results": "Results / observations",
    "weather": "Weather / conditions",
    "depthReachedM": "Depth reached",
    "lengthSurveyedM": "Length surveyed",
    "surveyStations": "Survey stations",
    "ropeMetres": "Rope used",
    "metres": "{{value, number}} m",
    "incident": "Incident",
    "hadIncidentYes": "Something went wrong",
    "maxParticipants": "Places",
    "maxParticipantsHelp": "How many people the trip has room for. Leave empty for no limit; anybody past the limit waits in the order they answered in.",
    "sections": {
      "title": "Trip report",
      "measured": "Measured",
      "fieldData": "Field data",
      "logistics": "Logistics",
      "safety": "Safety",
      "noFields": "This trip's purpose asks for nothing here.",
      "invalid": "The {{section}} section does not fit what this trip's purpose asks for.",
      "safetyWithheld": "Not shown to you",
      "safetyWithheldDetail": "What went wrong on a trip names the people it happened to, so the account of it is kept for whoever may change the trip. This is not a record that nothing happened.",
      "pickPerson": "Choose someone from the roster",
      "yes": "Yes",
      "no": "No"
    },
    "sectionValues": {
      "water_level": {
        "low": "Low",
        "normal": "Normal",
        "high": "High",
        "flood": "In flood"
      },
      "survey_grade": {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "X": "X"
      },
      "incident_severity": {
        "near_miss": "Near miss",
        "minor": "Minor",
        "serious": "Serious",
        "rescue": "Rescue"
      }
    },
    "sectionFields": {
      "conditions": "Conditions underground",
      "water_level": "Water level",
      "objective_reached": "Objective reached",
      "leads_found": "Leads found",
      "leads_remaining": "Leads still open",
      "survey_grade": "Survey grade",
      "instrument": "Instrument",
      "loops_closed": "Loops closed",
      "sketch_completed": "Sketch completed",
      "new_passage_note": "New passage",
      "permit_reference": "Permit reference",
      "permit_holder_caver_id": "Permit holder",
      "permit_holder_note": "Permit holder, if not on the roster",
      "key_holder_caver_id": "Key holder",
      "key_holder_note": "Key holder, if not on the roster",
      "landowner_caver_id": "Landowner contact",
      "landowner_note": "Landowner contact, if not on the roster",
      "access_notes": "Access notes",
      "cost_amount": "Cost",
      "cost_currency": "Currency",
      "cost_note": "What the cost covered",
      "incident_summary": "What happened",
      "incident_severity": "Severity",
      "equipment_failure": "Equipment failed",
      "lessons_learned": "Lessons learned",
      "reported_to": "Reported to",
      "meeting_time": "Meeting time",
      "meeting_description": "Meeting point, described",
      "transport_drivers": "Drivers",
      "transport_seats": "Seats available",
      "transport_departure": "Departure points",
      "equipment_note": "Equipment and rigging",
      "permit_required": "Permit required",
      "permit_obtained": "Permit obtained",
      "callout_contact_caver_id": "Callout contact",
      "callout_contact_note": "Callout contact, if not on the roster",
      "weather_note": "Weather note",
      "whatsapp_group_url": "Group chat link"
    },
    "state": "State",
    "stateValues": {
      "draft": "Draft",
      "proposed": "Proposed",
      "planned": "Planned",
      "confirmed": "Confirmed",
      "done": "Done",
      "published": "Published",
      "cancelled": "Cancelled",
      "delayed": "Delayed"
    },
    "publish": "Publish",
    "publishConfirm": "Publish this trip? The people named on it will be notified, and that cannot be taken back. Who may read it does not change: it stays readable by {{audience}}. Widening that is a separate edit.",
    "publishAudience": {
      "private": "you and anybody you have named",
      "cavingGroup": "your caving group",
      "authenticated": "everybody with an account here",
      "public": "anybody at all, including visitors without an account"
    },
    "publishSuccess": "Published. The people named on this trip have been notified.",
    "publishedAt": "Published on",
    "propose": "Float it",
    "proposeSuccess": "Floated as an idea.",
    "organise": "Start organising",
    "organiseSuccess": "Being organised.",
    "confirmGoing": "It is going ahead",
    "confirmGoingSuccess": "Confirmed as going ahead.",
    "delay": "Put it back",
    "delaySuccess": "Put back. Settle a new date when there is one.",
    "reschedule": "Settle a new date",
    "rescheduleSuccess": "Back to being organised.",
    "markDone": "Mark as done",
    "markDoneSuccess": "Recorded as done.",
    "callOff": "Call it off",
    "callOffConfirm": "Call this trip off? It is kept, and it can be reinstated as a draft.",
    "callOffSuccess": "Called off.",
    "unpublish": "Back to draft",
    "unpublishSuccess": "Back to draft.",
    "draftNotice": "This is a draft. Nobody has been notified about it yet — publish it when the write-up is ready.",
    "deleteConfirm": "Delete this trip log?",
    "deleted": {
      "link": "Deleted trips",
      "title": "Deleted trips",
      "intro": "The deleted trips you may put back. A restored trip returns exactly as it was: with its roster, the caves it names, its files and its place in a camp.",
      "introWindow": "A deleted trip is kept for {{period}} and then removed for good.",
      "introKept": "This installation keeps deleted trips until an administrator decides otherwise.",
      "restorableFor": "Nothing on it is removed. It can be restored from Deleted trips for {{period}}.",
      "restorable": "Nothing on it is removed. It can be restored from Deleted trips.",
      "empty": "Nothing here. A trip you delete is listed on this page until it is removed for good.",
      "loadFailed": "The deleted trips could not be loaded.",
      "columns": {
        "title": "Trip",
        "dates": "Dates",
        "deletedAt": "Deleted",
        "deletedBy": "Deleted by",
        "removed": "Removed for good"
      },
      "removedIn": "in {{period}}",
      "removedToday": "within a day",
      "kept": "Not scheduled",
      "restore": "Restore",
      "restoreConfirm": "Restore this trip?",
      "restoreConfirmDetail": "It returns with everything it had, and opens once it is back. Nobody is notified.",
      "restored": "The trip is back.",
      "windowPassed": "That trip was deleted too long ago to be restored.",
      "gone": "That trip is no longer among the deleted ones.",
      "forbidden": "You may not restore that trip.",
      "notFoundHint": "If it was deleted, it may still be among the deleted trips."
    },
    "searchPlaceholder": "Search by title…",
    "organizingCavingGroup": "Organizing caving group",
    "gallery": "Photographs",
    "noPhotographs": "No photographs are filed against this trip yet.",
    "galleryVisibleToYou": "The photographs you may see. Somebody else may see more, or fewer.",
    "report": {
      "open": "Report view",
      "backToTrip": "Back to the trip",
      "print": "Print",
      "account": "Account",
      "whoWasThere": "Who was there",
      "peopleCount": "People: {{count}}",
      "sketchPoint": "Sketch: a point at {{position}}.",
      "sketchShape": "Sketch: {{shape}}, {{count}} points, centred on {{position}}.",
      "north": "N",
      "south": "S",
      "east": "E",
      "west": "W",
      "download": "Download document",
      "keep": "Save to the trip",
      "kept": "The document was filed against the trip.",
      "documentFailed": "The document could not be produced.",
      "downloadPdf": "Download PDF",
      "pdfNoAnswer": "The service that makes the PDF did not answer in time. Try again, or download the Word document.",
      "pdfRefused": "The service that makes the PDF could not lay this write-up out. Download the Word document instead.",
      "pdfUnavailable": "This installation no longer offers a PDF of a write-up. Download the Word document, or print to PDF from the browser.",
      "template": "Layout",
      "templateDefault": "Standard layout",
      "audienceNotice": "This report shows what you may see. Somebody else reading the same trip may see more, or less.",
      "keepAudience": "The copy saved to the trip can be opened by everybody who may read the trip, so it leaves out what only editors of the trip may see. Your own fuller copy is the download.",
      "meetingPoint": "Meeting point: a point at {{position}}.",
      "meetingShape": "Meeting point: {{shape}}, {{count}} points, centred on {{position}}.",
      "map": {
        "legendSketch": "Where the trip worked (its sketch)",
        "legendMeeting": "Meeting point",
        "legendCave": "Cave the trip names",
        "background": "Background map: {{attribution}}",
        "noBackgroundNoneOffered": "No background map: this installation offers no map source that may be copied into a document.",
        "noBackgroundNotDelivered": "No background map: the map source did not deliver all of its tiles.",
        "noBackgroundTimedOut": "No background map: the map source did not answer in time.",
        "noBackgroundNotCopyable": "No background map: the browser would not let the map source's tiles be copied into a picture.",
        "withoutBackground": "The map in the document has no background map under it. The line under the map says why.",
        "notMade": "The document was downloaded without its map: the map could not be drawn in this browser.",
        "refused": "The document was downloaded without its map: the server did not take the picture."
      }
    },
    "geometry": "Trip sketch",
    "geometryHint": "Pick a shape, then draw on the map. A new shape replaces the one before it.",
    "drawHint": "Click the map to place points — double-click finishes a line or an area.",
    "drawPoint": "Point",
    "drawLine": "Line",
    "drawArea": "Area",
    "clearGeometry": "Clear shape",
    "geometryWarning": "Exact location — a trip's sketch is never approximated.",
    "geometryWarningDetail": "Everyone who may read this trip sees this shape exactly as drawn, whatever protection the caves it names carry. A sketch placed on a protected entrance therefore discloses that entrance.",
    "roleAdd": "Add",
    "roleShowingFirst": "Showing the first {{count}} of {{total}} records here.",
    "rolesTitle": "What this trip did",
    "roleOther": "Record something else",
    "roleNoteEmpty": "Describe it",
    "roleNoteEdit": "Describe what was left",
    "roles": {
      "trip-work-area": "Work areas",
      "trip-objective": "Main work features",
      "trip-visited": "Visited",
      "trip-surveyed": "Surveyed",
      "trip-discovered": "Discovered",
      "trip-dug": "Dug",
      "trip-photographed": "Photographed",
      "trip-searched-not-found": "Searched, not found",
      "trip-lead": "Leads left",
      "trip-follows-on-from": "Follows on from"
    },
    "mine": {
      "title": "My trips",
      "link": "My trips",
      "stateFilter": "Any state",
      "empty": "You are not on any trip yet. A trip appears here once somebody invites you to one or puts you on the party.",
      "emptyFiltered": "No trip of yours matches these filters.",
      "failed": "Your trips could not be loaded."
    },
    "track": {
      "import": "Import track (GPX)",
      "imported": "The recorded track is now the trip's sketch.",
      "problems": {
        "file_empty": "The file is empty.",
        "file_too_large": "The file is larger than a trip's track may be.",
        "format_unsupported": "A track is imported from a GPX file.",
        "file_unreadable": "The file could not be read as GPX.",
        "no_track": "The file holds no track or route — waypoints alone are not a track.",
        "too_many_points": "The track has more points than a trip's sketch may carry; shorten it before importing."
      }
    },
    "plan": {
      "new": "Plan a trip",
      "createMenu": "Other ways to create a trip",
      "audienceFromGroup": "Unless you choose otherwise, this plan is shared with your caving group, {{group}} — a plan only its author can read is a plan to nobody.",
      "audiencePrivate": "This plan starts private: you are in no single caving group, so the application does not guess which club should read it. Widen the audience here if it should be read.",
      "audienceFromChosenGroup": "Unless you choose otherwise, this plan is shared with the caving group it belongs to — a plan only its author can read is a plan to nobody."
    },
    "owningGroup": {
      "label": "Belongs to",
      "placeholder": "Choose a caving group",
      "required": "Choose the caving group this trip belongs to.",
      "only": "You record trips for {{group}}; this one will belong to it.",
      "several": "You record trips for your caving groups, so this one has to belong to one of them.",
      "meaning": "Who in the group may read and correct it is decided by the group's own rules, not by the visibility chosen here."
    },
    "expectedReturnAt": "Expected back",
    "calloutAlarmAt": "Raise the alarm at",
    "calloutAlarmHelp": "If nobody has said the party is out by this time, everyone on the trip is told. It cannot be earlier than the time you expect to be back. Leave both empty for no callout.",
    "calloutStatus": "Callout",
    "calloutStateValues": {
      "none": "None arranged",
      "armed": "Watching",
      "overdue": "Overdue",
      "stoodDown": "Party is out"
    },
    "calloutLastChecked": "Last checked",
    "calloutNeverChecked": "Never",
    "calloutUncheckedTitle": "Nothing has checked this callout recently",
    "calloutUncheckedBody": "An alarm is set, but the check that would raise it has not run lately — so nobody has confirmed this party is on time. Treat it as unchecked, not as safe, and contact them another way.",
    "calloutOverdueTitle": "This party is overdue",
    "calloutOverdueBody": "The alarm time passed and nobody had said the party was out. Everyone on the trip has been told.",
    "calloutStandDown": "The party is out",
    "calloutStoodDownSuccess": "Recorded — the callout has been stood down.",
    "calloutStandDownFailed": "The callout could not be stood down. Try again, and reach somebody another way if it keeps failing.",
    "calloutArrange": "Arrange a callout",
    "calloutChange": "Change the callout",
    "calloutSaved": "Saved — the callout is set.",
    "calloutCleared": "Saved — no callout is arranged for this trip.",
    "calloutSaveFailed": "The callout could not be saved. Try again.",
    "calloutAlarmBeforeReturn": "The alarm cannot be earlier than the time you expect to be back.",
    "meetingGeometry": "Meeting point",
    "meetingGeometryHint": "Where the party gathers, and the way in to it if your club draws one. Everyone who may read this trip is told this position exactly, including readers the trip does not name its caves to.",
    "meetingGeometryWarning": "Exact position — where the party gathers is never approximated.",
    "meetingGeometryWarningDetail": "Everyone who may read this trip sees this position exactly as placed, including readers the trip does not name its caves to. A meeting point a few hundred metres from a protected entrance therefore points at that entrance.",
    "checklist": "Checklist",
    "tabChecklist": "Checklist",
    "tabTracking": "Tracking",
    "tracking": {
      "setup": "Tracking setup",
      "state": "Tracking",
      "stateValues": {
        "off": "Not tracked",
        "armed": "Tracking",
        "closed": "Tracking closed"
      },
      "kinds": {
        "entered": "Went in",
        "atStation": "At a station",
        "atDepth": "At a depth",
        "note": "Note",
        "exited": "Came out",
        "caveNote": "About the cave"
      },
      "caveNote": {
        "who": "The cave",
        "hint": "A note about the cave is about nobody. It moves no one on the model or in the table, whoever may read this trip can read it, and it is never on a published page.",
        "words": "What to say about the cave",
        "wordsRequired": "Say what there is to say — a note about the cave is its words.",
        "station": "Station, if it is at one place",
        "stationHelp": "Optional. Leave it empty for something about the cave as a whole. Nobody is placed at this station.",
        "record": "Record the note about the cave",
        "recorded": "Note about the cave recorded.",
        "placeLabel": "About the cave, at"
      },
      "armedAt": "Tracking started",
      "closedAt": "Tracking closed",
      "firstArmedAt": "First started",
      "rearmedAt": "Started again",
      "arm": "Start tracking",
      "rearm": "Start tracking again",
      "close": "Close tracking",
      "closeConfirm": "Close tracking for this trip?",
      "closeConfirmBody": "The party stops being followed. A published page stops following it too — at once, or, on an installation that keeps a grace period after closing, when that has run out, saying meanwhile that the trip is over. The log itself stays open — reports can still be recorded, corrected or removed afterwards, so the write-up does not have to be finished first.",
      "armedNotice": "Tracking is on. Reports can be recorded now.",
      "closedNotice": "Tracking is closed. What was recorded stays on the log.",
      "surveyModel": "Survey",
      "surveyModelHelp": "The survey the party's positions are placed in. A cave whose exact position you may not be told offers no surveys here.",
      "surveyModelPlaceholder": "Choose a survey",
      "referenceStation": "Depth is measured from",
      "referenceStationHelp": "The station a reported depth counts down from. Left empty, the highest entrance station of the survey is used, and failing that its highest station.",
      "depthFilter": "Where the party said it was going",
      "depthFilterHelp": "The parts of the cave the party plans to visit — the start of a station or survey name. A reported depth is looked for only in these parts, and a station reported outside them is marked on this tab. Left empty, the whole survey is searched and nothing is marked.",
      "depthFilterPlaceholder": "Type a name and press Enter",
      "configWithheldTitle": "This tracking setup is not shown to you",
      "configWithheldBody": "A survey, a depth datum and a filter may well be set for this trip, in a cave whose exact position you may not be told — so they are kept from this page rather than being absent. The fields stay closed so that saving cannot replace what you were never shown. Open them only to set the whole thing afresh: that replaces the survey, and clears the datum and the filter every depth already on the log was resolved against.",
      "configReplace": "Set it afresh anyway",
      "teams": "Teams",
      "teamsNone": "No teams on this trip.",
      "teamAdd": "Add",
      "teamRename": "Rename",
      "teamDelete": "Delete",
      "teamDeleteConfirm": "Delete this team? The reports it labels keep their caver and lose only the label.",
      "teamTitlePlaceholder": "What this team is called",
      "report": "Record a report",
      "reportKind": "What is being reported",
      "reportStation": "Station",
      "reportStationHelp": "A station of the chosen survey, spelled the way the survey spells it.",
      "reportStationRequired": "Say which station.",
      "reportStationCorrect": "The survey may spell this station differently from the drawing you pressed. Correct it here and record it again.",
      "reportToStation": "Second station, if they are between two",
      "reportToStationHelp": "Only for word that they are somewhere between two stations — past the one above, not yet at this one. Leave it empty for a report at the one station.",
      "reportToStationSame": "That is the station above. Name the other end of the stretch, or leave this empty.",
      "stretch": "Between {{from}} and {{to}}",
      "reportPlaceLabel": "Reporting at",
      "reportNoPlace": "Going in, coming out and a note carry no place, so this report will not say anybody is at {{station}}.",
      "reportPlace": "Place",
      "reportPlaceHelp": "The places this cave has declared, shallowest first. Choosing one reports its depth, which lands on the station the cave declared for it.",
      "reportPlacePlaceholder": "Name the place instead of a depth",
      "reportPlaceOption": "{{place}} — {{depth}} m",
      "reportPlaceOptionUnnamed": "{{station}} — {{depth}} m",
      "reportPlaceOptionMissing": "{{place}} — station not in this survey",
      "reportPlaceNone": "This cave has declared no places, so a place is reported as a station or as a depth.",
      "reportPlaceNoneLink": "Declare them on the cave's page",
      "reportDepth": "Depth below the datum (m)",
      "reportDepthHelp": "Metres down. The sign makes no difference: −120 and 120 are both 120 metres down.",
      "reportDepthRequired": "Say how deep.",
      "depthPreview": "Which station is that?",
      "depthCandidates": "Stations that depth could mean, closest first:",
      "depthCandidate": "{{depth, number}} m down · {{delta, number}} m off",
      "depthCandidatesNone": "No station of the survey matches that depth under this trip's filter.",
      "depthCandidateChoose": "Use this station",
      "depthGapTitle": "That depth is {{gap, number}} m from the nearest station",
      "depthGapBody": "You typed {{asked, number}} m down. The nearest station under this trip's filter is {{station}}, which is {{depth, number}} m down — a depth is always recorded at the nearest station, however far away that is. Check the number, or ask which station it means and pick the one you meant.",
      "depthGapDeclaredTitle": "This cave declares that depth as {{station}}, which the survey puts {{gap, number}} m from it",
      "depthGapDeclaredBody": "You typed {{asked, number}} m down, and this cave has declared that depth to mean {{station}}, so that is where the report lands. Measured from this trip's depth datum, though, {{station}} is {{depth, number}} m down. If that is where they are, record it; if not, check the number, or the declaration under “What this cave's depths mean” on the cave's page.",
      "depthChecking": "Checking which station this depth means…",
      "depthCheckFailed": "This depth has not been checked against the survey",
      "depthCheckFailedBody": "Recording is not blocked, and the depth will still be written down at the nearest station of this trip's filter, however far away that is. Check the number yourself before recording it, or try the check again.",
      "reportTeam": "Team",
      "reportTeamNone": "No team",
      "reportNote": "Note",
      "reportActivity": "Activity",
      "reportActivityHint": "What they were doing, in the party's own words — rigging, surveying, asleep. Optional.",
      "reportAt": "When it was said",
      "reportAtHelp": "Left empty, the report is stamped now. Fill it in for word relayed out some time after it was said; a time in the future is refused.",
      "reportAtHelpAfterClose": "The moment the report was made, during the trip. A time in the future is refused.",
      "reportWhenRequired": "Say when this was said. The tracking is closed, so the report cannot be stamped with the present time.",
      "recordAfterCloseTitle": "This trip's tracking is closed — a report added now is being written up afterwards",
      "recordAfterCloseBody": "It goes on the log at the moment you give it, so say when it was made during the trip. Nothing is stamped with the present time, and that goes for marking people out too.",
      "reportAtNow": "Now",
      "reportAtMinutesAgo": "{{minutes}} min ago",
      "reportAtHoursAgo": "{{hours}} h ago",
      "recordFor": "Record for {{count}} selected",
      "markOut": "Mark {{count}} out",
      "selectNobody": "Tick the people this report is about first — one report is recorded for all of them at once.",
      "selectEverybody": "Select everybody ({{count}})",
      "silenceFirst": "Longest silence first",
      "recorded": "Recorded for {{count}}.",
      "outbox": {
        "held": "No answer from the server — not sent yet. The report is kept in this browser and is sent by itself when the connection returns.",
        "heldBusy": "The server is busy and did not take the report — not sent yet. The report is kept in this browser and is sent by itself a little later.",
        "notKept": "Not sent: no answer came from the server, and this browser would not keep the report to send it later. What you typed is still here — send it again when the connection is back.",
        "heldSignedOut": "Your sign-in has lapsed — not sent yet. The report is kept in this browser and is sent once you have signed in again: open the held reports at the top of the page to sign in.",
        "lapsedTitle": "Your sign-in has lapsed",
        "lapsedBody": "These reports cannot be sent until you have signed in again. Signing in leaves this page and comes back to it; the reports stay in this browser meanwhile and are sent once you are back.",
        "signInAgain": "Sign in again",
        "people": "People: {{count}}",
        "openTrip": "Open the trip",
        "title": "Held reports: {{count}}",
        "storedHere": "These reports got no answer from the server. Their text is kept in this browser, for this account only, until each one is sent or discarded — they are sent by themselves when the connection returns.",
        "show": "Show them",
        "sendNow": "Send now",
        "sendAgain": "Send again",
        "discard": "Discard",
        "discardConfirm": "Discard this report?",
        "discardConfirmDetail": "The copy kept in this browser is deleted and is not sent again. It may already have reached the server — a send that got no answer can still have been written — so look at the trip's log afterwards and remove the report there if it is listed.",
        "discarded": "Report discarded: its copy in this browser is deleted and will not be sent again. If it is on the trip's log, it reached the server before — remove it there.",
        "refused": "Refused: {{reason}}",
        "refusedNoReason": "the server refused this report and named no reason this page has words for.",
        "sent": "Held reports sent: {{count}}.",
        "alreadyRemoved": "Held reports the server already had, and that were taken off the log since: {{count}}. Nothing was written again.",
        "refusedSome": "Held reports the server refused: {{count}}. They are kept in this browser — open the held reports at the top of the page to send them again or discard them.",
        "stillNoAnswer": "Still no answer from the server. The reports stay held.",
        "signedOut": "Your sign-in has lapsed, so the held reports cannot be sent. They stay in this browser and are sent once you have signed in again — open the held reports at the top of the page to sign in.",
        "serverBusy": "The server cannot take reports right now. They stay held — try again in a few minutes.",
        "everywhere": "Held reports: {{count}} — kept in this browser until they are sent. Show them."
      },
      "notArmedTitle": "Tracking has not been started for this trip",
      "notArmedBody": "A report names a place on a survey, and a watch that was never started has no survey to place it on. Start tracking above: everything reported from then on is kept on the log, and the log can still be written up after the watch is closed.",
      "participantsNone": "Nobody is on this trip's roster yet.",
      "columnCaver": "Caver",
      "columnTeam": "Team",
      "columnLastKind": "Last report",
      "columnLastRecordedAt": "When",
      "columnLastHeard": "Last heard",
      "neverHeard": "No word yet",
      "columnPosition": "Where",
      "positionSince": "Reported {{since}}",
      "positionAsked": "Reported as {{depth, number}} m down",
      "positionGap": "{{gap, number}} m from the reported depth",
      "positionGapDetail": "The report said {{asked, number}} m down. It was recorded at {{station}}, which is {{depth, number}} m down — {{gap, number}} m away. A depth is recorded at whichever station of the trip's filter is nearest, with no tolerance at all, so a mistyped depth still lands somewhere.",
      "positionGapDetailDeclared": "The report said {{asked, number}} m down, a depth this cave declares as {{station}}, so it was recorded there. Measured from the trip's depth datum, {{station}} is {{depth, number}} m down — {{gap, number}} m away. It is the declaration that placed it, not the nearest station, so if the place is wrong, the declaration is what to look at.",
      "columnNote": "Note",
      "columnActivity": "Activity",
      "positionWithheld": "Not shown to you",
      "positionWithheldDetail": "This position exists and you may not be told it — the cave it is measured in is one whose exact position you may not be given. It is marked rather than left blank, because a blank would read as nobody knowing where this caver is.",
      "positionMaybeWithheld": "Not shown, or not reported",
      "positionMaybeWithheldDetail": "This caver's last report carried no place — going in, coming out and a note never do. So either nobody has reported where they are, or a position was reported and is one you may not be told. This page cannot tell the two apart and does not claim either.",
      "modelMissingTag": "Survey deleted",
      "modelMissingTitle": "The survey this watch is on has been deleted",
      "modelMissingBody": "Tracking is still armed and still takes entries, exits and notes, but nobody can be placed: the survey model it was armed on is no longer on this server. Choose another survey for this trip to start placing people again. Reports already on the log keep the survey they were made against and are not moved.",
      "scopeTitle": "Tracking records reports; it does not raise an alarm",
      "scopeBodyWithCallout": "This is a record of where each person was last reported, kept as word reaches you. It watches no clock: if the party does not come out, nothing here will notice and nobody will be told. The callout arranged for this trip, higher up this page, is the separate thing that holds an alarm time and raises the alarm once it passes.",
      "scopeBodyNoCallout": "This is a record of where each person was last reported, kept as word reaches you. It watches no clock: if the party does not come out, nothing here will notice and nobody will be told. No callout is arranged for this trip either — a callout is the separate arrangement that holds an alarm time and raises the alarm once it passes, and it is set on the trip itself rather than here.",
      "scopeAtArming": "Starting tracking does not arrange a callout, and this trip has none. If somebody should be alerted when this party is overdue, arrange a callout on this trip as well.",
      "scopeAtArmingWithCallout": "Starting tracking does not change the callout already arranged for this trip. Tracking records where people were reported; the callout is what raises the alarm.",
      "modelObstacleTag": {
        "notALinePlot": "No stations: cave walls",
        "stillReading": "No stations yet",
        "importFailed": "No stations: import failed"
      },
      "modelObstacleTitle": {
        "notALinePlot": "Nobody can be placed on a file of cave walls",
        "stillReading": "Nobody can be placed yet — this survey is still being read",
        "importFailed": "Nobody can be placed on this survey"
      },
      "modelObstacleBody": {
        "notALinePlot": "The survey this watch is on is a file of cave walls. It holds no stations — a wall mesh is turned into a picture and never yields one, so importing it again will not change that. A reported place is the name of a station, so no report can claim one here and nobody will appear on the drawing. Choose a line plot above instead. Entries, exits and notes go on being recorded as usual.",
        "stillReading": "The survey this watch is on is still being read, so it holds no stations yet and nobody can be placed on it. A reported place is the name of a station. Nothing needs doing: once the reading finishes, places can be reported as usual. Entries, exits and notes are recorded throughout.",
        "importFailed": "The survey this watch is on holds no stations — its import did not come through. A reported place is the name of a station, so no report can claim one here and nobody will appear on the drawing. Import that survey again from the cave's page, or choose another survey above. Entries, exits and notes go on being recorded as usual."
      },
      "modelObstacleOption": {
        "notALinePlot": "cave walls, no stations",
        "stillReading": "still being read",
        "importFailed": "import did not come through"
      },
      "modelNothingToDrawTitle": "There is no drawing to show",
      "modelNothingToDrawBody": "The survey this watch is on holds no stations, so there is nothing to draw and nobody can be placed on it. The tracking setup at the top of this tab says what to do about it. Entries, exits and notes are unaffected.",
      "noCaveNamedTitle": "This trip does not say which cave it is in",
      "noCaveNamedBody": "A watch places people at stations of a survey, and a survey belongs to a cave — so until this trip names one there is nothing to choose here, however many surveys the cave itself has. Name the cave on this trip's own details, above this tab, and its surveys appear in the list.",
      "noSurveyUploadedTitle": "This cave has no survey uploaded",
      "noSurveyUploadedBody": "A reported place is the name of a station, and stations come from a survey file. Nothing has been uploaded to this cave yet, so there is nothing to place anybody on. Upload a line plot — a Therion .lox or a Survex .3d — from the cave's page, and it appears in the list here once it has been read.",
      "surveysUnreadTitle": "This cave's surveys could not be read",
      "surveysUnreadBody": "The list of surveys did not come back, so nothing can be said about whether the cave has one. Try again; if it keeps failing, the server is the place to look, not the cave's page.",
      "surveysWithheldTitle": "This cave's surveys are not shown to you",
      "surveysWithheldBody": "A survey is a measured drawing of the cave, so it is kept from anybody who may not be told the cave's exact position — which includes you on this cave. It may well have surveys; setting the watch up on one is for somebody who can see them.",
      "noPlaceableModelTitle": "None of this cave's surveys can be used here",
      "noPlaceableModelBody": "A reported place is the name of a station, and none of the surveys uploaded to this cave holds any: each is either a file of cave walls, which has no stations, or a file whose import did not come through. Import one again from the cave's page, then choose it here.",
      "noPlaceableModelStillReadingTitle": "This cave's surveys are still being read",
      "noPlaceableModelStillReadingBody": "A reported place is the name of a station, and a survey holds none until it has been read right through. At least one of this cave's surveys is still being read; it will appear in the list here as soon as it finishes. Nothing needs doing in the meantime.",
      "positionsOnOtherModelTitle": "Some places were reported on a different survey",
      "positionsOnOtherModelBody": "This watch now uses a different survey model than the one those reports were made against. A station name means whatever the survey it was measured in says it means, so those places are not drawn on the survey in use — they are marked as reported on another survey instead of being moved onto it. Report a place again to put somebody on the survey now in use.",
      "positionOtherModel": "On another survey",
      "positionOtherModelDetail": "This place was reported against a different survey model than the one this watch uses now — either the watch was re-pointed, or the survey it was measured in has been deleted. A station name means whatever the survey it was measured in says it means, so this is a true record of what was reported and not where this caver is on the survey in force. Report a place again to put them on it.",
      "eventOtherModelDetail": "This place was reported against a different survey than the one this watch uses now — either the watch was pointed at another survey after this report, or the survey it was measured in has been deleted. It is a true record of what was reported at the time; the same station name can mean another place on the survey in force. If that survey is still here, choose it on the model below to see the report where it was made.",
      "viewOnLabel": "Look at the reports on",
      "viewOnWatch": "{{name}} — this watch's survey",
      "viewOnOther": "{{name}} — added {{date}}",
      "viewOnReadOnlyTitle": "Showing the reports recorded on {{name}}",
      "viewOnReadOnlyBody": "This is another survey that reports of this trip were made on, shown for looking only. Nothing can be recorded while it is on screen — a report is always measured against the survey this watch uses. Choose {{watch}} to record again.",
      "positionNotOnModel": "Not on the drawing",
      "positionNotOnModelDetail": "This place was reported against the survey this watch uses, and the drawing of it opened below holds no station of that name — so nobody can be marked there, and the model shows this caver nowhere. A survey re-exported with its stations renamed does that to every place reported before it, under the same survey, with nobody having changed the watch. What was reported stands; where it is on the drawing does not. Report a place again to put this caver back on it.",
      "modelSwapClearsDatumTitle": "Saving this will clear the depth datum and the station filter",
      "modelSwapClearsDatumBody": "Both name stations of the survey in use now, and those names mean nothing — or somewhere else — in another survey, so they are not carried across. Until a reference station is set again, a depth report will be refused: set it on the new survey straight after saving, or type one into the box below and save both together. Places already reported keep the survey they were measured against.",
      "modelSwapClearedDatumNotice": "The depth datum and the station filter were cleared with the survey. Set a reference station on the new survey before reporting a depth.",
      "positionsWithheldTitle": "Some positions are not shown to you",
      "positionsWithheldBody": "This trip is tracked in a cave whose exact position you may not be told, so station names and depths are kept from this page. Who is in and who is out is shown as it stands.",
      "standing": {
        "underground": "Underground",
        "out": "Out",
        "unheard": "Not heard from"
      },
      "unknownCaver": "Somebody not on the roster",
      "notOnRoster": "No longer on the roster",
      "outsideDeclaredParts": "Outside the declared parts",
      "outsideDeclaredPartsHelp": "This station is not in the parts of the cave the party said it was going to. It is a mark for whoever reads this tab: nothing is sent and no alarm is raised.",
      "declaredOnly": "Show only the declared parts",
      "declaredOnlyHelp": "Takes off the drawing every survey that holds nothing the party said it was going to. Markers stay.",
      "declaredOnlyHidden": "Surveys outside the declared parts, hidden: {{surveys}}. Somebody reported there keeps their marker, drawn without the passage around it.",
      "declaredOnlyNothing": "Every survey of this drawing is in the declared parts.",
      "declaredOnlyUnmatched": "This drawing has no survey called: {{entries}}. It cannot be narrowed to the declared parts.",
      "declaredOnlyWaiting": "Available once the model has loaded.",
      "personActions": "More for {{name}}",
      "notOnRosterDetail": "Taken off the trip's roster after reports about them were recorded. Their reports stay in the log; nothing more can be recorded for them, and a published page does not show them.",
      "quiet": {
        "tagHours": "No word for over {{amount}} h",
        "tagMinutes": "No word for over {{amount}} min",
        "countHours": "No word for over {{amount}} h: {{people}}",
        "countMinutes": "No word for over {{amount}} min: {{people}}"
      },
      "plan": {
        "label": "Planned out by",
        "lateHours": "{{amount}} h late",
        "lateMinutes": "{{amount}} min late"
      },
      "marksNote": "The readings for a long silence and for a late return are for whoever has this page open. Nothing is sent, no alarm is raised and none is stood down.",
      "modelTitle": "The party on the survey",
      "modelShow": "Show the model",
      "modelHide": "Hide the model",
      "modelHint": "Opens {{name}} and marks each caver where they were last reported. Anybody whose position is not known, or not shown to you, is listed on it rather than left off.",
      "modelLarger": "Bigger model",
      "modelSmaller": "Smaller model",
      "recordHere": "Record here",
      "recordHereTitle": "Record a report",
      "reportWho": "Who this is about",
      "reportWhoPlaceholder": "Choose the cavers",
      "reportWhoRequired": "Say who this report is about.",
      "replay": {
        "open": "Replay the trip",
        "leave": "Back to live",
        "reading": "Reading the whole log…",
        "logUnavailable": "The log could not be read",
        "logUnavailableBody": "A replay is built from every report on the log, and this read did not finish. Nothing is replayed over part of a log: the reports arrive newest first, so a replay over what came back would open with the party already underground at places nothing says they walked to — and would animate that as confidently as it animates anything else.",
        "nothingToReplay": "There is nothing to replay: this trip's tracking covers no stretch of time.",
        "play": "Play",
        "pause": "Pause",
        "speed": "{{value}}×",
        "scrub": "Moment of the trip",
        "note": "{{when}} · {{who}}: {{note}}",
        "caveNote": "{{when}} · About the cave: {{note}}",
        "caveNoteAt": "{{when}} · About the cave, at {{station}}: {{note}}",
        "noteNone": "Nothing had been said in words by this moment.",
        "notePrevious": "Previous note",
        "noteNext": "Next note"
      },
      "pictures": {
        "title": "Photographs of this moment",
        "hint": "Photographs belong to a moment of the trip rather than to a report, so correcting a report in place, or deleting one, never takes a photograph with it. The moment comes from each picture's own file where it says one.",
        "attach": "Attach photographs ({{count}})",
        "attachHere": "Photograph here",
        "attached": "Attached: {{count}}. Not attached: {{refused}}.",
        "attachFailed": "The photographs could not be attached.",
        "subject": "About",
        "subjectNobody": "Nobody in particular",
        "subjectHint": "A photograph about one person is drawn where that person was at this moment. One about nobody in particular is shown on the timeline and placed nowhere — a party that has split is in two places, and guessing would put a photograph somewhere nobody was.",
        "clockOffset": "The camera's clock was ahead by",
        "clockOffsetUnit": "minutes (negative if it was behind)",
        "takenAt": "taken {{at, datetime(dateStyle: short; timeStyle: short)}}",
        "noTakenAt": "no time on the file",
        "none": "This trip has no photographs yet. Add them to the trip's gallery first.",
        "guessedTitle": "Photographs whose file says nothing about when they were taken: {{count}}",
        "guessedBody": "They will be filed at this moment, which is a guess rather than a reading — check it before attaching.",
        "fallbackMoment": "Moment for photographs with no time of their own",
        "thumbnailAlt": "Photograph of this moment",
        "panelTitle": "Photographs of this trip's moments",
        "panelHint": "Each one is filed at the moment it was taken, not at a report — so correcting a report in place, or deleting one, never takes a photograph with it. The survey model is not needed to add or read them.",
        "panelNone": "No photographs have been hung on this trip's moments yet.",
        "panelAdd": "Add photographs",
        "panelUnavailable": "The trip's photographs could not be read. This says nothing about whether there are any.",
        "aboutParty": "About the party",
        "aboutCaver": "About {{name}}",
        "attachAtReport": "Photograph at this moment",
        "detach": "Take this photograph off the trip",
        "detachConfirm": "Take this photograph off this moment? The photograph itself stays in the trip's gallery.",
        "strayTitle": "Photographs whose file puts them far outside this trip: {{count}}",
        "strayBody": "The first of them says {{at, datetime(dateStyle: short; timeStyle: short)}}, which is usually a camera clock that was never set. They will be attached at the moments shown — correct the clock offset above if that is wrong.",
        "detached": "The photograph was taken off the moment.",
        "detachFailed": "The photograph could not be taken off the moment.",
        "subjectApplyAll": "Choosing here applies to every chosen photograph; one that is about somebody else is changed in the list below.",
        "previewTitle": "Where each will be drawn",
        "previewHint": "Read from the trip's reports at each photograph's moment, on the survey this watch is on. It follows the clock correction and the person chosen.",
        "filedAt": "{{at, datetime(dateStyle: short; timeStyle: medium)}}",
        "rowSubject": "Whom {{title}} is about",
        "willDrawAt": "Drawn at station {{station}}",
        "onOtherSurvey": "They were placed on another survey then — on the timeline only",
        "placeWithheld": "Their place at that moment is not shown to you — on the timeline only",
        "noPlaceThen": "No station had been reported for them by then — on the timeline only",
        "noSurvey": "This trip has no survey you can see it drawn on — on the timeline only",
        "timelineOnly": "On the timeline only — name somebody to place it",
        "placeReading": "Reading the trip's reports…",
        "placeUnread": "The trip's reports could not be read, so where it will be drawn is not known. It can still be attached."
      },
      "events": "Reports",
      "eventsCorrection": "A report written down wrongly is corrected in place — it keeps its place on the log and everything pinned to it. One that should not be there at all is deleted, and can be put back from Removed reports under the log. Either way the log stays what somebody said at a moment.",
      "logReadOnlyTitle": "These positions came from an import and cannot be corrected one by one",
      "logReadOnlyBody": "Tracking was never started for this trip, so a report on its log can be neither corrected nor deleted here. The positions were put on the trip by importing a recording, and they are taken back, all together, by undoing that import under Geodata → Imports.",
      "eventsNone": "Nothing has been reported yet.",
      "eventsNoneForCaver": "Nothing has been reported about this person.",
      "eventsFilterCaver": "Narrow the log to one person",
      "eventsFilterEverybody": "Everybody's reports",
      "eventsOlder": "Show older reports",
      "eventsNewer": "Show newer reports",
      "eventsShown": "Reports shown: {{from}}–{{to}} of {{total}}",
      "eventCorrectedMark": "Corrected",
      "eventCorrectedMarkHelp": "This report was changed after it was first written down.",
      "eventsUnavailable": "The reports could not be read. What is shown here may be out of date, and reports may be missing from it.",
      "eventDelete": "Delete this report",
      "eventDeleteConfirm": "Delete this report? It comes off the log and is kept under Removed reports, below the log, where it can be put back. A report that was only written down wrongly is corrected instead, with Correct beside it.",
      "eventCorrected": "The report has been corrected.",
      "eventEditTitle": "Correct this report",
      "eventEditAbout": "Correct the report about {{name}} of {{when}}",
      "eventEditBeforeArmedTitle": "This moment is before the watch was started",
      "eventEditBeforeArmedBody": "The watch was started on {{armed}}. A report from before that is saved as written — check the day and the hour first.",
      "eventEditSave": "Save the correction",
      "eventEditNoticeTitle": "This changes what the log says happened",
      "eventEditNoticeBody": "The report keeps its place on the log and everything pinned to it, and the replay, the published page and anything else drawn from the log all follow the correction. Use this where a report was written down wrongly; where it should not be there at all, remove it instead.",
      "eventEdit": "Correct",
      "eventDeleted": "The report is off the log.",
      "eventDeleteUndo": "Undo",
      "eventRestored": "The report is back on the log, as it was.",
      "removeReportsOf": {
        "action": "Remove their reports from this trip",
        "actionCounted": "Remove their reports from this trip: {{count}}",
        "confirmTitle": "Remove every report about {{name}} from this trip, for good?",
        "confirmTitleCounted": "Remove every report about {{name}} from this trip, for good? Reports: {{count}}",
        "confirmBody": "This destroys every report this trip's tracking log holds about them — the ones on the log and the ones already taken off it and kept. It cannot be undone, and nothing is left to put back. The replay of this trip and any published page of it will change. What stays: their name on the trip's roster, until the trip is edited; and the trip's history, which records that the reports were removed and keeps what each one said.",
        "confirmOk": "Remove for good",
        "done": "Reports removed for good: {{count}}",
        "failed": "The reports could not be removed."
      },
      "rosterTimes": {
        "open": "Roster times from the log",
        "openHint": "Take each person's entry and exit time from this log onto the trip's roster — after looking at them.",
        "title": "Entry and exit times from the tracking log",
        "intro": "The log has the moment each person was reported going in and coming out. Tick the people whose times on the trip's roster should become those. Nothing is written until you press the button; every time written is recorded in the trip's history.",
        "zone": "Time zone of the roster's times",
        "zoneMine": "My time zone — {{zone}}",
        "zoneHelp": "A time on a roster is a reading of a clock, with no zone of its own. Choose the zone the trip's times are kept in — normally the one the cave is in.",
        "zoneApplied": "Read on the clocks of {{zone}}.",
        "person": "Person",
        "fromLog": "From the log",
        "onRoster": "On the roster now",
        "take": "Take",
        "takeOf": "Take the times of {{name}}",
        "none": "None of their own — the trip's times stand",
        "same": "Already the same",
        "overwrites": "Replaces a time somebody typed",
        "stays": "Went in more than once (stays: {{count}}). The roster keeps the first going in and the last coming out, so the time on the surface in between is counted.",
        "problem": {
          "notOnRoster": "Not on the roster, so there is no row to hold a time. Add them on the trip's form first.",
          "noEntry": "No report says they went in.",
          "noExit": "No report says they came out.",
          "exitBeforeEntry": "The log has them coming out before they went in.",
          "entryOffTripDate": "They went in on a day that is not the trip's first, and a time on a roster has no day of its own.",
          "exitOffTripDate": "They came out on a day the trip's dates do not reach. Correct the trip's dates first.",
          "clockChanged": "The clocks changed while they were underground, so the two times would say an hour more or less than really passed. Type them by hand if they are wanted."
        },
        "write": "Write to the roster: {{count}}",
        "written": "Times written to the roster. People: {{count}}",
        "nothingWritten": "The roster already held those times; nothing was written.",
        "failed": "The times could not be written.",
        "unavailable": "The times could not be read."
      },
      "removed": {
        "title": "Removed reports: {{count}}",
        "help": "Reports taken off this log. They are shown nowhere else — not in the party table, on the survey, in a replay or on a published page — and are kept for as long as the trip exists. A report put back returns exactly as it was, with its place and its moment. One deleted for good cannot be brought back.",
        "removedAt": "Taken off the log: {{when}}",
        "restore": "Put back",
        "destroy": "Delete for good",
        "destroyConfirm": "Delete this report for good? This cannot be undone: nothing brings the report back afterwards.",
        "destroyed": "The report has been deleted for good.",
        "unavailable": "The removed reports could not be read. What is shown here may be out of date."
      },
      "unavailable": "This trip's tracking could not be read.",
      "staleTitle": "This watch has stopped refreshing",
      "staleBody": "The trip could not be re-read just now — the connection may have dropped. Everything below is the last word this tab was given, and it starts refreshing again by itself as soon as it can. Nothing you have selected or typed has been lost.",
      "problems": {
        "notWritable": "Tracking has never been started for this trip, so its log cannot be written to. Start it first; a trip whose tracking has been closed can still be corrected.",
        "notConfigured": "This trip has no watch to import reports onto. Choose a survey and save the tracking setup first; the sheet can be read again straight after.",
        "csvZoneUnknown": "This server does not know that time zone, so the sheet was not read. Choose another name for the same clock under File settings — a nearby city in the same country usually is one.",
        "csvPlanChanged": "Nothing was imported. The trip or its log changed after this sheet was read — a report typed by somebody else, a team or a participant changed, a place declared in the cave — so importing would no longer have done what the table showed. The sheet has been read again: check the rows, tick the overwrite again if it is still wanted, and press Import.",
        "csvSheetUnreadable": "The sheet cannot be read as it stands, so nothing was imported. Read it again here: the findings above the table say what to change.",
        "stateInvalid": "Tracking cannot move that way. Read the page again and see where it stands.",
        "modelMissing": "Tracking needs a survey to place people in. Choose one first.",
        "modelUnavailable": "That survey cannot be used here — it no longer exists, or its cave is one whose exact position you may not be told.",
        "modelOtherCave": "That survey belongs to a different cave. A watch that is armed follows a party in one cave, and its cave is also what protects every position on its log, so it can only be moved to another survey of the same cave. Close the watch first if this trip really is somewhere else.",
        "referenceUnknown": "The survey has no station by that name to measure depths from.",
        "stationUnknown": "The survey has no station by that name.",
        "toStationUnknown": "The survey has no station by the name given for the second station, the far end of the stretch.",
        "stretchSameStation": "Both ends of the stretch are the same station. Choose a different second station, or report at that one station.",
        "reportSubjectFixed": "A report about a person cannot be turned into a note about the cave, nor a note about the cave into a report about a person. Take this one off the log and record the other.",
        "stationReadingOutdated": "That station has no name in the survey file, and this survey was read before such stations could be reported at. Read the survey again — \"Read again\", under \"3D survey models\" on the cave's page — and then report here.",
        "noStationAtDepth": "No station matches that depth under this trip's filter. Widen the filter, or report a station by name.",
        "caverNotParticipant": "Everybody a report is about has to be on the trip's roster first.",
        "recordedInFuture": "A report cannot be about the future. Check the time on it.",
        "teamNotFound": "That team is no longer on this trip.",
        "eventNotFound": "That report is no longer on the log — somebody else may have taken it off.",
        "eventNotRemoved": "That report is on the log again — somebody put it back. Take it off first, then delete it for good.",
        "noReportsOfPerson": "This trip holds no reports about that person any more — somebody else may have removed them.",
        "rosterTimesZoneUnknown": "This server does not know that time zone, so no times were read. Choose another name for the same clock — a nearby city in the same country usually is one.",
        "rosterTimesChanged": "Nothing was written. The log or the roster changed after these times were read — a report corrected, taken off or added, somebody taken off the trip. The times have been read again: look at them, tick again, and press once more.",
        "concurrentWrite": "Somebody else wrote to this tracking at the same moment. The page has been read again; try once more.",
        "tripNotFound": "This trip is no longer there, or is no longer yours to read.",
        "ifMatchRequired": "This page lost track of which version it was changing. It has been read again; try once more.",
        "versionMismatch": "Somebody else changed this tracking while you were working on it. The page has been read again; look at it before saving.",
        "shareNotFound": "That follow link is no longer there — somebody may have taken it back already.",
        "publicationRefusedCave": "Publishing this trip hands over its cave's survey drawing, and that takes the right to share the cave. Ask whoever looks after it.",
        "publicationRefusedProtected": "This trip's cave has protected coordinates, so the trip cannot be published at all. A published page says where the party is inside the cave, and there is no version of that which withholds the position.",
        "publicationNotArmed": "A follow link opens a page only while the watch is running. Arm the watch, then publish the trip.",
        "shareRevoked": "That link has already been taken back, so there is nothing to replace. Publish the trip again instead.",
        "notTracked": "Tracking has never been started for this trip, so it has no moments to hang a photograph on. Start it first; a trip whose tracking has been closed still takes photographs.",
        "pictureInFuture": "A photograph cannot be filed at a moment that has not happened yet. Check the camera's clock offset, or the moment given to photographs with no time of their own.",
        "pictureNotImage": "One of the chosen files is not a picture. Only photographs can be hung on a moment.",
        "pictureAlreadyAttached": "A chosen photograph is already on that moment of the trip, so it was not added again.",
        "pictureRelationMissing": "This installation is missing the kind of link that ties a photograph to a trip's moment, so none can be stored. Tell whoever runs the installation.",
        "pictureNotFound": "That photograph is no longer on this moment — somebody else may have taken it off."
      },
      "publish": {
        "title": "Publish this trip",
        "explain": "A follow link lets somebody with no account watch the party come out: the trip's name, who is on it, where each was last reported, and the survey drawing with everybody on it. A cave whose coordinates are protected cannot be published at all.",
        "namesShown": "This installation publishes real names. Everybody on this trip is named on the page — and in any website block showing it — by the name the roster holds for them, unless somebody has been given a name of their own for this trip's page, which is shown instead.",
        "namesHidden": "Names are not published here. Everybody on this trip appears as a place in the party — Caver 1, Caver 2 — unless somebody has been given a name of their own for this trip's page.",
        "mintedNamesShown": "This address shows the party's real names.",
        "mintedNamesHidden": "This address shows places in the party, not people's names.",
        "mint": "Create a follow link",
        "mintedTitle": "The follow link is ready",
        "tokenOnce": "Copy it now — this is the only time it is shown.",
        "linkLabel": "The address to hand out",
        "linkCopied": "Follow link copied.",
        "copy": "Copy",
        "embedLabel": "For a website",
        "embedHelp": "Paste this into a page on your own site to show the survey drawing there. It resizes itself to whatever column it is in. Links in the surrounding text can drive it — the block explains how. Your site must also be named in this installation's embedding setting, or a browser will refuse to show the frame.",
        "copyEmbed": "Copy the website block",
        "embedCopied": "Website block copied.",
        "copyFailed": "This browser would not let the page write to the clipboard. The text is selected — copy it by hand.",
        "none": "This trip is not published. Nobody can follow it without an account.",
        "statusActive": "Live",
        "statusDormant": "Not open",
        "dormantUntil": "This link opens nothing at the moment. The page answers while the watch is running — and through any grace period this installation keeps after its closing — and only while the trip’s cave may be published — if that changes back, this link works again until {{when}}.",
        "createdAt": "Created {{when}}",
        "revoke": "Take it back",
        "revokeConfirm": "Take this follow link back? Anybody holding it stops being able to open the page.",
        "revoked": "The follow link has been taken back.",
        "listUnavailable": "This trip's follow links could not be read.",
        "expiresAt": "Works until {{when}}",
        "ends": "A follow link stops following on its own: when the watch is closed — or, where this installation keeps a grace period after closing, when that has run out, the page saying meanwhile that the trip is over — and in any case on the date below. That ends the following, not the publication: unless past trips are switched off for this installation, the same address goes on opening this trip among its cave’s past trips — the party with it — until the link is taken back. Taking it back ends both at once.",
        "mintedExpires": "This address stops following the party on {{when}}, or sooner: once you have closed the watch (and any grace period this installation keeps after closing has run out). Unless past trips are switched off here, it then still opens this trip among its cave’s past trips until you take it back.",
        "tellsParty": "Everybody on this trip who has an account is told that it has been published.",
        "languageLabel": "Language the page opens in",
        "languageDefault": "None named",
        "languageHelp": "An address that names no language opens in Romanian, or in whatever its reader chose on this site before. Naming one here rewrites the address and the website block below — nothing new is created, the same link answers either way, and the reader can still change the language on the page. An installation that has switched the published pages' language choice off ignores a language in the address: there, leave this on the first option.",
        "replace": "Replace link",
        "replaceConfirm": "Replace this follow link? The old address stops answering at once, wherever it has been pasted. A fresh one is shown here, once; it runs out when the old one would have, and nobody on the trip is told.",
        "replacedTitle": "The new address is ready",
        "replacedOnce": "Copy it now — this is the only time it is shown. The old address no longer answers.",
        "boundsWarning": "A protected cave, or one of its entrances, stands inside the area this trip's survey covers. This is a check by position only and cannot see inside the survey file — the survey may not enter that cave at all. Nothing was refused: look at the survey, and take the link back if it shows what should not be published.",
        "statusRanOut": "Run out",
        "ranOutAt": "Ran out {{when}}. It follows nobody any more — but while nobody takes it back, it can still keep this trip among its cave’s past trips, and its address still opens them.",
        "revokeRanOutConfirm": "Take this follow link back? It already follows nobody. Taking it back also removes this trip from its cave’s past trips, unless another link of the trip still stands."
      },
      "published": {
        "title": "This trip is published",
        "since": "Since {{when}}, anybody holding the link can open a page about this trip without an account. It shows who was on the trip, what the page calls each of them, and where each was last reported.",
        "until": "The link stops following the party on {{when}}, or sooner: once the watch is closed (and any grace period this installation keeps after closing has run out). Unless past trips are switched off here, it then still opens this trip among its cave’s past trips until it is taken back.",
        "whereToLook": "The list below shows what the page calls each person on this trip, including you. A caption set on somebody is what the page prints for them instead."
      },
      "publicName": {
        "column": "On the public page",
        "columnExplain": "The caption beside a name is what a follow link shows instead — it replaces that person's name on the public page and in any website block showing it, and it outranks the setting above in both directions. Nothing else changes: every screen here still calls them by their own name.",
        "settingRealNames": "This installation publishes real names.",
        "settingPlaces": "This installation publishes places in the party — Caver 1, Caver 2 — and no names.",
        "placeInParty": "A place in the party",
        "captionDetail": "A caption set for this trip. The public page uses it instead of this person's name, whichever way this installation's name setting stands.",
        "realNameDetail": "No caption is set and this installation publishes names, so the public page names this person. A caption is what keeps their name off it. The page prints the name on the club's roster, which can differ from the name shown here where an account has chosen its own display name.",
        "placeInPartyDetail": "No caption is set and this installation publishes no names, so the public page calls this person Caver 1, Caver 2 and so on. A caption is what makes it name them.",
        "edit": "Set what the public page calls this person",
        "title": "What the public page calls {{name}}",
        "explain": "A caption is what a follow link shows instead of this person's name — on the page itself and in any website block showing it. Nothing else changes: this tab, the log and every other screen here still call them by their own name.",
        "outranks": "It outranks this installation's setting in both directions: a caption keeps somebody off a page that would otherwise name them, and names somebody on a page that would otherwise call them by a number. A setting changed afterwards cannot undo it.",
        "fieldLabel": "Caption",
        "placeholder": "What the public page should call them",
        "emptyClears": "Leave it empty and save to take the caption off again.",
        "clear": "Take the caption off",
        "saved": "The public page will use that caption.",
        "cleared": "The caption is off. The public page goes back to what this installation publishes.",
        "asCaption": "The public page will call them “{{caption}}”.",
        "asRealName": "The public page will call them {{name}}.",
        "asPlaceInParty": "The public page will call them by their place in the party — Caver 1, Caver 2 — and not by name.",
        "rosterName": "The names here are the ones this application uses. The public page prints the name on the club's roster instead, which differs wherever somebody's account has chosen its own display name — set a caption where it has to be exact."
      },
      "refusedTitle": "This watch will not be read again",
      "refusedBody": "{{reason}} Everything below is the last word this tab was given, and nothing will refresh it — open the trip again once that has been put right.",
      "refusedSignedOut": "You are no longer signed in, so this trip cannot be read again. Sign in and open it afresh.",
      "refusedUnknown": "The server would not answer for this trip. It may no longer be there, or no longer yours to read.",
      "csvExport": {
        "download": "Download the log (CSV)",
        "hint": "The whole log as the sheet the import reads, oldest report first: correct it in a spreadsheet and import it again. A place you may not be told is left out, and its row is marked so that it cannot be imported."
      },
      "csvImport": {
        "open": "Import a sheet",
        "title": "Import reports from a spreadsheet",
        "help": "A coordinator's sheet — a line per phone call, with a time, who it was about and how deep they were — read onto this trip's log. Reading it writes nothing: what you get back is exactly what importing would do. Each report is filed under the person and the moment, so a corrected sheet imported again changes the rows it corrected rather than doubling them. A time written without a zone is filed as UTC, exactly as written: a sheet's 14:30 becomes 14:30 UTC, which this page then shows in your own zone. To have it read on the clock it was written by instead, name the sheet's time zone under File settings, or write the offset in the cell (2026-09-12T14:30+03:00).",
        "choose": "Choose a CSV file, or drop one here",
        "source": "Where the sheet comes from",
        "sourceFile": "A file",
        "sourcePaste": "Pasted rows",
        "pasteLabel": "The sheet's rows, header row first",
        "pastePlaceholder": "Select the rows in your spreadsheet — the header row included — copy them, and paste them here.",
        "pasteFromClipboard": "Paste from the clipboard",
        "pasteUnavailable": "The browser would not hand over the clipboard. Paste into the box by hand instead.",
        "pastedAs": "columns separated by {{delimiter}}",
        "template": "Download a sample sheet",
        "look": "Read it",
        "commit": "Import",
        "columns": "Column settings",
        "columnsHelp": "Every column is detected from its header. Point a field at a header only where the detection got it wrong — read the sheet once first, so the headers are there to choose from.",
        "detected": "Detected",
        "shape": "File settings",
        "shapeHelp": "How the file was saved. Each is worked out from the file itself and shown here; change one only where the reading below says it was wrong.",
        "encoding": "Characters",
        "encodingAuto": "Detected",
        "readAs": "read as {{encoding}}, columns separated by {{delimiter}}",
        "encodings": {
          "utf-8": "UTF-8",
          "windows-1250": "Windows-1250, Central European",
          "iso-8859-2": "ISO-8859-2, Latin-2"
        },
        "delimiter": "Column separator",
        "delimiterAuto": "Detected",
        "delimiters": {
          "comma": "Comma",
          "semicolon": "Semicolon",
          "tab": "Tab"
        },
        "dateOrder": "Day and month",
        "dateOrderAuto": "From the file's own dates",
        "dateOrderDayFirst": "Day first (12.09.2026)",
        "dateOrderMonthFirst": "Month first (09/12/2026)",
        "zone": "Sheet's time zone",
        "zoneAsWritten": "Exactly as written (UTC)",
        "zoneMine": "My time zone — {{zone}}",
        "zoneHelp": "Whose clock the sheet's times were read off. A time that writes its own offset is read as it says, whatever is chosen here.",
        "depthsBelow": "Every depth is below the entrance",
        "depthsBelowHelp": "Tick where the sheet writes depths as plain numbers, or mixes −40 with 40: each is then read as metres below the entrance. Leave it unticked for a cave with passages above its entrance, where −40 is a different place from 40.",
        "sheetDayTitle": "This sheet writes times with no dates",
        "sheetDay": "The day the sheet was kept on",
        "sheetDayHelp": "Every time that has no date of its own is put on this day. Check it, then read the sheet again.",
        "fields": {
          "RecordedAt": "When",
          "Date": "Date only",
          "Time": "Time only",
          "Depth": "Depth",
          "Station": "Station",
          "ToStation": "Second station (a stretch)",
          "Place": "Place",
          "Cavers": "People",
          "Team": "Team",
          "Note": "Note",
          "Details": "More details",
          "State": "Went in / came out"
        },
        "wentInWords": "Words for going in",
        "cameOutWords": "Words for coming out",
        "wentInPlaceholder": "went in, entered",
        "cameOutPlaceholder": "went out, exited",
        "notedWords": "Words for a note",
        "notedPlaceholder": "note",
        "stateWordsHelp": "Words separated by commas. Words written here replace the usual ones for that side, so write every word the sheet uses for it. Capitals and diacritics are ignored: ieșire and iesire are the same word.",
        "rowsRead": "Rows read",
        "creates": "New reports",
        "replaces": "Already on the log",
        "line": "Line",
        "moment": "When",
        "caver": "Person",
        "writtenAs": "written as {{written}}",
        "place": "Place",
        "outcome": "Outcome",
        "findings": "Findings",
        "momentsRule": "Times written without a zone were read as UTC. Dates were read {{order}}.",
        "momentsRuleZone": "Times written without a zone were read on the clocks of {{zone}}, and are shown below as those clocks showed them. Dates were read {{order}}.",
        "momentsOnDay": "Times with no date were put on {{day}}.",
        "datesDayFirst": "day first (12.09.2026)",
        "datesMonthFirst": "month first (09/12/2026)",
        "datesByFile": "The file's own dates settle it.",
        "datesByDefault": "No date in the file settles it, so the usual reading was used; if that is wrong, choose the other under File settings and read the sheet again.",
        "datesByChoice": "No date in the file settles it, so the choice under File settings was used.",
        "datesConflict": "The file writes dates both ways round, so one reading was applied to every row; choose which under File settings.",
        "chooseRowsHelp": "Only the ticked rows are imported. A line of the sheet naming several people is taken or left out whole.",
        "chooseRow": "Import line {{line}}",
        "willCreate": "New",
        "willReplace": "Replaces",
        "writtenAsHint": "The written name is shown beside the matched one wherever they differ.",
        "unmatchedTitle": "Some names answer to nobody on this trip",
        "unmatchedBody": "Their reports will be left out. Add the people to the trip's roster first, or correct the spelling in the sheet.",
        "unmappedTitle": "Columns nothing claimed",
        "replaceExisting": "Overwrite what the log already holds at these moments (reports to overwrite: {{count}})",
        "problems": "Findings worth reading: {{count}}",
        "atLine": "Line {{line}}",
        "problemNames": {
          "UnterminatedQuote": "A quotation mark was opened and never closed, so the rest of the file was swallowed into one cell.",
          "NoHeader": "The file has no rows, so there is no header to read.",
          "TooManyColumns": "More columns than a sheet plausibly has — this is probably not the file you meant.",
          "NamedColumnMissing": "You pointed a field at a header the file does not have.",
          "UnmappedColumn": "Nothing claimed this column. A misspelled header is otherwise silent.",
          "MomentColumnMissing": "No column carries the time, without which no row can be placed.",
          "CaverColumnMissing": "No column carries the people, so no row is about anybody.",
          "TimeColumnNeedsADay": "The sheet writes its times with no dates, so they cannot be placed until the day the sheet was kept on is named.",
          "MomentUnreadable": "Something is written where the time should be, and it is not a time.",
          "MomentWithoutTime": "A date with no time cannot place a report; filed at midnight, a whole day's reports would collapse onto one moment.",
          "MomentSkippedByClockChange": "This time never existed in the sheet's time zone — the clocks went forward over it. Correct the cell, or write its offset beside the time (for example +02:00).",
          "MomentRepeatedByClockChange": "This time happened twice in the sheet's time zone — the clocks went back over it. It was read as the first of the two; if the second was meant, write its offset beside the time (for example +02:00).",
          "MomentWithoutDate": "A time with no date. The date is not carried down from the row above — write it on this row.",
          "MomentMissing": "The time cell is empty.",
          "RaggedRow": "The row is not as wide as the header; it was lined up with it and read anyway.",
          "NoCavers": "The row names nobody.",
          "NoPlaceAndNoState": "The row says neither where anybody is nor that they went in or came out.",
          "DepthUnreadable": "The depth is not a number.",
          "DepthOutOfRange": "That is a number, but not a depth any cave has.",
          "StateWordUnknown": "This row's place was kept back from whoever wrote the sheet out, and the sheet marks it with this word. It is not read as going in, coming out or what the party was doing.",
          "NoteTooLong": "The note is longer than a report may carry (2000 characters, note and details together). Shorten it in the sheet.",
          "StateOverridesPlace": "The row says somebody went in or came out and also names a place inside; going in and coming out claim no station, so the place was dropped.",
          "CaverNotOnRoster": "Nobody on this trip answers to that name.",
          "CaverAmbiguous": "More than one person on this trip answers to that name, and only you can say which.",
          "TeamNotOnTrip": "That is not one of this trip's teams, so the report was kept without a team.",
          "TeamAmbiguous": "More than one of this trip's teams has that name, so which one is meant cannot be decided. A report already in the log keeps the team it has; a new one is made without a team.",
          "PlaceLabelUnknown": "The cave has declared no place by that name.",
          "PlaceLabelAmbiguous": "Two of the cave's declarations share that name, so which station is meant cannot be decided.",
          "StationNotInModel": "The station is not one of the survey this watch is on.",
          "ToStationNotInModel": "The second station, the far end of the stretch, is not one of the survey this watch is on.",
          "StretchSameStation": "The row names the same station as both ends of a stretch.",
          "ToStationWithoutStation": "The row names a second station and no station for the stretch to start from.",
          "DepthReferenceUnknown": "The survey has no datum to measure a depth from.",
          "NoStationAtDepth": "No station the trip's depth filter allows is at that depth.",
          "ModelMissing": "This watch has no survey, so no row claiming a place can be placed.",
          "DuplicateInFile": "Another row of this file is the same report — same person, same moment.",
          "MomentInFuture": "A report cannot be about the future.",
          "ClockRunsBackwards": "This time is earlier than one further up the sheet (the line shown), and both were read on the one day named for the sheet. If the sheet ran past midnight this row belongs to the next day: leave it out, or give the sheet a date column.",
          "AlreadyRecorded": "The log already holds this report, and overwriting was not allowed.",
          "AlreadyRecordedSeveralTimes": "The log holds more than one report for this person at this moment, so which one the row corrects cannot be decided. Settle it on the tracking tab first.",
          "DateOrderConflict": "The file's dates argue both ways about which number is the day; the reading shown was chosen for the whole file."
        },
        "done": "{{created}} recorded, {{updated}} corrected, {{unchanged}} already as the sheet says, {{skipped}} left out.",
        "placeNamed": "{{label}} → {{station}}",
        "noteQuoted": "“{{note}}”",
        "beforeLabel": "In the log now:",
        "afterLabel": "After the import:",
        "deskTask": "A sheet is a desk task: it is for writing a trip up from notes, read whole, checked row by row and then written in one go. For a report that comes in while the party is underground, use the report form on the trip — it takes one report at a time and overwrites nothing.",
        "planChangedTitle": "The trip changed while this sheet was being checked"
      }
    },
    "checklistNone": "This trip works through no checklist you can see.",
    "checklistReadiness": "{{ticked}} of {{total}} settled",
    "checklistAdvisory": "This is a reading for the party, not a rule. Nothing is refused because a line is unsettled, and how settled a trip is never changes who may read it.",
    "checklistTickedAt": "Confirmed {{when}}",
    "checklistTickFailed": "That confirmation could not be recorded.",
    "empty": "No trips yet.",
    "emptyFiltered": "No trips match this filter.",
    "listFailed": "The trips could not be loaded.",
    "filters": {
      "showing": "Showing {{matching}} of {{overall}} trips you can read",
      "reset": "Clear filters",
      "yourAccess": "Counts are of trips you can read",
      "moreParticipants": "More people than this list offers went on these trips. Narrow the other filters to reach them.",
      "moreAreas": "More areas than this list offers were reached on these trips. Narrow the other filters to reach them.",
      "incident": "Incident",
      "incidentYes": "Something went wrong",
      "incidentNo": "Nothing went wrong",
      "participant": "Person",
      "area": "Area",
      "fromDate": "Trips from",
      "toDate": "Trips until",
      "showOnMap": "Show on map"
    },
    "grouping": {
      "groupBy": "Group by",
      "thenBy": "then by",
      "trips": "Trips",
      "span": "Days",
      "topTypes": "Mostly",
      "topPeople": "Who",
      "unassigned": "Not recorded",
      "empty": "Nothing to group",
      "overlapping": "A trip counts into every value it holds, so these add up to more than the {{count}} trips shown.",
      "truncated": "Grouped over the first {{count}} trips the filter matched. Narrow the filter to shape the rest.",
      "dimensions": {
        "none": "Nothing",
        "year": "Year",
        "type": "Purpose",
        "state": "State",
        "visibility": "Audience",
        "incident": "Incident",
        "area": "Area",
        "participant": "Person"
      }
    }
  },
  "expeditions": {
    "notFound": "No such camp",
    "notFoundDetail": "Either it is not there, or it is not yours to read. This page cannot tell the two apart, and does not try.",
    "title": "Camps",
    "searchPlaceholder": "Search camps",
    "nameField": "Name",
    "state": "State",
    "stateFilter": "Any state",
    "date": "Day",
    "dates": "Days",
    "cavingGroup": "Organising club",
    "tabTrips": "Trips",
    "tabWatch": "Who is underground",
    "tabMap": "Map",
    "tabLeads": "Leads",
    "tabRoster": "Who was there",
    "tabFiles": "Files",
    "tabHistory": "History",
    "rosterPeople": "People at this camp: {{count}} — counted once each, however many roles they are recorded under.",
    "rosterEmpty": "Nobody has been recorded as having been at this camp yet.",
    "rosterWithheld": "Who was at this camp is not shown to you",
    "rosterWithheldDetail": "You may read this camp, but not the people in this installation — so the names, the days and how many there were are withheld together. Showing the stays with the names struck out would still say how many people were there and when.",
    "rosterUnavailable": "Who was at this camp could not be read just now.",
    "stay": {
      "add": "Add a stay",
      "edit": "Edit stay",
      "remove": "Remove stay",
      "removeConfirm": "Remove this stay of {{name}}? Only the record that they were at this camp for these days goes — the person stays in the list of cavers.",
      "hint": "One stay is one person in one role, for one stretch of days. Somebody who cooked and also surveyed is two stays, and so is somebody who left and came back.",
      "person": "Who",
      "personPlaceholder": "Somebody from the list of cavers, or a new name",
      "personRequired": "Say who was there",
      "role": "Role",
      "roleRequired": "Choose a role",
      "daysHint": "The first and the last day they were there. For a single day, pick it twice.",
      "daysRequired": "Pick the first and the last day, or tick “still there”.",
      "firstDay": "First day",
      "lastDay": "Last day",
      "stillThere": "Still there",
      "stillThereChoice": "Still there — they have not left yet",
      "since": "from {{date}}, still there",
      "note": "Note",
      "notePlaceholder": "Arrived late, left early, came back…",
      "personGone": "That person is no longer in the list of cavers. Choose them again, or type their name."
    },
    "mapEmpty": "Nothing to draw for this camp: it has no working area, and none of the trips you may read left a sketch or named a cave you may place.",
    "mapCaveat": "Drawn over the trips you may read. The working area is the shape somebody drew on the plan; a trip's sketch is shown exactly as drawn, whatever protection the caves it names carry; and a cave entrance appears only where you may see its exact position.",
    "mapTruncated": "This camp names more cave entrances than one map can carry, so not every entrance is drawn.",
    "noTripsVisible": "No trips in this camp that you may read.",
    "tripsTruncated": "Showing {{shown}} of {{total}} trips.",
    "watch": {
      "intro": "Who is underground on this camp's trips, as each trip's own tracking tells it — counted over the trips you may read. It records what was reported: it watches no clock and raises no alarm.",
      "empty": "No trip of this camp is being tracked, and none had its tracking closed recently — or none you may read. A trip appears here once tracking is started on its Tracking tab, and stays for a while after tracking is closed.",
      "unavailable": "The head count could not be read.",
      "truncated": "This camp has more tracked trips than this list shows. Trips being tracked now come first; the ones left off are those whose tracking was closed longest ago.",
      "expectedReturn": "Expected back",
      "neverHeard": "no word yet",
      "closedAt": "Closed",
      "partyEmpty": "Nobody is on this trip's list.",
      "unnamed": "Unnamed person",
      "openTracking": "Open this trip's tracking"
    },
    "albums": "Albums about this camp",
    "noAlbums": "No albums about this camp yet.",
    "rosterRoleValues": {
      "member": "Member",
      "organiser": "Organiser",
      "cook": "Cook",
      "base_camp": "Base camp",
      "driver": "Driver",
      "medic": "Medic",
      "equipment": "Equipment",
      "guest": "Guest"
    },
    "leadsCount": "Leads on this board: {{count}} — counted once each, however many of this camp's trips named them.",
    "leadsEmpty": "This camp's trips left nothing open — or nothing you may be shown.",
    "leadsAsVisible": "Read as visible to you: leads found on trips you may read, and only the ones you may be told the place of.",
    "leadsUnavailable": "The leads could not be read.",
    "leadsTruncated": "This camp has more leads than the board shows.",
    "leadUnnamed": "Unnamed lead",
    "leadGrade": "Promise {{grade}}",
    "leadStateUnrecorded": "Not recorded",
    "leadStates": {
      "open": "Open",
      "checked": "Checked",
      "dead-end": "Dead end",
      "continues": "Continues"
    },
    "new": "New camp",
    "edit": "Edit camp",
    "publicNote": "Note for readers of published trips",
    "publicNoteHint": "Said above the figures a page works out from this camp's published trips — for example how far they are to be trusted while the records are still being completed. Unlike the description, it is read by people with no account: everybody who can open a published trip of this camp.",
    "workingArea": "Working area",
    "workingAreaHint": "Roughly where the camp works: the shape drawn on the plan, not a position anybody navigates by, and not derived from the caves the camp's trips reach.",
    "workingAreaWarning": "Shown exactly to everybody who may read the camp.",
    "workingAreaWarningDetail": "The working area carries no location protection — it is the shape somebody drew on the plan. Draw it roughly, and never tightly around an entrance that must stay protected.",
    "publishConfirm": "Announce this camp? Nobody is notified by this; it marks the camp as announced. Who may read it does not change: it stays readable by {{audience}}. Widening that is a separate edit.",
    "publishSuccess": "Announced.",
    "callOff": "Call it off",
    "callOffConfirm": "Call this camp off? It is kept, and it can be reinstated as a draft.",
    "deleteConfirm": "Delete this camp? The trips it gathered stay; the camp goes, with its own rules and any write-up saved to it.",
    "draftNotice": "This is a draft. It has not been announced yet — announce it when the plan is settled, or record it as done once it has happened.",
    "sharing": {
      "title": "Share the camp",
      "button": "Share",
      "intro": "Sharing a camp writes one rule onto each trip it gathers, marked as the camp's, so whoever it is shared with can read what the camp gathered. Each trip answers for itself: the camp is shared on every trip whose permissions you may manage, and the others are skipped and listed. A trip that joins the camp later is not covered until the sharing is applied again.",
      "memberTrips": "Trips in this camp: {{count}}.",
      "notAllowed": "You cannot share this camp.",
      "empty": "This camp is not shared with anybody yet.",
      "actions": "Rights",
      "coverage": "Trips covered",
      "covered": "{{trips}} of {{total}}",
      "behind": "Not every trip",
      "behindHint": "Not every trip in this camp carries its sharing. Some joined after it was last applied; others were skipped because whoever applied it could not manage their permissions. Apply the sharing again to cover the ones you may.",
      "addTitle": "Share with somebody else",
      "apply": "Apply sharing",
      "applyHint": "Writes these rules onto every trip in the camp whose permissions you may manage, and lists the ones it skipped. Rules already applied are kept; nothing is removed.",
      "applied": "The camp is shared.",
      "reapply": "Apply again",
      "reapplied": "The sharing now covers every trip in the camp.",
      "withdraw": "Withdraw sharing",
      "withdrawConfirm": "Withdraw this camp's sharing from every trip it gathers? Rules written on a trip's own permissions tab are kept.",
      "withdrawn": "The camp's sharing was withdrawn.",
      "incomplete": "Not shared: you may not manage the permissions of any of this camp's trips ({{count}}), or you asked to pass on more than you hold on them. Their owners have to let you manage their permissions first.",
      "noTrips": "This camp gathers no trips yet, so there is nothing to share.",
      "nothingShared": "This camp shares nothing to apply again.",
      "inPart": "Trips shared: {{shared}} of {{total}}. The rest were skipped — they are listed in this dialog.",
      "skippedTitle": "Trips shared: {{shared}}. Trips skipped: {{skipped}}.",
      "skippedReason": {
        "notAdministered": "its owner must let you manage its permissions",
        "beyondHolding": "you asked to pass on more than you hold on this trip yourself"
      },
      "skippedNotNamed": "Skipped trips that you may not read, and that are therefore not named here: {{count}}. Their owners must let you manage their permissions.",
      "skippedHint": "Nothing was written onto a skipped trip. Apply the sharing again once that has changed, and it will be picked up."
    },
    "report": {
      "open": "Write-up",
      "backToCamp": "Back to the camp",
      "keep": "Save to the camp",
      "kept": "The document was filed against the camp.",
      "keepAudience": "The copy saved to the camp can be opened by everybody who may read the camp, so it is built from what any account may see of its trips. Your own fuller copy is the download.",
      "audienceNotice": "This write-up shows what you may see. Somebody else reading the same camp may see more, or less: the trips in it, the people, the pictures.",
      "account": "About the camp",
      "trips": "The trips",
      "accounts": "What each trip wrote",
      "accountsVisibleToYou": "What each trip wrote about itself, for the trips in this camp you may read. Somebody else may see more of them, or more of what one of them wrote.",
      "whoWasThere": "Who was there",
      "areaPoint": "Working area: a point at {{position}}.",
      "areaShape": "Working area: {{shape}}, {{count}} points, centred on {{position}}."
    },
    "tabPhotos": "Photographs",
    "noPhotographs": "No photographs are filed against this camp or the trips in it that you may read.",
    "galleryVisibleToYou": "The photographs you may see, from the camp and the trips in it you may read. Somebody else may see more, or fewer."
  },
  "tags": {
    "title": "Tags",
    "add": "Add tag",
    "filterPlaceholder": "Filter by tag…"
  },
  "audit": {
    "title": "Audit trail",
    "at": "When",
    "user": "User",
    "action": "Action",
    "entityType": "Entity",
    "entityId": "Entity id",
    "entityTypePlaceholder": "Filter by entity type (e.g. Cave)…"
  },
  "history": {
    "title": "History",
    "empty": "No changes recorded yet.",
    "hidden": "Value hidden (protected location)",
    "geometrySummary": "Geometry of {{points}} points (too large to record in full)",
    "systemUser": "System",
    "restoreField": "Restore this value",
    "restoreAll": "Restore all values from before this change",
    "restored": "Value restored.",
    "restoredPartly_one": "{{count}} value was put back. Some were left as they are:",
    "restoredPartly": "{{count}} values were put back. Some were left as they are:",
    "restoredNothing": "Nothing was put back:",
    "openBatch": "View this import",
    "changesInSet_one": "{{count}} change",
    "changesInSet": "{{count}} changes",
    "source": {
      "web": "Edited in the browser",
      "fileImport": "File import",
      "deviceSync": "Phone upload",
      "speleolocArchive": "Phone archive import",
      "restore": "Restored from history",
      "undo": "Undo",
      "reviewDecision": "Review decision",
      "job": "Background job",
      "tripConversion": "Trip converted from a recording"
    },
    "skipReason": {
      "not_restorable": "history cannot put this one back",
      "redacted": "its earlier value is hidden from you because the location is protected",
      "no_pre_image": "the earlier shape was not kept, because this change was recorded before large shapes were saved in full",
      "forbidden": "you may edit this feature, but not its position, altitude or quality",
      "superseded": "it has been changed since"
    },
    "action": {
      "created": "Created",
      "updated": "Updated",
      "deleted": "Deleted"
    },
    "entity": {
      "Cave": "Cave",
      "CaveEntrance": "Entrance",
      "SurfaceFeature": "Surface feature",
      "TripLog": "Trip report",
      "CaveCenterline": "Centerline",
      "SurveyModel": "Survey model",
      "Attachment": "Attachment",
      "Tagging": "Tag",
      "TripLogParticipant": "Participant",
      "Expedition": "Expedition",
      "ExpeditionTrip": "Expedition trip",
      "ExpeditionRosterEntry": "Roster entry",
      "TripInvitation": "Invitation",
      "Event": "Event"
    },
    "rosterTimes": {
      "written": "Entry and exit times on the roster were taken from the tracking log.",
      "people": "People: {{n}}",
      "rows": "Roster rows: {{n}}",
      "zone": "Read on the clocks of {{zone}}."
    },
    "field": {
      "name": "Name",
      "description": "Description",
      "geom": "Location",
      "altitude": "Altitude",
      "positionQuality": "Position quality",
      "closestAddress": "Closest address",
      "landRegistryNumber": "Land registry number",
      "locationNotes": "Location notes",
      "caveId": "Linked cave",
      "visibility": "Visibility",
      "caption": "Caption",
      "title": "Title",
      "file": "File",
      "role": "Role",
      "sortOrder": "Position among the files"
    },
    "changesOf": "Changes made {{when}}"
  },
  "cavingGroups": {
    "title": "Caving groups",
    "new": "New caving group",
    "name": "Name",
    "type": "Type",
    "types": {
      "cavingClub": "Caving club",
      "group": "Group",
      "organization": "Organization"
    },
    "members": "Members",
    "manage": "Manage",
    "addMember": "Add",
    "removeConfirm": "Remove this member?",
    "announce": {
      "open": "Announce",
      "title": "Announce to {{name}}",
      "message": "Announcement",
      "placeholder": "One line — a change of time, a meeting place, a closure.",
      "reaches": "People this reaches: {{people}}",
      "reachesHint": "Members without an account are not counted, and you are never sent your own announcement. Each of the others receives it the way they chose to be told things.",
      "nobody": "Nobody on this roster holds an account, so there is nobody to tell.",
      "confirm": "This goes now to the people counted above. It cannot be taken back.",
      "send": "Send",
      "done": "Sent. People told: {{people}}",
      "queued": "Being sent — this club is large enough that the notices are written in the background. People to be told: {{people}}",
      "failed": "The announcement was not sent. Please try again."
    },
    "roles": {
      "member": "Member",
      "admin": "Admin",
      "owner": "Owner"
    }
  },
  "cavers": {
    "title": "Cavers",
    "new": "New caver",
    "edit": "Edit caver",
    "name": "Name",
    "shortName": "Short name",
    "shortNameHint": "What the party calls them — the name a surface log is written in. Shown on published trips in place of the full name, and matched when a sheet of reports is imported.",
    "email": "Email",
    "phone": "Phone",
    "notes": "Notes",
    "notesHint": "Only people who keep the roster can read these.",
    "search": "Search by name…",
    "pick": "Find a caver…",
    "noAccount": "No account",
    "cavingGroups": "Caving groups",
    "cavingGroupsHint": "The groups this person belongs to. They join as an ordinary member; who runs a group is set on the group's own page.",
    "cavingGroupsWarningTitle": "This changes what the person's account may do",
    "cavingGroupsWarning": "Belonging to a group is what gives a person's account the group's rights: its members read and edit what the group shares and see the exact position of the caves it protects, and they are told when they are added. Taking somebody out takes those rights away at once. Nothing recorded about them — trips, hours, reports — is changed.",
    "cavingGroupsRefused": "The person was saved, but these groups could not be changed: {{names}}. Changing who is in a group takes the right to edit that group.",
    "phoneUsers": "Phone users",
    "merge": "Merge",
    "mergeInto": "Merge into {{name}}",
    "mergeHint": "Pick the duplicate entry to fold in. Their trips and caving groups move across, and the duplicate is removed.",
    "deleteConfirm": "Remove this person from the roster?",
    "deleteRefused": "This person could not be removed.",
    "deleteRefusedCamp": "This person is on a camp's roster and cannot be removed while they are. If this is a duplicate entry, merge it instead.",
    "rosterProblems": {
      "grantsFullAdmin": "Only a full administrator can do this: it would make this person's account a full administrator.",
      "revokesFullAdmin": "Only a full administrator can do this: it would take full administration away from an account.",
      "exceedsOwnRights": "You cannot do this: it would give this person's account rights you do not hold yourself.",
      "memberRaced": "Somebody else added this person to the group at the same moment. Reload the group and try again.",
      "lastFullAdmin": "This would leave the installation without a full administrator who can sign in."
    },
    "heldByTrips": {
      "title": "{{name}} cannot be removed yet",
      "intro": "Trips still name this person, so their entry cannot be removed. Each trip below says what holds them there.",
      "onRoster": "On the roster",
      "onRosterHelp": "Open the trip and take them off its roster.",
      "reports": "Tracking reports: {{count}}",
      "notRemovable": "Their reports cannot be removed from here: that takes the right to edit this trip, and a tracking log that has been started.",
      "elsewhere": "Something not shown here also holds this person — a trip you cannot open, a deleted trip, or more trips than this list names. Ask an administrator.",
      "nothingLeft": "Nothing listed here holds this person any more.",
      "deleteNow": "Remove this person",
      "deleted": "{{name}} has been removed from the roster.",
      "stillHeld": "Something still holds this person. The list has been read again.",
      "merge": "Merge a duplicate instead",
      "mergeHint": "If this is a second entry for somebody the roster already has, merge it instead: its trips and reports move to the entry that stays."
    },
    "picker": {
      "picked": "From the list of cavers.",
      "typed": "Not chosen from the list, so it is saved as a name: it means whoever the list of cavers already holds under exactly this name, and adds them if nobody is."
    }
  },
  "recordings": {
    "title": "Phone recordings",
    "intro": "Trips recorded with the SpeleoLoc app in this cave. A recording is what a phone saw, not yet the club's trip report: it is turned into a report on its own when it is closed and nothing in it is in doubt, and waits here for a person when it is not.",
    "columns": {
      "recording": "Recording",
      "started": "Started",
      "scans": "Scans",
      "standing": "State"
    },
    "scanCount": "{{count}}",
    "stillOpen": "Still open on the phone",
    "standing": {
      "waiting": "Waiting",
      "converted": "Made into a trip",
      "needsAttention": "Needs attention"
    },
    "standingHint": {
      "waiting": "No trip report has been made from this recording yet. A recording still open on the phone waits for the phone to close it; one the installation was told not to convert with problems waits for you.",
      "converted": "Made into a trip report.",
      "needsAttention": "Made into a trip report that somebody still has to look at."
    },
    "openTrip": "Open the trip",
    "convert": "Convert to a trip",
    "convertHint": "Opens the review of this recording, where you choose the survey and the trip it goes onto and settle each scan."
  },
  "tripAttention": {
    "title": "This trip was made from a phone recording and needs somebody to look at it",
    "titleCleared": "This trip was made from a phone recording that needed looking at",
    "intro": "The trip was made automatically. What follows could not be settled on its own, so the trip may be missing positions or people. Fix what you can with the tools that already exist, then say you are done.",
    "clearedAt": "Marked as resolved on {{when}}. The reasons stay here for whoever looks next.",
    "reasons": {
      "place_unknown": "scans at no place, or at a place this installation no longer holds as a marked place",
      "unresolved_station": "scans whose place does not give one single survey station",
      "unmapped_person": "scans by a phone user who is not linked to a caver yet; link them on the Phone users page",
      "recorded_in_future": "scans dated later than now, which no position can be",
      "recording_changed_after_conversion": "changes made to the recording on a phone after this trip was made from it; the trip was not rewritten"
    },
    "unknownReason": "something else that needed looking at",
    "markResolved": "Mark as resolved",
    "resolved": "Marked as resolved.",
    "errors": {
      "changed": "The flag gained a reason while you were reading it. Read it again before marking it as resolved.",
      "forbidden": "You may read this trip but not change it, so you cannot mark it as resolved.",
      "failed": "The flag could not be cleared."
    }
  },
  "phoneUsers": {
    "title": "Phone users",
    "backToCavers": "Back to cavers",
    "intro": "Everyone who has used the SpeleoLoc app with this installation, one row for each login on a phone. A phone login is not a person: say which caver each one is, so that what they record is credited to the right name. Nobody is matched for you, and nobody becomes a caver or an account by being listed here.",
    "unmappedTitle": "Some phone users are not mapped to a caver yet",
    "unmappedBody": "Until a phone user is mapped, what they record is shown under the name their phone gave, marked as unmapped, and a trip they recorded is flagged for attention or, if this installation does not make trips from recordings with problems, waits on the cave page to be converted by hand.",
    "columns": {
      "user": "Phone user",
      "lastSeen": "Last seen",
      "caver": "Caver",
      "linkedBy": "Mapped by"
    },
    "firstSeen": "First seen {{when}}",
    "deviceAccount": "account {{id}}",
    "noName": "No name sent",
    "notDescribed": "Not yet described by the phone",
    "sentBy": "Sent by {{name}}",
    "chooseCaver": "Say which caver this is",
    "unnamedCaver": "Somebody this page cannot name",
    "notMapped": "Not mapped",
    "sourceDevice": "The phone",
    "sourceArchiveImport": "An archive import",
    "sourceAdministrator": "Somebody keeping the roster",
    "unlink": "Remove mapping",
    "unlinkConfirm": "Remove this mapping?",
    "unlinkConfirmBody": "The phone user stays listed, as not mapped. What was recorded under them is not changed, and the phone may say who they are again.",
    "linked": "Mapped.",
    "unlinked": "Mapping removed.",
    "empty": "No phone has sent anything yet.",
    "forbidden": "The list of phone users is open to accounts that may read the roster of cavers.",
    "loadFailed": "The phone users could not be loaded.",
    "errors": {
      "caverNotFound": "That caver is no longer on the roster.",
      "userNotFound": "That phone user is no longer listed."
    }
  },
  "statistics": {
    "title": "Trip statistics",
    "open": "Statistics",
    "asVisibleToYou": "Counted over the trips you may read. Somebody with different access sees different totals for the same subject, and both are right.",
    "hoursPartial": "Hours cover the {{counted}} of {{total}} times somebody went where entry and exit times were written down.",
    "span": "From {{from}} to {{to}}.",
    "trips": "Trips",
    "people": "People",
    "places": "Places",
    "firstVisits": "First visits",
    "hoursUnderground": "Hours underground",
    "hours": "{{value, number}} h",
    "metresSurveyed": "Surveyed",
    "metresOfRope": "Rope",
    "surveyStations": "Survey stations",
    "incidents": "Trips with an incident",
    "photographs": "Photographs",
    "trackedTrips": "Tracked trips",
    "watchHoursUnderground": "Hours underground, from tracking",
    "watchNote": "The hours from tracking are a second count, taken from the entries and exits in the trips' tracking logs. They are not added to the hours underground above: where a trip has both, they are the same hours. Times somebody went that they cover: {{counted}}.",
    "orientation": {
      "rose": "Passage rose",
      "weighting": "Weighting",
      "byLength": "By length",
      "byCount": "By count",
      "north": "N",
      "east": "E",
      "south": "S",
      "west": "W",
      "ringLabel": "{{value}}%",
      "meanAxis": "Mean trend {{value}}°",
      "roseDescriptionLength": "Passage trends over {{sectors}} sectors of {{width}}°, north up, weighted by surveyed length. Each trend is drawn on both sides of the diagram because a passage running one way and the same passage surveyed from its other end are one trend, not two. The strongest is {{from}}–{{to}}°, carrying {{percent}}% of the length.",
      "roseDescriptionCount": "Passage trends over {{sectors}} sectors of {{width}}°, north up, weighted by the number of survey legs. Each trend is drawn on both sides of the diagram because a passage running one way and the same passage surveyed from its other end are one trend, not two. The strongest is {{from}}–{{to}}°, carrying {{percent}}% of the legs.",
      "title": "Passage orientation",
      "dipAxis": "Inclination",
      "legs": "Survey legs",
      "countAxis": "Count axis",
      "linearCount": "Linear",
      "logCount": "Logarithmic",
      "degrees": "{{value}}°",
      "loading": "Working the figures out.",
      "meanSteepness": "Mean steepness {{value}}° from level, ignoring whether a leg climbs or descends.",
      "dipRefusedTitle": "Steepness cannot be worked out",
      "dipRefusedReason": "This line work carries no altitudes, so nothing in it says whether a passage climbs or descends. Drawing it anyway would show the cave as level everywhere, which is a statement about the cave and not one this drawing can make.",
      "noTrendTitle": "No direction can be worked out",
      "noTrendReason": "Nothing in this line work runs anywhere on the map: every surveyed leg either drops straight down, climbs straight up, or is marked as passage already surveyed on another trip. A cave of pure pitches is the ordinary case for this. There is no trend to draw here, which is a statement about the line work and not about the cave — the lengths beside it were measured from the same survey and stand."
    },
    "cave": {
      "title": "Survey statistics",
      "nothingMeasured": "This cave has no line work to measure. Nothing here is computed from a survey.",
      "totalLength": "Length surveyed",
      "planLength": "Length in plan",
      "verticalExtent": "Vertical extent",
      "maximumExtent": "Greatest span",
      "verticality": "Verticality",
      "horizontality": "Horizontality",
      "linearity": "Linearity",
      "sinuosity": "Sinuosity",
      "segments": "Segments",
      "paths": "Paths",
      "highest": "Highest point",
      "lowest": "Lowest point",
      "lengthToDepth": "Length to depth",
      "pathSinuosityTitle": "Sinuosity of the longest passages",
      "path": "Passage",
      "pathNumber": "#{{value}}",
      "pathLength": "Length",
      "straightLine": "Straight line",
      "lengthAgainstRecord": "Length against the record",
      "depthAgainstRecord": "Depth against the record",
      "notComputed": "Not computed from this cave's line work.",
      "notDeclared": "{{computed}} computed; nothing written in the record to compare it with.",
      "against": "{{computed}} computed, {{declared}} in the record, a difference of {{difference}}.",
      "disagreementTitle": "The survey and the record do not agree",
      "disagreementBody": "A figure computed from this cave's line work differs from the one written in its record. Neither is automatically the wrong one: a typed-in morphometry is frequently older than the survey it is being compared against, and a survey can be incomplete. Check which is the more recent before changing either.",
      "basisSurveyFlags": "Measured from the compiled survey, using the surveyor's own flags to decide which shots are passage. This is what these figures are defined as.",
      "hasAltitudes": "This line work carries altitudes, so the vertical figures above are measured from it rather than assumed.",
      "noAltitudes": "This line work carries no altitudes — a plan drawing of a cave is not a flat cave. Every vertical figure above is therefore left blank rather than shown as nought: nothing here says how far the cave descends, which is a statement about the drawing and not about the cave.",
      "measuredFromModel": "Measured from the survey \"{{name}}\". A cave may hold several uploaded surveys, and figures taken from two different ones are not the same measurement.",
      "basisSkeletonHeuristic": "Approximated from the stored centerline, because this cave has no compiled survey carrying per-shot flags. The shape of the line work stands in for the surveyor's flags: it keeps most of the surveyed length but drops loose shots at a station, and with them the last few metres of every dead end. These figures should not be set against a cave measured from its survey as though the two were the same measurement."
    },
    "topology": {
      "title": "Passage network",
      "sizeTitle": "The network as surveyed",
      "nodes": "Stations in the network",
      "nodesGloss": "Survey stations that at least one passage leg reaches.",
      "edges": "Passage legs",
      "edgesGloss": "Pairs of stations joined by passage. A passage surveyed twice counts once.",
      "components": "Separate pieces",
      "componentsGloss": "Parts of the survey that do not join up to one another underground.",
      "junctions": "Junctions",
      "junctionsGloss": "Places where three or more passages meet.",
      "extremities": "Dead ends",
      "extremitiesGloss": "Places where the survey stops — a choke, a sump, or simply where the surveyors turned back.",
      "cyclomatic": "Independent loops",
      "cyclomaticGloss": "How many genuinely different ways round the network there are. Nought means every place is reached one way only.",
      "reducedTitle": "The network with its straight runs contracted",
      "reducedNodes": "Junctions and dead ends",
      "reducedNodesGloss": "What is left once every run of passage between two of them is treated as a single connection.",
      "reducedEdges": "Connections between them",
      "reducedEdgesGloss": "One per run of passage. The three ratios below are counted over these rather than over the raw legs.",
      "reducedComponents": "Separate pieces, contracted",
      "reducedComponentsGloss": "Parts the contracted network falls into.",
      "alpha": "Loopiness (alpha)",
      "alphaGloss": "Loops present against the most a network of this size could hold. Nought is a cave with no loops at all.",
      "beta": "Connections per junction (beta)",
      "betaGloss": "Below one is a branching cave; above one means it closes back on itself.",
      "gamma": "Connectedness (gamma)",
      "gammaGloss": "Connections present against the most a network of this size could hold.",
      "degreeTitle": "How passages meet",
      "meanDegree": "Passages at an average junction or dead end",
      "meanDegreeGloss": "Below two is a branching cave; well above two is a maze.",
      "degreeSpread": "Spread of that figure",
      "degreeSpreadGloss": "How much the number of passages meeting varies from place to place.",
      "degreeVariation": "That spread against the average",
      "degreeVariationGloss": "The same spread as a proportion, so caves of different sizes can be set beside one another.",
      "degreeCorrelation": "Do junctions join junctions?",
      "degreeCorrelationGloss": "Positive means busy places connect to busy places; negative means junctions mostly hang dead ends off themselves.",
      "branchesTitle": "Runs of passage",
      "branches": "Branches",
      "branchesGloss": "Runs of passage from one junction or dead end to the next.",
      "loopingBranches": "Branches returning to where they started",
      "loopingBranchesGloss": "These have no straight line to be measured against, so they take no part in the wandering figure below.",
      "meanBranchLength": "Average branch length",
      "meanBranchLengthGloss": "How far it typically is from one junction to the next.",
      "shortestBranch": "Shortest branch",
      "shortestBranchGloss": "The shortest run of passage between two junctions or dead ends.",
      "longestBranch": "Longest branch",
      "longestBranchGloss": "The longest such run.",
      "branchLengthVariation": "Spread of branch lengths",
      "branchLengthVariationGloss": "Against their average. A high figure means a few long passages among many short ones.",
      "shapeTitle": "How the network runs",
      "lengthEntropy": "Evenness of branch lengths",
      "lengthEntropyGloss": "Nought to one. High means branches of all lengths in equal measure; low means they are mostly of one length.",
      "orientationEntropy": "Evenness of passage bearings",
      "orientationEntropyGloss": "Nought to one, weighted by passage length. Low means the cave follows one or two directions, commonly the joints in the rock; high means it runs every way.",
      "tortuosity": "Wandering",
      "tortuosityGloss": "How long a run of passage is against the straight line between its ends. One is dead straight.",
      "averagePath": "Branches between two places",
      "averagePathGloss": "How many runs of passage you pass along, on average, to get from one junction to another.",
      "centralPointDominance": "Reliance on one junction",
      "centralPointDominanceGloss": "Nought to one. High means most routes through the cave pass through a single place.",
      "clustering": "Passages closing back on each other",
      "clusteringGloss": "How often two passages leaving the same junction are themselves joined.",
      "completenessWhole": "Every leg in the survey file joined the station network, and no two stations shared a position. The figures above cover the whole of it.",
      "completenessPartial": "{{dropped}} leg(s) in the survey file could not be attached to the station network, and {{merged}} station(s) shared a position with another and became a single node. The figures above were computed over what remained.",
      "completenessUnknown": "It is not recorded what the reading of this survey may have left out, so the figures above may cover less than the file contains.",
      "measuredFromModel": "Measured from the survey “{{name}}”. A cave may hold several uploaded surveys, and figures taken from two different ones are not the same measurement."
    }
  },
  "permissions": {
    "title": "Permissions",
    "button": "Permissions",
    "subject": "Subject",
    "user": "User",
    "cavingGroup": "Caving group",
    "pickUser": "Search users…",
    "pickCavingGroup": "Pick a caving group…",
    "addRule": "Add rule",
    "notManager": "You cannot manage permissions on this object.",
    "scope": "Applies to",
    "scopeObject": "This object only",
    "scopeSubtree": "This object and everything inside",
    "viaExpedition": "From a camp",
    "viaExpeditionHint": "Some of these rules were written by a camp this trip belongs to, and are changed there rather than here. They are shown so the whole list of who may read this trip is in one place.",
    "denyHint": "A deny outweighs every allow at the same level, and a rule on the object itself outweighs anything inherited. Check what it costs before saving.",
    "reviewRightWarning": {
      "title": "Whoever reviews uploads sees every waiting change in full",
      "body": "The right to review uploads shows every change waiting for review as it was sent, including the exact positions of protected caves and pictures of caves the reviewer could not otherwise open. Give it only to people trusted with all caves. Outside review, a reviewer still sees only what their other rights allow."
    },
    "viaNamedExpedition": "Granted through camp {{name}}",
    "proposed": "proposed",
    "proposedHint": "This was opened from a link about {{name}}. Read on this object, and nothing more, is proposed for them in the row marked “proposed”. Nothing is granted until you press OK.",
    "proposedAlready": "This was opened from a link about {{name}}, who already has a rule here that includes Read. Nothing was added."
  },
  "access": {
    "whyTitle": "Your access here, and why",
    "allowed": "Allowed",
    "denied": "Denied",
    "effect": "Effect",
    "effects": {
      "allow": "Allow",
      "deny": "Deny"
    },
    "domain": "Applies to",
    "actionsColumn": "Actions",
    "scope": "Scope",
    "scopes": {
      "all": "Everything",
      "own": "Own objects",
      "cavingGroup": "A caving group's content",
      "subtree": "A feature and everything inside",
      "featureSet": "A feature set",
      "cabinet": "A cabinet and everything filed below it",
      "object": "One object"
    },
    "levels": {
      "object": "object",
      "collection": "collection",
      "global": "global"
    },
    "actions": {
      "read": "Read",
      "write": "Write",
      "create": "Create",
      "delete": "Delete",
      "share": "Share",
      "execute": "Run",
      "managePermissions": "Manage permissions",
      "viewExactLocation": "Exact location"
    },
    "domains": {
      "features": "Features",
      "tripLogs": "Trip logs",
      "geofiles": "Geodata files",
      "georeferencedMaps": "Georeferenced maps",
      "mapViews": "Saved map views",
      "files": "File store",
      "documents": "Documents",
      "expeditions": "Expeditions",
      "mapLayers": "Map layers",
      "tags": "Tags",
      "hierarchies": "Hierarchies",
      "taxonomies": "Taxonomies",
      "cavers": "Cavers",
      "cavingGroups": "Caving groups",
      "users": "User accounts",
      "permissionGroups": "Permission groups",
      "featureSets": "Feature sets",
      "settings": "Installation settings",
      "messageTemplates": "Message texts",
      "audit": "Audit log",
      "jobs": "Jobs",
      "terrain": "Terrain",
      "checklists": "Checklists",
      "events": "Calendar events",
      "uploadReview": "Upload review"
    },
    "sources": {
      "fullAdministrators": "Full administration: membership decides before any rule is consulted.",
      "ownership": "Granted by ownership of the object.",
      "visibility": "Granted by the object's visibility.",
      "none": "No rule grants this."
    },
    "decidedByRule": "Decided at the {{level}} level by \"{{rule}}\".",
    "decidedByHiddenRule": "Decided at the {{level}} level by a rule you cannot see.",
    "decidedByDirectRule": "Decided by a rule written directly on this object."
  },
  "permissionGroups": {
    "title": "Permission groups",
    "intro": "Named rulesets with members. A rule lives here or directly on an object — never in a caving group, which can only be a member and pass what it holds to its people.",
    "new": "New permission group",
    "name": "Name",
    "description": "Description",
    "membersColumn": "Members",
    "rulesColumn": "Rules",
    "manage": "Manage",
    "deleteConfirm": "Delete this permission group and its rules? Members only lose what it granted.",
    "protected": "Protected",
    "seeded": "Built-in",
    "nameTaken": "A permission group with this name already exists.",
    "nameInvalid": "The name must contain letters or digits.",
    "lastFullAdmin": "Refused: this would leave no active Full Administrator able to sign in.",
    "exceedsOwnRights": "Refused: a rule cannot hand out rights you do not hold yourself.",
    "rulesTab": "Rules",
    "membersTab": "Members",
    "previewTab": "Preview",
    "addRule": "Add rule",
    "fullAdminNoRules": "Full Administrators holds no rules: membership itself is the grant, decided before any rule — which is also why no deny can reach it.",
    "previewRequired": "This ruleset contains a deny. Open the preview and look at what somebody affected would hold before saving — a blind deny can lock people out.",
    "openPreview": "Open the preview",
    "addMember": "Add",
    "noMembers": "No members yet.",
    "removeMemberConfirm": "Remove this member?",
    "runPreview": "Preview",
    "previewIntro": "Pick a user or caving group to see the rights they would hold.",
    "previewLegend": "Expand a row to see which rule decided each action.",
    "noRights": "nothing",
    "narrowKind": "Narrow to kind…",
    "narrowType": "Narrow to type…",
    "pickCavingGroupAnchor": "Pick a caving group…",
    "pickFeatureSetAnchor": "Pick a feature set…",
    "pickCabinetAnchor": "Pick a cabinet…",
    "pickFeatureAnchor": "Search features…",
    "pickPermissionGroupAnchor": "Pick a permission group…",
    "anchorIdPlaceholder": "Object id (paste it from the object's page)"
  },
  "featureSets": {
    "title": "Feature sets",
    "intro": "Named sets of features that access rules can be scoped to — the way to say \"these particular caves\" when no area of the hierarchy contains exactly them.",
    "new": "New feature set",
    "edit": "Edit feature set",
    "name": "Name",
    "description": "Description",
    "membersColumn": "Features",
    "membersTitle": "Features in \"{{name}}\"",
    "editMembers": "Edit features",
    "membershipMovesAccess": "Rules can be scoped to this set, so changing its features moves access. Every change is recorded in the audit log.",
    "searchFeature": "Search features…",
    "addFeature": "Add",
    "noMembers": "No features in this set.",
    "deleteConfirm": "Delete this feature set?",
    "inUse": "Rules still point at this feature set; remove them first.",
    "nameTaken": "A feature set with this name already exists."
  },
  "cavingGroupPicker": {
    "create": "Create «{{name}}»",
    "created": "{{name}} was added to the caving groups.",
    "noMatch": "No caving group by that name.",
    "nameTaken": "A caving group with this name already exists. Choose it from the list.",
    "nameInvalid": "A caving group's name needs letters or digits.",
    "nameTooLong": "That name is too long for a caving group.",
    "forbidden": "You are not allowed to add caving groups.",
    "createFailed": "The caving group could not be added."
  },
  "security": {
    "title": "Account security",
    "password": {
      "title": "Password",
      "intro": "Change the password you sign in with. You need the one you use now.",
      "current": "Current password",
      "currentRequired": "Enter the password you use now.",
      "incorrect": "This is not your current password.",
      "rejected": "This password is not accepted. Use at least 10 characters.",
      "notSet": "This account signs in without a password.",
      "signsOut": "Changing your password signs you out everywhere, including here. You then sign in again with the new one.",
      "revokeKeys": "Also revoke my access keys",
      "revokeKeysHint": "Devices that upload with one of your keys stop working until you give them a new key. Leave it off to keep them working.",
      "submit": "Change password",
      "changed": "Your password was changed."
    },
    "mfa": "Two-factor authentication",
    "statusOn": "Enabled",
    "statusOff": "Off",
    "intro": "Ask for a second proof of identity when you sign in. An authenticator app is the strongest; a code sent to you is easier to set up.",
    "enable": "Set up two-factor",
    "enterKey": "If you cannot scan it, add this key by hand:",
    "codePlaceholder": "6-digit code",
    "confirm": "Confirm",
    "codeInvalid": "The code is not valid.",
    "lockedOut": "Too many wrong codes. The account is locked for a while; wait, then try again.",
    "enabled": "Two-factor authentication is on.",
    "disabled": "Two-factor authentication is off.",
    "disable": "Disable",
    "disableConfirm": "Disable two-factor authentication?",
    "recoveryLeft": "Recovery codes left: {{count}}",
    "recoveryTitle": "Store these recovery codes now — they are shown only once.",
    "linkedAccounts": "Linked accounts",
    "linkedIntro": "Sign in with an external provider in addition to your password.",
    "linkWith": "Link {{provider}}",
    "linkAdded": "Account linked.",
    "linkFailed": "That account could not be linked. It may already be linked elsewhere.",
    "unlink": "Unlink",
    "unlinkConfirm": "Remove this linked account?",
    "unlinked": "Account unlinked.",
    "unlinkFailed": "The account could not be unlinked.",
    "method_authenticator": "Authenticator app",
    "method_email": "Emailed code",
    "method_sms": "Texted code",
    "methodHint_authenticator": "A six-digit code from an app on your phone. Works without a signal.",
    "methodHint_email": "A code sent to your confirmed address.",
    "methodHint_sms": "A code texted to your confirmed number.",
    "methodNotAllowed": "Not enabled on this installation.",
    "methodEmailNotReady": "Confirm your email address first.",
    "methodSmsNotReady": "Confirm a phone number first.",
    "methodUnusable": "Cannot be used now",
    "methodDisabled": "That method is off.",
    "turnOn": "Turn on",
    "turnOff": "Turn off",
    "makeDefault": "Make default",
    "default": "Default",
    "disableMethodConfirm": "Turn this method off?",
    "scanTitle": "Set up your authenticator app",
    "codeSent": "Code sent to {{destination}}.",
    "resendCode": "Send again",
    "challengeFailed": "The code could not be sent.",
    "phoneTitle": "Phone number",
    "phoneVerified": "Verified",
    "phoneAdd": "Add number",
    "phoneChange": "Change number",
    "phoneRemove": "Remove",
    "phoneRemoveConfirm": "Remove your number? Texted codes will be switched off with it.",
    "phoneRemoveLastFactorTitle": "Remove your only second factor?",
    "phoneRemoveLastFactor": "Texted codes are the only second factor on this account. Removing the number switches two-factor sign-in off: from then on your password alone protects the account. You will get an email saying so.",
    "phoneRemoveLastFactorOk": "Remove and switch off",
    "phoneRemoved": "Your number has been removed.",
    "phoneConfirmed": "Your number is confirmed.",
    "phoneNumber": "Phone number",
    "phonePending": "Waiting for the code texted to {{number}}.",
    "phoneSendFailed": "The code could not be sent to that number.",
    "phoneTaken": "Another account already uses that number.",
    "phoneHint": "Used only for sign-in codes. Enter it in international form, for example +40712345678.",
    "smsNotConfigured": "This installation has no SMS gateway, so texted codes are unavailable.",
    "scanHint": "Scan this with your authenticator app, then type the code it shows.",
    "scanAlt": "QR code for your authenticator app"
  },
  "workspace": {
    "menu": "Workspace: presets and arrangement",
    "presetsTitle": "Arrangements",
    "preset": {
      "map": "Map",
      "map3d": "Map + 3D",
      "survey": "Survey review",
      "trip": "Trip planning",
      "twoScreens": "Two screens"
    },
    "presetHint": {
      "map": "The map between its two panels",
      "map3d": "The 3D scene beside the map",
      "survey": "A cave's survey model beside the map",
      "trip": "Under the map: what is in view, and the 3D ground",
      "twoScreens": "The map here, the 3D scene in a window of its own"
    },
    "savedTitle": "Saved arrangements",
    "saveCurrent": "Save the current arrangement…",
    "saveTitle": "Save the current arrangement",
    "saveHint": "Keeps the panels, the panes around the map and whether the 3D scene is open, under a name. Saved arrangements follow your account.",
    "tableToggle": "Table under the map",
    "swapDocks": "Swap the side panels",
    "maximiseMap": "Fill the workspace with the map",
    "mapName": "the map",
    "scene3dName": "3D scene",
    "surveyName": "Survey model",
    "tableName": "the table",
    "move": "Move {{name}}",
    "maximise": "Fill the workspace with {{name}}",
    "restore": "Give {{name}} its own size back",
    "restoreShort": "Restore",
    "close": "Close {{name}}",
    "place": {
      "left": "Left of the map",
      "right": "Right of the map",
      "bottom": "Under the map",
      "window": "In its own window"
    },
    "pickedTab": "Picked ({{count}})",
    "pickedEmpty": "Nothing picked. Hold Ctrl or Shift while clicking the map to pick several objects.",
    "surveyPickCave": "Pick a cave on the map: its survey models are listed here.",
    "surveyNone": "This cave has no survey model that can be opened here.",
    "surveyChoose": "Open one of the cave's survey models here:",
    "resizePanes": "Resize the panes on either side",
    "resizeBottom": "Resize the map and the strip under it",
    "shortcutMaximise": "Fill the workspace with the pane you are in, or give every pane its own size back",
    "admin": {
      "tab": "Workspace",
      "intro": "The arrangement a new account starts with on the map. It is applied once, the first time an account opens the map without having arranged anything; after that the arrangement is the member's own.",
      "preset": "Starting arrangement",
      "builtIn": "Map (as shipped)",
      "saved": "Saved.",
      "unreadable": "The installation's starting arrangement could not be read, so it was not changed. Fix it through the settings API first."
    }
  },
  "views": {
    "title": "Saved views",
    "namePlaceholder": "View name…",
    "save": "Save current view",
    "filterHoldsPosition": "This view's filter holds a typed point, a pasted polygon or a place to measure nearest first from, and a saved view never stores one. Measure from an object or a named area instead, or apply a saved filter.",
    "share": "Share link",
    "linkCopied": "Share link copied.",
    "exportImage": "Export map image",
    "sharedNotFound": "This shared view does not exist or was revoked.",
    "sharedClusterHint": "{{count}} entrances here — zoom in to see them one by one.",
    "sharedNoBackground": "No background map is available for shared views on this installation.",
    "sharedUnnamed": "Unnamed",
    "sharedClose": "Close",
    "sharedProtectedNote": "Protected caves are never shown on a shared map.",
    "exportUnreadable": "The map cannot be put into an image: a layer on it comes from a provider that does not allow that.",
    "exportUnreadableLayers": "The map cannot be put into an image while it shows {{layers}}: the provider does not allow that.",
    "exportUnreadableTry": "Switch the background to one allowed in documents, such as {{name}}, turn off any other layer named here, and export again.",
    "exportUnreadableNone": "None of this installation’s backgrounds may be put into an image.",
    "shareTitle": "Share the view {{name}}",
    "shareExplain": "Anyone with this link can open the view without an account. It shows the area the view looks at over a public background, with the layers the view had on — limited to what is public in its own right, with protected caves and features left out entirely.",
    "shareWithoutData": "This view is narrowed by a saved filter or by a filter from a link, which a link cannot run — so the link shows the area and its background without the caves and features. Layers drawn from saved filters are never shown through a link either.",
    "shareWithoutFilterLayers": "Layers drawn from saved filters are never shown through a link; the link shows the view's other layers.",
    "shareQr": "The link to the view {{name}} as a QR code"
  },
  "panel": {
    "unknown": "Unknown panel.",
    "registryTitle": "Cave registry",
    "popOut": "Pop out the registry into its own window",
    "popOut3d": "Open 3D viewer window",
    "popOutScene3d": "Open the 3D scene in its own window",
    "viewer3dTitle": "3D viewer",
    "viewer3dEmpty": "Select a cave with a 3D model to display it here.",
    "viewer3dUnavailable": "This survey model is no longer available, or you may not see it.",
    "scene3dTitle": "3D scene",
    "sections": {
      "details": "Details",
      "tags": "Tags",
      "attachments": "Files",
      "links": "Links",
      "history": "History",
      "permissions": "Permissions",
      "text": "Text"
    },
    "reorder": "Move {{section}}",
    "reorderHint": "Drag to reorder, or hold Alt and press the up and down arrows",
    "hideSection": "Hide this section",
    "hideSectionNamed": "Hide {{section}}",
    "showSection": "Show this section again",
    "hiddenSections": "Hidden:",
    "restoreSections": "Restore the default arrangement",
    "allHidden": "Every section is hidden.",
    "back": "Back to the previous selection",
    "forward": "Forward",
    "pin": "Push the map aside",
    "unpin": "Float over the map",
    "density": "Spacing",
    "layouts": "Saved arrangements",
    "layoutName": "Name this arrangement",
    "deleteLayout": "Delete {{name}}",
    "layoutKeptHere": "This browser only",
    "layoutKeptHereWhy": "Your account’s stored preferences were full when this arrangement was saved, so it is kept only in this browser and will not be found in another one. Delete an arrangement you no longer use, and this one goes to your account with that change.",
    "deleteLayoutConfirm": "Delete the arrangement {{name}}?",
    "selectionTitle": "Selection",
    "popOutSelection": "Open the selection panel in its own window",
    "multiTitle_one": "{{count}} selected",
    "multiTitle": "{{count}} selected",
    "multiReadable": "Readable here",
    "multiMixed": "Mixed",
    "multiHint": "Hold Ctrl or Shift while clicking the map to add to the selection.",
    "multiNothingReadable": "None of the selected objects can be read here.",
    "clearSelection": "Clear the selection",
    "zoomToAll": "Zoom to all",
    "bulkTag": "Tag all",
    "bulkTagHint": "Bulk tagging arrives with the shared filter."
  },
  "scene3d": {
    "unsupportedTitle": "This browser cannot show the 3D view",
    "unsupportedHint": "The 3D view needs WebGL 2, which this browser or its graphics driver does not provide. Try an up-to-date browser, or keep using the 2D map.",
    "openFlatMap": "Open the 2D map",
    "startFailed": "The 3D view could not be started",
    "centerlinesFlat": "{{count}} centerline(s) drawn on the surface — no surveyed depths were available for them.",
    "surfaceTitle": "Ground over the cave",
    "surfaceOverlay": "Show the cave through it",
    "surfaceOverlayHint": "The survey is drawn over the ground and stays visible from every angle. How deep a passage is shows in the colour of the line, not in what hides it.",
    "surfaceCutaway": "Cut it away",
    "surfaceCutawayHint": "The ground above the cave is cut away, so the survey is seen down an opening in the surface.",
    "cutawayUnsupported": "This browser cannot cut the ground away. The cave is shown through it instead.",
    "cutawayNoCave": "No survey is loaded to cut around. The cave is shown through the ground instead.",
    "cutawayPaused": "The opening is edge-on from here — tilt the view down towards the cave to look into it.",
    "cutawayUnderground": "The view is below the surface, where there is no ground left between you and the cave. Rise back above it to look down into the opening.",
    "meshLayer": "Cave walls",
    "meshNoCave": "Pick a cave to see the walls that were surveyed for it.",
    "meshOff": "The walls are not loaded, and hold no graphics memory.",
    "meshLooking": "Looking for a wall model of this cave…",
    "meshAsk": "These walls are {{size}} to download.",
    "photosLayer": "Photographs at their stations",
    "photosNoCave": "Select a cave to mark where its photographs were taken.",
    "photosOff": "Not shown.",
    "photosLooking": "Looking for photographs linked to the cave's stations…",
    "photosFailed": "The photographs could not be looked up.",
    "photosNone": "No photograph of this cave is linked to a station of its survey.",
    "photosDrawn": "Photographs: {{count}} · stations: {{places}} — press a camera to open them.",
    "meshAskDownload": "Download them",
    "meshLoading": "Loading the walls…",
    "meshLoadingSized": "Loading the walls — {{triangles}} triangles.",
    "meshDrawn": "The walls are drawn.",
    "meshDrawnSized": "The walls are drawn — {{triangles}} triangles.",
    "meshConverting": "The uploaded model is still being converted. It appears here once it is ready.",
    "meshNone": "No wall model has been uploaded for this cave.",
    "meshFailed": "The walls of this cave could not be drawn.",
    "meshFailedBecause": "The walls could not be drawn: {{reason}}",
    "meshPrecisionLost": "The uploaded file had already lost detail before it arrived. Re-exporting it about a local origin recovers it.",
    "terrainUnreachable": "This installation's elevation data could not be reached, so the ground is shown as a smooth globe. Check that the terrain directory is served at the configured address.",
    "terrainUnreachableFellBack": "This installation's elevation data could not be reached at the configured address, so the ground is drawn from the pyramid this installation baked for itself instead. Check that the terrain directory is served where the configuration says, or remove that setting.",
    "terrainMalformed": "The address configured for elevation data does not hold a terrain tile set, so the ground is shown as a smooth globe. Check that the baked pyramid, including its layer.json, is served there.",
    "terrainMalformedFellBack": "The address configured for elevation data does not hold a terrain tile set, so the ground is drawn from the pyramid this installation baked for itself instead. Check that the baked pyramid, including its layer.json, is served there, or remove that setting.",
    "terrainEncodingMismatch": "The elevation tiles are being served with a compression that does not match their contents, so the ground is shown as a smooth globe. The web server must declare exactly the encoding the files on disk are in, and nothing else.",
    "terrainEncodingMismatchFellBack": "The elevation tiles at the configured address are being served with a compression that does not match their contents, so the ground is drawn from the pyramid this installation baked for itself instead. The web server must declare exactly the encoding the files on disk are in, and nothing else.",
    "depthLegend": "Depth below the top of the cave",
    "depthLegendBand": "{{meters}} m",
    "showingElsewhere": "The 3D scene is open in another panel of this window.",
    "fitCave": "Frame the cave in view",
    "cameraTitle": "Camera",
    "closeCallout": "Close",
    "projectionOrthographic": "Remove perspective",
    "projectionOrthographicHint": "Remove perspective, so distances read the same near and far",
    "projectionPerspectiveHint": "Put perspective back",
    "coupleToMap": "Move with the map",
    "coupleToMapHint": "Move with the flat map again, and bring the camera to where it is looking",
    "uncoupleFromMapHint": "Stop moving with the flat map, so each can be moved on its own",
    "presetGlyph": {
      "top": "⌖",
      "north": "N",
      "south": "S",
      "east": "E",
      "west": "W"
    },
    "preset": {
      "top": "Look straight down (plan)",
      "north": "View from the north",
      "south": "View from the south",
      "east": "View from the east",
      "west": "View from the west"
    },
    "contextLostTitle": "The 3D view stopped",
    "contextLostHint": "The browser released the graphics resources this view was using, twice in quick succession. Reloading the page usually restores it.",
    "contextLostReload": "Reload",
    "rasterOverlayHint": "On the globe each sheet is flattened to a single picture, so it softens under close zoom. The flat map reads the file itself and stays sharp.",
    "geofileTracksHint": "Tracks and outlines from these files are drawn as lines, in the colours the flat map uses. A track that recorded no altitude is laid on the ground.",
    "catalogueLayer": {
      "unavailable": "Not drawn in 3D",
      "cog_unreadable": "This GeoTIFF could not be read, so the 3D view does not draw it.",
      "cog_not_georeferenced": "This GeoTIFF does not say where on the ground it lies, so the 3D view does not draw it.",
      "cog_projection_unusable": "This GeoTIFF's coordinate system cannot be used here, so the 3D view does not draw it.",
      "cog_band_missing": "This GeoTIFF lacks a band its entry asks for, so the 3D view does not draw it.",
      "cog_short_pyramid": "This GeoTIFF carries no reduced copies of itself, so the 3D view draws it only from close in.",
      "vector_unreadable": "This background's style or data could not be loaded, so the 3D view does not draw it.",
      "vector_stand_in": "Drawn in 3D as {{name}}."
    },
    "terrainTitle": "Ground",
    "terrainBuildsHint": "Each build covers one area to one level of detail. Switching re-reads the ground and moves the surveys onto the new surface.",
    "terrainConfiguredEntry": "The configured elevation model",
    "terrainBuildLevel": "Level {{level}}",
    "terrainBuildSize": "{{width}} × {{height}} km",
    "terrainFinerOffer": "Finer terrain covers this area — draw it?",
    "terrainFinerDraw": "Draw it",
    "terrainFinerDismiss": "Not now",
    "meshLoadingBytes": "Loading the walls — {{size}}.",
    "meshDrawnBytes": "The walls are drawn — {{size}}.",
    "meshDrawnBytesTriangles": "The walls are drawn — {{size}}, {{triangles}} triangles.",
    "meshMode": "Which caves' walls are drawn",
    "meshModeSelected": "Selected cave",
    "meshModeInView": "Every cave in view",
    "meshesInViewZoomIn": "Zoom in to see the walls of the caves in view.",
    "meshesInViewLooking": "Looking for the walls of the caves in view…",
    "meshesInViewFailed": "The walls of the caves in view could not be listed.",
    "meshesInViewNone": "No cave in view has walls to draw.",
    "meshesInViewShown": "Walls of {{shown}} of {{total}} caves in view — {{size}}.",
    "meshesInViewOverBytes": "Walls of {{shown}} of {{total}} caves in view — the rest would exceed {{limit}}.",
    "meshesInViewOverCount": "Walls of {{shown}} of {{total}} caves in view — the rest are beyond the {{limit}} drawn at once.",
    "meshesInViewLoading": "Still loading: {{count}}.",
    "meshesInViewUnreadable": "Could not be read: {{count}}.",
    "meshesInViewLimitsLink": "Change these limits in Settings › Advanced",
    "surfaceFeaturesCapped": "Showing the first {{limit}} surface features in this view, which is this installation's limit; zoom in to see the rest.",
    "entrancesCapped": "Showing the first {{limit}} cave entrances in this view, which is this installation's limit; zoom in to see the rest.",
    "saveImage": "Save image",
    "saveImageHint": "Save this view as a picture",
    "saveImageFailed": "This view could not be saved as an image."
  },
  "caveview": {
    "dankezCaveView": {
      "tab": "LochViewer (trial)",
      "trialNotice": "A second viewer on trial, showing the same file. It is a separate application: its settings, measurements and sharing are its own and are not saved here. Where the frame below stays empty, this installation does not allow it to be framed: open it in a new window.",
      "openWindow": "Open in a new window",
      "sending": "Handing the survey to the viewer…",
      "loaded": "Stations loaded: {{count}}",
      "station": "Station clicked: {{name}}"
    },
    "loadError": "Failed to load the 3D model",
    "linkThisPart": "Link this…",
    "notInThisModel": "That point is not in this model",
    "labelSize": "Size of station names",
    "labelSizeValue": "{{percent}}%",
    "stationPicture": "Picture at this station",
    "compare": {
      "open": "Compare with…",
      "overlaid": "Overlaid",
      "sideBySide": "Side by side",
      "mode": "How the two models are shown",
      "stop": "Stop comparing",
      "linkViews": "Link views",
      "linkViewsHint": "Turning, tilting or zooming one model does the same to the other",
      "sync": "Sync",
      "syncHint": "Showing or hiding a survey does the same to the survey of the same name in the other model",
      "surveys": "Surveys",
      "surveysOf": "Surveys of {{model}}",
      "showAll": "Show all",
      "noSurveys": "This model has no named surveys to show or hide.",
      "legend": "Which model is which",
      "apart": {
        "title": "These two models are not in the same coordinates",
        "body": "They cannot be laid over one another. One may be measured from a point of its own and the other in a national grid, or each from a different point. Side by side, each is framed on its own and they can still be compared.",
        "sideBySide": "Compare side by side"
      }
    },
    "picked": {
      "modelStation": "Station {{name}}",
      "modelStationRange": "The passage from {{name}}",
      "modelSurvey": "Survey {{name}}"
    },
    "tracking": {
      "people": "Cavers ({{count}})",
      "caveNotes": "About the cave: {{count}}",
      "caveNoteMark": "Cave: {{note}}",
      "showLabels": "Show names on the model",
      "showTimes": "Show when each position was reported",
      "markerNameTime": "{{name}} · {{when}}",
      "markerNameOut": "{{name}} (out)",
      "close": "Close",
      "out": "Out",
      "noTeam": "No team",
      "cardTeam": "Team",
      "cardEntered": "Went in",
      "cardPosition": "Position",
      "cardPositionAt": "Position reported",
      "cardLastHeard": "Last heard",
      "positionWithheld": "Not shown to you",
      "positionWithheldDetail": "This position exists and you may not be told it — this cave's exact position is one you may not be given. It is marked rather than left blank, because a blank would read as nobody knowing where this caver is.",
      "positionMaybeWithheld": "Not shown, or not reported",
      "positionMaybeWithheldDetail": "This caver's last report carried no place — going in, coming out and a note never do. So either nobody has reported where they are, or a position was reported and is one you may not be told.",
      "positionOtherModel": "On another survey",
      "positionOtherModelDetail": "Somebody did report where this caver is, but they were placed on a different survey of this cave than the one drawn here. The same station name can mean a different place in another survey, so no marker is drawn rather than one that might be wrong. The report itself is on the trip's log.",
      "positionNotOnModel": "Not on the drawing",
      "positionNotOnModelDetail": "Somebody reported this caver at {{station}}, on the very survey drawn here — but this drawing holds no station of that name, so there is nowhere to mark them. That is what a survey re-exported with its stations renamed does to every place reported before it, without anybody having changed anything. The report itself stands on the trip's log, and the station above is what it said.",
      "positionStretch": "Between {{from}} and {{to}}",
      "positionStretchShort": "{{from}} – {{to}}",
      "stretchNotDrawn": "No line is drawn for this stretch",
      "stretchToNotOnModelDetail": "This caver was reported between {{from}} and {{to}}. The marker stands at {{from}}; this drawing holds no station named {{to}}, so no line is drawn on to it. The report itself stands on the trip's log.",
      "stretchUnroutableDetail": "This caver was reported between {{from}} and {{to}}. The marker stands at {{from}}; the survey drawn here has no legs joining the two stations, so no line is drawn between them. The report itself stands on the trip's log.",
      "positionNotOnMap": "No point on this map",
      "positionNotOnMapDetail": "Somebody reported this caver at {{station}}, and this map has no point defined for that station — so there is nowhere to mark them on this sheet. The survey itself still holds the station, and the 3D view can still show them. Defining a point for the station on this map, from the survey viewer, is what puts them on it.",
      "positionUnreported": "No position reported"
    },
    "movie": {
      "legendTripTeam": "{{trip}} · {{team}}",
      "legendMore": "+ {{count}} more",
      "legendTripColoursRepeat": "Trip colours repeat",
      "legendTeamColoursRepeat": "Team colours repeat",
      "noteBy": "{{name}}: {{note}}",
      "clockElapsed": "Elapsed {{time}}",
      "clockSpeed": "{{clock}} · ×{{factor}}",
      "previewLoading": "Loading the model for the preview…",
      "previewError": "The model could not be loaded for the preview.",
      "opening": "Opening the movie maker…",
      "openFailed": "The movie maker could not open.",
      "openFailedStale": "The application was updated after this page was opened, and the page still asks for the old version's files. Reload the page to use the new version.",
      "previewLoadingSoFar": "Loading the model for the preview… {{received}} so far",
      "previewLoadingOf": "Loading the model for the preview… {{received}} of {{total}}",
      "previewStalled": "Nothing of the survey file arrived for {{seconds}} seconds, so the download was given up. The server or the connection may be slow; try again.",
      "previewRetry": "Try again",
      "make": "Make a movie",
      "makeHelp": "Export a movie of this model with its tracked trips moving through it",
      "title": "Tracking movie",
      "titleOf": "Movie of {{model}}",
      "groups": {
        "trips": "Trips",
        "output": "Output",
        "motion": "Motion",
        "cavers": "Cavers",
        "view": "View",
        "captions": "Captions",
        "pictures": "Photographs"
      },
      "tripsHint": "Tick the trips the movie shows. Each keeps its colour in the order you tick them.",
      "tripReports": "Reports: {{reports}}",
      "tripLive": "Still under way · new reports since opening: {{count}}",
      "whoAppears": "Who appears: {{shown}} of {{total}}",
      "whoAppearsHelp": "Somebody you untick has no marker and no trail in this movie, and a note they spoke is not captioned. The choice is for this movie only; it is not remembered.",
      "noTrackedTrips": "No trip has been tracked on this model yet.",
      "trackedLoadError": "The trips tracked on this model could not be read.",
      "tripsLoadError": "A chosen trip's tracking could not be read.",
      "stretchNote": "Some reports of these trips say a caver was between two stations. The movie draws each of them at the first of the two, and draws no line to the second.",
      "tripLoadError": "This trip could not be read.",
      "tripsFailedHint": "A chosen trip could not be read. Untick it, or close and try again.",
      "tripsLoading": "Reading the chosen trips…",
      "chooseTrip": "Choose at least one trip to preview and export a movie.",
      "format": "Format",
      "formats": {
        "gif": "GIF",
        "webm": "WebM",
        "mp4": "MP4"
      },
      "formatHelp": {
        "gif": "Loops and plays almost anywhere; grows large at big sizes and long lengths.",
        "webm": "A video every browser plays; small for its quality.",
        "mp4": "A video messaging apps, presentations and phones open."
      },
      "formatChecking": "Checking which formats this browser can write…",
      "formatUnsupported": "This browser cannot write {{format}} at {{size}}, {{fps}} frames a second.",
      "formatNoVideoEncoder": "This browser has no video encoder, so only a GIF can be made here.",
      "size": "Frame size",
      "aspects": {
        "16x9": "Wide (16:9)",
        "4x3": "Standard (4:3)",
        "9x16": "Vertical (9:16) — Reels, TikTok, Shorts, Stories",
        "1x1": "Square (1:1) — Instagram, Facebook posts",
        "4x5": "Portrait (4:5) — Instagram and Facebook feed",
        "3x4": "Portrait (3:4)"
      },
      "sizeGifLimit": "A GIF is at most {{width}} pixels wide.",
      "fps": "Frames a second",
      "fpsGifHelp": "A GIF holds only these rates exactly.",
      "duration": "Length (seconds)",
      "durationGifLimit": "A GIF holds at most {{frames}} frames, so at this rate its replay lasts at most {{seconds}} s.",
      "holdEnd": "Still at the end (seconds)",
      "quality": "Quality",
      "qualities": {
        "low": "Low",
        "medium": "Medium",
        "high": "High"
      },
      "qualityHelpGif": "Colours in the palette: 64, 128 or 256.",
      "qualityHelpVideo": "Bits spent per frame: higher is sharper and larger.",
      "summary": "{{frames}} frames · about {{size}}",
      "summaryCalibrated": "{{frames}} frames · about {{size}}, going by the last GIF made here",
      "gifTooLarge": "At about {{size}} this GIF is larger than most messaging apps take. Make it shorter, smaller or slower, lower its quality, stop the turn, or make a video instead.",
      "rotation": "Turn the model",
      "rotationMode": "How far",
      "rotationModes": {
        "speed": "At a set speed",
        "fullTurn": "One full turn over the movie"
      },
      "degreesPerSecond": "Degrees a second",
      "direction": "Direction, seen from above",
      "clockwise": "Clockwise",
      "counterClockwise": "Counter-clockwise",
      "transition": "Marker slide (seconds)",
      "transitionHelp": "How long a caver's marker takes to move to the next station.",
      "timelineMode": "Several trips",
      "timelineModes": {
        "calendar": "On one calendar",
        "together": "Side by side"
      },
      "timelineHelp": {
        "calendar": "The trips play in real time order; the clock shows the date and time.",
        "together": "Every trip starts at the same moment, to compare them; the clock shows the time elapsed."
      },
      "shortenQuiet": "Shorten quiet stretches",
      "shortenQuietHelp": "Where no chosen trip reports anything, the movie jumps ahead: the picture never stands still for longer than this, nor plays more than half an hour of the trips' time with nothing happening. The clock shows the jump.",
      "quietGap": "Longest still wait",
      "secondsShort": "s",
      "labels": "Caver labels",
      "labelsHelp": "The first name is the first word of the name on the roster; two people who would read the same gain an initial.",
      "caverLabels": {
        "first": "First name",
        "full": "Full name",
        "initials": "Initials",
        "off": "No labels"
      },
      "labelSize": "Label size",
      "labelSizeHelp": "In pixels of the movie.",
      "labelPlate": "Plate behind the labels",
      "showTimes": "Time of the last report in the label",
      "colourBy": "Marker colour",
      "colourByValues": {
        "auto": "Automatic",
        "trip": "By trip",
        "team": "By team",
        "single": "One colour"
      },
      "colourByHelp": {
        "auto": "By team for one trip, by trip for several.",
        "trip": "Each trip in its own colour.",
        "team": "Each team in its own colour.",
        "single": "Everybody underground in one colour."
      },
      "showOut": "Show cavers who have come out",
      "trails": "Trail of the route walked",
      "layers": {
        "legs": "Centre lines",
        "stations": "Stations",
        "stationLabels": "Station names",
        "stationComments": "Station comments",
        "entrances": "Entrance names",
        "entrance_dots": "Entrance dots",
        "splays": "Splays",
        "walls": "Walls",
        "scraps": "Scraps",
        "duplicateLegs": "Duplicate legs",
        "surfaceLegs": "Surface legs",
        "traces": "Dye traces",
        "warnings": "Survey warnings",
        "fog": "Fog",
        "HUD": "Compass and altitude display",
        "box": "Bounding box",
        "grid": "Grid"
      },
      "layerMissing": "This model has none.",
      "hudWarning": "The compass and altitude display prints altitudes and a bearing into every frame.",
      "shading": "Shading",
      "shadings": {
        "default": "As the viewer draws it",
        "height": "By height",
        "length": "By leg length",
        "inclination": "By inclination",
        "single": "One colour",
        "survey": "By survey",
        "depth": "By depth below the surface",
        "depthCursor": "Depth cursor"
      },
      "shadingNeedsTerrain": "needs terrain",
      "camera": "Camera",
      "cameras": {
        "perspective": "Perspective",
        "orthographic": "Orthographic"
      },
      "viewDirection": "Starting view",
      "viewDirections": {
        "plan": "Plan (from above)",
        "north": "N elevation — facing north",
        "south": "S elevation — facing south",
        "east": "E elevation — facing east",
        "west": "W elevation — facing west"
      },
      "viewDirectionHelp": "How the camera looks at the whole model when the movie starts: from above, or level and facing one way. Turning or zooming the preview afterwards is kept.",
      "viewDirectionAgain": "Turn to it again",
      "linewidth": "Line width",
      "zScale": "Vertical scale",
      "captionTitle": "Title",
      "titleText": "Title text",
      "titlePlaceholder": "The trips' titles",
      "captionClock": "Clock",
      "captionSpeed": "Time-lapse figure",
      "captionSpeedHelp": "After the clock, how many times faster than life the movie runs: ×240. Left out when it runs at about life speed.",
      "captionLegend": "Legend",
      "captionProgress": "Progress bar",
      "captionNote": "Latest note",
      "captionNoteHelp": "Notes are free text and can carry safety details.",
      "captionSize": "Caption size",
      "pictureMode": "Photographs on the trips' moments",
      "pictureModes": {"off": "Not shown", "corner": "In a corner", "full": "Over the whole frame"},
      "pictureModeHelp": {"off": "The movie is of the model and the party alone.", "corner": "Each photograph comes up in a corner of the frame when the movie reaches the moment it was hung on.", "full": "Each photograph fills the frame for a moment when the movie reaches the moment it was hung on; the clock and the bar stay on top."},
      "pictureSeconds": "Seconds each is shown",
      "pictureSecondsHelp": "Seconds of the movie, not of the trip. Photographs that would overlap are shown one after the other.",
      "pictureFade": "Fade in and out",
      "pictureCorner": "Corner",
      "pictureCorners": {"bottomRight": "Bottom right", "bottomLeft": "Bottom left", "topRight": "Top right", "topLeft": "Top left"},
      "pictureCaptions": "Their captions",
      "picturesNone": "No photograph is hung on a moment of these trips. Hang them from the trip's tracking log.",
      "picturesCount": "Photographs on these trips' moments: {{count}}.",
      "picturesLoading": "Photographs on these trips' moments: {{count}}; still loading: {{loading}}.",
      "picturesFailed": "Photographs on these trips' moments: {{count}}; could not be loaded and will be left out: {{failed}}.",
      "position": "Moment in the movie",
      "playPreview": "Play the preview",
      "stopPreview": "Stop the preview",
      "previewHint": "Drag the model to choose the view the movie starts from; the camera turns from there.",
      "preview": "Preview of the movie",
      "keysHint": "With the preview or the slider selected, Space plays and pauses; Home and End go to the start and the end.",
      "saveStill": "Save this moment as a picture",
      "stillFailed": "The picture could not be made.",
      "presetsTitle": "Presets",
      "presets": {
        "chat": "For a chat",
        "hd": "HD video",
        "vertical": "Reels / TikTok",
        "feed": "Instagram feed",
        "square": "Square post"
      },
      "presetHelp": {
        "chat": "A small GIF: 480 × 270, 10 frames a second, 15 seconds, medium quality.",
        "hd": "A 1280 × 720 video at 30 frames a second, high quality: MP4 where this browser can write it, WebM where it cannot.",
        "vertical": "Full-screen vertical video for Reels, TikTok, YouTube Shorts and Stories: 1080 × 1920 MP4, 30 frames a second, 30 seconds. The captions keep clear of the buttons those apps draw over a video.",
        "feed": "A portrait post for the Instagram and Facebook feed: 1080 × 1350 MP4 (4:5), 30 frames a second, 30 seconds.",
        "square": "A square post for Instagram, Facebook or X: 1080 × 1080 MP4, 30 frames a second, 30 seconds."
      },
      "presetsHelp": "A preset changes the file only — never who appears, the view or the captions.",
      "presetHdUnavailable": "This browser cannot write a 1280 × 720 video, so nothing was changed.",
      "presetMp4Unavailable": "This browser cannot write a {{size}} MP4, which is what social media takes, so nothing was changed.",
      "reset": "Reset to defaults",
      "resetHelp": "Puts every setting back to what a first opening shows — the captions, the labels and the view as well as the file, so the title caption and the file named after it come back. The trips and the people chosen stay as they are.",
      "privacy": "The movie shows the cave's survey and where the party was. Share it only with people who may see both.",
      "export": "Export {{format}}",
      "cancelExport": "Cancel export",
      "progress": {
        "starting": "Starting…",
        "sampling": "Choosing colours: {{done}} of {{total}}",
        "rendering": "Frame {{done}} of {{total}}",
        "finishing": "Writing the file…"
      },
      "progressElapsed": "{{elapsed}} elapsed",
      "progressTimes": "{{elapsed}} elapsed · about {{remaining}} left",
      "saved": "Saved {{name}}",
      "fileNamed": "The file will be saved as {{name}}",
      "fileAsked": "A video this long is written to its file as it is made. Export asks where to save it, as {{name}} unless you choose another name.",
      "closeWhileExporting": {
        "title": "Stop making the movie?",
        "body": "The export is still running. If you close now, the frames drawn so far are thrown away and no file is saved.",
        "stop": "Stop and close",
        "keep": "Keep going"
      },
      "exportFailed": "The movie could not be made.",
      "frameUncomposed": "The browser gave no drawing surface to compose it on. That usually means it is short of graphics memory: closing other tabs, or loading the page again, may help.",
      "videoTooLong": "This video renders every one of its frames, in software on a computer without a graphics card, and may take a long time to export. A shorter length, a lower frame rate or a smaller size is quicker.",
      "layersMissing": "Greyed layers: this model has none of them.",
      "shadingTerrainHelp": "The depth shadings need the model to stand on real terrain, which this one does not.",
      "terrain": "Terrain over the cave",
      "terrainHelp": "Draws the surface the survey file carries. Off until you turn it on: a cave shown under its hills can be placed on a map by whoever gets the file.",
      "terrainNoneHelp": "This survey file carries no terrain of its own, so there is none to draw.",
      "pixels": "{{value}} px",
      "times": "×{{value}}",
      "percent": "{{value}} %",
      "zScaleHelp": "×1, at the mark, is true height."
    }
  },
  "surveyModels": {
    "title": "3D survey models",
    "stationSearchMore": "More stations: {{count}} — type more of the name",
    "upload": "Upload model",
    "uploaded": "Model uploaded",
    "takeOverLinePlot": "Make it the current line plot once it has been read, instead of “{{name}}”",
    "takeOverMesh": "Make them the current walls once they have been converted, instead of “{{name}}”",
    "takeOverLinePlotHint": "The current line plot is what the map draws and what the cave's figures are measured over. Until this file has been read, “{{name}}” stays current. If somebody chooses another model in the meantime, their choice stands.",
    "takeOverMeshHint": "The current walls are what the 3D scene draws. Until this file has been converted, “{{name}}” stays current. If somebody chooses another model in the meantime, their choice stands.",
    "uploadedTakingOver": "Model uploaded. It becomes the current one once it has been read.",
    "uploadFailed": "Upload failed",
    "deleteFailed": "The model could not be deleted",
    "trackingArmedNamed": "A trip's live tracking is armed on this survey model: {{trips}}. Deleting it would leave that trip unable to place anybody. Open that trip's tracking and close it, or point it at another survey, and then delete this one.",
    "format": "Format",
    "surveyedAt": "Surveyed",
    "view": "View in 3D",
    "openBesideMap": "Open beside the map",
    "openInWindow": "Open in another window",
    "openOverlay": "Open over the whole window",
    "deleteConfirm": "Delete this survey model?",
    "empty": "No 3D models yet",
    "uploadTitle": "Upload a survey model",
    "chooseFile": "Choose a file, or drop it here",
    "acceptHint": "Therion .lox, Survex .3d, or cave walls as a binary .stl — up to 100 MB.",
    "status": "State",
    "statusValues": {
      "ready": "Ready",
      "pending": "Waiting its turn",
      "processing": "In progress",
      "failed": "Could not be processed"
    },
    "formats": {
      "lox": "Therion .lox",
      "survex3d": "Survex .3d",
      "stl": "Walls .stl"
    },
    "converting": "The walls are being prepared for the 3D scene. This list updates itself when they are ready.",
    "conversionFailed": "The walls could not be converted.",
    "triangles": "{{count}} triangles",
    "wallsBuilt": "Walls built from this survey's own scraps and passage dimensions",
    "current": "Current",
    "makeCurrent": "Make current",
    "makeCurrentFailed": "The model could not be made current",
    "readAgain": "Read again",
    "readAgainConfirm": "Read this file again?",
    "readAgainHint": "The file stored for this model is read again, and what the last reading produced is replaced by what this one produces. Nothing has to be uploaded. Use it after an upgrade that reads surveys better, or when a reading failed for a reason that has since gone.",
    "readAgainStarted": "The reading is queued. This list updates itself when it is done.",
    "readAgainFailed": "The reading could not be started",
    "readingAgain": "Being read again",
    "convertingAgain": "Being converted again",
    "currentHint": "The current line plot is what the map and the measurements read; the current wall mesh is what the 3D scene draws. The first model of each kind stays current until you choose another here; choosing a line plot also makes its centerline the cave's shape on the map.",
    "precisionLost": "The file lost precision before it arrived",
    "precisionLostHint": "The coordinates in this file were too large for the numbers it stores them in, so the survey is coarser than it was surveyed. Re-exporting it about a local origin recovers the detail.",
    "meshDeclaration": "Where these walls sit in the world",
    "meshDeclarationHint": "An .stl file is bare triangles: nothing in it says which coordinate system its numbers are in, and read as the neighbouring zone the same file lands hundreds of kilometres away. Say what its numbers mean.",
    "coordinatesLocal": "Metres from a point",
    "coordinatesLocalHint": "The usual export: the numbers are metres east, north and up from one point. Give the position of that point.",
    "coordinatesProjected": "A projected coordinate system",
    "coordinatesProjectedHint": "The numbers are eastings and northings in a national or UTM grid. Give the code of that grid.",
    "sourceEpsg": "EPSG code",
    "originLongitude": "Longitude of the origin",
    "originLatitude": "Latitude of the origin",
    "originFromEntrance": "Filled in from this cave's main entrance, which is where a local export usually starts.",
    "originObfuscated": "The position shown to this account for this cave is deliberately approximate, so it cannot be used as an origin. Enter the true position of the file's zero point.",
    "originNoEntrance": "No entrance position is recorded for this cave, so there is nothing to fill in from. Enter the position of the file's zero point.",
    "originHeightM": "Altitude of the file's zero level (m)",
    "originHeightHint": "The heights in these files are measured from the export's own origin, not from sea level. Give the altitude that its zero level sits at — for an export starting at the entrance, the entrance's own altitude.",
    "problems": {
      "formatUnsupported": "Upload a Therion .lox, a Survex .3d, or cave walls as a binary .stl.",
      "sizeInvalid": "The file is empty or larger than 100 MB.",
      "crsInvalid": "Give the coordinate system as an EPSG code — a positive number.",
      "heightInvalid": "Give the altitude, in metres, that the file's zero level sits at.",
      "originInvalid": "A file in local coordinates needs the position its zero point sits at.",
      "notFound": "This survey model no longer exists.",
      "trackingArmed": "A trip's live tracking is armed on this survey model, and deleting it would leave that trip unable to place anybody. This account cannot read that trip, so ask its team — or an administrator, who can read every trip — to close that tracking or point it at another survey. Then delete this one.",
      "notReady": "This model is still being read, or could not be. Only a model that has finished can be made the current one.",
      "readingInProgress": "This model is already being read. Wait for that reading to finish before asking for another.",
      "caveNotFound": "This cave no longer exists.",
      "forbidden": "You are not allowed to change this cave's survey models."
    },
    "reading": "The survey is being read into its stations and shots. The plot can be viewed already; this list updates itself when the reading is done.",
    "readingFailed": "The survey could not be read.",
    "plotDeclaration": "Where this survey sits in the world",
    "plotDeclarationRequiredHint": "A .lox file has no field for a coordinate system, so it never says where it is. Say what its numbers mean — without this the survey cannot be placed, and nothing can be read out of it.",
    "plotDeclarationOptionalHint": "A .3d file states its own coordinate system only when the survey was compiled with one. If this one does, that is used and what you give here is ignored; if it does not, this is the only thing that can place it."
  },
  "centerlines": {
    "title": "Centerlines",
    "upload": "Upload centerline",
    "uploaded": "Centerline uploaded",
    "uploadFailed": "Upload failed",
    "length": "Length",
    "source": "Source",
    "sourceValues": {
      "uploaded": "Uploaded",
      "extracted": "Extracted"
    },
    "deleteConfirm": "Delete this centerline?",
    "empty": "No centerlines yet",
    "default": "Default",
    "makeDefault": "Make default shape",
    "promoted": "Centerline set as the cave's default shape",
    "paths": "Paths"
  },
  "settings": {
    "title": "Settings",
    "nav": {
      "profile": "Profile",
      "account": "Account",
      "emails": "Emails",
      "notifications": "Notifications",
      "security": "Security",
      "accessibility": "Accessibility",
      "filters": "Saved filters",
      "coordinates": "Coordinates",
      "sync": "Sync",
      "access-keys": "Access keys",
      "survey-uploads": "Survey uploads",
      "advanced": "Advanced"
    },
    "visibility": {
      "label": "Who can see this",
      "tooltip": "Visible to: {{audience}}",
      "legend": "The small icon beside a field sets who can see it: only you, people who share a caving group with you, or anyone signed in."
    },
    "visibilityValues": {
      "private": "Only me",
      "cavingGroup": "My caving groups",
      "authenticated": "Signed-in members"
    },
    "profile": {
      "identity": "Identity",
      "about": "About you",
      "username": "Username",
      "email": "Email address",
      "manageElsewhere": "Change",
      "firstName": "First name",
      "lastName": "Surname",
      "displayName": "Display name",
      "displayNameHint": "Shown beside everything you add. Without one you appear under a generated name.",
      "bio": "About",
      "phone": "Phone number",
      "phoneNone": "Not set",
      "phoneManagedInSecurity": "Change it under Security — a code is texted to the new number first.",
      "cavingClub": "Caving club",
      "avatar": "Profile picture",
      "addresses": "Addresses",
      "addressesHint": "Where you can be reached. Each address can carry a point on the map.",
      "locationAudience": "Map points:",
      "noAddresses": "No addresses yet.",
      "addAddress": "Add an address",
      "editAddress": "Edit address",
      "removeAddress": "Remove address",
      "removeAddressConfirm": "Remove this address?",
      "addressLabel": "Label",
      "country": "Country",
      "city": "City",
      "addressText": "Street and the rest",
      "location": "Point on the map",
      "noLocation": "No point set",
      "pickLocation": "Pick on the map",
      "changeLocation": "Change point",
      "clearLocation": "Clear the point"
    },
    "avatar": {
      "upload": "Upload a picture",
      "preset": "Pick a built-in one",
      "choosePreset": "Built-in pictures",
      "remove": "Remove",
      "tooLarge": "Pick an image under 5 MB.",
      "uploadFailed": "That image could not be used.",
      "presetNames": {
        "bat": "Bat",
        "helmet": "Helmet",
        "lamp": "Headlamp",
        "rope": "Rope",
        "karst": "Karst",
        "stalactite": "Stalactite",
        "compass": "Compass",
        "sump": "Sump"
      }
    },
    "emails": {
      "current": "Email address",
      "confirmed": "Confirmed",
      "unconfirmed": "Not confirmed",
      "verify": "Send a confirmation link",
      "verifySent": "Check your inbox.",
      "change": "Change your address",
      "changeHint": "We send a link to the new address. Nothing changes until you open it.",
      "newEmail": "New address",
      "sendLink": "Send the link",
      "requested": "If that address is free, a link is on its way to it.",
      "requestFailed": "That address could not be used.",
      "pending": "Waiting for {{email}} to be confirmed",
      "pendingHint": "Open the link we sent to that address. Until then you keep signing in with the current one.",
      "resend": "Send it again",
      "resent": "Sent again.",
      "tooSoon": "Wait a minute before asking again.",
      "cancelChange": "Cancel the change",
      "cancelled": "Change cancelled.",
      "confirmSuccess": "Your address has been changed.",
      "confirmFailed": "That link is invalid or has expired."
    },
    "account": {
      "usernameSection": "Username",
      "usernameHint": "You always sign in with your email address, so changing this only changes how you are listed.",
      "changeUsername": "Change username",
      "usernameConfirm": "Change your username?",
      "usernameChanged": "Username changed.",
      "usernameTaken": "That name is already in use.",
      "usernameInvalid": "That name cannot be used.",
      "usernameCharacters": "Use letters, digits and . _ @ + - only.",
      "noDeletion": "Accounts are not deleted from here. Anything you have added stays with the club, so ask an administrator.",
      "export": {
        "heading": "Export your data",
        "intro": "A copy of your profile, addresses, settings and a list of what you have added.",
        "request": "Prepare an export",
        "requested": "Preparing your export.",
        "download": "Download",
        "status": {
          "queued": "Queued",
          "running": "Preparing…",
          "ready": "Ready",
          "failed": "Failed"
        }
      },
      "calendarFeed": {
        "heading": "Calendar feed",
        "intro": "Subscribe to your own calendar from a phone or desktop calendar application. A feed carries the title and dates of the trips, camps and events you are on, and a link back to each — nothing else.",
        "label": "Name for this address",
        "labelPlaceholder": "Phone, work laptop…",
        "mint": "Create a feed address",
        "mintedTitle": "Your new feed address — copy it now, it is shown only once.",
        "mintedHint": "Anyone holding this address can read your calendar, so treat it like a password. If it gets out, revoke it here and create another.",
        "mintFailed": "The address could not be created.",
        "unlabelled": "Unnamed address",
        "createdOn": "Created {{when}}",
        "active": "Active",
        "revoked": "Revoked",
        "revoke": "Revoke",
        "revokeConfirm": "Revoke this address? A calendar still using it will stop updating.",
        "revokedMessage": "Address revoked."
      }
    },
    "notifications": {
      "categories": "What to notify me about, and where",
      "category": "Notify me about",
      "channels": {
        "inApp": "In the app",
        "email": "Email",
        "sms": "Text message"
      },
      "choices": {
        "off": "Off",
        "immediate": "As it happens",
        "daily": "Daily summary"
      },
      "alwaysOn": "Always sent — this one cannot be switched off.",
      "reachesNobody": "This will not reach you anywhere.",
      "notOffered": "Not sent this way",
      "notConfigured": "not set up",
      "notConfiguredHere": "This installation has not set up: {{channels}}. Your choices there are saved and will be used as soon as it is.",
      "events": {
        "cavingGroupMembership": "Caving group membership changes",
        "permissionGranted": "Someone shares something with me",
        "tripParticipation": "I am added to a trip",
        "tripPublished": "A trip I am on was published as a page anybody with the link can read",
        "tripNeedsAttention": "A trip recorded on a phone needs somebody to look at it, or could not be made into a trip report",
        "uploadAwaitingReview": "An account whose uploads are reviewed sent something that waits for a reviewer",
        "uploadReviewed": "A reviewer decided about something I uploaded",
        "expeditionUpdate": "An expedition I am on the roster of is changed or called off",
        "tripPlanning": "I am invited to a trip or a club event, a trip I am on changes, a trip needs access I can grant, or a trip or club event I answered about is coming up",
        "commentReply": "Someone replies to a comment I wrote",
        "commentOnMine": "Someone comments on something of mine",
        "groupAnnouncement": "Someone writes to a caving group I am in",
        "jobCompleted": "My uploads finish processing",
        "securityAlerts": "Security alerts",
        "tripCallout": "A trip I am on is overdue and nobody has said the party is out"
      },
      "delivery": "Delivery",
      "masterEmail": "Notify me by email",
      "digest": "How often",
      "digestValues": {
        "immediate": "As things happen",
        "daily": "A daily summary"
      },
      "alwaysOnReasons": {
        "securityAlerts": "Always sent — this one warns you about your own account.",
        "tripCallout": "Always sent, and never held for the daily summary — an overdue party is nobody's news in the morning."
      },
      "noDelivery": "This installation has no mail server configured, so nothing is sent yet. Your choices are saved and will be used once one is."
    },
    "filters": {
      "heading": "Saved filters",
      "intro": "A filter you save starts out shared with the audience chosen here. You can still choose differently each time you save one, and later in the list of saved filters. Sharing gives others the question only — each of them is answered with what they themselves may see.",
      "defaultAudience": "Share new filters with",
      "groupGone": "The caving group chosen here is no longer one you can share with, so new filters start out private until you choose again.",
      "manage": "Your saved filters"
    },
    "accessibility": {
      "heading": "Appearance",
      "intro": "These follow you to every device you sign in on.",
      "theme": "Theme",
      "themeValues": {
        "system": "Match my system",
        "light": "Light",
        "dark": "Dark"
      },
      "density": "Density",
      "densityValues": {
        "comfortable": "Comfortable",
        "compact": "Compact"
      },
      "reduceMotion": "Reduce motion",
      "reduceMotionHint": "Turns off animations and map fly-to movement.",
      "highContrast": "Higher contrast",
      "highContrastHint": "Darker text, outlines you can see on every field, and a stronger focus ring — in the light and the dark theme.",
      "deviceOnly": "This browser only",
      "deviceOnlyIntro": "These stay on this device — a phone and a workstation want different answers.",
      "landingPage": "Open the app on",
      "landingValues": {
        "map": "The map",
        "dashboard": "The dashboard"
      },
      "mapChrome": "Hide the on-map controls",
      "reset": "Reset these",
      "resetDone": "Reset.",
      "overviewMap": "Overview map on the map"
    },
    "advanced": {
      "wallsHeading": "Cave walls in the 3D view",
      "wallsSelectedHeading": "Walls of the selected cave",
      "wallsSelectedIntro": "Selecting a cave in the 3D view downloads its walls straight away, unless they are larger than this — then the view says how large they are and waits until you choose to download them. 0 asks every time.",
      "wallsAskAboveMegabytes": "Ask above (MB)",
      "wallsIntro": "When the 3D view draws the walls of every cave in view, three numbers bound it: the zoom it starts from, how many caves it draws at once, and how much it downloads and holds for them. What you set here stays in this browser only — a phone and a workstation want different answers.",
      "wallsMinZoom": "Show from zoom",
      "wallsMaxCaves": "Caves at most",
      "wallsMaxMegabytes": "Megabytes at most",
      "wallsCeilings": "This installation allows at most {{caves}} caves and {{megabytes}} MB.",
      "centerlinesHeading": "Survey lines on the map",
      "centerlinesIntro": "Two numbers bound the survey lines the flat map draws: the zoom from which full survey detail appears, splays included, and how many lines one view may hold. The map's layer list shows the same two while Cave centerlines is switched on. Like everything on this page, they are kept for this browser alone.",
      "centerlinesDetailZoom": "Detail from zoom",
      "centerlinesMaxPaths": "Line budget",
      "centerlinesCeiling": "This installation allows a line budget of at most {{paths, number}}.",
      "emptyHint": "An empty field follows this installation's default, shown in grey.",
      "useDefaults": "Use this installation's defaults"
    },
    "pointPicker": {
      "title": "Pick a point",
      "hint": "Click the map, or type the coordinates.",
      "use": "Use this point"
    },
    "surveyUploads": {
      "loadFailed": "The survey-upload settings could not be loaded.",
      "outputsTitle": "Always produce",
      "outputsIntro": "When a survey is uploaded from a device, these results are produced in addition to what the device asks for. With nothing asked for, the installation produces: {{defaults}}.",
      "linksTitle": "Public links",
      "linksIntro": "Each upload can get a link that shows its results to whoever holds it — anyone, or only signed-in accounts of this installation. It never includes the survey files themselves, the team or station names. A cave with a protected location gets one only when you ask for it explicitly for that upload.",
      "linksSwitch": "Public links for my uploads",
      "audienceTitle": "Default link audience",
      "audienceIntro": "Who a new upload's link opens for, unless the upload asks otherwise. A link for signed-in accounts asks whoever opens it to sign in."
    },
    "sync": {
      "intro": "Choose the caves a phone carries offline. A selection names caves — it never takes them over — so ending one here stops a device asking for them and changes nothing about the caves themselves.",
      "serverTitle": "What this server speaks",
      "contractVersion": "Protocol version",
      "limits": "Limits",
      "limitsValue": "{{pageSize}} rows per download page, {{uploadRows}} rows per upload",
      "served": "Available",
      "servedNone": "Selections only — this server does not move rows yet.",
      "setsTitle": "Selections",
      "newSet": "New selection",
      "editSet": "Edit selection",
      "noSets": "No selection yet. Nothing is carried offline.",
      "name": "Name",
      "caves": "Caves",
      "cavesPlaceholder": "Search caves by name",
      "caveCount": "Caves carried: {{total}}",
      "unnamedCave": "A cave you can no longer read",
      "uploadVisibility": "New records are visible to",
      "uploadVisibilityHelp": "What a device's own records get when it sends them back. Only you, until you widen it.",
      "uploadsAs": "Uploads as: {{visibility}}",
      "cavingGroup": "Caving group",
      "noCavingGroup": "No caving group",
      "noCavingGroupsHere": "This installation has no caving groups.",
      "cavingGroupRequired": "Choose the caving group these records belong to. Without one, records visible to a caving group are visible to nobody.",
      "notInCavingGroup": "You are not a member of that caving group, so a device cannot create records for it.",
      "caveUnreadable": "One of the chosen caves is no longer readable by you. Remove it and save again.",
      "changedElsewhere": "This selection was changed somewhere else — on a device, or in another tab. Reopen it and make the change again.",
      "revoke": "Revoke",
      "revokeConfirm": "Revoke this selection? A device will stop being able to ask for these caves. Nothing already on it is deleted.",
      "revoked": "Selection revoked."
    }
  },
  "admin": {
    "forbidden": "You need administrator rights to see this page.",
    "users": {
      "title": "Accounts",
      "intro": "Everyone who can sign in to this installation. Invite somebody to open an account for them, lock an account to shut it out until you unlock it, or delete one — the person stays on the roster and on the trips they were on.",
      "search": "Search accounts",
      "searchPlaceholder": "Name or email address",
      "invite": "Invite someone",
      "name": "Name",
      "email": "Email address",
      "status": "Status",
      "createdAt": "Opened",
      "actions": "Actions",
      "you": "you",
      "statusActive": "Can sign in",
      "statusLocked": "Locked",
      "statusNoPassword": "No password yet",
      "statusAdministrator": "Full administrator",
      "lock": "Lock",
      "unlock": "Unlock",
      "locked": "{{name}} is locked out.",
      "unlocked": "{{name}} can sign in again.",
      "sendAgain": "Send the invitation again",
      "delete": "Delete",
      "deleteConfirm": "Delete the account of {{name}}?",
      "deleteConfirmDetail": "They will no longer be able to sign in. Their entry on the roster and the trips they were on stay.",
      "deleted": "The account of {{name}} was deleted.",
      "inviteTitle": "Invite someone",
      "inviteIntro": "An account is opened for this address. Its owner receives a link to choose their own password; you never learn it.",
      "inviteName": "Name",
      "inviteNameRequired": "Say who the account is for.",
      "inviteEmail": "Email address",
      "inviteEmailRequired": "Enter the address they will sign in with.",
      "inviteEmailInvalid": "This is not an email address.",
      "inviteSubmit": "Open the account",
      "invitationSent": "An invitation was sent to {{email}}.",
      "handOverTitle": "Hand this link over",
      "handOverIntro": "The invitation for {{name}} ({{email}}) could not be sent by email, because this installation has no mail server or sending failed. Give them this link yourself; it lets them choose their password.",
      "handOverOnce": "Copy it now: it is shown only this once. It works once and for {{hours}} hours; after that, send the invitation again.",
      "handOverDone": "I have copied it",
      "statusTwoFactor": "Second factor on",
      "statusUploadReview": "Uploads need review",
      "uploadReviewMark": "Hold uploads for review",
      "uploadReviewClear": "Stop holding uploads",
      "uploadReviewSet": "Everything {{name}} uploads will now wait for a reviewer.",
      "uploadReviewCleared": "What {{name}} uploads is no longer held for review.",
      "resetTwoFactor": "Reset second factor",
      "resetTwoFactorConfirm": "Reset the second factor of {{name}}?",
      "resetTwoFactorConfirmDetail": "Every second factor they set up is switched off — the authenticator app, codes by email or text message — and their recovery codes stop working. They are signed out on every device and are told by email. They can then sign in with their password alone and set up a second factor again from their security settings.",
      "twoFactorReset": "The second factor of {{name}} was reset.",
      "groupsTitle": "Permission groups",
      "groupsIntro": "What this account belongs to. Membership is changed on the permission groups page, not here.",
      "groupsNone": "Only the group every account belongs to.",
      "groupsFailed": "The permission groups could not be read.",
      "groupDirect": "member",
      "groupThrough": "through {{groups}}",
      "problems": {
        "lastAdministrator": "This is the last full administrator who can sign in. Make somebody else a full administrator first, or the installation would have nobody to administer it.",
        "cannotLockSelf": "You cannot lock your own account.",
        "cannotDeleteSelf": "You cannot delete your own account.",
        "deleteBlocked": "This account still owns records: {{owned}}. Hand them over or remove them first; deleting the account would orphan them.",
        "deleteBlockedKinds": {
          "albums": "photo albums",
          "cave_level_bands": "confirmed level bands",
          "cave_qr_publications": "published cave QR codes",
          "checklists": "checklists",
          "documents": "documents",
          "events": "events",
          "expeditions": "expeditions",
          "features": "caves and other map features",
          "feature_shares": "feature share links",
          "geofiles": "geodata files",
          "georeferenced_maps": "georeferenced maps",
          "import_batches": "confirmed imports",
          "raster_maps": "scanned maps",
          "survey_uploads": "survey uploads",
          "survey_upload_public_links": "public survey-upload links",
          "trips": "trips",
          "trip_recordings": "trip recordings",
          "trip_tracking_shares": "trip follow links",
          "upload_batches": "upload batches"
        },
        "emailTaken": "An account with this address already exists.",
        "alreadyEnterable": "This account can already be signed in to. Its owner resets their own password.",
        "notFound": "This account no longer exists.",
        "invalid": "Check the name and the address.",
        "forbidden": "You are not allowed to do this.",
        "cannotChangeOwnReviewMark": "Another administrator decides whether your uploads need review.",
        "cannotResetOwnTwoFactor": "You manage your own second factor from your security settings.",
        "twoFactorNotEnabled": "This account has no second factor switched on, so there is nothing to reset.",
        "fullAdministratorAccount": "Only a full administrator can lock, unlock, delete or reset the second factor of a full administrator's account."
      }
    },
    "messaging": {
      "title": "Messaging",
      "intro": "Where email and text messages go, and what signing in requires. These can also be set from the deployment environment; anything saved here replaces it.",
      "mailTab": "Email",
      "smsTab": "Text messages",
      "policyTab": "Sign-in policy",
      "protectionTab": "Location protection",
      "protectionIntro": "Documents attached to a protected cave are always served — they are never hidden or stripped of their text. What this setting controls is whether someone who may not see where the cave is gets told which documents point at it.",
      "revealAssociations": "Show attachments of protected caves to everyone who can read them",
      "revealAssociationsHint": "Turning this on never reveals a position: following the link still gives the protected view. A photo carrying its own capture point stays unpaired with a protected cave either way, because pairing the two would place the cave.",
      "calendarFeedEnabled": "Let members subscribe to their calendar from outside",
      "calendarFeedEnabledHint": "Each member can then create secret addresses that a phone or desktop calendar polls without signing in. A feed carries only the titles, dates and links of what that member is on — never a place or a position — and is read through the member's own permissions on every poll. Off by default; switching it off again stops every address already handed out.",
      "keepLocationInPhotoFiles": "Keep the location inside photo files",
      "keepLocationInPhotoFilesHint": "On: someone who may see where a photo was taken can download it exactly as it was uploaded, GPS position included. Off: everyone downloads the full-size picture with its location data (GPS, XMP, IPTC place names) removed; camera details stay. Either way, someone who may not see where a photo was taken only ever gets the copy without its location. Videos, sound recordings and pictures that cannot be rewritten (anything but JPEG, PNG and WebP) are offered to such a person only as previews — and when this is off, to nobody at all except as previews, unless the next switch is on. The position shown on the map and beside the photo follows the location rules as before.",
      "serveUnstrippableOriginalsToLocationReaders": "With the location switch off, still let people who may see the location download videos, recordings and pictures that cannot be rewritten",
      "serveUnstrippableOriginalsToLocationReadersHint": "Matters only while “Keep the location inside photo files” is off. Videos, sound recordings and pictures in formats that cannot be rewritten (anything but JPEG, PNG and WebP) have no copy without their location, so with that switch off nobody can download them — only their previews can be seen, and videos and recordings have none. On: someone who may see where such a file was taken can download it exactly as it was uploaded, location included. Someone who may not see the location still never gets it. Off by default.",
      "describeLocationFreeCopies": "Tell phones the size and fingerprint of photos sent without their location",
      "describeLocationFreeCopiesHint": "When the SpeleoLoc app asks to download a photo it will receive without its location, the server makes that copy there and then and tells the app its size and SHA-256 fingerprint, so the app can show the size and check that the download arrived whole. Those requests get slower — up to 200 photos can be rewritten in one — and each copy takes disk space as soon as it is asked for. Off: the app is told no size for such photos and checks the download against its length. Photos the app receives as uploaded are described either way. Off by default.",
      "enabled": "Enabled",
      "host": "Server",
      "port": "Port",
      "security": "Connection security",
      "securityAuto": "Automatic",
      "securitySsl": "TLS on connect (465)",
      "securityNone": "None (plain text)",
      "username": "Username",
      "password": "Password",
      "secretStored": "A password is stored. Leave blank to keep it.",
      "secretNone": "No password stored.",
      "fromAddress": "Sender address",
      "fromName": "Sender name",
      "replyTo": "Reply-to address",
      "timeout": "Timeout (seconds)",
      "acceptInvalidCertificate": "Accept an invalid certificate",
      "acceptInvalidCertificateHint": "Only for an internal relay with a self-signed certificate. It removes the protection on the password above.",
      "mailWorking": "Email is configured",
      "mailInactive": "No mail server configured. Messages are not delivered; the server log records only the recipient and which message it was. An invitation link is shown to the administrator instead.",
      "smsWorking": "The SMS gateway is configured",
      "smsInactive": "No SMS gateway configured. Texts are not delivered; the server log records only the recipient and which message it was.",
      "smsIntro": "Any gateway that accepts an HTTP request will work. Use {to}, {text} and {from} in the URL or body; each is escaped for you.",
      "smsUrl": "Gateway URL",
      "smsMethod": "Method",
      "smsContentType": "Content type",
      "smsBody": "Request body",
      "smsBodyHint": "For example: To={to}&From={from}&Body={text}",
      "smsAuthHeader": "Authorization header",
      "smsAuthHint": "Sent as the Authorization header, for example \"Basic ...\" or \"Bearer ...\".",
      "smsFrom": "Sender number or id",
      "testTitle": "Send a test",
      "testRecipient": "Test recipient",
      "sendTest": "Send test",
      "testSent": "Test message sent.",
      "testFailed": "Sending failed: {{error}}",
      "testNotConfigured": "Configure and save the channel first.",
      "sendConfirmation": "Send a confirmation message when an account is created",
      "requireConfirmed": "Require a confirmed address to sign in",
      "requireConfirmedHint": "Accounts that have not confirmed their address will be refused at sign-in and offered a new confirmation message.",
      "requireConfirmedInert": "Has no effect until a mail server is configured — otherwise nobody could ever confirm.",
      "allowAuthenticator": "Allow authenticator apps",
      "allowEmail": "Allow emailed codes",
      "allowSms": "Allow texted codes",
      "needsMail": "Needs a mail server before anyone can use it.",
      "needsSms": "Needs an SMS gateway before anyone can use it.",
      "smsWeakest": "The weakest of the three: a number can be moved to another SIM by persuading the mobile operator.",
      "codeLifetime": "Code lifetime (minutes)",
      "resendInterval": "Wait between codes (seconds)",
      "importTab": "Vector import",
      "importIntro": "An imported file is reviewed before anything is created. This is where that step can be removed, and how far duplicate detection looks by default.",
      "allowWithoutReview": "Let a trusted user create objects without reviewing them",
      "allowWithoutReviewHint": "Off by default. Rules are a guess about somebody’s naming habits, and the first import against a set nobody has tuned is where that guess is worst. Turning this on never widens who may create — the importer still needs the right to create features — it only removes the step in between.",
      "duplicateRadius": "Look for something already there within",
      "duplicateRadiusHint": "The starting radius for a new review; the importer can change it. Only objects whose exact position the reviewer may see are ever measured against.",
      "duplicateSimilarity": "Names count as the same above",
      "duplicateSimilarityHint": "How alike two names must be, 0 to 1, before a nearby object is called the same thing rather than merely close to it.",
      "syncTab": "Phone sync",
      "syncIntro": "What this installation does with the SpeleoLoc phone app. A change applies at once to every phone that syncs; saving replaces all five settings together.",
      "syncPeopleDirectoryEnabled": "Give phones the list of people",
      "syncPeopleDirectoryEnabledHint": "On: a phone can download a list of cavers, names only and never an address or a phone number, so that its user can say who they are and who was on a trip. Off: phones get no list and cannot say which caver one of their users is. Mappings already made on the Phone users page stay, and what a phone records about its own users is still kept.",
      "syncPeopleDirectoryScope": "Whose names the list holds",
      "syncPeopleDirectoryScopeHint": "A phone can only say its user is somebody it was shown, so this also decides whom a phone may name.",
      "syncScopeMyGroups": "Cavers in the phone account's caving groups, and the account's own caver",
      "syncScopeEveryone": "Every caver on the roster",
      "syncScopeEveryoneWarning": "Everyone on the roster is shown to every account that syncs a phone, whatever their group. Choose this only when the roster is no secret from the people who sign in.",
      "syncConvertTripsWithProblems": "Make trips from recordings that have problems",
      "syncConvertTripsWithProblemsHint": "A trip recorded on a phone is turned into a trip report by itself. On: this also happens when some of it could not be matched, such as a station nobody can place or a phone user not mapped to a caver. The trip is flagged as needing attention and says why. Off: such a recording waits on the cave page until somebody converts it by hand.",
      "syncStagedUploadRetentionDays": "Keep photos sent ahead of an upload for (days)",
      "syncStagedUploadRetentionDaysHint": "A phone sends the bytes of a photo before the upload that uses them. If no upload claims them within this many days they are deleted. A change applies to files that arrive after it. Waiting files count against the sending account's storage, so allow room for about this many days of a phone's photographs. From 1 to 365.",
      "syncRejectedHeldBytesRetentionDays": "Keep the files of a turned-down upload for (days)",
      "syncRejectedHeldBytesRetentionDaysHint": "When an upload that was held for review is decided without its files being used, because it was turned down, replaced by a later one or accepted without them, the files are deleted after this many days. While an upload is still waiting for a reviewer its files are kept however long that takes. From 1 to 365.",
      "notificationsTab": "Notifications",
      "notificationsIntro": "How long this installation keeps what it has told people. What is saved here replaces the deployment's own setting; leave it alone and that setting stays in force.",
      "retentionDays": "Keep notifications for (days)",
      "retentionDaysHint": "A notification is deleted after this, read or unread alike, and whether or not an email ever went out for it. The record of how it was sent goes with it.",
      "announcementsIntro": "What an announcement to a whole caving group may cost this installation. Text messages are charged for by the segment and cannot be recalled once sent, so they reach nobody until this is switched on, and stop for the day once the limit below is reached.",
      "paidChannelsEnabled": "Allow announcements on channels that charge for what they send",
      "paidChannelsEnabledHint": "Off means off: while it is off, nobody can choose such a channel, no saved preference for one resolves to anything, and no outbound copy on one is ever created.",
      "dailyPaidMessageCap": "Charged message segments a day",
      "dailyPaidMessageCapHint": "A carrier bills a text message by the segment, not by the message: 160 characters of the plain Latin alphabet travel in one segment, but a single accented letter re-encodes the whole message into segments of 70, so the same wording costs twice as much in Romanian as in English. An announcement that would take the day past this is refused outright rather than sent to half the roster. Segments already committed today count, including ones still waiting to go out.",
      "photoLibrariesTab": "Photo libraries",
      "surveyUploadsTab": "Survey uploads",
      "surveyUploadsIntro": "Choices about surveys sent from a field device, such as TopoDroid.",
      "firstModelOfCreatedCave": "A cave made by an upload takes its first model",
      "firstModelOfCreatedCaveHint": "When an upload creates a cave, the first model it brings becomes the cave's current model and its centreline the cave's shape. Off: a model from an upload never becomes current on its own; somebody chooses on the web.",
      "surveyUploadsEnvironmentNote": "How many versions of a survey keep their results (SILEXGIS__SurveyUploads__KeepArtefactVersions) and the size the pages warn at (SILEXGIS__SurveyUploads__OlderVersionsWarnMegabytes) are set in the server's environment.",
      "photoLibrariesIntro": "These switches stop this installation using a photo library it already has, and start it again afterwards. They cannot connect one: which libraries this installation has is decided by the deployment that gave them their addresses and credentials."
    },
    "basemap": {
      "tab": "Own basemap",
      "title": "This installation's own basemap",
      "intro": "An OpenStreetMap vector basemap served from this installation alone: download a region of a Protomaps planet build, and the map backgrounds drawn from it are offered on the map from then on. Its labels follow the reader's language. The tiles carry no contours, so keep the topographic backgrounds for relief.",
      "off": "This installation does not serve a basemap of its own: self-hosting is switched off in its configuration (SILEXGIS__Basemap__SelfHosted), or the basemap overlay is not running.",
      "none": "No basemap has been downloaded yet.",
      "waiting": "These map backgrounds are offered once a region is downloaded: {{entries}}.",
      "noEntry": "No background in the map catalogue is drawn from it yet: add one with {basemap} in its address.",
      "current": "Served now",
      "build": "Build",
      "size": "Size",
      "downloadedAt": "Downloaded",
      "region": "Region (W, S, E, N)",
      "maxZoom": "Last zoom level",
      "newDownload": "Download a region",
      "preset": {
        "romania": "Romania",
        "apuseni": "Apuseni (karst region)",
        "custom": "A box of my own"
      },
      "side": {
        "west": "West",
        "south": "South",
        "east": "East",
        "north": "North"
      },
      "latest": "Latest build",
      "buildsFailed": "The list of builds could not be read; the latest one is used.",
      "estimate": "Estimate size",
      "download": "Download",
      "estimated": "About {{size}}, from build {{build}}.",
      "source": "Cut from {{source}}. The largest download accepted is {{limit}}.",
      "replaceTitle": "Replace the basemap being served?",
      "replaceBody": "The new region replaces the current one once its download has finished. Until then the current one goes on being served.",
      "latestDownload": "Latest download:",
      "cancel": "Cancel download",
      "loadFailed": "The basemap's state could not be read.",
      "state": {
        "queued": "queued",
        "running": "running",
        "succeeded": "finished",
        "failed": "failed",
        "cancelled": "cancelled"
      },
      "refusal": {
        "too_large": "Too large for this installation: choose a smaller box or a lower last zoom level.",
        "disk_full": "There is not enough room on the disk for it beside the current basemap.",
        "source_unreachable": "The source could not be reached. Try again later.",
        "build_not_found": "The source does not list that build.",
        "cancelled": "The download was cancelled; the basemap being served is unchanged.",
        "extract_failed": "The download failed; the basemap being served is unchanged.",
        "download_running": "A download is already underway.",
        "self_hosting_off": "Self-hosting is switched off."
      }
    },
    "mapBackgrounds": {
      "tab": "Maps in documents",
      "intro": "Which map backgrounds a document may copy. A trip's downloaded write-up carries a map drawn over one background: the default one if it is switched on here, otherwise the first that is.",
      "reason": "Copying a source's tiles into a document must be something that source's terms allow. Showing a map on screen and putting it into a file that is then mailed and printed are different uses, and each provider decides the second separately — so switch a background on only after reading its terms. The installation ships with an answer for each; what you decide here is kept across restarts and upgrades.",
      "loadFailed": "The map backgrounds could not be loaded.",
      "noneOn": "No background is switched on, so the map in a write-up is drawn on a plain ground, and says so.",
      "columns": {
        "background": "Background",
        "inDocuments": "In documents",
        "shipped": "As shipped"
      },
      "switchLabel": "Copy {{name}} into documents",
      "shippedOn": "Shipped: on",
      "shippedOff": "Shipped: off",
      "decidedHere": "Decided here",
      "useShipped": "Use the shipped answer",
      "noCredit": "No credit is recorded for this source, so it cannot be copied into a document.",
      "needsCredit": "That source has no credit to write under the picture, so it cannot be copied into a document."
    },
    "documentTypes": {
      "title": "Document kinds",
      "intro": "The kinds of document this installation recognises, and the details each kind asks for. Rewriting a kind's details never changes documents already filed under it: they keep the version they were checked against and are re-checked only when someone next edits them.",
      "add": "Add a kind",
      "edit": "Edit document kind",
      "editAction": "Edit",
      "name": "Name",
      "code": "Code",
      "codeHint": "Lower-case letters, digits and underscores. Installations exchange documents by this code, so keep it stable.",
      "description": "Description",
      "sortOrder": "Sort order",
      "fields": "Details asked for",
      "noSchema": "No details",
      "schema": "Details schema (JSON Schema)",
      "schemaHint": "Leave empty for a kind that asks for nothing. Only flat text, number, yes/no and choice fields appear on the form.",
      "schemaVersion": "Schema version",
      "schemaInvalid": "That is not a usable JSON Schema.",
      "codeTaken": "Another kind already uses that code.",
      "seeded": "Ships with the product",
      "seededImmutable": "A kind that ships with the product keeps its code.",
      "preview": "Fields the document form will offer",
      "noFields": "None — nothing in this schema can be rendered as a field.",
      "kinds": {
        "string": "text",
        "number": "number",
        "integer": "whole number",
        "boolean": "yes/no",
        "enum": "choice"
      }
    },
    "featureTypes": {
      "title": "Feature kinds",
      "intro": "The kinds of feature this installation records on the map — the ones that ship with the product and the ones you add — with the shapes each may be drawn as and how a protected one is shown to people without exact view. The kinds that ship keep their code, category, protected display and need for a parent; their wording, symbol, order and details are yours. Once features of a kind exist, its category stays, no shape can be taken away and it cannot start needing a parent, because stored features would stop agreeing with it.",
      "add": "Add a kind",
      "edit": "Edit feature kind",
      "editAction": "Edit",
      "delete": "Delete",
      "deleteConfirm": "Delete the kind “{{name}}”? Only a kind no feature uses can be deleted.",
      "name": "Name",
      "code": "Code",
      "codeHint": "Lower-case letters, digits and underscores. Installations exchange features by this code, so keep it stable.",
      "description": "Description",
      "sortOrder": "Sort order",
      "category": "Category",
      "categories": {
        "surface": "Surface",
        "underground": "Underground",
        "area": "Area",
        "structure": "Structure"
      },
      "shapes": "Shapes it may be drawn as",
      "shapesHint": "A shape can always be added; once features of this kind exist, none can be taken away.",
      "shapesRequired": "Choose at least one shape.",
      "shapeNames": {
        "point": "Point",
        "lineString": "Line",
        "polygon": "Outline",
        "multiPoint": "Several points",
        "multiLineString": "Several lines",
        "multiPolygon": "Several outlines"
      },
      "protectedDisplay": "When protected",
      "displays": {
        "snapPoint": "Shown snapped to the grid (points only)",
        "withhold": "Not shown at all"
      },
      "requiresParent": "Only inside another feature",
      "requiresParentHint": "For kinds that make no sense on their own, such as a place inside a cave.",
      "symbol": "Map symbol",
      "noSymbol": "No symbol",
      "style": "Map style overrides (JSON object)",
      "styleHint": "Optional. Leave empty for the default style.",
      "schema": "Details schema (JSON Schema)",
      "schemaHint": "Leave empty for a kind that asks for nothing. Only flat text, number, yes/no and choice fields appear on the form.",
      "schemaVersion": "Schema version",
      "seeded": "Ships with the product",
      "shippedNote": "This kind ships with the product: its code, category, protected display and need for a parent stay as shipped, and it keeps every shape it ships with.",
      "preview": "Fields the feature form will offer",
      "noFields": "None — nothing in this schema can be rendered as a field.",
      "schemaInvalid": "That is not a usable JSON Schema.",
      "styleInvalid": "The style must be a JSON object.",
      "codeTaken": "Another kind already uses that code.",
      "seededImmutable": "A kind that ships with the product keeps its code, category, protected display, need for a parent and shapes, and cannot be deleted.",
      "boundToCaves": "Every cave",
      "boundNote": "Every cave carries this type, and nothing else can. Add your club's own cave fields to its schema; the fields it ships with are what imports write and stay as they are.",
      "boundSchemaLocked": "This type's schema keeps the fields it ships with, stays open to other fields and cannot make a field required.",
      "inUse": "Features of this kind exist, so its category, shapes and need for a parent can only be loosened, and it cannot be deleted."
    },
    "tripTypes": {
      "title": "Trip purposes",
      "intro": "What trips at this installation are recorded as being for, and what each purpose asks a report to record. The purposes that ship with the product are shown in your language and keep their codes — other installations read trips by them — while their wording, ordering and questions are yours to change. Rewriting what a purpose asks for never changes reports already written: each keeps the version it was checked against and is re-checked only when someone next edits it.",
      "add": "Add a purpose",
      "edit": "Edit trip purpose",
      "editAction": "Edit",
      "delete": "Delete",
      "deleteConfirm": "Delete this purpose? Trips already recorded under it keep it, so it can only go once none are left.",
      "name": "Name",
      "code": "Code",
      "codeHint": "Lower-case letters, digits and underscores. Installations exchange trips by this code, so keep it stable.",
      "description": "Description",
      "sortOrder": "Sort order",
      "source": "Where it comes from",
      "seeded": "Ships with the product",
      "custom": "Added here",
      "fieldDataSchema": "Field data schema (JSON Schema)",
      "logisticsSchema": "Logistics schema (JSON Schema)",
      "safetySchema": "Safety schema (JSON Schema)",
      "schemaHint": "Leave empty for a section that asks for nothing. Only flat text, number, yes/no and choice fields appear on the form.",
      "schemaInvalid": "That is not a usable JSON Schema.",
      "codeTaken": "Another purpose already uses that code.",
      "seededImmutable": "A purpose that ships with the product keeps its code and cannot be deleted.",
      "inUse": "Trips still record this purpose; move them first.",
      "sections": "Sections asked for",
      "noSchema": "Nothing asked for",
      "preview": "Fields the trip form will offer",
      "noFields": "None — nothing in this schema can be rendered as a field.",
      "requiredWarning": "A field marked required (shown in blue) is asked for whenever the section is saved, but a trip is created before its report is written and nothing on the create form can answer it — so a purpose with a required field refuses every new trip recorded under it, and refuses moving an existing trip to it. Leave fields optional unless reports are filled in some other way.",
      "kinds": {
        "string": "text",
        "number": "number",
        "integer": "whole number",
        "boolean": "yes/no",
        "enum": "choice"
      },
      "defaultChecklist": "Checklist",
      "defaultChecklistHint": "The list trips of this purpose work through. Naming one here confers nothing: a reader who may not open the list is told the trip has none."
    },
    "participantRoles": {
      "title": "Trip roles",
      "intro": "The jobs somebody may be recorded as having done on a trip. The roles that ship with the product are shown in your language and keep their codes — other installations read trips by them — while their wording and ordering are yours to change. Add a role here for a job your club runs that nobody thought of.",
      "add": "Add a role",
      "edit": "Edit trip role",
      "editAction": "Edit",
      "delete": "Delete",
      "deleteConfirm": "Delete this role? People already recorded in it keep it, so it can only go once none are left.",
      "name": "Name",
      "nameHint": "How this job reads on a roster.",
      "code": "Code",
      "codeHint": "Lower-case letters, digits and underscores. Installations exchange trips by this code, so keep it stable.",
      "description": "Description",
      "sortOrder": "Sort order",
      "source": "Where it comes from",
      "seeded": "Ships with the product",
      "custom": "Added here",
      "codeTaken": "Another role already uses that code.",
      "seededImmutable": "A role that ships with the product keeps its code and cannot be deleted.",
      "inUse": "People are still recorded in this role; move them first."
    },
    "campRosterRoles": {
      "title": "Camp roles",
      "intro": "What somebody was at a camp as. The roles that ship with the product are shown in your language and keep their codes — other installations read camps by them — while their wording and ordering are yours to change. Add a role here for a job your club has at camp that nobody thought of. This list is separate from the trip roles: cooking for thirty or keeping the base camp is not a job underground, and a role added here is never offered on a trip.",
      "add": "Add a role",
      "edit": "Edit camp role",
      "editAction": "Edit",
      "delete": "Delete",
      "deleteConfirm": "Delete this role? People already recorded in it keep it, so it can only go once none are left.",
      "name": "Name",
      "nameHint": "How this role reads on a camp's roster.",
      "code": "Code",
      "codeHint": "Lower-case letters, digits and underscores. Installations exchange camps by this code, so keep it stable.",
      "description": "Description",
      "sortOrder": "Sort order",
      "source": "Where it comes from",
      "seeded": "Ships with the product",
      "custom": "Added here",
      "codeTaken": "Another role already uses that code.",
      "seededImmutable": "A role that ships with the product keeps its code and cannot be deleted.",
      "inUse": "People are still recorded in this role; move them first."
    },
    "reportTemplates": {
      "title": "Report layouts",
      "intro": "The layouts a trip or a camp is written up in. Download the standard layout for the kind you want, edit it in a text editor — it explains what you may put in it, in its own comments — and bring it back here. The layout marked as used is the one a write-up of that kind is built in when nobody chooses another.",
      "downloadShipped": "Download the standard layout",
      "downloadFailed": "The standard layout could not be downloaded.",
      "add": "Add a layout",
      "edit": "Edit layout",
      "editAction": "Edit",
      "delete": "Delete",
      "deleteConfirm": "Delete this layout? Write-ups fall back to the standard one.",
      "none": "No layout of your own yet. Write-ups are built in the standard layout.",
      "name": "Name",
      "kind": "Writes up",
      "kindTrip": "A trip",
      "kindExpedition": "A camp",
      "kindHint": "A trip layout and a camp layout are written in different words, and each kind has its own layout used when nobody chooses.",
      "used": "Used by default",
      "isDefault": "Used when nobody chooses",
      "isDefaultHint": "Only one layout can be, and marking this one takes the mark off the other.",
      "tripType": "Trip purpose",
      "tripTypeHint": "A trip of this purpose is written up in this layout unless another is chosen, ahead of the layout used for everything else. One layout per purpose; leave it empty for a layout any trip may use.",
      "tripTypeAny": "Any purpose",
      "body": "Layout",
      "fromFile": "From a file",
      "fromFileHint": "The file is read here and put in the box below; nothing is stored until you save.",
      "chooseFile": "Choose a file",
      "invalid": "The layout could not be read."
    },
    "relationTypes": {
      "title": "Link relations",
      "intro": "The wording links between items are recorded with. The relations that ship with the product are shown in your language and cannot be changed — other installations read links by them. Anything you add here belongs to this installation and is shown exactly as you write it.",
      "add": "Add a relation",
      "edit": "Edit relation",
      "delete": "Delete",
      "deleteConfirm": "Delete this relation? Links already recorded with it keep it, so it can only go once none are left.",
      "name": "Reads as",
      "nameHint": "How the relation reads from the item it starts at, for example \"Contains\" or \"Surveyed by\".",
      "code": "Code",
      "codeHint": "The short name this relation is stored and exchanged under. Keep it stable once links use it.",
      "directed": "Reads one way",
      "directedHint": "On when the two ends say different things — one contains the other, one documents the other. Off when both ends read the same, like \"Adjacent to\".",
      "inverseName": "The other way round",
      "inverseNameHint": "How the relation reads from the other end, for example \"Contained in\".",
      "bothWays": "Reads the same from both ends",
      "description": "Description",
      "sortOrder": "Sort order",
      "source": "Where it comes from",
      "seeded": "Ships with the product",
      "custom": "Added here",
      "seededReadOnly": "Not editable"
    },
    "templates": {
      "title": "Message texts",
      "intro": "The wording of everything the application sends. Leave one alone and it follows the product; rewrite it and your version is used.",
      "email": "Email",
      "sms": "Text message",
      "customised": "Rewritten",
      "usingDefault": "This is the wording that ships with the product.",
      "placeholders": "Available placeholders",
      "subject": "Subject",
      "body": "Message",
      "reset": "Restore the default",
      "resetConfirm": "Discard your version and use the default wording?",
      "resetDone": "The default wording is back.",
      "name_email_confirm_address": "Confirm your address",
      "name_email_change_address": "Confirm a new address",
      "name_email_password_reset": "Password reset",
      "name_email_account_invitation": "Invitation to a new account",
      "name_email_two_factor_code": "Sign-in code by email",
      "name_sms_two_factor_code": "Sign-in code by text",
      "name_sms_verify_phone": "Phone verification code",
      "name_notify_caving_group_joined": "Added to a caving group",
      "name_notify_caving_group_role_changed": "Caving group role changed",
      "name_notify_caving_group_removed": "Removed from a caving group",
      "name_notify_permission_granted": "Given access to a record",
      "name_notify_trip_participation": "Listed on a trip report",
      "name_notify_trip_published": "A trip was published as a public page",
      "name_notify_trip_needs_attention": "A trip made from a phone recording needs attention",
      "name_notify_trip_recording_waiting": "A phone recording was not made into a trip",
      "name_notify_upload_awaiting_review": "An upload waits for a reviewer",
      "name_notify_upload_reviewed": "A reviewer decided about an upload",
      "name_notify_trip_plan_invitation": "Invited to a planned trip",
      "name_notify_trip_plan_changed": "A planned trip changed",
      "name_notify_trip_plan_cancelled": "A planned trip was called off",
      "name_notify_trip_invitee_cannot_open_cave": "An invited caver cannot open a cave",
      "name_notify_trip_plan_reminder": "A planned trip is coming up",
      "name_notify_event_reminder": "A club event is coming up",
      "name_notify_event_invitation": "Invited to a club event",
      "name_notify_expedition_update": "An expedition on my roster was changed",
      "name_notify_expedition_cancelled": "An expedition on my roster was called off",
      "name_notify_expedition_participation": "I was put on an expedition roster",
      "name_notify_trip_callout_overdue": "A trip is overdue and the party is unaccounted for",
      "name_notify_trip_callout_overdue_sms": "A trip is overdue and the party is unaccounted for, by text",
      "name_notify_job_completed": "Processing finished",
      "name_notify_job_failed": "Processing failed",
      "name_notify_survey_upload_succeeded": "A survey you sent was processed",
      "name_notify_survey_upload_failed": "A survey you sent could not be processed",
      "name_notify_security_password_changed": "Password changed",
      "name_notify_security_email_changed": "Email address changed",
      "name_notify_security_two_factor_disabled": "Two-step sign-in switched off",
      "name_notify_comment_reply": "A reply to a comment",
      "name_notify_comment_on_mine": "A comment on something of yours",
      "name_notify_group_announcement": "An announcement to a caving group",
      "name_notify_group_announcement_sms": "An announcement to a caving group, by text",
      "name_notify_digest": "Daily summary"
    },
    "importSection": "Vector import"
  },
  "notifications": {
    "bell": "Notifications",
    "title": "Notifications",
    "markAllRead": "Mark all as read",
    "allCategories": "All categories",
    "scopeAll": "All",
    "scopeUnread": "Unread",
    "what": "What happened",
    "about": "About",
    "when": "When",
    "empty": "Nothing to read.",
    "withheld": "The thing this is about is no longer available to you.",
    "unrenderable": "This notification can no longer be shown."
  },
  "unsubscribe": {
    "title": "Notification settings",
    "working": "Applying your choice…",
    "done": "You will no longer be emailed about: {{category}}.",
    "theseMessages": "these messages",
    "changeAnyTime": "You can turn it back on, or change any of your other notification settings, at any time.",
    "failed": "That link is no longer valid. You can change your notification settings after signing in.",
    "doneDigest": "The daily summary has stopped, and with it every other notification email.",
    "alertsStillSent": "Alerts about your own account are still sent — they warn you when someone changes it.",
    "manage": "Manage notification settings",
    "inboxUntouched": "Nothing else changed: these notifications still appear in your inbox inside the application, where you can read them whenever you like."
  },
  "featureKinds": {
    "generic": "Feature",
    "cave": "Cave",
    "caveEntrance": "Cave entrance",
    "centerline": "Centerline"
  },
  "search": {
    "features": "Features",
    "trips": "Trip logs",
    "expeditions": "Camps",
    "documents": "In document text",
    "moreDocuments": "Showing {{shown}} of {{total}} matching documents",
    "noTextLayerHint": "No document text matched. Scanned pages hold no text to search until they are typed up.",
    "supersededVersion": "version {{number}}, replaced",
    "divisions": {
      "page": "page {{number}}",
      "sheet": "sheet {{number}}",
      "slide": "slide {{number}}"
    },
    "openFailed": "Could not open this record."
  },
  "shares": {
    "title": "Share links",
    "button": "Share",
    "create": "Create link",
    "mode": "Access",
    "modes": {
      "public": "Public",
      "requiresLogin": "Requires sign-in"
    },
    "includeSubtree": "Include contained records",
    "linkReady": "Share link created",
    "tokenOnce": "Copy it now — this link is shown only once.",
    "linkCopied": "Share link copied.",
    "copy": "Copy",
    "createdAt": "Created",
    "status": "Status",
    "statusActive": "Active",
    "statusRevoked": "Revoked",
    "revoke": "Revoke",
    "revokeConfirm": "Revoke this share link?",
    "revoked": "Share link revoked.",
    "empty": "No share links yet",
    "notAllowed": "You cannot share this record.",
    "readOnly": "Shared read-only view",
    "childrenTitle": "Included records",
    "sharedNotFound": "This shared link does not exist or was revoked.",
    "loginRequired": "Sign in to view this shared record.",
    "signIn": "Sign in",
    "qrLabel": "The share link as a QR code"
  },
  "publicSurvey": {
    "notFound": "This link does not work. It may have been withdrawn, or it may never have existed.",
    "signInRequired": "This link opens for signed-in accounts of this installation.",
    "signInRequiredHint": "Whoever made it chose to show these results to the installation's accounts only. Sign in and you come back to this page.",
    "signIn": "Sign in",
    "loadFailed": "The result could not be loaded.",
    "caveAndVersion": "{{cave}} — uploaded {{when}}",
    "downloadLog": "Download the whole log",
    "logDownloadFailed": "The log could not be downloaded. Please try again."
  },
  "publicTrip": {
    "notFoundTitle": "Nothing to show for this link",
    "notFoundBody": "This link does not open a trip. It may never have existed, it may have been taken back, or the trip may no longer be published.",
    "caverOrdinal": "Caver {{ordinal}}",
    "noTeam": "Not in a team",
    "state": {
      "off": "Not being followed",
      "armed": "Underground now",
      "closed": "Finished"
    },
    "standing": {
      "underground": "Underground",
      "out": "Out",
      "unheard": "Not reported yet"
    },
    "columnPosition": "Last reported at",
    "positionSince": "Reported {{since}}",
    "positionAt": "Reported at {{clock}}",
    "columnLastHeard": "Last heard",
    "positionMaybeWithheld": "Not shown, or not reported",
    "positionUnreported": "No position reported",
    "positionOtherModel": "Reported on another survey",
    "otherModelTitle": "Some places are not shown on this drawing",
    "otherModelBody": "Somebody reported where these cavers are, but the place was measured on a different survey of this cave than the one drawn here. The same station name can mean a different place in another survey, so it is left off the drawing rather than shown somewhere it might not be. It is not that nobody knows where they are.",
    "positionNotOnModel": "Not on the drawing",
    "notOnModelTitle": "The drawing does not hold some of these stations",
    "notOnModelBody": "These cavers were reported at stations of the very survey drawn above, and that drawing has no station of those names — the survey has been redrawn since, and the names moved with it. Their places are named here in words instead of being marked on the drawing. It is not that nobody knows where they are: somebody reported each of them, and what was reported is what is written beside their name.",
    "closedTitle": "This trip is over",
    "closedBody": "The watch has been closed, so this page no longer changes. What it shows is the last word about each person.",
    "withheldTitle": "Some positions are not shown here",
    "withheldBody": "At least one position on this trip was reported against a cave that is not published. Those people are listed, but not placed.",
    "staleTitle": "This page has stopped refreshing",
    "staleBody": "The trip could not be read just now — the connection may have dropped. What is below is the last word this page was given, and it starts refreshing again by itself as soon as it can.",
    "staleBodySince": "The trip could not be read just now — the connection may have dropped. What is below is the last word this page was given, {{since}}, and it starts refreshing again by itself as soon as it can.",
    "staleLine": "Not refreshing — last read {{since}}",
    "camp": "Camp: {{name}}",
    "unreachableTitle": "The trip could not be read just now",
    "unreachableBody": "This phone or computer could not reach the server — check the connection and try again. Nothing here says anything about the link itself.",
    "retry": "Try again",
    "endedTitle": "This link has stopped answering",
    "endedBody": "It may have been taken back, or the trip's publication may have ended. What is below is the last word this page was given, and it will not be refreshed again.",
    "endedBodyAt": "It may have been taken back, or the trip's publication may have ended. What is below is the last word this page was given, at {{clock}}, and it will not be refreshed again.",
    "since": {
      "running": "Followed since {{clock}} · {{duration}}",
      "started": "Following started {{clock}}",
      "span": "Followed {{span}}"
    },
    "planned": {
      "ahead": "Planned out by {{clock}}",
      "passed": "The plan was to be out by {{clock}}"
    },
    "updated": {
      "running": "Page updated {{since}}",
      "settled": "Last read at {{clock}}"
    },
    "about": {
      "line": "Each place below is where somebody was last reported, at the time beside it — word is passed out of the cave and typed in by a person. It is not a live position.",
      "title": "How this page works",
      "body": "Nobody is tracked by a device underground. A place appears here when a party passes word to the surface and somebody types it in, so it says where a person was at that time, not where they are this minute. Long gaps are normal: there is no signal in a cave, and word gets out only from a telephone point or from the entrance. A gap means nobody has passed word yet. It does not mean anything has happened."
    },
    "language": {
      "name": "English",
      "short": "EN",
      "switchTo": "Show this page in English"
    },
    "embedNoModel": "There is no survey drawing to show for this trip.",
    "past": {
      "sectionTitle": "Past trips in this cave",
      "none": "No past trips of this cave have been published.",
      "rowWhen": "{{dates}} · {{count}} in the party",
      "play": "Play",
      "playing": "Playing",
      "pause": "Pause",
      "notPlayable": "Nothing to play",
      "more": "There are older trips than these.",
      "otherTrips": "Other trips of this cave",
      "listFailedTitle": "The past trips could not be read",
      "listFailedBody": "This link opens the trip above, and just now it could not also read the cave's earlier ones. Try opening this list again.",
      "listNotOfferedTitle": "Past trips are not offered through this link",
      "listNotOfferedBody": "This installation does not open the cave's earlier trips to visitors, so there is nothing here to read.",
      "listLinkEndedTitle": "Past trips cannot be read through this link any more",
      "listLinkEndedBody": "This link has stopped answering, and the cave's earlier trips are refused along with it: the link may have been taken back or have run out, or this installation may not open its archive to visitors. Trying again will not change that.",
      "tag": "Past trip",
      "bannerTitle": "You are looking at a past trip",
      "bannerWhat": "{{title}} — {{dates}}. What is drawn below is how this trip was reported at the moment on the clock. Nobody is being followed here, and nothing on this page is where anybody is now.",
      "bannerWhatShort": "{{title}} — {{dates}}. Not where anybody is now.",
      "bannerLoading": "Reading this trip…",
      "truncated": "This trip reported more than one reading of it can carry, so the replay ends at the last report it holds — the party went on after that moment.",
      "truncatedShort": "The record ends before the trip did — the party went on.",
      "unknownTrip": "A past trip",
      "backToNow": "Back to the party now",
      "backToThisTrip": "Back to this link's trip",
      "backToNowShort": "Now",
      "backToThisTripShort": "Back",
      "controls": "Replay controls and other trips",
      "switchTrip": "Play another trip of this cave",
      "noLiveParty": "This link's own trip is over too, so there is no party underground to go back to.",
      "following": "Keeping up with {{who}}.",
      "stopFollowing": "Stop following",
      "followNobody": "Follow nobody",
      "followNotInTrip": "Not in this trip",
      "followLabel": "Who the view keeps up with",
      "reading": "Reading this trip…",
      "trackFailedTitle": "This trip could not be read",
      "trackFailedBody": "It may no longer be published, or it may have passed the point where this installation keeps trips readable.",
      "nothingToPlay": "Nothing was recorded on this trip that a replay could show.",
      "speed": "{{value}}×",
      "scrub": "Moment of the trip",
      "reportPrevious": "Previous report",
      "reportNext": "Next report",
      "reportPreviousOf": "Previous report about {{who}}",
      "reportNextOf": "Next report about {{who}}",
      "reportPreviousFollowed": "Previous report about the party being followed",
      "reportNextFollowed": "Next report about the party being followed",
      "copyMoment": "Copy link to this moment",
      "copyPlaying": "Copy link that plays from here",
      "copiedMoment": "Link copied. It opens this trip at {{when}}.",
      "copiedPlaying": "Link copied. It opens this trip at {{when}} and starts playing.",
      "copyRefused": "This browser did not allow copying. The link is below: select it and copy it by hand.",
      "copyByHand": "Link to this moment",
      "pictures": {
        "heading": "Photographs from {{when}}",
        "of": "Photograph of {{who}}",
        "ofMoment": "Photograph of this moment"
      }
    },
    "live": {
      "heading": "Being followed now",
      "underground": "Underground now",
      "justFinished": "Just finished",
      "thisLink": "This link's trip",
      "none": "No party of this cave is being followed right now.",
      "failedTitle": "The parties being followed could not be read",
      "failedBody": "This link opens the trip above, and just now it could not also read who else is being followed in the cave. Try opening this list again.",
      "linkEndedTitle": "The parties being followed cannot be read through this link any more",
      "linkEndedBody": "This link has stopped answering, and the list of who else is being followed in the cave is refused along with it. Trying again will not change that.",
      "pastOnlyTitle": "This link no longer lists who is in the cave today",
      "pastOnlyBody": "This link has stopped reporting the parties being followed in the cave now, and opening this list again will not change that. The cave's past trips are still here to read and play.",
      "pastOnlyWatchBody": "What is below is the last word this page was given about this party, and it will not be refreshed again. The cave's past trips are still here.",
      "pastOnlyWatchBodyAt": "What is below is the last word this page was given about this party, at {{clock}}, and it will not be refreshed again. The cave's past trips are still here.",
      "more": "There are more parties being followed than these.",
      "sectionTitle": "Also in this cave now",
      "standingCount": "{{standing}}: {{number}}",
      "watch": "Watch",
      "watching": "Watching",
      "backToOwn": "Back to this link's trip",
      "watchBannerTitle": "You are watching another party of this cave",
      "watchBannerWhat": "{{title}} — {{dates}}. This is not the trip this link was published for: it is another party being followed in the same cave, drawn on this link's survey.",
      "watchBannerLoading": "Reading who is being followed in this cave…",
      "watchClosedTitle": "This party's trip is over",
      "watchClosedBody": "Its watch has been closed, so nothing about it changes any more. It stays in the list of parties being followed for a while longer and then leaves it.",
      "watchEndedTitle": "The party you were watching is no longer in the list",
      "watchEndedBody": "{{title}} is no longer among the parties being followed in this cave that this link lists, so the page is showing this link's own trip again.",
      "watchEndedClose": "Close this notice",
      "watchLine": "Another party of this cave: {{title}}",
      "watchEndedLine": "{{title}} is no longer in the list of parties being followed. This is this link's trip again."
    }
  },
  "qr": {
    "button": "Printed codes",
    "title": "Printed codes at this cave",
    "cardTitle": "Printed code",
    "explainTitle": "What publishing does",
    "explainBody": "A code printed on a label here answers a visitor with no account: it confirms the code is registered with this installation, and says nothing else. No name, no position and no photograph is disclosed by publishing, and the cave does not appear on any public map. Until you publish, a scanned label answers nothing at all.",
    "statusPublished": "Codes resolve for anyone",
    "statusUnpublished": "Codes resolve for nobody",
    "publish": "Publish",
    "published": "Printed codes at this cave now resolve.",
    "revoke": "Stop publishing",
    "revokeConfirm": "Stop this cave's printed codes resolving? Labels already in the field will answer nothing.",
    "revoked": "Printed codes at this cave no longer resolve.",
    "publishedAt": "Published",
    "revokedAt": "Withdrawn",
    "notAllowed": "You cannot decide this for this cave.",
    "noCodeHere": "This cave carries no printed code of its own. Places inside it carry theirs, and each of them resolves through the decision above — open a place to see its square.",
    "copyUrl": "Copy address",
    "urlCopied": "Address copied.",
    "codeNotScannableTitle": "This code cannot be printed as a label",
    "codeNotScannableBody": "It contains characters the address has to escape, and the scanner on a phone reads the address exactly as written rather than unescaping it. A browser would still open the square below, but the caving app would not resolve it. Change the code, or the separator it was assembled from, so it uses only letters and digits.",
    "landingFoundTitle": "This code is registered",
    "landingFoundBody": "The code you scanned is registered with {{instance}}, and that is all this page says: no cave, no place and no position. An account changes nothing here — the answer is the same for everyone.",
    "landingUnknownTitle": "Nothing to show for this code",
    "landingUnknownBody": "This code is not registered here, or the cave it belongs to is not published. Check the characters on the label, or ask whoever put it there.",
    "address": "Address",
    "squareFor": "QR code for {{code}}"
  },
  "resLinks": {
    "titleCount": "Linked items ({{count}})",
    "incomplete": "Incomplete",
    "incompleteHint": "Only one item of this link is visible to you. A link says something once it connects two or more — add another item if there is one to add.",
    "addAction": "Link…",
    "moreMembers": "+{{count}}",
    "rowActions": "Link actions",
    "openPage": "Open link page",
    "copyUrl": "Copy link address",
    "urlCopied": "Link address copied",
    "edit": "Edit link",
    "delete": "Delete link",
    "deleteConfirm": "Delete this link? Nothing it connects is deleted with it.",
    "restricted": "Restricted item",
    "restrictedHint": "This link names something you may not read.",
    "mainMember": "Main member",
    "mainMemberPlaceholder": "Which item the relation reads from",
    "showingFirst": "Showing the first {{count}} of {{total}}.",
    "targetTypes": {
      "feature": "Feature",
      "document": "Document",
      "tripLog": "Trip log",
      "caver": "Caver",
      "cavingGroup": "Caving group",
      "mapView": "Saved view",
      "surveyModel": "3D survey model",
      "geofile": "Geodata file",
      "cabinet": "Cabinet",
      "expedition": "Expedition",
      "unknown": "Item"
    },
    "anchors": {
      "part": "part",
      "quote": "quote",
      "quoteOnPage": "quote, p. {{page}}",
      "page": "p. {{page}}",
      "pageRange": "pp. {{from}}–{{to}}",
      "region": "region",
      "station": "station {{station}}",
      "splayFrom": "splay from {{station}}",
      "stationRange": "stations {{from}}→{{to}}",
      "survey": "survey {{survey}}",
      "surveyRange": "surveys {{from}}→{{to}}",
      "modelPoint": "point",
      "waypoint": "waypoint {{index}}",
      "waypointNamed": "waypoint {{name}}",
      "waypointRange": "waypoints {{from}}–{{to}}",
      "tripMoment": "at {{at, datetime(dateStyle: short; timeStyle: short)}}",
      "regionShapes": {
        "rect": "rectangle",
        "circle": "circle",
        "polygon": "outline",
        "point": "point"
      }
    },
    "anchorStates": {
      "reanchored": "Measured against an older version, found again in the current one",
      "degraded": "Measured against an older version — shown on the whole resource",
      "unresolvable": "This part is no longer in the resource"
    },
    "relations": {
      "unspecified": "Related",
      "same-object": {
        "name": "Same object as"
      },
      "related-to": {
        "name": "Related to"
      },
      "contains": {
        "name": "Contains",
        "inverse": "Contained in"
      },
      "documents": {
        "name": "Documented by",
        "inverse": "Documents"
      },
      "derived-from": {
        "name": "Source of",
        "inverse": "Derived from"
      },
      "adjacent-to": {
        "name": "Adjacent to"
      },
      "duplicate-of": {
        "name": "Original of",
        "inverse": "Duplicate of"
      },
      "needs-clarification": {
        "name": "Needs clarification"
      },
      "trip-work-area": {
        "name": "Worked in",
        "inverse": "Work area of trip"
      },
      "trip-objective": {
        "name": "Aimed at",
        "inverse": "Objective of trip"
      },
      "trip-visited": {
        "name": "Visited",
        "inverse": "Visited on trip"
      },
      "trip-surveyed": {
        "name": "Surveyed",
        "inverse": "Surveyed on trip"
      },
      "trip-discovered": {
        "name": "Discovered",
        "inverse": "Discovered on trip"
      },
      "trip-dug": {
        "name": "Dug at",
        "inverse": "Dug on trip"
      },
      "trip-photographed": {
        "name": "Photographed",
        "inverse": "Photographed on trip"
      },
      "trip-searched-not-found": {
        "name": "Searched, not found",
        "inverse": "Searched for on trip, not found"
      },
      "trip-lead": {
        "name": "Left lead",
        "inverse": "Lead left on trip"
      },
      "trip-follows-on-from": {
        "name": "Follows on from",
        "inverse": "Followed up by"
      },
      "text-of": {
        "name": "Text of",
        "inverse": "Has text"
      },
      "map-plan-of": {
        "name": "Plan map of",
        "inverse": "Has plan map"
      },
      "map-profile-of": {
        "name": "Profile map of",
        "inverse": "Has profile map"
      },
      "map-other-of": {
        "name": "Map of (other view)",
        "inverse": "Has map (other view)"
      },
      "map-station-point": {
        "name": "Marks station",
        "inverse": "Marked on map"
      },
      "map-place-point": {
        "name": "Marks place",
        "inverse": "Marked on map"
      },
      "place-at-station": {
        "name": "At station",
        "inverse": "Station of place"
      }
    },
    "members": "Members",
    "noVisibleMembers": "Nothing in this link is visible to you.",
    "memberType": "Kind of item",
    "memberSource": "Which item",
    "pickExisting": "Pick something that already exists",
    "newPointOnMap": "Mark a new point on the map",
    "target": "Item",
    "searchPlaceholder": "Type at least two letters to search…",
    "anchorKind": "What it points at",
    "anchorKindPending": "Pointing at this kind of part arrives with the viewer that can select it.",
    "note": "Note",
    "notePlaceholder": "Why these belong together (optional)",
    "markAsMain": "This is the item the relation reads from",
    "mainNeedsDirected": "Only a relation that reads one way has an item it reads from.",
    "mainAlreadySet": "This link already reads from one of its items; change that on the link page.",
    "newMember": "the new item",
    "thisItem": "this item",
    "createTitle": "Record a link",
    "addMemberTitle": "Add an item",
    "relation": "Relation",
    "relationPlaceholder": "How they are related (optional)",
    "directionNeedsMain": "This relation reads one way; mark which item it reads from.",
    "directionPreview": "From {{main}}: {{forward}} · the other way round: {{inverse}}",
    "description": "Description",
    "descriptionPlaceholder": "What this link records (optional)",
    "editDetails": "Edit this link",
    "doneEditing": "Done",
    "linkAddress": "Address",
    "created": "Recorded",
    "createdByYou": "{{when}}, by you",
    "createdBy": "{{when}}, by {{who}}",
    "openTarget": "Open",
    "setMain": "Read the relation from this one",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "removeMember": "Remove from link",
    "removeMemberConfirm": "Remove this item from the link?",
    "anchorKinds": {
      "whole": "The whole thing",
      "textRange": "A passage of text",
      "page": "A page",
      "pageRange": "A range of pages",
      "imageRegion": "A region of an image",
      "timePoint": "A moment in the recording",
      "timeRange": "A stretch of the recording",
      "modelStation": "A survey station",
      "modelStationRange": "A run of survey stations",
      "modelSurvey": "A survey",
      "modelSurveyRange": "A run of surveys",
      "modelPoint": "A point in the model",
      "waypoint": "A waypoint",
      "waypointRange": "A run of waypoints",
      "tripMoment": "A moment of the trip"
    },
    "anchorEditors": {
      "page": "Page",
      "fromPage": "First page",
      "toPage": "Last page",
      "seconds": "Seconds",
      "start": "From (seconds)",
      "end": "To (seconds)",
      "textHint": "Open the document below and drag across the passage you mean. What is stored is the passage itself, so the link still finds it after the document is read again.",
      "textCaptured": "Page {{page}}: “{{quote}}”",
      "textNotFound": "Those words are not in the text read from this page, so nothing here can say where they are. Selecting a passage that is real text — rather than part of a picture — records it exactly.",
      "textPageNotRead": "This page has not been read yet, so there is no text to place the passage in. Try again once the document has been read.",
      "textNeedsDocument": "Choose the document first; the passage is selected in it.",
      "textNotSelectable": "This document's words cannot be selected here. A page of it can still be pointed at.",
      "textRequired": "Select a passage in the document.",
      "textEmpty": "The selection is empty.",
      "pageRequired": "Give a page number of 1 or more.",
      "pageRangeRequired": "Give both page numbers, each 1 or more.",
      "pageRangeBackwards": "The last page cannot come before the first.",
      "timeRequired": "Give a time in seconds, 0 or more.",
      "timeRangeRequired": "Give both times in seconds, each 0 or more.",
      "timeRangeBackwards": "The end must come after the start; use a single moment for an instant.",
      "regionShape": "Shape",
      "regionShapes": {
        "rect": "Rectangle",
        "circle": "Circle",
        "polygon": "Outline",
        "point": "Point"
      },
      "regionHelp": {
        "rect": "Drag across the picture to box the part you mean. From the keyboard: move with the arrow keys (Shift for larger steps), press Enter at one corner and again at the opposite one.",
        "circle": "Press at the centre and drag outwards. From the keyboard: move with the arrow keys, press Enter at the centre and again on the edge.",
        "polygon": "Click each corner in turn, then double-click to close the outline. From the keyboard: move with the arrow keys and press Enter at each corner; press Enter twice on the last corner to close it, Backspace to take a corner back.",
        "point": "Click the spot you mean. From the keyboard: move with the arrow keys and press Enter."
      },
      "regionDrawn": "The part you drew",
      "regionSurface": "Draw on {{name}}: arrow keys move the cursor, Enter places it, Escape abandons the shape",
      "regionUnnamed": "Region {{number}}",
      "regionClear": "Draw it again",
      "regionRequired": "Draw the part of the picture you mean.",
      "regionNeedsDocument": "Choose the picture first, then draw on it.",
      "regionNotAPicture": "This document is not a picture, so it has no regions to point at. Choose another part instead.",
      "regionNoRendering": "This picture cannot be shown here, so there is nothing to draw on."
    },
    "point": {
      "title": "New point",
      "name": "Name",
      "namePlaceholder": "Name for this point (optional)",
      "altitude": "Altitude (m)",
      "altitudePlaceholder": "Altitude in metres (optional)",
      "visibility": "Who can see it",
      "visibilityDefault": "Default",
      "audienceDefaultGroup": "By default this point will be visible to members of {{group}}. You can change it here, or later by editing the point.",
      "audienceDefaultAuthenticated": "By default this point will be visible to everyone signed in. You can change it here, or later by editing the point.",
      "audienceUnknown": "Who this point would be visible to by default could not be checked. Choose an audience above to be certain.",
      "audience": {
        "private": "Only you will be able to see this point.",
        "cavingGroup": "Members of your caving club will see this point — this works when you belong to exactly one club; otherwise only you will see it until you name a club by editing the point.",
        "authenticated": "Everyone signed in will be able to see this point.",
        "public": "Anyone will be able to see this point, including visitors who are not signed in."
      }
    },
    "problems": {
      "signedOut": "You are signed out. Sign in and try again.",
      "forbidden": "You are not allowed to do that.",
      "createForbidden": "You are not allowed to create features here.",
      "validationFailed": "Something in the form is not accepted. Check the values and try again.",
      "placePointFixed": "A point on a phone's map is moved or removed on its map, not edited as a link.",
      "placeStationFixed": "A place's station is set on the phones and is not edited as a link; it can be removed.",
      "placePointMapNotFound": "This picture is not a map a phone carries.",
      "placePointPlaceNotFound": "That place is not in this map's cave, or you may not see where it is.",
      "placePointPlacePinned": "That place already has a point on this map.",
      "placePointNotCurrentFile": "The map's picture changed meanwhile. Open the map again and try again.",
      "placePointFrameUnknown": "The size of this picture is not known, so the phones could not use a point on it.",
      "linkGone": "This link no longer exists.",
      "codeUnresolved": "This link address does not lead anywhere.",
      "typeUnknown": "This client asked for a kind of item the server does not know.",
      "targetGone": "That item cannot be found, or you may not read it.",
      "targetInvalid": "That item cannot take part in a link.",
      "typeNotLinkable": "This kind of item cannot take part in a link.",
      "anchorKindNotAllowed": "That kind of item cannot be pointed at that way.",
      "anchorInvalid": "The part you pointed at is not described in a way the server accepts.",
      "anchorFileInvalid": "The file this points into does not belong to that item.",
      "anchorPinRequired": "Pointing at a region needs the file it is measured against.",
      "memberLimit": "This link already holds as many items as it can.",
      "lastMember": "A link keeps at least one item; delete the link instead.",
      "mainRequired": "A relation that reads one way needs the item it reads from.",
      "mainNotSingle": "Exactly one item can be the one the relation reads from.",
      "mainNotAllowed": "This relation reads the same both ways, so no item is the one it reads from.",
      "mainNotAMember": "The item the relation should read from is not in this link.",
      "memberGone": "That item is no longer part of this link.",
      "relationUnknown": "That relation is not one this installation offers.",
      "relationGone": "That relation no longer exists.",
      "duplicateWhole": "This link already names that item as a whole.",
      "geoPointUnavailable": "Points cannot be created here: the generic feature kind is not installed.",
      "relationCodeTaken": "Another relation already uses that code.",
      "relationSeededImmutable": "A relation that ships with the product keeps its code and the way it reads.",
      "relationSeededUndeletable": "A relation that ships with the product cannot be deleted.",
      "relationInUse": "Links already record this relation, so it cannot be changed that way or deleted."
    }
  },
  "importReview": {
    "held": "Your account's imports wait for a reviewer. Nothing has been created yet; it will be once a reviewer accepts it."
  },
  "vectorImport": {
    "title": "Review and import",
    "reviewAndImport": "Review and import into the registry",
    "mapPreview": "Map preview",
    "dryRun": "What each rule claims",
    "optionsRules": "Rules and naming",
    "optionsCreated": "What gets created",
    "optionsUnmatched": "Points no rule recognised",
    "unmatched": "What to do with them",
    "unmatchedHint": "A rule set recognises the names your group writes down; a GPS unit emptied at the end of a season is mostly WPT0142. Points nothing recognised propose nothing, and a row proposing nothing cannot be ticked — so leaving this at 'leave for review' means selecting everything selects only the rows the rules named.",
    "unmatchedIgnore": "Leave them for review, one at a time",
    "unmatchedAsFeature": "Propose a surface feature",
    "unmatchedAsEntrance": "Propose a cave entrance",
    "unmatchedKind": "Of this type",
    "optionsTracks": "Tracks and routes",
    "optionsMapping": "Which field is which",
    "ruleSet": "Rule set",
    "languages": "Languages",
    "languagesAll": "All the set holds",
    "languagesHint": "Only terms in these languages take part. Terms marked as belonging to no language always do.",
    "namePrefix": "Name prefix",
    "duplicateRadius": "Look for something already there within",
    "duplicateRadiusHint": "Only objects whose exact position you may see are measured against. A protected cave you cannot locate is not answered about.",
    "elevation": "GPS altitude",
    "elevationKeep": "Keep what the file says",
    "elevationDiscard": "Leave it empty",
    "locationProtected": "Mark everything created as a protected location",
    "tracks": "Tracks and routes",
    "tracksIgnore": "Leave them in the file",
    "tracksAsLine": "Import as a line feature",
    "trackKind": "Line feature kind",
    "mappingAuto": "Work it out",
    "mapping": {
      "nameField": "Name",
      "descriptionField": "Description",
      "codeField": "Identification code",
      "elevationField": "Altitude"
    },
    "selectAll": "All",
    "selectAllPages": "Select all {{count}} across every page",
    "selectInvertPages": "Invert across every page ({{count}})",
    "selectNone": "None",
    "selectInvert": "Invert",
    "selectedCount": "{{count}} of {{total}} selected",
    "searchPlaceholder": "Search names…",
    "filterByRule": "By rule",
    "filterByKind": "By kind",
    "onlyWithNearby": "Only ones with something nearby",
    "geometryAll": "All",
    "geometry": {
      "point": "Point",
      "line": "Track",
      "area": "Area",
      "other": "Other"
    },
    "fileSummary": "{{candidates}} points · {{matched}} claimed by a rule · {{unmatched}} unclaimed · {{tracks}} tracks · {{areas}} areas",
    "columns": {
      "name": "Name",
      "kind": "Becomes",
      "type": "Type",
      "rule": "Rule",
      "position": "Position",
      "nearby": "Already there",
      "decision": "Decision"
    },
    "kinds": {
      "cave": "Cave",
      "caveEntrance": "Cave entrance",
      "surfaceFeature": "Surface feature"
    },
    "kindNone": "Nothing",
    "actions": {
      "create": "Create",
      "attach": "Already there",
      "skip": "Skip"
    },
    "noRule": "No rule claimed it",
    "conflict": "Two rules claimed it",
    "conflictHint": "Also claimed by: {{rules}}. The rule earlier in the set wins.",
    "nothingNearby": "Nothing nearby",
    "metresAway": "{{distance}} m away",
    "itIsThisOne": "It is this one",
    "secondEntranceOf": "Second entrance of {{cave}}",
    "unnamed": "Unnamed",
    "createSelected": "Create {{count}} objects",
    "createWithoutReview": "Create everything the rules claimed",
    "commitFailed": "Nothing was created. Check the message and try again.",
    "fileNotFound": "That file is not available.",
    "truncatedTitle": "The file is larger than one review reads",
    "truncated": "The first {{scanned}} of {{total}} rows are shown. Confirm these, then open the review again for the rest.",
    "resultTitle": "What the import did",
    "created": "Created",
    "attached": "Recognised",
    "skipped": "Skipped",
    "someFailedTitle": "{{count}} rows could not be created",
    "someFailed": "Everything else was created. Fix these and confirm them on their own.",
    "failureReason": "Why",
    "viewBatches": "See the imports",
    "batchFile": "File",
    "batchFromPhotos": "Photographs",
    "batchFromDevice": "Phone upload",
    "batchMode": "How",
    "batchDetail": "What this import created",
    "confirmedAt": "Confirmed",
    "modes": {
      "reviewed": "Reviewed",
      "autoCreated": "Without review"
    },
    "upload": {
      "intro": "A phone sent these changes. Open a line to see what it changed in that row. Undoing puts every value back as it was before the upload; a value somebody has changed since is left as it is.",
      "undo": "Undo this upload",
      "undoConfirm": "Undo this upload?",
      "undoLeaves": "Caves and features it created are deleted, what it deleted comes back, and each value it changed goes back. A value changed again since is left as it is, and the result says which.",
      "undoAnyway": "Undo anyway",
      "undoAnywayConfirm": "Undo this upload, even the values changed since?",
      "undoAnywayRowConfirm": "Undo this row, even the values changed since?",
      "undoAnywayExplain": "The later changes are overwritten with the value from before the upload. They stay in the history, so they can be put back from there. A position you may not see exactly is never put back.",
      "undoRow": "Undo this row",
      "undoRowConfirm": "Undo this row only?",
      "lineUndone": "Undone",
      "supersededHint": "A field somebody has edited again since the upload is left by \"Undo this row\"; the result says which. \"Undo anyway\" puts it back too.",
      "createdRow": "The upload created this row.",
      "noRecordedChange": "The history holds no change to this row from this upload.",
      "undone": "The upload was undone.",
      "undoneWithLeft_one": "Undone, except {{count}} line. See below.",
      "undoneWithLeft": "Undone, except {{count}} lines. See below.",
      "fieldLeft": "{{field}} was left: {{reason}}",
      "outcome": {
        "undone": "Undone",
        "partly": "Partly undone",
        "not_undone": "Not undone"
      },
      "reason": {
        "already_undone": "already undone",
        "purged": "the row has been removed for good",
        "container_deleted": "the cave it belongs to is still deleted",
        "superseded": "it was deleted again after the upload",
        "fields_left": "other changes to it are left",
        "no_history": "this upload is older than the history that says what it changed",
        "forbidden": "you may not change this row",
        "trip_changed": "somebody has worked on the trip report made from it, so the report is kept",
        "converted_elsewhere": "its trip report was made by an archive import, so the report is kept"
      }
    },
    "revert": "Undo",
    "reverted": "The import was undone.",
    "revertedTag": "Undone",
    "reviewPendingTag": "Waiting for review",
    "reviewRejectedTag": "Turned down in review",
    "reviewPartlyTag": "Partly accepted in review",
    "reviewPendingExplain": "A reviewer has not decided this import yet. Nothing of it has been written; what is accepted is written then, and can be undone afterwards.",
    "revertConfirm": "Delete all {{count}} objects this import created?",
    "revertTripsRestorableFor": "Each trip it created can be restored from Deleted trips for {{period}}.",
    "revertTripsRestorable": "Each trip it created can be restored from Deleted trips.",
    "tripDeletedRestore": "Restore it from Deleted trips",
    "revertFeaturesRestorable": "Each cave and feature it created can be restored from Deleted caves and features.",
    "featureDeletedRestore": "Restore it from Deleted caves and features",
    "fileGone": "The file has been deleted",
    "notCreated": "Nothing created",
    "deletedTag": "Deleted",
    "elevationPerCandidate": "Decide per candidate",
    "elevationHint": "The file is the only source. Nothing is taken from an elevation model: a public grid beside a cliff — which is where entrances are — is out by a hundred metres, with nothing on screen to say so.",
    "keepAltitude": "Keep {{altitude}} m",
    "batchFromCatalogue": "From the cave catalogue",
    "batchFromTrips": "From a trip spreadsheet",
    "batchFromSpeleoloc": "From a phone's trip recording",
    "creating": "Creating {{count}} objects. This runs on the server and keeps going if you leave this page.",
    "creatingHint": "The batch appears under Import batches when it is done, and reverts as one thing.",
    "progress": "{{done}} of {{total}} rows reached",
    "retrying": "The last attempt did not finish and will be tried again shortly.",
    "saving": "All {{total}} rows reached; saving them"
  },
  "photoImport": {
    "title": "Features from photographs",
    "openFromGeodata": "From photographs",
    "openFromTrip": "Derive features from this trip's photographs",
    "filedUnderTrip": "Filed under this trip",
    "mapPreview": "Map preview",
    "dropTitle": "Drop a trip's worth of photographs here",
    "dropHint": "Pictures that record where they were taken are grouped into places. Ones that do not can be matched against a track, or dragged onto the map.",
    "uploading": "Uploading… {{count}} to go",
    "uploadFailed": "The pictures could not be uploaded.",
    "commitFailed": "Nothing could be created from the selection.",
    "createSelected": "Create {{count}} selected",
    "unreadable": "{{count}} of the chosen files could not be read and are not in the review.",
    "unplacedTitle": "{{count}} of the pictures have no position",
    "unplacedHint": "Choose a track to match them against by their capture time, or select a row and place it on the map by hand.",
    "placingTitle": "Click the map to place this picture. It is written to the review, never back into the file.",
    "placeOnMap": "Place on the map",
    "unnamed": "Unnamed",
    "typePlaceholder": "Choose a type",
    "nothingNearby": "Nothing nearby",
    "nearbyCount": "{{count}} nearby",
    "nearbyOption": "{{name}} · {{distance}} m",
    "createNew": "Create a new one",
    "altitude": "{{value}} m",
    "bearing": "Facing {{value}}°",
    "bearingMagnetic": "Facing {{value}}° (magnetic)",
    "optionsPlaces": "Places and grouping",
    "optionsCreated": "What gets created",
    "optionsClock": "Pictures with no position",
    "defaultKind": "Each place becomes",
    "namePrefix": "Name prefix",
    "clusterRadius": "Two pictures are the same place within",
    "clusterRadiusHint": "Twelve photographs of one entrance are one candidate with a gallery. A shaft shot from the rim and from the floor of the doline is thirty metres apart and still one hole.",
    "proximityRadius": "Look for something already there within",
    "proximityRadiusHint": "Only objects whose exact position you may see are measured against. A protected cave you cannot locate is not answered about.",
    "elevation": "Capture altitude",
    "elevationHint": "A phone's GPS altitude is the least reliable of the three numbers it reports, so it is left out unless you ask for it.",
    "clockIntro": "A picture with no fix of its own can be placed by matching when it was taken against a track somebody walked.",
    "track": "Match against this track",
    "trackNone": "Do not match by time",
    "trackHasNoTimes": "That file records no times, so nothing can be matched against it.",
    "trackFixes": "The track holds {{count}} recorded positions.",
    "clockOffset": "Camera clock offset",
    "clockOffsetHint": "Added to each picture's stated time before comparing. Camera clocks drift, and one left on the wrong zone is out by whole hours while looking perfectly plausible.",
    "matchTolerance": "Match within",
    "matchToleranceHint": "How far from a recorded position a picture may still be placed. Beyond it the track says nothing about where the photographer was.",
    "seconds": "s",
    "trackMatchGap": "{{seconds}} s from a fix",
    "trackMatchHint": "How far this position sits from a recorded one. A few seconds is a placement; two minutes is a guess about somebody walking.",
    "confidenceHint": "How much the satellite fix behind this picture is worth, as the camera reported it.",
    "columns": {
      "pictures": "Pictures",
      "name": "Name",
      "becomes": "Becomes",
      "type": "Type",
      "position": "Position",
      "nearby": "Already there",
      "decision": "Decision"
    },
    "sources": {
      "none": "Not placed",
      "noneHint": "Neither the camera nor a track placed this. Drag it onto the map to give it a position.",
      "exif": "From the camera",
      "exifHint": "The position the camera itself recorded when the picture was taken.",
      "trackMatch": "From a track",
      "trackMatchHint": "Worked out by matching the capture time against a recorded track.",
      "manual": "Placed by hand",
      "manualHint": "Somebody put this on the map. It is stored with the record and never written back into the file."
    },
    "confidence": {
      "unknown": "Quality unknown",
      "excellent": "Excellent fix",
      "good": "Good fix",
      "moderate": "Moderate fix",
      "poor": "Poor fix"
    },
    "actions": {
      "create": "Create",
      "createHint": "A new object is created here, with these pictures attached.",
      "attach": "File on",
      "attachHint": "Nothing new is created; the pictures are hung on the object already there.",
      "skip": "Skip",
      "skipHint": "Left out of this confirmation."
    }
  },
  "photoFacts": {
    "title": "Photograph",
    "takenAt": "Taken",
    "camera": "Camera",
    "lens": "Lens",
    "exposure": "Exposure",
    "dimensions": "Size",
    "orientation": "Orientation",
    "position": "Position",
    "altitude": "Altitude",
    "direction": "Facing",
    "nothingRecorded": "This picture records nothing about how it was taken.",
    "usePosition": "Use this picture's position",
    "usePositionTitle": "Move this object to where the picture was taken?",
    "usePositionHint": "An ordinary change, recorded in this object's history and undone there. The picture itself is not altered.",
    "usePositionOk": "Move it",
    "positionApplied": "The object was moved to the picture's position.",
    "positionApplyFailed": "The object could not be moved.",
    "orientations": {
      "1": "Upright",
      "2": "Mirrored",
      "3": "Upside down",
      "4": "Mirrored, upside down",
      "5": "Mirrored, turned left",
      "6": "Turned right",
      "7": "Mirrored, turned right",
      "8": "Turned left"
    }
  },
  "termRules": {
    "title": "Detection rules",
    "intro": "What a waypoint called Peștera, P., aven, izbuc, ponor or doline is proposed to become. Order decides: when two rules claim one candidate, the earlier one wins.",
    "name": "Name",
    "scope": "Belongs to",
    "ruleCount": "Rules",
    "newSet": "New set",
    "edit": "Edit set",
    "editCopy": "Edit a copy of your own",
    "copyOf": "Copy of {{name}}",
    "export": "Save as a file",
    "importFile": "Load from a file",
    "imported": "The file was loaded as a set of your own.",
    "importFailed": "That file could not be read as a rule set.",
    "promote": "Make default",
    "makeInstallationDefault": "Make this what every import starts from",
    "promoted": "Every import now starts from this set.",
    "promoteFailed": "Only an administrator can change what everybody inherits.",
    "deleteConfirm": "Delete this rule set?",
    "default": "Default",
    "shipped": "Shipped",
    "invalid": "The set cannot be saved as written",
    "orderHint": "Order decides. When two rules claim one candidate, the one higher up wins.",
    "ruleName": "Rule name",
    "enabled": "On",
    "addRule": "Add a rule",
    "matchMode": "Compare by",
    "target": "Proposes",
    "proposedType": "Type",
    "strip": "Take the term out of the name",
    "readName": "Read the name",
    "readDescription": "Read the description",
    "termsPlaceholder": "Type a term and press Enter",
    "scopes": {
      "installation": "The whole installation",
      "cavingGroup": "A caving group",
      "user": "You"
    },
    "matchModes": {
      "contains": "Contains",
      "wholeWord": "Whole word",
      "prefix": "Starts with",
      "regex": "Regular expression"
    },
    "stripModes": {
      "none": "Keep it",
      "leading": "Only from the front",
      "trailing": "Only from the end",
      "anywhere": "Wherever it is"
    },
    "languages": {
      "ro": "Romanian terms",
      "en": "English terms",
      "any": "Terms in no language"
    }
  },
  "filters": {
    "typed": {
      "understood": "Read as: {{text}}",
      "unreadable": "Could not read this, so nothing is applied. Write a number such as 300, or a comparison such as >300, <=30, !=300 or 300..500.",
      "unreadableDay": "Could not read this, so nothing is applied. Write a day such as 2024-05-01 or 1.5.2024, or a comparison such as >2024-05-01, !=2024-05-01 or 2024-05-01..2024-06-30.",
      "notOffered": "This field cannot be compared that way, so nothing is applied.",
      "hint": "e.g. >300, 300..500",
      "hintDay": "or type >2024-05-01",
      "number": {
        "equals": "equal to {{value}}",
        "notEquals": "not equal to {{value}}",
        "greaterThan": "more than {{value}}",
        "greaterOrEqual": "at least {{value}}",
        "lessThan": "less than {{value}}",
        "lessOrEqual": "at most {{value}}",
        "between": "between {{low}} and {{high}}"
      },
      "day": {
        "equals": "on {{value}}",
        "notEquals": "not on {{value}}",
        "greaterThan": "after {{value}}",
        "greaterOrEqual": "on or after {{value}}",
        "lessThan": "before {{value}}",
        "lessOrEqual": "on or before {{value}}",
        "between": "from {{low}} to {{high}}"
      }
    },
    "editor": {
      "wholeRefusal": {
        "malformed": "The filter could not be read. Reload the page, or rebuild the condition and apply it again.",
        "unreadable": "That saved filter cannot be read with your access, so it was not applied."
      },
      "sort": "Order",
      "descending": "Descending",
      "ascending": "Ascending",
      "spatial": {
        "radius": "Distance in metres",
        "metres": "m",
        "of": "of",
        "anchorKind": "Measured from",
        "anchorKinds": {
          "selection": "the selected object",
          "object": "an object",
          "point": "a point",
          "savedFilter": "a saved filter's results"
        },
        "selectionNamed": "Measured from the object selected on the map.",
        "noSelection": "Select an object on the map first.",
        "outlineKind": "Outline",
        "outlineKinds": {
          "view": "the map view",
          "draw": "an outline drawn on the map",
          "area": "a named area",
          "polygon": "a pasted polygon"
        },
        "draw": "Draw on the map…",
        "drawAgain": "Draw again…",
        "takeViewAgain": "Take the view again",
        "outlineSet": "Outline set: {{count}} corners.",
        "object": "Object to measure from",
        "area": "Area",
        "areas": "Areas",
        "savedFilter": "Saved filter to measure from",
        "longitude": "Longitude",
        "latitude": "Latitude",
        "polygon": "Polygon as GeoJSON",
        "polygonHint": "Paste a GeoJSON Polygon, or a Feature holding one",
        "polygonProblems": {
          "notJson": "This is not GeoJSON.",
          "notPolygon": "This is not a single polygon.",
          "offGlobe": "A position is not a longitude and latitude on the globe.",
          "notClosed": "Each ring must end where it starts.",
          "tooLarge": "An outline holds at most 2000 positions."
        },
        "needsAnchor": "Nearest first needs a place to measure from: type a point or pick an object.",
        "refused": {
          "notFound": "What this condition measures from is not available to you.",
          "notAnArea": "The object chosen is not an area with an outline.",
          "nested": "A saved filter measured from cannot itself measure from a saved filter.",
          "tooLarge": "That saved filter finds too many objects to measure from."
        },
        "notSaved": "A typed point, a map view, a drawn or pasted outline or a place to measure nearest first from is never saved. Use an object or a named area instead."
      },
      "apply": "Apply",
      "count": "Matches: {{count}}",
      "rowRefused": "The server cannot use this condition. Check its comparison and values, or remove it.",
      "refused": "The server refused this filter. Check its conditions, or remove the ones you do not need.",
      "problems": {
        "newer_version": "This filter was saved by a newer version of the application and cannot be read here.",
        "unreadable": "This filter has a part missing and cannot be read.",
        "no_scope": "The filter does not say what it is about.",
        "too_many_worlds": "A filter covers at most {{limit}} kinds of object.",
        "world_repeated": "A kind of object is named twice.",
        "unknown_world": "One of the kinds of object cannot be filtered here.",
        "sort_unsupported": "None of the chosen kinds of object can be sorted that way.",
        "too_many_nodes": "A filter holds at most {{limit}} conditions and groups.",
        "too_deep": "Groups are nested at most {{limit}} deep.",
        "empty_group": "A group needs at least one condition in it.",
        "unknown_field": "This field cannot be used here.",
        "op_unsupported": "This field does not support that comparison.",
        "takes_no_value": "This comparison takes no value.",
        "value_count": "Wrong number of values for this comparison: it takes {{limit}}.",
        "value_missing": "This condition needs at least one value.",
        "too_many_values": "One condition takes at most {{limit}} values.",
        "value_kind": "A value is of the wrong kind for this field.",
        "text_too_long": "A value is longer than {{limit}} characters.",
        "number_out_of_range": "A number here is too large to compare.",
        "range_reversed": "The range ends before it starts.",
        "anchor_not_stored": "A saved filter never keeps a place to measure from.",
        "radius_out_of_range": "A distance here is out of range: it can be at most {{limit}} metres.",
        "point_off_globe": "A point here is not on the globe.",
        "outline_invalid": "An outline here is not a simple polygon of at most {{limit}} positions.",
        "anchor_kind": "A distance cannot be measured from that kind of place or object.",
        "anchor_missing": "Nearest first needs a place to measure from."
      },
      "allOf": "All of these (AND)",
      "anyOf": "Any of these (OR)",
      "combinator": "How the conditions combine",
      "not": "Not",
      "addCondition": "Add condition",
      "addGroup": "Add group",
      "removeCondition": "Remove condition",
      "removeGroup": "Remove group",
      "tooDeep": "Groups are nested at most {{max}} deep.",
      "field": "Field",
      "chooseField": "Choose a field",
      "operator": "Comparison",
      "value": "Value",
      "yes": "Yes",
      "no": "No",
      "unavailableField": "a field not available to you",
      "needsType": "Asked only together with its feature type in the same AND group.",
      "propertyField": "Property: {{label}}",
      "ops": {
        "equals": "is",
        "in": "is one of",
        "contains": "contains",
        "startsWith": "starts with",
        "lessThan": "less than",
        "lessOrEqual": "at most",
        "greaterThan": "more than",
        "greaterOrEqual": "at least",
        "between": "between",
        "isEmpty": "is empty",
        "isNotEmpty": "is not empty",
        "within": "within",
        "inside": "inside"
      },
      "values": {
        "featureKinds": {
          "generic": "Generic",
          "cave": "Cave",
          "caveEntrance": "Cave entrance",
          "centerline": "Centreline"
        },
        "featureCategories": {
          "surface": "Surface",
          "underground": "Underground",
          "area": "Area",
          "structure": "Structure"
        },
        "visibilities": {
          "private": "Private",
          "cavingGroup": "Caving group",
          "authenticated": "Signed-in accounts",
          "public": "Public"
        },
        "activityStates": {
          "draft": "Draft",
          "proposed": "Proposed",
          "planned": "Planned",
          "confirmed": "Confirmed",
          "done": "Done",
          "published": "Published",
          "cancelled": "Cancelled",
          "delayed": "Delayed"
        },
        "mapKinds": {
          "geological": "Geological",
          "topographic": "Topographic",
          "tourist": "Tourist",
          "caveMap": "Cave map",
          "other": "Other"
        },
        "surveyModelFormats": {
          "lox": "Therion (.lox)",
          "survex3d": "Survex (.3d)",
          "stl": "Wall mesh (.stl)"
        },
        "geofileFormats": {
          "gpx": "GPX",
          "kml": "KML",
          "geoJson": "GeoJSON",
          "shapefile": "Shapefile",
          "wkt": "WKT",
          "wkb": "WKB",
          "kmz": "KMZ",
          "csv": "CSV"
        }
      }
    },
    "worlds": {
      "feature": "Features",
      "tripLog": "Trip logs",
      "mapView": "Map views",
      "document": "Documents",
      "georeferencedMap": "Georeferenced maps",
      "cabinet": "Cabinets",
      "surveyModel": "Survey models",
      "photograph": "Photographs",
      "geofile": "Geodata files",
      "savedFilter": "Saved filters"
    },
    "fields": {
      "position": "Position",
      "name": "Name",
      "title": "Title",
      "kind": "Kind",
      "category": "Category",
      "type": "Type",
      "tag": "Tag",
      "owner": "Owner",
      "cavingGroup": "Caving group",
      "organizingGroup": "Organising group",
      "visibility": "Visibility",
      "protected": "Protected location",
      "created": "Created",
      "updated": "Last changed",
      "tripType": "Trip type",
      "tripDate": "Trip date",
      "hadIncident": "Had an incident",
      "state": "State",
      "language": "Language",
      "region": "Region",
      "rockType": "Rock type",
      "surveyedLength": "Surveyed length (m)",
      "depth": "Depth (m)",
      "caveType": "Cave type",
      "otherToponyms": "Other names",
      "names": "Name, other names or code",
      "property": "Property",
      "mapKind": "Map kind",
      "surveyFormat": "Survey format",
      "surveyedAt": "Surveyed on",
      "isCurrent": "Current model",
      "cave": "Cave",
      "takenAt": "Taken on",
      "caption": "Caption",
      "placeName": "Place name",
      "datedAt": "Dated (taken, else uploaded)",
      "fileFormat": "File format"
    },
    "problems": {
      "noWorlds": "Choose at least one kind of object to search.",
      "tooManyWorlds": "A filter covers at most {{max}} kinds of object.",
      "worldTwice": "Each kind of object appears once.",
      "tooLarge": "This filter has more than {{max}} parts. Try splitting it.",
      "tooDeep": "These conditions are nested more than {{max}} deep.",
      "tooManyValues": "A condition holds at most {{max}} values.",
      "textTooLong": "Text in a condition is at most {{max}} characters.",
      "sortUnavailable": "Nothing being searched can be sorted that way."
    },
    "selector": {
      "placeholder": "Search",
      "typeToSearch": "Type at least {{count}} characters",
      "noMatches": "Nothing matches",
      "nothingChosen": "Nothing chosen",
      "chosen": "{{count}} chosen",
      "restricted": "{{count}} not shown — gone, or not yours to see",
      "placeable": "You can be shown where this is",
      "mapPlaceholder": "Go to…",
      "noDestination": "Nothing to open for that yet.",
      "savedFilterNotForMap": "That saved filter does not ask about features, or cannot be run with your access, so it was not applied to the map.",
      "clear": "Clear the choice",
      "matchedOtherToponyms": "also known as {{text}}",
      "matchedCode": "code {{text}}"
    },
    "sorts": {
      "created": "Added",
      "updated": "Changed",
      "title": "Name",
      "owner": "Owner",
      "occurred": "Date",
      "proximity": "Nearest"
    },
    "scopes": {
      "caves": "Caves",
      "entrances": "Entrances",
      "features": "All features",
      "documents": "Documents",
      "trips": "Trips",
      "views": "Views",
      "photographs": "Photographs",
      "savedFilters": "Saved filters"
    }
  },
  "notificationHealth": {
    "title": "Message delivery",
    "intro": "Whether messages are getting out of this installation. Every row here is one somebody was meant to receive: a channel a person has switched off produces no row at all, so a backlog is always a backlog.",
    "stalled": "Nothing has been sent for {{age}}.",
    "stalledHint": "The oldest message still waiting was queued that long ago. Check the mail server settings and the test send on the messaging page.",
    "oldestPending": "Oldest still waiting",
    "nothingWaiting": "Nothing waiting",
    "paidToday": "Charged message segments today",
    "paidTodayValue": "{{spent}} of {{cap}}",
    "byChannel": "By channel",
    "noDeliveries": "Nothing has been sent yet.",
    "anyStatus": "Any status",
    "attentionOnly": "Only what needs attention",
    "refresh": "Refresh",
    "createdAt": "Queued",
    "recipient": "For",
    "unknownRecipient": "Account no longer exists",
    "category": "About",
    "templateKey": "Message",
    "channel": "Channel",
    "status": "Status",
    "attempts": "Attempts",
    "error": "What went wrong",
    "retry": "Send again",
    "retryTitle": "Send this message again?",
    "retryConfirm": "This sends “{{template}}” to the person it was meant for. Their current answer is read again first, so if they have since asked not to be told about this, nothing is sent.",
    "retryOk": "Send again",
    "retryFailed": "It could not be put back.",
    "ageMinutes": "{{count}} minutes",
    "ageHours": "{{count}} hours",
    "ageDays": "{{count}} days",
    "statuses": {
      "pending": "Waiting",
      "deferred": "Held for the daily summary",
      "sent": "Sent",
      "dead": "Given up"
    },
    "outcomes": {
      "notFound": "There is no such message any more.",
      "notDead": "That one has not given up, so there is nothing to put back.",
      "templateUnknown": "Nothing knows how to write this message, so it would fail the same way. The wording has to be restored first.",
      "unreachable": "There is nowhere to send it: the account is gone, or no longer has an address.",
      "suppressed": "The person it was for has since asked not to be told about this, so it was not sent. They can still read it in their own list.",
      "queued": "Back in the queue."
    }
  },
  "calendar": {
    "title": "Calendar",
    "when": "When",
    "what": "What",
    "kind": "Kind",
    "state": "State",
    "postponed": "Date not settled",
    "togglePast": "Past",
    "toggleTrips": "Trips",
    "toggleCamps": "Camps",
    "toggleEvents": "Events",
    "kindFilter": "Any kind of event",
    "kindFilterOff": "Events are turned off, so there is nothing for a kind to narrow. Turn Events on to choose.",
    "kindFilterNote": "Kinds narrow the events only. Trips and camps have no kind, so they are still listed — turn them off beside it to see the events alone.",
    "toggleCancelled": "Called off",
    "toggleMine": "Only mine",
    "groupFilter": "Any group",
    "omitted": "{{count}} more rows fall in these days than this page can carry. Ask for fewer days.",
    "empty": "Nothing is recorded in these days.",
    "emptyFiltered": "Nothing in these days matches what you asked for.",
    "emptyNoKind": "No kind of record is selected.",
    "failed": "The calendar could not be read.",
    "views": {
      "record": "Record",
      "month": "Month",
      "week": "Week",
      "year": "Year",
      "agenda": "Agenda"
    },
    "weekPrevious": "Previous week",
    "weekNext": "Next week",
    "weekToday": "This week",
    "weekDayEmpty": "Nothing",
    "monthCount": "{{count}} records",
    "spanDay": "day {{day}} of {{count}}",
    "grouping": {
      "groupBy": "Group by",
      "unassigned": "Not recorded",
      "unlistedGroup": "A group you cannot list",
      "dimensions": {
        "none": "Nothing",
        "month": "Month",
        "week": "Week",
        "kind": "Kind",
        "state": "State",
        "cavingGroup": "Caving group"
      }
    },
    "today": "Today",
    "todayLine": "Today · {{date}}",
    "todayNoPlace": "Arranged this way, the list has no one place that is today. Order it by When, and group it by nothing, month or week.",
    "mapToggle": "Map",
    "mapEmpty": "No trip or camp in view has a position recorded. Pan or zoom the map to look elsewhere.",
    "mapFailed": "The map of these days could not be read, so nothing is drawn on it — which is not the same as there being nothing there. Try again in a moment.",
    "mapDrawn": "{{count}} of the trips and camps in these days are drawn here.",
    "mapTruncated": "More trips fall inside this view than one answer can carry, so not every trip is drawn. Zoom in to see the rest.",
    "mapCaveat": "Only trips and camps are drawn, and only the ones inside this view: club dates carry no shape, a camp is its working area and nothing more, and a record outside the view is drawn once you move to it. A hollow ring is where a party meets, a filled one is where it worked.",
    "sourceValues": {
      "tripLog": "Trip",
      "expedition": "Camp",
      "event": "Event"
    }
  },
  "events": {
    "title": "Events",
    "titleField": "Title",
    "create": "New event",
    "edit": "Edit event",
    "delete": "Delete",
    "deleteConfirm": "Delete this event?",
    "searchPlaceholder": "Search by title",
    "kind": "Kind",
    "kindFilter": "Any kind",
    "kindValues": {
      "clubMeeting": "Club meeting",
      "training": "Training",
      "maintenanceDay": "Working day",
      "gearCheck": "Gear check",
      "conference": "Conference",
      "deadline": "Deadline"
    },
    "dates": "Dates",
    "time": "Time",
    "startTime": "Starts at",
    "endTime": "Ends at",
    "place": "Place",
    "description": "Description",
    "cavingGroup": "Caving group",
    "state": "State",
    "stateFilter": "Any state",
    "announce": "Announce",
    "announceSuccess": "The event was announced.",
    "unannounce": "Back to draft",
    "unannounceSuccess": "The event went back to the workshop.",
    "propose": "Float the idea",
    "proposeSuccess": "The event was floated.",
    "organise": "Start organising",
    "organiseSuccess": "The event is being organised.",
    "confirm": "It is going ahead",
    "confirmSuccess": "The event is going ahead.",
    "postpone": "Put it back",
    "postponeSuccess": "The event was put back.",
    "reschedule": "Settle a new date",
    "rescheduleSuccess": "The event is being organised again.",
    "markDone": "It happened",
    "markDoneSuccess": "The event was recorded as having happened.",
    "notFound": "No such event",
    "notFoundDetail": "Either it is not there, or it is not yours to read. This page cannot tell the two apart, and does not try.",
    "callOff": "Call it off",
    "callOffConfirm": "Call this event off?",
    "callOffSuccess": "The event was called off.",
    "maxParticipants": "Places",
    "maxParticipantsHelp": "How many people the event has room for. Leave empty for no limit; anybody past the limit waits in the order they answered in.",
    "tabResponses": "Who is coming",
    "kindHasResponses": "People have already said whether they are coming, and an event of that kind is not answered. Change the kind back, or take the answers off first.",
    "tabHistory": "History",
    "repeats": "It comes round again",
    "repeatsHelp": "Writes the whole run now, as ordinary events. Each one is then edited, answered and called off on its own.",
    "repeatFrequency": "How often",
    "repeatFrequencyValues": {
      "daily": "Every day",
      "weekly": "Every week",
      "fortnightly": "Every other week",
      "monthly": "Every month"
    },
    "repeatRule": "In your own words",
    "repeatRuleHelp": "How you would describe the repetition to somebody reading the calendar — “every Tuesday in term time”. It is shown exactly as written, and no date is ever worked out from it.",
    "repeatCount": "How many",
    "repeatCountHelp": "The first one included. At most {{max}}, and never more than two years past the first day.",
    "repeatUntil": "Or up to and including",
    "repeatUntilHelp": "The last day one may fall on. Give this, or a number, or both.",
    "repeatBoundRequired": "Say how many there are, or the last day one falls on. A repetition told neither is not written at all.",
    "scope": "This change applies to",
    "scopeOccurrence": "Only this occurrence",
    "scopeFollowing": "This one and every later one",
    "seriesBanner": "One occurrence of something that comes round again.",
    "seriesRule": "Described as: {{rule}}",
    "seriesFrequency": "Comes round {{frequency}}.",
    "seriesFrequencyValues": {
      "daily": "every day",
      "weekly": "every week",
      "fortnightly": "every other week",
      "monthly": "every month"
    },
    "seriesFrequencyChangeHelp": "Changing this re-spaces this occurrence and every later one from this one's day. Earlier occurrences keep their days.",
    "seriesOccurrences": "See the other occurrences",
    "seriesFilter": "Showing one repeating event's occurrences",
    "seriesEdited": "{{count}} occurrences were changed.",
    "seriesDeleteTitle": "Call off the rest of this run?",
    "seriesDeleteDetail": "Occurrences that have already begun are kept whatever is chosen here: each is the record of an evening that happened and of who said they would come.",
    "seriesDeleted": "{{deleted}} occurrences went; {{kept}} had already happened and were kept.",
    "recurrenceUnbounded": "Say how many occurrences there are, or the last day one falls on. Nothing was written.",
    "recurrenceNotRepeating": "What was asked for happens once, so there is no run to write. Leave the repetition off for a single event.",
    "recurrenceTooMany": "That is more occurrences than one request writes. Ask for a shorter run — nothing was written, rather than part of it.",
    "recurrenceHorizonTooFar": "That run would reach further ahead than a run is written for. Stop it sooner, or make it come round less often — nothing was written, rather than part of it.",
    "recurrenceCreateOnly": "A repetition is settled when an event is written. Changing this occurrence changes this occurrence.",
    "seriesPartlyForbidden": "This run holds an occurrence that is not yours to change, so none of it was changed. A half-applied change would leave the calendar disagreeing with itself.",
    "notInSeries": "This event does not come round again, so there is no run to act on.",
    "seriesMoveOutOfRange": "Moving this occurrence that far would carry a later one of the run off the end of the calendar, so none of them were moved. Pick a nearer day.",
    "responses": {
      "title": "Who is coming",
      "invite": "Ask",
      "invitePlaceholder": "Somebody the club knows",
      "signUp": "Sign me up",
      "signUpHint": "Nobody has asked you yet, but anybody who may read this can put themselves down as coming, in the order they say so.",
      "invited": "Added to the list.",
      "pickFromDirectory": "Choose somebody from the list of suggestions. A person is asked by their entry in the club's records, not by a name typed here — a name nobody can resolve would be a name nobody can tell.",
      "empty": "Nobody has been asked about this event yet.",
      "emptyWithheld": "Everybody on this event's list is somebody you may not be told about.",
      "unavailable": "This event's list could not be read.",
      "limit": "{{attending}} of {{max}} places taken, {{waiting}} waiting.",
      "noLimit": "{{attending}} coming. This event sets no limit on how many.",
      "place": "#{{place}}",
      "attending": "Coming",
      "waiting": "Waiting",
      "selected": "Picked",
      "select": "Pick this person for the event",
      "deselect": "Put this person back in the order",
      "notePlaceholder": "A word about it",
      "removeConfirm": "Take this person off the list entirely, answer and all?",
      "concurrentAnswer": "Somebody wrote about this person at the same moment. The list has been read again — repeat the change if it is still wanted.",
      "caverUnknown": "The club's records hold nobody by that name.",
      "selectNotAttending": "Only somebody who has said they are coming can be picked for the event.",
      "noteInvalid": "That note is too long to store.",
      "kindTakesNoResponses": "This kind of event is a date rather than a gathering, so there is nobody to come to it and nothing to answer.",
      "withheld": "{{count}} on the list, not shown to you",
      "withheldDetail": "Somebody is on this event's list whom you may not be told about. They are counted here so the numbers beside the list add up, and named nowhere.",
      "responseValues": {
        "pending": "Not answered",
        "yes": "Coming",
        "no": "Not coming",
        "maybe": "Maybe"
      }
    }
  },
  "checklists": {
    "title": "Checklists",
    "subtitle": "The lists a party works through before it sets off.",
    "new": "New checklist",
    "edit": "Edit checklist",
    "empty": "No checklists yet.",
    "saved": "Checklist saved.",
    "saveFailed": "That checklist could not be saved.",
    "deleteConfirm": "Delete this checklist? Trips lose the confirmations made against its lines.",
    "lineCount": "{{count}} lines",
    "fieldTitle": "Title",
    "fieldDescription": "Description",
    "fieldVisibility": "Who may read it",
    "visibilityHint": "A list everyone may read is how one is published for the whole installation.",
    "fieldCavingGroup": "Caving group",
    "fieldItems": "Lines",
    "itemPlaceholder": "Something to settle before setting off",
    "addLine": "Add a line",
    "removeLine": "Remove this line",
    "visibilityValues": {
      "private": "Only me",
      "cavingGroup": "My caving group",
      "authenticated": "Anyone signed in",
      "public": "Everyone"
    },
    "delete": "Delete this checklist"
  },
  "workAreas": {
    "title": "Work areas",
    "allAreas": "All areas",
    "thisLevel": "At this level",
    "noSubAreas": "Nothing inside this one yet.",
    "none": "No work area has been marked yet. Draw an area on the map and record it as a work area.",
    "untitled": "Unnamed area",
    "openOnMap": "On the map",
    "seeAll": "See all",
    "loadFailed": "The work areas could not be loaded.",
    "truncated": "Not every work area is shown: this installation holds more than this view lists.",
    "subAreaCount": "Areas inside: {{count}}"
  },
  "accessKeys": {
    "title": "Access keys",
    "intro": "An access key lets a field device — TopoDroid on a phone — upload surveys to your account without your password. The key can only upload surveys: it cannot read the rest of your account, list or make keys, or change anything else. Make one per device, so a lost phone is one revocation.",
    "signInRequired": "Access keys can only be managed when you are signed in with your password, not from a device that holds a key.",
    "loadFailed": "The access keys could not be loaded.",
    "createFailed": "The access key could not be created.",
    "createdTitle": "The key for \"{{name}}\" — copy it now, it is shown only once.",
    "createdWarning": "Paste it into the device's settings straight away. Once you close this message nobody, including you, can read it again; if it is lost, revoke it and make another. Anyone holding it can upload surveys as you.",
    "form": {
      "name": "Name",
      "namePlaceholder": "TopoDroid on my phone",
      "lifetime": "Valid for",
      "days": "{{count}} days"
    },
    "create": "Create key",
    "revoke": "Revoke",
    "revokeConfirm": "Revoke \"{{name}}\"? The device holding it is refused at its next upload.",
    "revokedMessage": "Key revoked.",
    "empty": "No access keys yet.",
    "neverUsed": "Never",
    "columns": {
      "name": "Name",
      "prefix": "Key starts with",
      "purpose": "For",
      "created": "Created",
      "lastUsed": "Last used",
      "expires": "Expires",
      "state": "State"
    },
    "purposes": {
      "surveyUpload": "Survey uploads"
    },
    "states": {
      "active": "Active",
      "expired": "Expired",
      "revoked": "Revoked"
    }
  },
  "surveyUploads": {
    "stages": {
      "archive": "Archiving",
      "unpack": "Reading the archive",
      "scaffold": "Preparing the compilation",
      "compile": "Compiling",
      "store": "Storing the results",
      "read": "Reading the results"
    },
    "stageStates": {
      "skipped": "Not needed"
    },
    "status": {
      "receiving": "Receiving files",
      "queued": "Waiting to run",
      "running": "Running",
      "succeeded": "Finished",
      "failed": "Failed",
      "abandoned": "Abandoned"
    },
    "origins": {
      "topodroid": "TopoDroid",
      "therion": "Therion",
      "other": "Other"
    },
    "fileRoles": {
      "archive": "Survey archive",
      "therionSource": "Therion source",
      "therionSketch": "Sketch",
      "other": "Other file",
      "generatedConfig": "Generated configuration",
      "output": "Result",
      "log": "Log"
    },
    "fileStates": {
      "declared": "Not received",
      "received": "Received",
      "stored": "Stored",
      "refused": "Refused"
    },
    "artefacts": {
      "title": "Results",
      "empty": "Nothing was produced.",
      "download": "Download",
      "view": "View",
      "log": "Compiler's log"
    },
    "problems": {
      "filesMissing": "A file of this upload is no longer in the server's store. Ask the administrator to restore it, then run the upload again.",
      "archiveInvalid": "The archive is not a TopoDroid survey archive, or is too old or damaged to read. Export the survey again from TopoDroid and upload it afresh.",
      "archiveTooLarge": "The archive holds more than this server reads. Export a smaller survey.",
      "unexpected": "The server failed while processing this upload. The administrator can find the detail in the server log.",
      "sourceMissing": "Compiling was asked for, but no Therion source was sent.",
      "sourceInvalid": "A Therion source could not be read.",
      "compilerUnavailable": "The compiler could not be reached. The files are archived; run the upload again later.",
      "compileFailed": "Therion could not compile the survey. The log below says where.",
      "compileFailedNoLog": "Therion could not compile the survey.",
      "compileTimeout": "Compiling took longer than this server allows.",
      "outputMissing": "The compilation did not produce a result that was asked for.",
      "crsUnknown": "Stored, but not read into stations: the survey is fixed in a coordinate system this server does not know.",
      "storeFailed": "The results could not be stored.",
      "notFound": "This upload does not exist, or you may not see it.",
      "notCompleted": "This upload never received all its files, so it cannot be run again.",
      "runInProgress": "A run of this upload is already waiting or running.",
      "outputUnknown": "One of the requested results is not produced by this server.",
      "publicLinksDisabled": "This installation makes no public links.",
      "publicLinkForbidden": "Making a public link takes the right to share the cave.",
      "publicLinkProtected": "The cave's position is protected. A link to its results is made only when asked for explicitly, knowing that they show where its passages are.",
      "forbidden": "You may see this cave but not change it.",
      "requestFailed": "That did not work. Please try again."
    },
    "page": {
      "versionsTitle": "Versions of this survey",
      "olderVersionsTitle": "Older versions of this survey hold {{size}} of results (versions: {{count}}).",
      "olderVersionsTitleNamed": "Older versions of “{{survey}}” hold {{size}} of results (versions: {{count}}).",
      "olderVersionsHint": "Every version keeps what its run produced unless the installation keeps fewer. The setting {{setting}} {{keep}} An administrator can set it to 1 to keep only the newest version's results.",
      "olderVersionsKeepAll": "is 0 now, so every version keeps its results.",
      "olderVersionsKeepNewest": "is {{count}} now: that many of the newest versions keep their results.",
      "thisVersion": "(this one)",
      "newerExists": "A newer version of this survey exists. Open it from the list below.",
      "notFound": "This upload was not found, or you may not see it.",
      "loadFailed": "The upload could not be loaded.",
      "version": "Version of {{when}}",
      "rerun": "Run again",
      "rerunStarted": "The upload will run again.",
      "progressTitle": "Progress",
      "logTitle": "Log",
      "noLog": "The log is empty.",
      "filesTitle": "Files sent",
      "noFiles": "No files.",
      "fileRole": "Kind",
      "fileStatus": "State",
      "detailsTitle": "About this upload",
      "cave": "Cave",
      "caveCreated": "Made from this upload",
      "surveyName": "Survey name",
      "surveyDate": "Survey date",
      "surveyTeam": "Team",
      "uploaded": "Uploaded",
      "started": "Started",
      "finished": "Finished",
      "notFinished": "Not yet",
      "outputsAsked": "Results asked for",
      "noCompile": "None — the files were archived and read, not compiled"
    },
    "link": {
      "title": "Public link",
      "none": "This upload has no public link. The account's setting, the installation's, or a protected cave position can each be the reason.",
      "make": "Make a link",
      "madeAt": "Made {{when}}",
      "remint": "Make a new link",
      "remintConfirm": "Make a new link? The old address stops working.",
      "revoke": "Withdraw",
      "revokeConfirm": "Withdraw the link? Anyone holding it can no longer open the results.",
      "made": "Link made.",
      "dialogTitle": "Make a public link",
      "audienceLabel": "Who the link opens for",
      "audience": {
        "public": "Anyone with the link",
        "organization": "Signed-in accounts only"
      },
      "audienceHint": {
        "public": "Opens without signing in, for whoever is given the address.",
        "organization": "Whoever opens it is asked to sign in with an account of this installation. No right on the cave is needed beyond holding the address."
      },
      "protectedWarning": "This cave's position is protected. The results — the 3D model and the drawings — show where its passages are, and anyone the link opens for can see them.",
      "protectedAcknowledge": "I understand, and I want a link to this protected cave's results.",
      "protectedTag": "Protected cave — linked knowingly",
      "open": "Open",
      "refusal": {
        "protected-cave": "No public link was made because the cave's position is protected. One can be made only by asking for it explicitly, knowing that the results show where the cave's passages are.",
        "account-off": "No public link was made because \"Public links for my uploads\" is switched off for the account that sent it.",
        "not-wanted": "No public link was made because whoever sent this upload asked for none.",
        "installation-off": "No public link was made because this installation has public links switched off.",
        "no-share-right": "No public link was made because the account that sent this upload may not share the cave.",
        "revoked": "The public link of this upload was withdrawn. Somebody who may change the cave can make a new one."
      },
      "revoked": "Link withdrawn."
    },
    "surveys": {
      "title": "Surveys",
      "explanation": "Surveys sent to this cave from a device, with every version, newest first. Each version shows what it was sent and what was made from it; the models and sources further down are the cave's whole set.",
      "survey": "Survey",
      "source": "From",
      "versions": "Versions",
      "newest": "Newest version",
      "sent": "Files sent",
      "openStatus": "Status page"
    },
    "outputs": {
      "lox": "Therion 3D model (.lox)",
      "3d": "Survex 3D model (.3d)",
      "plan-pdf": "Plan map (PDF)",
      "extended-pdf": "Extended elevation (PDF)",
      "plan-svg": "Plan map (SVG)",
      "extended-svg": "Extended elevation (SVG)",
      "kml": "Google Earth (KML)",
      "dxf": "CAD drawing (DXF)",
      "sql": "Survey data (SQL)",
      "csv": "Survey data (CSV)",
      "survey-list-html": "List of surveys (HTML)",
      "continuation-list-html": "List of continuations (HTML)",
      "shp": "GIS shapefile (SHP)"
    }
  },
  "surveySources": {
    "title": "Survey sources",
    "explanation": "The material the compiled surveys above were made from. Kept so the survey can be compiled again when the tools that produced the export have moved on. A compilation log is opened, for the closure figures it reports; nothing else here is read or interpreted.",
    "upload": "Archive a source",
    "uploaded": "Source archived",
    "uploadFailed": "The file could not be archived",
    "acceptHint": "Therion .th, .th2 and .thconfig, Survex .svx, a compilation .log, or a survey app's .zip export — up to 100 MB.",
    "kind": "Kind",
    "size": "Size",
    "revision": "Revision",
    "download": "Download",
    "empty": "No sources archived yet",
    "deleteConfirm": "Remove this source from the cave's archive? The stored file itself is kept.",
    "kinds": {
      "therionSource": "Therion source",
      "therionConfig": "Therion .thconfig",
      "therionLog": "Compilation log",
      "survexSource": "Survex .svx",
      "topoDroidArchive": "Survey app export"
    },
    "problems": {
      "formatUnsupported": "Archive a survey source: Therion .th, .th2 or .thconfig, Survex .svx, a compilation .log, or a survey app's .zip export.",
      "contentMismatch": "This file is not what its name says it is. A survey source has to be the format its extension claims.",
      "sizeInvalid": "The file is empty or larger than 100 MB.",
      "nameInvalid": "The file's name is too long to archive. Rename it to 255 characters or fewer and try again.",
      "descriptionInvalid": "The description is too long; keep it to 4000 characters or fewer.",
      "notFound": "This archived source no longer exists.",
      "caveNotFound": "This cave no longer exists.",
      "forbidden": "You are not allowed to change this cave's survey archive."
    }
  },
  "surveyQuality": {
    "title": "Survey closure",
    "explanation": "How well each survey closed, exactly as the compiler that compiled it reported. Nothing here is worked out again: the columns are the compiler's own — REL-ERR, ABS-ERR, TOTAL-L, STS and the three axis errors — so a figure here and a figure in your own log are the same number.",
    "statuses": {
      "pending": "Queued for reading",
      "unreadable": "Could not be read"
    },
    "outcomes": {
      "succeeded": "Compiled",
      "succeededWithWarnings": "Compiled with warnings",
      "failed": "Compilation failed"
    },
    "unreadable": "This log could not be read, so nothing is known about the compilation it recorded. That is not a statement about the survey.",
    "compilationFailed": "This compilation did not finish. What is below is what the run had got as far as reporting — not a survey with no loops.",
    "stoppedAt": "It stopped at: {{stage}}.",
    "compiler": "Compiler",
    "compilerValue": "therion {{version}}",
    "compilerReleased": "Compiler released",
    "readAt": "Log read here",
    "revision": "Archive revision",
    "loopCount": "Loops the compiler found",
    "averageLoopError": "Average loop error",
    "medianLoopError": "Median loop error (from the table)",
    "medianAbsoluteError": "Median closing distance (from the table)",
    "totalLength": "Total length",
    "totalLengthAdjusted": "Total length, adjusted",
    "adjustment": "Adjustment moved",
    "compilationSeconds": "Compilation time (s)",
    "noLoops": "This run reported no loop errors: there are no closed loops in this survey to check.",
    "noLoopTable": "This log printed no loop-error table, so how well the survey closes is not known from it. That is not the same as a survey with no closed loops.",
    "loopsWithoutTable": "This run reported {{loops}} loops but printed no loop-error table, so how far each of them closed is not known from this log.",
    "orderedBy": {
      "relErr": "Ordered by REL-ERR, the ratio.",
      "absErr": "Ordered by ABS-ERR, the closing distance.",
      "totalLength": "Ordered by TOTAL-L, the loop's length.",
      "table": "In the compiler's own order."
    },
    "orderingExplanation": "A short loop can be the worse ratio and the smaller distance at the same time, so ordering by REL-ERR and ordering by ABS-ERR are not the same list. Sort by either heading.",
    "columns": {
      "ordinal": "Loop",
      "relErr": "REL-ERR",
      "relErrHint": "Ratio: the closing error as a % of the loop's length",
      "absErr": "ABS-ERR",
      "absErrHint": "Distance: how far the loop failed to close, in metres",
      "totalLength": "TOTAL-L (m)",
      "stationCount": "STS",
      "errorX": "X-ERROR",
      "errorY": "Y-ERROR",
      "errorZ": "Z-ERROR",
      "stations": "STATIONS"
    }
  },
  "karstArea": {
    "title": "Karst area statistics",
    "loading": "Working out what this area holds…",
    "basisDeclared": "Counted over the caves declared to be in this area",
    "basisDeclaredDetail": "Membership is the hierarchy somebody entered, not a test against the outline. {{drift}} cave(s) you can place fall inside the outline without being declared here, out of {{placeable}} of this area's caves you can place — a hint about how far the hierarchy has drifted from the map, and no part of any figure above.",
    "caveCount": "Caves",
    "entranceCount": "Entrances",
    "areaKm2": "Area (km²)",
    "cavesPerKm2": "Caves per km²",
    "surveyedLength": "Surveyed passage (m)",
    "surveyedPerKm2": "Surveyed metres per km²",
    "surveyedCaveCount": "Caves with a surveyed length",
    "ofCaves": "{{measured}} of {{total}}",
    "depressionCount": "Mapped depressions",
    "depressionRatio": "Depression cover (%)",
    "index": "Karstification index",
    "indexUnknown": "not measurable",
    "component": {
      "cave_density": "Cave density",
      "depression_area_ratio": "Depression cover"
    },
    "componentAbsent": "not recorded, so it is left out of the index rather than counted as nought",
    "componentPresent": "{{value}} against a reference of {{reference}}",
    "class": {
      "unknown": "Unknown",
      "veryLow": "Very low",
      "low": "Low",
      "moderate": "Moderate",
      "high": "High",
      "veryHigh": "Very high"
    },
    "deepest": "Deepest caves",
    "longest": "Longest caves",
    "rockType": "Rock type",
    "rockTypeUnrecorded": "Not recorded",
    "notMeasured": "not measured",
    "notMapped": "not mapped",
    "metresShort": "m",
    "scopeNote": "Every figure here is counted over the caves you may read. Another account may legitimately see different totals for the same area."
  },
  "karstDensity": {
    "title": "Density, spacing and alignment",
    "loading": "Reading the grid…",
    "notMeasured": "not measured",
    "protectionNote": "Protected coordinates are counted on this installation's {{metres}} m grid.",
    "protectionNoteDetail": "The grid counted {{counted}} entrances. The spacing and alignment figures use only the {{placed}} you may place exactly — a spacing measured between rounded coordinates measures the rounding, not the caves.",
    "cellSize": "Cell size. The finest this installation publishes is {{floor}} m, its location-protection grid.",
    "cellMetres": "Cell (m)",
    "bandwidthMetres": "Kernel bandwidth (m)",
    "cellCount": "Cells",
    "featureCount": "Entrances counted",
    "studyAreaKm2": "Study area (km²)",
    "peakDensity": "Peak smoothed density (per km²)",
    "clarkIndex": "Clark–Evans index",
    "clarkZ": "z",
    "clarkP": "p",
    "clustered": "Below one: the entrances sit closer together than chance would put them.",
    "spaced": "Above one: the entrances are more evenly spaced than chance would put them.",
    "random": "One: indistinguishable from chance.",
    "ripley": "Ripley's L, with the band {{simulations}} random scatters drew from seed {{seed}}.",
    "noEnvelope": "No simulations were run, so no band is drawn and no significance was tested.",
    "radiusM": "Radius (m)",
    "observedL": "L",
    "alignment": "Bearings between {{pairs}} pairs of entrances, {{min}}–{{max}} m apart.",
    "tooFewPlaceable": "Fewer than {{minimum}} entrances here can be placed exactly, which is too few for a spacing to mean anything.",
    "autocorrelationTitle": "Hot and cold spots",
    "autocorrelationBasis": "Read over the {{cells}} cells above and the {{pairs}} adjacencies between them, at this grid's {{metres}} m cell and no finer — both figures are arithmetic over the cells already drawn, so neither can show detail the grid does not already have.",
    "autocorrelationUndetermined": "There is no arrangement to test here: too few cells, none of them touching, or every cell carrying the same density.",
    "moranIndex": "Moran's I",
    "moranExpected": "Expected by chance",
    "moranZ": "Standard errors",
    "moranP": "p",
    "hotSpots": "{{hot}} cells read hot and {{cold}} read cold, of {{scored}} that could be scored. The score is taken at every cell at once and is not corrected for that, so a scattering of striking cells over a large window is what chance alone produces — read the shading, not the individual cell.",
    "pattern": {
      "undetermined": "The question could not be asked of this window.",
      "random": "The arrangement is indistinguishable from a chance one. That is a failure to find structure, not a demonstration that there is none.",
      "clustered": "Dense cells sit beside dense ones, and empty beside empty, more than chance would put them.",
      "dispersed": "Dense and empty cells alternate more than chance would put them."
    }
  },
  "karstStats": {
    "clusterArbitrary": "The grouping was still moving caves when it reached its limit, so which group a borderline cave fell into is arbitrary in its details rather than wrong.",
    "clusterCoverage": "{{measure}}: {{missing}} of the caves considered do not record it, and {{soleReason}} of those would have been grouped had this measure not been asked for.",
    "clusterEmpty": "Nothing could be grouped: fewer than {{minimum}} caves in this set record every measure asked for. The points below are drawn uncoloured, and the counts above still hold.",
    "clusterGroup": "Group {{group}}",
    "clusterMeasures": "Grouped over {{measures}}, each standardised first so that neither measure counts for more than the other simply for being recorded in larger numbers.",
    "clusterNoSeparation": "The groups' middles do not separate at all — the strongest reading available of there being no structure here. The colours divide these caves; they do not find anything in them.",
    "clusterNoWork": "Every grouped cave records the same {{measure}}, so that measure moved no cave into any group.",
    "clusterNotAsked": "This list is narrowed by something the registry-wide grouping cannot be asked about, so the caves are drawn uncoloured rather than coloured by a grouping of some other set of caves.",
    "clusterPopulation": "Grouped over the {{eligible}} of {{considered}} caves you may read in the whole set this list is narrowed to — not only the page drawn below — that record every measure asked for. The other {{excluded}} record fewer, so no grouping can place them, and having no length or no depth to plot they are absent from the chart rather than drawn in it.",
    "clusterUngrouped": "Not grouped",
    "clusterWeak": "The groups are as wide as they are far apart, so this grouping is weak. The method returns exactly the number of groups it was asked for on any data whatever, noise included, so the colours below are a division of these caves rather than a finding about them.",
    "clusterWithheld": "Some groups hold fewer than {{floor}} caves. Those are not summarised and their caves are drawn uncoloured, because a mean over two caves is those two caves' readings rather than anything about a group.",
    "count": "Caves",
    "depthAxis": "Depth (m)",
    "lengthAxis": "Surveyed length (m)",
    "nothingMeasured": "No cave on this page has a surveyed length.",
    "powerLawFit": "Power-law fit (exponent {{exponent}})",
    "rank": "Rank",
    "regression": "Fit: slope {{slope}}, R² {{r2}}",
    "scopeNote": "Computed from the {{shown}} of {{total}} caves on this page that carry a surveyed length. Caves without one are absent rather than counted as zero.",
    "title": "Distributions",
    "viewByType": "By type",
    "viewHistogram": "Length",
    "viewLengthDepth": "Length vs depth",
    "viewRankSize": "Rank–size"
  },
  "registryStats": {
    "basis": {
      "readable": "Computed over the caves you may read. Somebody with different access sees different figures for the same registry, and both are right.",
      "placeable": "Computed over the caves you may read and may place exactly. A cave whose position is closed to you is counted in the registry's totals and appears under no place, because a count under a place would say where it is.",
      "area": "Computed over the caves you may read and may place exactly, inside the area you named. A cave whose position is closed to you is absent from these figures altogether, totals included, because a count inside a named area would say it is there."
    },
    "distributionTitle": "Distribution across the registry",
    "asVisibleToYou": "Counted over the caves you may read. Somebody with different access sees different figures for the same registry, and both are right.",
    "stale": "These are the previous answer's figures, still on screen while the new one is worked out. No file is offered until the two are the same.",
    "measure": "Measurement",
    "bins": "Intervals",
    "floor": "Fewest caves per interval",
    "caveType": "Cave type",
    "rockType": "Rock type",
    "region": "Region",
    "regionPlaceholder": "Exact region name",
    "anyValue": "Any",
    "filterNote": "These narrowings are matched exactly, and nothing here counts how many caves each one would leave — that count is the question itself, so it is answered below rather than printed on the controls.",
    "linearCount": "Linear",
    "logCount": "Logarithmic",
    "caves": "Caves",
    "binCount": "{{caves}} caves",
    "joinedLabel": "{{from}}–{{to}} joined",
    "joinedNote": "Several intervals joined together, because one of them held too few caves to publish on its own.",
    "joinedSummary": "{{joined}} of these intervals are several joined together, marked in the chart and wider than the rest. The registry joins an interval holding too few caves rather than leaving it out, because leaving it out would itself say something is there.",
    "tailSpan": "The fitted tail begins at {{from}}: it describes the last {{intervals}} of the {{total}} intervals drawn, and nothing to the left of them.",
    "counts": "Computed over the {{measured}} of {{total}} caves in this set that record a value. A cave without one is absent rather than counted as zero.",
    "noRange": "There is no range to divide: nothing in this set records this measurement, or everything recording it records the same value.",
    "noFigure": "—",
    "percentiles": "Percentiles",
    "fraction": "Percentile",
    "percentileName": "{{percent}}th",
    "fits": "Fits",
    "lognormal": "Lognormal",
    "lognormalAbsent": "No lognormal fit: too few caves record this measurement, or they all record the same value. Parameters would exist arithmetically and mean nothing.",
    "paretoTail": "Power-law tail",
    "paretoAbsent": "No fitted tail: the upper tail holds too few caves for an exponent to mean anything.",
    "alphaValue": "{{alpha}} ± {{error}}",
    "tailFrom": "Tail starts at",
    "median": "Median",
    "mean": "Mean",
    "goodness": "Distance from the fitted tail",
    "fittedOver": "Fitted over",
    "fittedOverValue": "{{caves}} caves",
    "failed": "The distribution could not be worked out.",
    "correlationTitle": "Two measurements against each other",
    "correlationFailed": "The relationship could not be worked out.",
    "horizontal": "Horizontal measurement",
    "vertical": "Vertical measurement",
    "logFit": "Logarithmic",
    "linearFit": "Linear",
    "pair": "{{y}} against {{x}}",
    "fit": "The fit",
    "slope": "Slope",
    "intercept": "Intercept",
    "rSquared": "Goodness of fit (r²)",
    "correlationCoefficient": "Correlation",
    "pairs": "Taken over",
    "pairsValue": "{{caves}} caves recording both",
    "form": "Fitted",
    "drawnNote": "The line is the fitted relationship, drawn across the range the horizontal measurement covers in this set. The caves it was fitted through are not drawn: the registry answers this question with the relationship rather than with the caves behind it, and the range drawn across may be wider than the pairs the fit used.",
    "positiveOnly": "Fitted through the logarithms of both, so a cave recording zero or less on either measurement contributes to nothing rather than being nudged upwards. The count beside the fit says how many were left.",
    "absence": {
      "noPairs": "No cave in this set records both of these measurements, so there is no relationship to fit and none is drawn.",
      "notFitted": "Fewer than two caves record both of these measurements. A line through one point is not a relationship, so none is drawn.",
      "noRange": "The horizontal measurement covers no range in this set, so there is nothing to draw the relationship across. The figures beside it still stand.",
      "noPositiveRange": "The fit is taken over logarithms and the horizontal measurement reaches zero or below in this set, so it has no lower end to draw from. The figures beside it still stand.",
      "rangeUnknown": "The range this measurement covers in this set has not arrived yet, so there is nothing to draw the relationship across. The figures beside it already stand.",
      "rangeUnavailable": "The range this measurement covers in this set could not be read, so the relationship is not drawn. That is one figure that failed to arrive rather than anything about the caves, and the figures beside it still stand."
    },
    "measures": {
      "surveyedLength": "Surveyed length (m)",
      "estimatedLength": "Estimated length (m)",
      "depth": "Depth (m)",
      "positiveDepth": "Height above entrance (m)",
      "negativeDepth": "Depth below entrance (m)",
      "realExtension": "Real extension (m)",
      "projectedExtension": "Projected extension (m)",
      "volume": "Volume (m³)",
      "area": "Area (m²)",
      "ramificationIndex": "Ramification index"
    },
    "regionsTitle": "The registry by region",
    "regionsCard": "Caves per region",
    "regionsFailed": "The breakdown could not be worked out.",
    "noRegion": "No region recorded",
    "regionsCounts": "{{placed}} caves stand under a region below, out of {{total}} in this set that you may read.",
    "regionsShortfall": "The rows below do not add up to the total, and that is the answer rather than a fault in it: {{missing}} of the {{total}} caves you may read here have a position you may not see, so they are counted in the total and stand under no region. Which regions they belong to is exactly what is being withheld, so there is no row gathering them and no percentage that reconciles.",
    "regionsEmpty": "No cave in this set has a position you may see, so there is nothing to divide between regions. The total above still counts the caves you may read.",
    "categoriesTitle": "The registry by category",
    "groupBy": "Grouped by",
    "categories": {
      "caveType": "Cave type",
      "rockType": "Rock"
    },
    "noCategory": "None recorded",
    "categoriesFailed": "The comparison could not be worked out.",
    "nothingInScope": "No caves in this scope.",
    "categoriesCard": "{{measure}} by group",
    "categoriesNote": "Each box runs from the 25th to the 75th percentile, with the median across it and whiskers to the 10th and 90th. A group measured on fewer than {{count}} caves has its counts and no box.",
    "measured": "Measured",
    "box": "10th · 25th · median · 75th · 90th",
    "tooFewForABox": "Too few measured caves to draw"
  },
  "morphometry": {
    "title": "Measured shape",
    "area": "Area",
    "perimeter": "Perimeter",
    "circularity": "Circularity",
    "longAxis": "Long axis",
    "shortAxis": "Short axis",
    "elongation": "Elongation",
    "longAxisAzimuth": "Long-axis bearing",
    "centroid": "Centre",
    "unitMetres": "m",
    "unitSquareMetres": "m²",
    "unitDegrees": "°",
    "invalidGeometry": "This outline crosses itself, so it has no measurable area or shape. Redraw it before reading anything from it.",
    "measuredInWorkingSystem": "Measured in metres in this installation's working coordinate system, not in the degrees the outline is stored in.",
    "axisIsNotABearing": "The long-axis bearing is an alignment, not a direction: it runs from 0° to 180°, so 170° and 350° are the same alignment."
  },
  "closestApproach": {
    "title": "Closest approach",
    "pickOther": "Choose another cave",
    "pickOtherHint": "Choose a second cave to measure how close the two come to each other.",
    "distance": "Shortest distance",
    "horizontal": "Horizontal",
    "vertical": "Vertical",
    "bearing": "Bearing",
    "unitMetres": "m",
    "unitDegrees": "°",
    "between": "From {{from}} to {{to}}.",
    "horizontalIsOfTheSameLine": "The horizontal and vertical figures are the two parts of that same shortest line, not the shortest distance across and the shortest distance down, which are different pairs of points.",
    "unavailable": "No distance for this pair",
    "unavailableWhy": "A distance between two caves places each of them from the other, so it is given only to a reader who may see exactly where both are.",
    "absence": {
      "noLineWork": "At least one of these two caves has no line work to measure from.",
      "noAltitudes": "At least one of these two caves was drawn in plan and recorded no depths, so there is no honest distance in three dimensions."
    },
    "drawnOnMap": "The shortest line is drawn on the map and in the 3D view. On the map you see its plan only; in 3D it runs through the rock at the depths its two ends were surveyed at."
  },
  "viewLinks": {
    "controls": {
      "map2d": "Map",
      "scene3d": "3D scene",
      "caveview": "Survey viewer",
      "imageView": "Image"
    }
  },
  "textLink": {
    "notAnnotated": "This document is not a link-annotated text.",
    "empty": "This text has nothing in it yet.",
    "popOut": "Open in a window of its own",
    "controls": {
      "title": "Where links go",
      "hint": "Following a highlighted passage moves these views. Turn one off to leave it where it is.",
      "none": "No map, scene or viewer is open, so following a passage has nothing to move. Open one, or pop this text out beside it."
    },
    "edit": {
      "start": "Edit links",
      "stop": "Stop editing",
      "hint": "Select any part of the text to link it to a cave, a document, a trip or anything else.",
      "deleteTitle": "Delete this link?",
      "deleteBody": "The passage stops being highlighted. The things it linked are not affected."
    },
    "card": {
      "uncertain": "May have moved",
      "uncertainDetail": "These words are not where this link recorded them, so the highlight may be on the wrong passage.",
      "noTargets": "This link points at nothing else yet.",
      "openLink": "The link",
      "reveal": "Show",
      "revealHint": "Move the open views to this, without leaving the text.",
      "revealIn": "Show in…",
      "otherWindow": "another window",
      "open": "Open",
      "openNewWindow": "Open in a new window"
    },
    "section": {
      "none": "Nothing has been written about this yet.",
      "write": "Write one",
      "newTitle": "Notes on {{name}}",
      "newTitleBare": "Notes",
      "newBody": "Write here, then select any part of the text to link it."
    }
  },
  "speologie": {
    "title": "Cave catalogue",
    "subtitle": "Search the Romanian community cave catalogue at speologie.org, and bring caves from it into this installation.",
    "portalLink": "Open speologie.org",
    "openInPortal": "Open on speologie.org",
    "notConfigured": {
      "title": "This installation has no key for the catalogue",
      "body": "Searching speologie.org needs a personal API key, obtained from a profile on that site and set by an administrator. Until one is set, this screen can show nothing."
    },
    "search": {
      "term": "Name",
      "termPlaceholder": "Part of a cave's name, or its code",
      "county": "County",
      "countyPlaceholder": "Any county",
      "submit": "Search",
      "clear": "Clear",
      "needSomething": "Give a name to search for, a county, or both.",
      "spellingsWhy": "Romanian is written with two different diacritic conventions and often with none, and the catalogue's search treats them as different words. All the spellings are asked about at once.",
      "noResults": "The catalogue has nothing matching that.",
      "hint": "The catalogue holds about 8,650 published caves. It carries no coordinates, so a cave imported from it arrives without a position.",
      "spellings": "Searched for {{count}} spellings of what you typed: {{list}}",
      "noResultsHint": "Nothing in the catalogue matches that. Its search is sensitive to Romanian diacritics — this installation already asks for several spellings of what you typed, but a long name with more than one accented letter may still need typing as the catalogue spells it (Scărișoara rather than Scarisoara).",
      "basin": "Hydrographic basin",
      "basinPlaceholder": "Any basin",
      "basinNarrowed": "{{count}} of the {{scanned}} caves read match that basin.",
      "basinNarrowedWhy": "The catalogue cannot search by basin, so this narrows what the search brought back rather than asking it a different question. Choosing a massif includes every basin inside it."
    },
    "columns": {
      "name": "Name",
      "county": "County",
      "mountain": "Mountain range",
      "length": "Length (m)",
      "depth": "Depth (m)",
      "altitude": "Altitude (m)",
      "protectionClass": "Class",
      "state": "In this installation",
      "actions": "Actions",
      "basin": "Basin"
    },
    "state": {
      "imported": "Already imported",
      "importedElsewhere": "Already imported, not visible to you",
      "notImported": "Not here yet",
      "openCave": "Open the cave"
    },
    "flags": {
      "vanished": "Recorded as lost",
      "sump": "Has a sump"
    },
    "actions": {
      "import": "Import",
      "refresh": "Refresh from catalogue",
      "details": "Details",
      "importSelected": "Import selected ({{count}})"
    },
    "detail": {
      "title": "{{name}} — speologie.org",
      "description": "Description",
      "noDescription": "The catalogue records no description for this cave.",
      "descriptionNote": "Shown exactly as it would be stored: the catalogue's formatting is converted to plain text, and a very long description is shortened.",
      "identity": "Identity",
      "slug": "Catalogue slug",
      "catalogueId": "Catalogue id",
      "locality": "Locality",
      "rockCode": "Rock code",
      "rockCodeHint": "The catalogue publishes no legend for this code, so it is kept exactly as written rather than guessed at.",
      "science": "Scientific interest",
      "protectedAreaCode": "Protected-area code",
      "hydroNumber": "Hydrologic number",
      "hydroBasin": "Hydrographic basin",
      "hydroBasinUnknown": "The catalogue named a basin this installation's copy of its tree does not hold. Refreshing that table may resolve it."
    },
    "wizard": {
      "title": "Import from the catalogue",
      "back": "Back to the search",
      "nothingSelected": "Nothing was chosen. Go back to the search and pick the caves to import.",
      "options": "For every cave imported",
      "parent": "File them under",
      "parentPlaceholder": "Nothing — leave them at the top level",
      "noCoordinates": "The catalogue publishes no coordinates",
      "noCoordinatesBody": "A cave imported from it has no position, so it is in the registry and in search but on no map. Give one a position below and it gets a main entrance there; leave it and it can be placed later. Caves with no position are listed under Caves with the “no position” filter.",
      "candidates": "The caves",
      "action": "What to do",
      "actionCreate": "Create",
      "actionUpdate": "Refresh",
      "actionSkip": "Leave alone",
      "actionUpdateHint": "This cave was imported before. Refreshing rewrites its name, description, region, altitude, length, depth and protection class from the catalogue; anything else recorded on it is left alone.",
      "caveType": "Kind",
      "caveTypeDerived": "Read from the name",
      "position": "Position",
      "unplaced": "No position",
      "place": "Place on the map",
      "placing": "Click the map to place “{{name}}”",
      "clearPosition": "Remove the position",
      "commit": "Import",
      "committing": "Importing…",
      "subtitle": "Chosen from speologie.org: {{count}}. Ready to be brought in."
    },
    "result": {
      "title": "The import is done",
      "created": "Created",
      "updated": "Refreshed",
      "skipped": "Left alone",
      "failures": "These could not be imported",
      "undoHint": "The whole import is one batch and can be undone in Geodata → Import history.",
      "viewCaves": "See the caves"
    },
    "errors": {
      "notConfigured": "This installation has no API key for the catalogue.",
      "unauthorized": "The catalogue did not accept this installation's API key. An administrator needs to set a working one.",
      "unavailable": "The catalogue could not be reached. It is a small volunteer-run service — try again in a moment.",
      "rejected": "The catalogue rejected the request. This is a fault in this application rather than something you can fix.",
      "searchTooBroad": "Give a name to search for, a county, or both.",
      "caveNotFound": "The catalogue no longer publishes that cave.",
      "selectionTooLarge": "Too many caves were chosen for one import. Bring them in smaller batches — each one can be undone on its own.",
      "importFailed": "The import could not be completed."
    },
    "paging": {
      "previous": "Previous",
      "next": "Next",
      "page": "Page {{page}}"
    }
  },
  "tripImport": {
    "title": "Import trips from a spreadsheet",
    "uploadTitle": "Import trips from a spreadsheet",
    "uploadPrompt": "Drop a trip spreadsheet here, or click to choose one",
    "uploadHint": "A comma- or semicolon-separated export of a club's trip list. Nothing is written until you have read what it would do.",
    "duplicateTitle": "You have already uploaded this sheet",
    "duplicateBody": "The store already holds this exact file as “{{name}}”. Open the review that goes with it rather than starting a second one, or upload the sheet again as a separate copy if that is what you meant.",
    "duplicateResume": "Resume that review",
    "duplicateUploadAgain": "Upload it again anyway",
    "optionsReading": "How the sheet is read",
    "optionsMapping": "Which column is which",
    "optionsCreated": "What may be created",
    "optionsAudience": "Who these trips are for",
    "dateOrderHint": "Where a date has a component above twelve, the file settles whether it writes day or month first. Where nothing settles it, this choice does — and the rows it decides are counted beside it.",
    "dateOrder": "Date order",
    "dateOrderDayFirst": "Day first (31/12/2024)",
    "dateOrderMonthFirst": "Month first (12/31/2024)",
    "dateOrderSettled": "What settled it",
    "dateOrderRidesOn": "{{count}} rows ride on this choice",
    "dateOrderSources": {
      "stated": "Your choice",
      "file": "The file itself",
      "conflict": "The file disagrees with itself"
    },
    "encoding": "Character encoding",
    "encodingHint": "A sheet states nothing trustworthy about its encoding, so it is worked out from the bytes. An older code page read as UTF-8 loses every diacritic, so the answer is shown here and can be overruled.",
    "encodingDetect": "Work it out from the file",
    "encodingSettled": "What settled the encoding",
    "encodings": {
      "utf8": "UTF-8",
      "utf16Le": "UTF-16, little-endian",
      "utf16Be": "UTF-16, big-endian",
      "windows1250": "Windows-1250, Central European",
      "iso88592": "ISO-8859-2, Latin-2",
      "windows1252": "Windows-1252, Western European"
    },
    "encodingSources": {
      "stated": "Your choice",
      "mark": "A mark at the head of the file",
      "utf8": "The bytes are valid UTF-8",
      "guessed": "Guessed from the accented bytes"
    },
    "delimiter": "Column separator",
    "delimiterHint": "One character. It is pinned rather than guessed: a free-text column full of semicolons otherwise flips the whole reading.",
    "separators": "Separators inside a cell",
    "separatorsHint": "The characters that split several names or caves written in one cell.",
    "slashFields": "Also split on a slash",
    "slashFieldsHint": "Only for the columns you name. A slash splits “n/a” and “Piatra Craiului/Bucegi” as readily as it splits two names, so it is off unless you ask for it.",
    "unmappedColumns": "The sheet also carries: {{columns}}. Nothing is read from them.",
    "mappingAuto": "Detected automatically",
    "fields": {
      "sourceId": "Row number",
      "startDate": "Start date",
      "endDate": "End date",
      "title": "Title",
      "country": "Country",
      "massif": "Massif or area",
      "subArea": "Sub-area",
      "caves": "Caves",
      "proposers": "Proposed by",
      "participants": "Participants",
      "tripType": "Type",
      "details": "Details",
      "details2": "Further details",
      "errors": "Notes on the source data"
    },
    "createHint": "Each is off until you ask for it. Matching against what already exists happens either way — these decide only what becomes of a name nothing answered to. Taking the import back afterwards removes the trips and the caves and areas it made, and leaves behind the cavers and the type words it added.",
    "createCaves": "Create caves this sheet names but the register lacks",
    "createAreas": "Create massifs and sub-areas the register lacks",
    "createCavers": "Create cavers the roster lacks",
    "createAbbreviatedCavers": "Create cavers from abbreviated names too",
    "createAbbreviatedCaversHint": "A name like “Ion B.”, or a given name on its own, becomes a caver like any other. Turn this on for a sheet written that way throughout — otherwise almost nobody on it can be created. Expect duplicates: they are joined afterwards from the roster.",
    "createTripTypes": "Create trip types the vocabulary lacks",
    "audienceHint": "Chosen once and applied to every row. It starts at the most restrictive value: an import is a bulk act, and a bulk act that publishes by default publishes a club's whole history at once.",
    "visibility": "Who may read these trips",
    "cavingGroup": "Organising group",
    "summaryTitle": "What confirming would do",
    "newTripTypes": "New trip types",
    "newCavers": "New cavers",
    "newCaves": "New caves",
    "newAreas": "New areas",
    "peopleNeedingADecision": "People needing a decision",
    "placesNeedingADecision": "Places needing a decision",
    "peopleWarningTitle": "{{ambiguous}} names match more than one caver, and {{uncreatable}} cannot be created",
    "peopleWarningBody": "A name matching several people is never guessed at — say which one is meant. A name too short to place, a bare initial or a lone given name, creates nobody unless you allow it under what may be created: a person invented from one of those could never be confidently joined to the right caver later. Left as they are, these names are kept in the trip’s own text and the people are not on the roster of the trips they went on.",
    "peopleLeftOff": "People left off their trips",
    "leftOffTitle": "People the roster lacks who will be left off their trips: {{count}}",
    "leftOffBody": "Nothing is created while “Create cavers the roster lacks” is off, so these names stay in the trip’s own text and the people are not on the roster of the trips they went on. Turn it on under what may be created to add them.",
    "placesWarningTitle": "{{count}} place names match more than one record",
    "columns": {
      "take": "Take",
      "line": "Line",
      "when": "When",
      "title": "Title",
      "type": "Type",
      "places": "Places",
      "people": "People",
      "warnings": "Warnings",
      "reason": "Reason"
    },
    "untitledRow": "(no title)",
    "warningCount": "{{count}} warnings",
    "problemsTitle": "What could not be read ({{count}} rows)",
    "noProblems": "Every row read cleanly.",
    "wholeFile": "The file",
    "atLine": "Line {{line}}",
    "problems": {
      "mappedColumnMissing": "A column this mapping names is not in the sheet",
      "mappedColumnTaken": "Two fields are pointed at the same column",
      "unmappedColumn": "A column nothing reads",
      "raggedRow": "The row has a different number of cells than the header",
      "blankRow": "An empty row",
      "requiredFieldEmpty": "A field the row cannot do without is empty",
      "dateUnreadable": "A date in a shape this reader does not know",
      "dateOutOfRange": "A date whose day or month cannot exist",
      "dateTwoDigitYear": "A two-digit year, which could be either century",
      "dateAmbiguous": "A date that reads either way round",
      "dateOrderConflict": "The file writes dates both ways round",
      "valueDropped": "A value lost to the separators in use",
      "duplicateSourceId": "Two rows carry the same row number",
      "tooManyColumns": "More columns than the reader accepts",
      "noHeader": "No header line",
      "unterminatedQuote": "A quoted value that never closes"
    },
    "searchPlaceholder": "Search the rows",
    "rowCounts": "{{readable}} readable · {{failed}} unreadable · {{skipped}} set aside",
    "truncatedTitle": "This sheet is longer than one review reads",
    "truncated": "The first {{scanned}} rows were read. The rest are not in this review and confirming would not create them.",
    "createSelected": "Create {{count}} trips",
    "resultTitle": "The import is done",
    "viewBatches": "See the batch",
    "createdTrips": "Trips created",
    "createdFeatures": "Caves and areas created",
    "skipped": "Set aside",
    "undoHint": "Taking this batch back deletes the trips and the caves and areas it created. Each trip can be restored afterwards from Deleted trips, with its roster and its links. The cavers and trip types it added stay, because a type word is installation-wide and a person may already have been written into something else.",
    "someFailedTitle": "{{count}} rows could not be created",
    "errors": {
      "fileNotFound": "That sheet is not here any more, or you may not read it.",
      "createForbidden": "You may not create everything these choices would create. Turn off what you do not need, or ask for the right.",
      "groupBindingForbidden": "You may not file trips under that group.",
      "fileUnreadable": "The file could not be read as a spreadsheet.",
      "fileTooLarge": "The file is larger than this installation reads in one go.",
      "selectionEmpty": "No rows are taken, so there is nothing to create.",
      "selectionTooLarge": "Too many rows for one import. Set some aside and confirm the rest.",
      "nothingCreated": "Not one row could be created, so nothing was. Nothing has changed.",
      "commitFailed": "The import could not be completed.",
      "previewFailed": "This sheet could not be read with the current choices.",
      "uploadFailed": "The sheet could not be uploaded."
    },
    "chooseWhich": "Which of the {{count}}?",
    "andMoreNames": "and {{count}} more",
    "dateOrderFixedByFile": "The file settles this, so the choice above is not used.",
    "takeAll": "Take all {{count}}",
    "skipAll": "Set all aside",
    "keepFirst": "Keep only the first",
    "keepFirstApply": "Apply",
    "typesTitle": "What the type column would do to the vocabulary",
    "typesHint": "One line per distinct value, however many rows wrote it. A type word this import adds is installation-wide and stays behind if the import is taken back, so a value nothing answered to can be renamed before it is created, or pointed at a type that already exists.",
    "typesNone": "The sheet writes no trip types.",
    "typeAmbiguous": "More than one type answers to it",
    "typeNoMatch": "Nothing answers to it",
    "typeOutcomeLinked": "Recorded as “{{name}}”",
    "typeOutcomeCreated": "A new type word is added",
    "typeOutcomeNothing": "Nothing is added; the value is kept in the trip's own text",
    "typeUseExisting": "Use an existing type instead",
    "typeColumns": {
      "value": "As the sheet writes it",
      "matched": "What it matched",
      "outcome": "What confirming would do",
      "instead": "Or point it at"
    }
  },
  "speleolocImport": {
    "title": "Import a trip recorded on a phone",
    "recordingTitle": "Make a recording into a trip",
    "uploadTitle": "Import a trip recorded on a phone",
    "uploadPrompt": "Drop a SpeleoLoc export here, or click to choose one",
    "uploadHint": "The archive a phone exports, or the database inside it. The photographs it carries are never opened — only the recording is read, and nothing is written until you have seen what it would do.",
    "duplicateTitle": "You have already uploaded this archive",
    "duplicateBody": "The store already holds this exact file as “{{name}}”. Open the review that goes with it rather than starting a second one, or upload the archive again as a separate copy if that is what you meant.",
    "duplicateResume": "Resume that review",
    "duplicateUploadAgain": "Upload it again anyway",
    "optionsRecording": "Which recording",
    "recordingHint": "An export carries the phone's whole database, so it usually holds every trip that phone ever recorded. Nothing is read scan by scan until you have said which one this is about.",
    "recording": "Recording",
    "recordingPlaceholder": "Choose a recording from the archive",
    "recordingFacts": "Started {{started}} · ended {{ended}} · {{scans}} scans · {{documents}} photographs left in the archive",
    "scanCount": "{{count}} scans",
    "optionsDestination": "Where the positions go",
    "destinationExisting": "Onto a trip that already exists",
    "destinationNew": "Into a trip this import creates",
    "trip": "Trip",
    "tripPlaceholder": "Search your trips",
    "tripHint": "The positions are added to that trip's own history. The trip itself is not rewritten, and only somebody already on its roster can be given a position on it.",
    "createTripHint": "The trip is made from what the recording says — its title and its two moments — with exactly the people you name below on its roster. It is part of the same batch, so taking the import back takes the trip with it.",
    "visibility": "Who may read this trip",
    "cavingGroup": "Organising group",
    "optionsSurvey": "Which survey the positions are in",
    "surveyHint": "A position here is a station of a survey model, so a model has to be named before anything can be proposed from a depth. Models are listed per cave, and a cave whose exact position you may not be told lists none.",
    "cave": "Cave",
    "cavePlaceholder": "Search the register",
    "surveyModel": "Survey model",
    "surveyModelPlaceholder": "Choose a model of that cave",
    "candidateCount": "Stations offered per scan",
    "candidateCountHint": "How many stations each marker's depth is offered as, nearest first. More of them makes a wrong proposal easier to correct, and a long recording slower to read. Never fewer than two: a single offer would hide the depths that reach two stations equally well, which is what this screen exists to show you.",
    "peopleTitle": "Who was scanning",
    "peopleHint": "A device account is a login on a phone, not a person, and nothing in the archive says which caver it was. So nothing is proposed here: say who each account is, and a scan made by an account nobody has named is left out rather than attributed to a guess.",
    "peopleUnmappedTitle": "{{count}} device accounts name nobody",
    "peopleUnmappedBody": "Every scan made under an account nobody has named is left out of the import. Name them here and their scans can be taken like any other.",
    "peopleOffRosterTitle": "{{count}} people you named are not on this trip",
    "peopleOffRosterBody": "Putting somebody on a trip is a statement about who went, and this import will not make it. Their scans stay out until they are on the trip's roster, or until those scans are said to be somebody else's.",
    "peopleNone": "The chosen recording names no device accounts.",
    "deviceAccount": "Account {{id}}",
    "chooseCaver": "Say who this is",
    "knownLink": "Linked earlier",
    "unnamedCaver": "Somebody this page cannot name",
    "columns": {
      "take": "Take",
      "when": "Scanned",
      "place": "Marker",
      "station": "Station",
      "who": "Who",
      "note": "Note",
      "reason": "Why"
    },
    "states": {
      "proposed": "Proposed",
      "tied": "Several stations at that depth",
      "noPlace": "The scan names no marker",
      "placeUnknown": "This installation does not hold that marker",
      "depthUnknown": "The marker carries no depth",
      "noStationAtDepth": "No station of the survey is at that depth",
      "modelUnavailable": "No usable survey model is chosen"
    },
    "unresolvedHint": "Nothing could be proposed, so this scan is left out.",
    "namedStation": "To be recorded at {{station}}",
    "namedStationHint": "Nothing was proposed for this scan; that station is one you named yourself, and confirming records it there.",
    "clearStation": "Leave it out",
    "noPlaceTitle": "(no marker)",
    "placeDepth": "Recorded at {{depth, number}} m",
    "candidate": "{{depth, number}} m down · {{delta, number}} m off",
    "proposedFrom": "From the marker's depth, {{depth, number}} m",
    "whoUnmapped": "Nobody says who this account is",
    "whoAnonymous": "The scan names no account",
    "noScans": "No scans to show yet. Choose a recording above.",
    "takeAll": "Take all {{count}}",
    "skipAll": "Set all aside",
    "summaryTitle": "What confirming would do",
    "scans": "Scans",
    "proposed": "With a proposal",
    "unresolved": "Unresolved",
    "taken": "Taken",
    "blockersTitle": "Not ready to confirm yet",
    "blockers": {
      "recording": "Choose which recording in the archive this is about.",
      "archiveEmpty": "This archive holds no recording, so there is none to choose.",
      "destination": "Choose the trip the positions go onto, or ask for one to be created.",
      "model": "Choose the survey model whose stations these positions are.",
      "modelUnusable": "The chosen survey model is not one this account can place, so nothing can be proposed from it.",
      "selection": "No scans are taken, so there is nothing to record."
    },
    "unresolvedTitle": "{{count}} scans have no station",
    "unresolvedBody": "Each says why on its own row. They cannot be taken, and confirming leaves them alone; the rest of the recording is unaffected.",
    "createTripNote": "Confirming creates the trip and records the taken scans onto it, as one batch.",
    "existingTripNote": "Confirming records the taken scans onto the chosen trip, as one batch. The trip itself is not changed.",
    "undoHint": "Taking this batch back removes the positions it recorded onto a trip that was already there. A trip this import created is deleted with its recording instead, and can be restored from Deleted trips.",
    "recordSelected": "Record {{count}} positions",
    "withheldTitle": "The choices you made are not being shown back to you",
    "withheldBody": "A station is a position, and this account can no longer place the cave the chosen model belongs to. The review is still stored and still says what it said; only its contents are withheld here. Nothing changed on this page is saved while that is so, exactly so that what is stored survives.",
    "archiveEmptyTitle": "This archive holds no recordings",
    "archiveEmptyBody": "The upload was read and the phone's database carries no trip in it. There is nothing here to import — check that this is the export you meant, and that the recording was saved on the phone before the archive was made.",
    "resultTitle": "The recording has been imported",
    "viewBatches": "See the batch",
    "createdPositions": "Positions recorded",
    "skipped": "Set aside",
    "tripWasCreated": "The trip was created by this import, so taking the batch back removes it.",
    "tripWasExisting": "The positions were added to a trip that already existed, which this import did not change.",
    "someFailedTitle": "{{count}} scans could not be recorded",
    "failures": {
      "pointMissing": "The archive no longer reads that scan as part of this recording.",
      "stationUnresolved": "Nothing said which station this scan is, and none could be proposed.",
      "stationUnknown": "The station named is not one of the chosen model's stations.",
      "caverUnmapped": "Nobody said which person the scanning account is.",
      "caverNotParticipant": "The person named is not on the trip's roster.",
      "recordedInFuture": "The scan claims a moment after the clock.",
      "noteTooLong": "The scan's own note is longer than a position carries.",
      "unknown": "The scan was refused."
    },
    "errors": {
      "fileNotFound": "That archive is not here any more, or you may not read it.",
      "tripNotFound": "That trip is not here any more, or you may not add to it.",
      "createForbidden": "You may not record trips here.",
      "groupBindingForbidden": "You may not organise trips under that group.",
      "archiveUnreadable": "The upload could not be read as a SpeleoLoc archive.",
      "archiveTooLarge": "The archive is larger than this installation reads in one go.",
      "recordingTooLarge": "That recording holds more scans than one review reads. Nothing is shortened, because a shortened list reads exactly like a complete one.",
      "recordingNotFound": "That recording is not in the archive any more.",
      "recordingAlreadyConverted": "This recording has already been made into a trip report, so its positions are already recorded.",
      "recordingNotWritable": "This recording is already kept here under an account whose recordings you may not change.",
      "tripMissing": "Say where the positions go: a trip that exists, or one this import creates.",
      "tripAmbiguous": "A recording goes onto a trip or into a new one, not both.",
      "modelMissing": "A position is a station of a survey model, and none is chosen.",
      "modelUnavailable": "That survey model does not exist here, or its cave cannot be placed by this account.",
      "referenceUnknown": "The depth this survey is measured from could not be established.",
      "selectionEmpty": "No scans are taken, so there is nothing to record.",
      "selectionTooLarge": "Too many scans for one confirmation. Set some aside and record the rest.",
      "nothingCreated": "Not one of the chosen scans could be recorded, so nothing was. The review is untouched.",
      "keptRecordingNotFound": "That recording is not here any more, or you may not read it.",
      "recordingPreviewFailed": "This recording could not be read with the current choices.",
      "commitFailed": "The recording could not be imported.",
      "previewFailed": "This archive could not be read with the current choices.",
      "uploadFailed": "The archive could not be uploaded."
    }
  },
  "hypsometry": {
    "caveTitle": "Passage by height",
    "areaTitle": "Entrances by height",
    "loading": "Measuring…",
    "nothingMeasured": "There is no line work to measure.",
    "noAltitudesTitle": "No heights were recorded",
    "noAltitudesReason": "This survey carries no third coordinate, so there is nothing to distribute by height. A cave drawn in plan is not a cave lying on one level.",
    "noEntrances": "No entrance in this area has a recorded altitude you may place.",
    "axisAltitude": "Altitude (m)",
    "axisPassageMetres": "Passage (m)",
    "axisEntrances": "Entrances",
    "metres": "{{value}} m",
    "springLine": "Spring",
    "from": "From (m)",
    "to": "To (m)",
    "share": "Share",
    "noProposal": "The measurements do not separate into levels.",
    "notConfirmed": "No reading has been recorded yet",
    "confirm": "Record this reading",
    "clear": "Withdraw the reading",
    "clearConfirm": "Withdraw the recorded reading of this cave's levels?",
    "saved": "The reading was recorded.",
    "saveFailed": "The reading could not be recorded. Reload and check what stands.",
    "entrancesPlaced": "Entrances counted",
    "springsSeen": "Springs among them",
    "countedOverWhatYouMayPlace": "Counted over the entrances you may place, which is deliberately not a count of the entrances in this area.",
    "proposalIsNotAnAssertion": "The levels drawn behind the bars are read off the histogram by arithmetic. They are a proposal about the measurements, not a statement about the cave.",
    "springLinesExplained": "The dashed lines are the altitudes of the springs in this area. A level cut at the height water leaves the massif at means something a level anywhere else does not.",
    "proposedCount": "Levels proposed from the measurements: {{count}}",
    "confirmedCount": "Levels in the recorded reading: {{count}}"
  },
  "structureComparison": {
    "caveTitle": "Passage against the mapped structure",
    "areaTitle": "Depressions against the mapped structure",
    "loading": "Comparing…",
    "passageRose": "Passage trend",
    "noPassageTrend": "This cave's line work has no measurable trend.",
    "noStructureNearby": "No fracture trace you may place was mapped within reach.",
    "noStructureInArea": "No fracture trace you may place was mapped in this area.",
    "noDolines": "No outline here has a usable alignment.",
    "divergence": "Divergence",
    "meanSeparation": "Mean trends apart",
    "unitDegrees": "°",
    "noDivergence": "One side has nothing in it, so there is no disagreement to report. Nought here would claim agreement with a structure nobody has mapped.",
    "divergenceScale": "Nought means the two lie along each other; one means they lie across each other, a quarter turn apart.",
    "linesOnly": "Only mapped fracture and fault lines are compared. Bedding and joint readings taken at a station are a different kind of record and this installation stores none.",
    "dolineModeElsewhere": "The comparison of depression long axes against fault strikes is asked of an area, on that area's own page.",
    "structureRose": "Fracture traces ({{count}} within {{radius}} m)",
    "areaStructureRose": "Fracture traces ({{count}} in this area)",
    "dolineRose": "Depression long axes ({{count}} outlines)"
  },
  "overburden": {
    "title": "Rock overhead",
    "loading": "Measuring the rock overhead…",
    "nothingMeasured": "This cave has no line work to measure along, so there is nowhere to ask how much rock is overhead.",
    "noAltitudesTitle": "This cave's line work carries no altitudes.",
    "noAltitudesReason": "How much rock lies overhead is the ground surface less the altitude of the passage, and a survey recorded as a plan has no altitude for it to be measured down to. A profile of noughts would draw the whole cave lying on the surface.",
    "noTerrainBuilt": "No elevation data has been prepared on this installation, so the height of the ground over this cave is not known anywhere. This is not a statement about the cave.",
    "noCoverageHere": "Elevation data has been prepared here, but none of it reaches this cave. The ground over it is unknown rather than at sea level.",
    "axisDistance": "Distance along the passage (m)",
    "axisThickness": "Rock overhead (m)",
    "thinnest": "Thinnest",
    "thickest": "Thickest",
    "mean": "Mean",
    "passageLength": "Passage measured along",
    "coverage": "Readings with a ground height",
    "coverageValue": "{{covered}} of {{total}}",
    "unitMetres": "{{value}} m",
    "notMeasured": "—",
    "figuresScope": "The figures are taken over the readings that got a ground height and over no others, so a cave the elevation data covers in part is described over that part alone. A negative thickness is reported as measured: it means the elevation model puts the surface below the passage, and the two disagree.",
    "gap": {
      "outsideCoverage": "The curve breaks where no prepared elevation data reaches the passage. Nobody knows the height of the ground there, which is why the line stops rather than crossing the gap.",
      "noData": "The curve breaks where the elevation data reaches the passage but records nothing — a hole in the model, not a passage at the surface.",
      "mixed": "The curve breaks in two kinds of place: where no prepared elevation data reaches the passage, and where data reaches it but records nothing. Neither is a passage at the surface."
    },
    "distanceNote": "The horizontal axis is how much passage lies before each reading, in the order the line work records it. A survey is a network rather than one walk through the cave, so it is a length and not a route anybody could follow.",
    "pressToLocate": "Press a point on the curve to mark where that reading was taken, on the map and in the 3D scene.",
    "readout": "{{distance}} along · {{thickness}} · piece {{segment}} of the line work",
    "readoutWhere": "{{distance}} along the passage",
    "readoutThickness": "{{value}} of rock overhead",
    "readoutSegment": "Piece {{index}} of the line work",
    "readoutAbsent": {
      "outsideCoverage": "No elevation data reaches here",
      "noData": "The elevation data records nothing here"
    },
    "markLabel": "{{value}} of rock overhead",
    "markLabelAbsent": "Rock overhead not known here"
  },
  "altitudeCheck": {
    "title": "Entrance altitudes against the ground",
    "areaTitle": "Entrance altitudes against the ground",
    "loading": "Comparing entrance altitudes with the elevation data…",
    "noTerrainBuilt": "No elevation data has been prepared on this installation, so recorded altitudes cannot be compared with the ground. This is not a statement about the entrances.",
    "noEntrances": "There are no entrances here that you may place, so there is nothing to compare.",
    "colEntrance": "Entrance",
    "colRecorded": "Recorded",
    "colModelled": "Elevation model",
    "colDifference": "Difference",
    "colVerdict": "Result",
    "unitMetres": "{{value}} m",
    "notMeasured": "—",
    "unnamedCave": "Unnamed cave",
    "verdict": {
      "agrees": "Agrees",
      "disagrees": "Disagrees",
      "notRecorded": "No altitude recorded",
      "notModelled": "No ground height here"
    },
    "disagreeing_one": "{{count}} entrance differs from the ground height by more than {{tolerance}} m. A gap that size usually means the coordinate is wrong, not the altitude.",
    "disagreeing": "{{count}} entrances differ from the ground height by more than {{tolerance}} m. A gap that size usually means the coordinate is wrong, not the altitude.",
    "explained": "The difference is the recorded altitude less the ground height the elevation model gives under the entrance. A gap beyond {{tolerance}} m is flagged, which is more than the model's own error and the foot of a cliff explain. Filling takes the ground height and writes it only where nothing is recorded: a measured altitude is never replaced by the model.",
    "fill": "Fill from ground",
    "filled": "Altitude filled from the elevation model.",
    "fillFailed": "The altitude could not be filled. It may already be recorded, or the elevation data may not reach this entrance.",
    "entrancesPlaced": "Entrances compared",
    "compared": "With both altitudes",
    "disagreeingTitle": "Disagreeing",
    "notRecordedTitle": "No altitude recorded",
    "truncated": "Showing the {{count}} with the widest gaps. The figures above count them all.",
    "countedOverWhatYouMayPlace": "Counted and ranked over the entrances you may place, which is deliberately not the number of entrances in this area."
  },
  "systemFigures": {
    "title": "Depth and height across entrances",
    "loading": "Measuring from the entrances…",
    "noEntrances": "This cave has no entrance you may place, so there is nothing to measure from.",
    "entrances": "Entrances",
    "highestEntrance": "Highest entrance",
    "lowestEntrance": "Lowest entrance",
    "entranceSpread": "Height between entrances",
    "totalDepth": "Depth below the highest entrance",
    "height": "Height above the lowest entrance",
    "resurgenceLevel": "Resurgence level of the area",
    "potentialDepth": "Potential depth to the resurgence level",
    "declaredPotentialDepth": "Potential depth on record",
    "disagreesWithRecord": "differs from the computed figure",
    "unitMetres": "{{value}} m",
    "notMeasured": "—",
    "noSurveyAltitudes": "The survey carries no altitudes, so depth and height cannot be measured from it. A plan drawing is not a cave of no depth.",
    "explained": "Depth is measured from the highest entrance down to the lowest point the survey reaches, and height from the lowest entrance up to the highest. The resurgence level is the lowest spring cave entrance in the area that contains this cave, among those you may place; potential depth is the highest entrance less that level."
  },
  "depthProfile": {
    "title": "Depth profile",
    "loading": "Drawing the profile…",
    "noAltitudes": "This cave's line work carries no altitudes, so no depth profile can be drawn. A plan drawing is not a flat cave.",
    "axisDistance": "Distance along the passages (m)",
    "axisDepth": "Altitude (m)",
    "highest": "Highest point",
    "lowest": "Lowest point",
    "deepest": "Depth between them",
    "passageLength": "Passage length",
    "unitMetres": "{{value}} m",
    "readout": "{{distance}} along the passages: altitude {{altitude}}, {{depth}} below the highest point",
    "explained": "Distance is the length of passage before each point in the order the survey records it, not a walk from the entrance, so a branch that climbs back shows as a rise. The profile carries no position."
  },
  "terrainProfile": {
    "tool": "Terrain profile: draw a line on the map",
    "title": "Terrain profile",
    "drawHint": "Click to place the points of the line; double-click to finish.",
    "failed": "The profile could not be read.",
    "noTerrainBuilt": "No elevation model has been built on this installation yet.",
    "noCoverage": "The elevation data does not reach this line.",
    "length": "Length",
    "ascent": "Ascent",
    "descent": "Descent",
    "axisDistance": "Distance along the line (m)",
    "axisElevation": "Elevation (m)",
    "unitMetres": "{{value}} m",
    "readout": "{{distance}} along the line: elevation {{elevation}}",
    "explained": "Elevation comes from the installation's elevation model. Where the model has no ground height the line is left open rather than joined across."
  },
  "terrainStats": {
    "title": "Entrances and sinkholes against the terrain",
    "chartLabel": "Shares of entrances, sinkholes and the area's ground by {{measure}}",
    "loading": "Reading the terrain…",
    "noTerrainBuilt": "No elevation model has been built on this installation yet.",
    "noLayer": "No picture of the terrain has been computed for this measure yet. An administrator can compute one from the terrain page.",
    "needsSlope": "Facing is counted only on sloping ground, and that needs the slope picture.",
    "slopeUnit": "The slope picture exists only in percent; the classes are cut in degrees.",
    "entrances": "Entrances",
    "sinkholes": "Sinkholes",
    "background": "Ground of the area",
    "class": "Class",
    "ratio": "Ratio",
    "measure": {
      "slope": "Slope",
      "aspect": "Facing",
      "position": "Position on the relief"
    },
    "classes": {
      "lt5": "under 5°",
      "5to15": "5–15°",
      "15to30": "15–30°",
      "30to45": "30–45°",
      "gt45": "over 45°",
      "n": "N",
      "ne": "NE",
      "e": "E",
      "se": "SE",
      "s": "S",
      "sw": "SW",
      "w": "W",
      "nw": "NW",
      "hollow": "hollow",
      "level": "level",
      "rise": "rise"
    },
    "counts": "{{entrances}} entrances and {{sinkholes}} sinkholes placed, against {{background}} points of ground.",
    "explained": "The ratio is the share of the entrances (or sinkholes) in a class divided by the share of the area's ground in the same class: above 1 means caves sit there more often than the ground alone would suggest, below 1 less often. Only what you may place is counted; the ground is sampled on a regular grid over the area's outline.",
    "flatNote": "Facing is counted only where the slope is at least 2°."
  },
  "crossSection": {
    "title": "Passage size",
    "loading": "Measuring…",
    "noReadings": "This cave's line work carries no wall distances. Nobody measured how wide or how tall the passage is, which is not the same as the passage having no size.",
    "stations": "Stations measured",
    "readings": "Wall readings",
    "width": "Width",
    "height": "Height",
    "ratio": "Width over height",
    "area": "Cross-section",
    "volume": "Passage volume",
    "median": "Median",
    "mean": "Mean",
    "range": "{{min}} to {{max}}",
    "quartiles": "Middle half {{lower}} to {{upper}}",
    "measuredOver": "over {{count}} stations",
    "notMeasured": "—",
    "volumeNotComputed": "Not computed: no piece of passage has all four walls measured at both of its ends. Nought here would say this cave encloses no space.",
    "volumeScope": "Computed over {{measuredLength}} of {{totalLength}} of passage — {{measured}} of {{total}} pieces. A station where a wall was never reached leaves the estimate rather than counting as zero, so this describes the part of the cave that was measured and no more.",
    "bandsTitle": "By height",
    "bandsNote": "Each slice is {{height}} tall. A slice no station fell in is absent rather than drawn as passage of no size, and a station whose line work carried no altitude is in none of them.",
    "bandLabel": "{{from}} to {{to}}",
    "unitMetres": "{{value}} m",
    "unitSquareMetres": "{{value}} m²",
    "unitCubicMetres": "{{value}} m³",
    "ratioNote": "Above one is passage wider than it is tall; below one is a canyon.",
    "spreadTitle": "Spread of sizes",
    "spreadNote": "Each box is the middle half of the measurements, the line across it the median, and the whiskers the smallest and largest. A slice of the cave nobody measured leaves a gap rather than a box on the floor of the axis.",
    "bandChartTitle": "Sizes by height",
    "scaling": "How height scales with width",
    "scalingValue": "height rises as width to the power {{exponent}}",
    "scalingFit": "over {{count}} stations, accounting for {{r2}} of the spread",
    "scalingNote": "A power near one is a cave whose large passages are scaled-up copies of its small ones; below one it widens faster than it heightens, above one it heightens faster. It describes the measured dimensions and estimates no discharge.",
    "axisMetres": "m"
  },
  "passagePattern": {
    "title": "What the shape suggests",
    "loading": "Reading the shape…",
    "suggested": "Suggested",
    "notAnAssertion": "The pattern below is read off the measurements by rules whose thresholds are chosen conventions, not measurements. It is a proposal about this survey, not a statement about the cave — which is why every rule is shown, including the ones that looked and stayed silent.",
    "rulesTitle": "Every rule, and what it did",
    "scoresTitle": "What each pattern scored",
    "assessed": "{{fired}} of {{assessable}} rules that could be assessed fired. {{assessable}} of {{total}} rules had figures to read.",
    "supports": "Counts towards",
    "weight": "Weight",
    "figures": "Read",
    "network": "Network",
    "networkFigures": "{{nodes}} places passages meet or end, {{loops}} independent loops, {{ends}} dead ends.",
    "pattern": {
      "insufficient": "Too little measured to try",
      "undetermined": "No pattern came out ahead",
      "vadoseBranchwork": "Vadose branchwork",
      "waterTable": "Water-table cave",
      "looping": "Phreatic loops",
      "angularMaze": "Angular maze"
    },
    "outcome": {
      "notAssessable": "Nothing to read",
      "didNotFire": "Did not fire",
      "fired": "Fired"
    },
    "rule": {
      "networkIsLooped": "The network closes on itself often",
      "networkIsTreeLike": "The network barely closes on itself",
      "networkEndsOften": "Much of the network is where the survey stopped",
      "networkRings": "Passages leaving a junction are themselves joined",
      "bearingsAreConcentrated": "The passage runs on a small number of trends",
      "passageIsSteep": "The passage is steep on average",
      "passageIsLevel": "The passage is level and the cave gains little height",
      "profileOscillates": "The passage climbs and descends while the cave stays near one level",
      "sectionIsWide": "The cross-section is wider than it is tall",
      "sectionIsTall": "The cross-section is taller than it is wide"
    },
    "figure": {
      "loopsPerNode": "Loops per junction",
      "deadEndFraction": "Dead ends",
      "clustering": "Junction ringing",
      "orientationEntropy": "Spread of bearings",
      "meanAbsoluteDip": "Mean steepness",
      "maximumDip": "Steepest climb",
      "minimumDip": "Steepest descent",
      "verticality": "Height gained per metre of passage",
      "medianWidthHeightRatio": "Median width over height"
    },
    "caveat": {
      "figuresAreApproximated": "The figures were approximated from the stored centerline rather than taken from the surveyor's own per-shot flags, so this suggestion rests on a guess for a measurement.",
      "networkIsIncomplete": "Reading the survey file lost legs or merged stations, so the network described here is smaller than the one that was surveyed.",
      "networkCompletenessIsUnknown": "Nothing records whether reading the survey file lost anything, which is not the same as nothing having been lost.",
      "noAltitudes": "The line work carries no altitudes, so every rule about the profile had nothing to read.",
      "noCrossSections": "No station measured a complete cross-section, so the rules about passage shape had nothing to read.",
      "noNetworkFigures": "The passage network was never measured, so the rules about its shape had nothing to read."
    }
  },
  "imageLink": {
    "regionCount": "Linked parts of this picture: {{count}}"
  },
  "tripStats": {
    "title": "Trip insights",
    "open": "Insights",
    "backToList": "Back to the list",
    "scopeFiltered": "The current filter",
    "scopeAll": "All trips",
    "populationFiltered": "the {{matching}} of {{overall}} trips you can read that this filter leaves",
    "populationAll": "all {{overall}} trips you can read",
    "compareHint": "Switch to all trips to see the same charts without the filter, as something to compare this against.",
    "perYear": "Trips per year, over {{population}}",
    "byType": "What they were for, over {{population}}",
    "byArea": "Where they went, over {{population}}",
    "byPerson": "Who was on them, over {{population}}",
    "year": "Year",
    "trips": "Trips",
    "areasSoFar": "Distinct areas reached",
    "newGroundNote": "The line is how many distinct areas the counted trips had reached by the end of each year. Still climbing means new ground is being found; flattening under bars that are not means the same places are being revisited.",
    "newWithin": "“New” means new among {{population}}, not new to the whole archive. An area that a trip outside them had already reached counts as new the first time one of them gets there, so a narrower filter starts the line again from nothing.",
    "overlapping": "A trip counts into every value it holds, so these bars add up to more than the {{count}} trips counted.",
    "showingValues": "Showing the {{shown}} largest of {{distinct}}.",
    "empty": "No trips to count.",
    "failed": "The totals could not be worked out."
  },
  "libraryPhotos": {
    "layerName": "Photo library ({{library}})",
    "browse": {
      "title": "Photo library",
      "noPositionShown": "Where these pictures were taken is not shown here. The map is where a library's photographs are placed.",
      "showingOf": "Showing {{shown}} of {{total}} photographs the library holds",
      "showingUnknownTotal": "Showing {{count}} photographs. This library does not say how many it holds.",
      "pageCapped": "This installation asks for at most {{count}} pictures at a time.",
      "empty": "This library holds nothing matching.",
      "pastEnd": "The listing ended before this page — the library said there might be more, and there was not.",
      "silent": "This library did not answer, so there is nothing to show. It may be stopped, or still starting up.",
      "readAt": "Read from the library {{when}}",
      "previous": "Previous",
      "next": "Next",
      "page": "Page {{page}}",
      "pageTooDeep": "That page is further into the library than this installation will ask for, so nothing was asked. Go back towards the first page."
    },
    "search": {
      "placeholderText": "Search titles, captions and labels",
      "placeholderMeaning": "Describe the picture",
      "textOnly": "This library matches your words against titles, captions and labels somebody wrote down. It does not look at the pictures themselves, so a word nobody wrote finds nothing however well it describes what is there.",
      "byMeaning": "This library reads your words as a description and puts everything it holds in order of how close each picture is to it. Nothing is matched and nothing is left out, so what you see is the closest it found — there is no count of what fits.",
      "showing": "Showing {{count}} photographs",
      "showingMore": "Showing {{count}} photographs, and the library says there are more",
      "empty": "Nothing came back for those words. That is about the words rather than about the library, which may hold plenty.",
      "tooLong": "A search here is at most {{count}} characters and this one was longer, so nothing was asked of the library.",
      "showingRanked": "Showing {{count}} pictures from the front of this library's ordering",
      "showingRankedMore": "Showing {{count}} pictures from the front of this library's ordering, which continues past them — everything the library holds is somewhere in it, so further pages are not further matches.",
      "noRanking": "This library put nothing in order for those words. An ordering always has a front, so this is not about the words: the library ranked nothing at all, which is what happens when its picture recognition is switched off.",
      "silentByMeaning": "This library did not answer the search. Its picture recognition may be switched off, in which case it cannot answer words by meaning at all — or the library may be stopped, or still starting up.",
      "reduced": "This library reads a colon as naming one of its own fields, so it was asked for: {{words}}",
      "nothingLeft": "There were no words left once the field separators were taken out, so no library was asked anything."
    },
    "albums": {
      "choose": "The whole library",
      "loading": "Reading this library's albums…",
      "none": "This library keeps no albums",
      "silent": "This library did not answer about its albums",
      "untitled": "Untitled album",
      "withCount": "{{title}} — {{count}} photographs",
      "truncated": "Only the first {{count}} albums this library keeps are offered here.",
      "notWithASearch": "A search goes to the library whole and cannot be narrowed to an album, so the album chosen is not being used. Clear the search to browse the album again.",
      "showingOf": "Showing {{shown}} of {{total}} photographs the library puts in this album",
      "showingUnknownTotal": "Showing {{count}} photographs from this album. This library does not say how many it puts in it.",
      "nothingIn": "This library puts nothing in this album. The library answered; it may hold plenty elsewhere.",
      "notFound": "That is not an album this installation will ask a library about, so nothing was asked."
    },
    "trip": {
      "title": "Photographs from the photo library",
      "explains": "Pictures a connected photo library holds from the days this trip was out. They come from that library and nothing here has been filed against the trip. The days asked about reach at least a day past each end of the trip, because a trip's dates carry no time zone and a camera's clock does — so pictures from the day before or the day after can appear, and each one shows its own date.",
      "showingOf": "Showing {{shown}} of {{total}} photographs the library holds from these days",
      "showingUnknownTotal": "Showing {{count}} photographs from these days. This library does not say how many it holds.",
      "nothingTaken": "This library holds nothing taken while this trip was out. The library answered; it may hold plenty from other days.",
      "notFound": "This trip could not be read, so no library was asked anything about it.",
      "datesUnusable": "This trip's dates do not give a stretch of time to ask a photo library about, so nothing was asked. Check the day it started and the day it ended."
    },
    "detail": {
      "title": "Photograph",
      "takenAt": "Taken",
      "camera": "Camera",
      "lens": "Lens",
      "aperture": "Aperture",
      "exposure": "Exposure",
      "iso": "ISO",
      "focalLength": "Focal length",
      "library": "Library",
      "isVideo": "This is a video. Only a still of it is shown here.",
      "gone": "This library no longer reports that photograph. The list was read a moment ago and the library has changed since.",
      "silent": "This library did not answer about that photograph."
    },
    "source": {
      "immich": "Immich",
      "photoprism": "PhotoPrism"
    },
    "loading": "Reading this library…",
    "count": "{{count}} photographs shown",
    "empty": "This library has no photographs in this area.",
    "unavailable": "This library did not answer. The photographs shown are the last positions read from it.",
    "truncated": "Only the first {{count}} photographs in this area are shown — zoom in to see the rest.",
    "readAt": "Positions read {{when}}",
    "notConfigured": "No photo library is connected to this installation.",
    "takenAt": "Taken {{when}}",
    "noTitle": "Untitled",
    "video": "Video",
    "thumbnailFailed": "The photograph could not be loaded.",
    "asPictures": "Show the photographs themselves",
    "picturesSuppressed": "Too many photographs here to show them as pictures — zoom in.",
    "createFeature": "Create a feature here",
    "createTitle": "Create a feature from this photograph",
    "createHint": "The position comes from the photograph itself, read from the library that holds it. Everything else can be edited afterwards.",
    "kind": "What is it?",
    "kindCave": "Cave",
    "kindEntrance": "Cave entrance",
    "kindOther": "Another kind",
    "featureType": "Kind",
    "cave": "Cave it belongs to",
    "name": "Name",
    "created": "{{name}} was created at the position this photograph records.",
    "openCreated": "Open it",
    "nearbyTitle": "Something is already recorded near here",
    "nearbyHint": "Check that this is not the same place recorded a second time.",
    "nearbyItem": "{{name}} — {{distance}} m away",
    "refusals": {
      "photographGone": "This library no longer reports that photograph in the area on screen, so nothing was created. Refresh the map and start again from the photograph.",
      "answerTruncated": "There are more photographs here than this library answers with at once, and this one was not in its answer. Zoom in and try again.",
      "caveGone": "That cave is no longer there, or you may not see it.",
      "caveForbidden": "You may not add an entrance to that cave.",
      "typeUnknown": "This installation has no kind to create that as.",
      "positionInvalid": "The library reported a position that is not a place on the earth, so nothing was created.",
      "notAllowed": "You may not reach this installation's photo libraries.",
      "createForbidden": "You may not create features here.",
      "propertiesRefused": "That kind cannot hold the two lines saying which library the position came from, so nothing was created.",
      "needsContainer": "That kind has to sit inside something else, which this dialogue does not ask for. Create it from the map instead.",
      "librarySilent": "The library did not answer, so nothing was created. It may be busy or still starting — try again in a moment."
    },
    "health": {
      "notAnswering": "This library is configured but did not answer. Check that it is running and that the address is right.",
      "credentialRefused": "This library would not accept the credential this installation is configured with. Issue a new one in the library and set it here.",
      "missingPermissions": "The credential this installation uses is missing: {{permissions}}. Add them to it in the library's own settings.",
      "unreadable": "This library answered, but not in a way this installation could read.",
      "partlyAnswering": "This library answered, but one of the questions this installation asks it did not come back. It may be busy or still starting up.",
      "picturesStopped": "Photographs from this library are not being fetched: it answered a picture request without a picture, which can mean it cannot reach its originals.",
      "versionChecked": "Version {{version}} · checked {{when}}",
      "checked": "Checked {{when}}",
      "recheckFailed": "The library still did not answer, so nothing changed.",
      "recheckRefused": "The library answered and would not accept the credential this installation is configured with, so nothing changed.",
      "suspended": "This installation is not using this photo library for now. It is still running and still reachable at its own address."
    },
    "notConnected": "{{library}} is not connected: this installation has no address or credential for it.",
    "recheck": "Check again",
    "admin": {
      "suspend": "Stop using this photo library",
      "suspendHint": "While this is on, nothing here asks the library anything: no map layer, no browsing, no search and no pictures.",
      "stillHoldsEverything": "Stopping SilexGIS from using it changes nothing about what it holds, what it indexes, or who can log into it directly.",
      "stopCommand": "To stop the photo library itself, use the deployment: {{command}}",
      "cannotConnect": "{{library}} is not connected: this installation has no address or credential for it. Connecting one is part of the deployment and cannot be done from this page.",
      "none": "This installation has been given no photo library, so there is nothing to stop."
    }
  },
  "karstlinkExport": {
    "menuItem": "KarstLink (JSON-LD)",
    "notInWindow": "Not while the list is cut to the map's window — clear the window to export the whole filtered list.",
    "changeAnswer": "KarstLink (JSON-LD) — change my answer…",
    "title": "Export caves for interchange",
    "intro": "Caves described in the published cave and karst vocabulary, as a file you can hand to somebody else. A file outlives the permission that produced it, so what it says about a protected location is decided here and written into the file itself.",
    "download": "Export",
    "caveCount": "{{count}} cave(s) in this export.",
    "protectedCount": "{{count}} of them have a location this installation protects. The answer below applies to all of them.",
    "noneProtected": "None of them has a location this installation protects, so nothing below changes this file.",
    "tooMany": "This selection holds {{count}} cave(s) and one file may hold {{limit}}. Narrow the filters and export in parts — a file that stopped at a limit looks exactly like a complete one to whoever receives it.",
    "remember": "Remember this answer, and stop asking me",
    "askAgain": "That export could not be made with your remembered answer. Please choose again.",
    "treatments": {
      "grid_position": {
        "label": "Place them on the protection grid",
        "help": "The same coarse position the map already shows to anyone without the right to see the exact one. The file says beside each of them how far it may be from the real place."
      },
      "no_position": {
        "label": "Include them with no coordinates",
        "help": "Everything else about the cave — its name, its code, its length and depth — and nothing about where it is."
      },
      "omit": {
        "label": "Leave them out of the file",
        "help": "The file states how many caves were left out, because counts taken from it will otherwise disagree with the registry and the recipient would have no way to know."
      }
    },
    "errors": {
      "tooManyCaves": "One file may hold {{count}} caves. Narrow the filters and export in parts."
    }
  },
  "externalIds": {
    "title": "Identifiers in other registers",
    "explanation": "The number another register knows this cave by. It is the only stable way to say that a cave here and a cave there are the same cave: names are not stable, and a position is exactly what may not be shared. Only the number is kept — nothing else a register says about the cave is copied here, so nothing here can go stale while still looking authoritative.",
    "placeholder": "Not recorded",
    "lookup": "Look this cave up in Grottocenter",
    "lookupFailed": "Grottocenter could not be asked.",
    "notConfigured": "This installation does not look caves up in Grottocenter. An administrator turns the integration on before it can be used; until then nothing is sent anywhere.",
    "noCandidates": "Grottocenter offered nothing for this name.",
    "accept": "Record this one",
    "systems": {
      "grottocenter": "Grottocenter",
      "national_cadastre": "National cadastre"
    }
  },
  "rastermap": {
    "tab3d": "3D",
    "untitledMap": "Untitled map",
    "imageMissing": "The map image cannot be shown.",
    "supersededPoints": "Points placed on an older scan of this map: {{count}}",
    "addMap": "Add map",
    "declareTitle": "Add a map of this model",
    "editMapTitle": "Map settings — {{title}}",
    "mapDocument": "Map image document",
    "notAnImage": "The chosen document's current file is not an image, so it cannot be shown as a map.",
    "viewKind": "View",
    "viewKinds": {
      "plan": "Plan",
      "profile": "Profile",
      "other": "Other view"
    },
    "undeclare": "Remove map from this model",
    "undeclareConfirm": "Remove this map from the model?",
    "undeclareHint": "Only the declaration is removed: the document stays, and any station points stay on their links.",
    "mapDeclared": "Map added.",
    "mapRemoved": "Map removed.",
    "definePoints": "Define points",
    "doneDefining": "Done",
    "mapSettings": "Map settings",
    "armedStation": "Placing {{station}} — click its point on the map",
    "armHint": "Press a station in the 3D view, or find it by name",
    "stationPlaceholder": "Station name…",
    "pickSingleStation": "Pick a single station — a survey or a leg cannot be a point.",
    "alreadyPinned": "{{station}} already has a point on this map",
    "moveHere": "Move it here",
    "pinTitle": "Point {{station}}",
    "movePin": "Move",
    "deletePin": "Delete",
    "cannotEditPin": "You may not correct this point — it belongs to a link you cannot edit.",
    "replacePin": "Re-place",
    "pinSaved": "Point saved for {{station}}.",
    "pinDeleted": "Point deleted."
  },
  "placeMap": {
    "openAsMap": "Open as map",
    "title": "{{title}} — map",
    "untitled": "Map",
    "earlierPicture_one": "{{count}} point was measured on an earlier picture.",
    "earlierPicture": "{{count}} points were measured on an earlier picture.",
    "notOnPicture_one": "{{count}} point is not on this picture.",
    "notOnPicture": "{{count}} points are not on this picture.",
    "addPoint": "Add a point",
    "addHint": "Click the map where the place is.",
    "moveHint": "Click the map where {{place}} should be.",
    "stopPlacing": "Stop",
    "pickPlaceTitle": "Which place is here?",
    "pickPlace": "Place",
    "move": "Move",
    "delete": "Delete",
    "deleteConfirm": "Remove this point from the map? Phones carrying the map are told.",
    "saved": "Point saved.",
    "deleted": "Point removed.",
    "cannotEdit": "You may not change the points of this map.",
    "unnamedPlace": "Place without a name"
  },
  "publishedTrips": {
    "title": "Published trips",
    "intro": "Every follow link this installation has handed out, and what each one opens for whoever holds it. A link stays listed after it has been taken back, for as long as its trip exists.",
    "asOf": "Statuses as of {{when}}.",
    "refresh": "Refresh",
    "namesShown": "The published pages of this installation show the party's real names.",
    "namesHidden": "The published pages of this installation show places in the party, not people's names.",
    "archiveOff": "Past trips are switched off here, so no link is in the archive: once a trip's own page has closed, its link opens nothing.",
    "settings": {
      "title": "What these statuses rest on in this installation",
      "lifetime": "A link runs out by itself after its trip's last day, whatever its tracking does (the date under “Runs out”) — {{span}}",
      "grace": "“Just closed” lasts this long after tracking is closed, and never past the date the link runs out — {{span}}",
      "graceNone": "“Just closed” is not used here: a link stops opening its page the moment its tracking is closed.",
      "retention": "“In the archive” lasts this long after a trip's last day — {{span}}",
      "retentionUnlimited": "“In the archive” has no time limit here.",
      "siblings": "An old link goes on listing the parties tracked in its cave now for this long after its own trip's last day — {{span}}",
      "siblingsUnlimited": "An old link goes on listing the parties tracked in its cave now, with no time limit.",
      "siblingsNone": "An old link stops listing the parties tracked in its cave now as soon as its own trip is over and its own page has ended.",
      "siblingsWhileArchived": "An old link goes on listing the parties tracked in its cave now for as long as its own trip stays in the archive (the line above).",
      "siblingsWithinArchive": "An old link goes on listing the parties tracked in its cave now for this long after its own trip's last day, and never after its trip has left the archive — {{span}}",
      "siblingsArchiveOff": "An old link lists nobody here: with past trips switched off, a link whose own page has ended opens nothing.",
      "readLimit": "Requests one address may make to the published pages in a minute, before it is told to wait: {{limit}}",
      "span": {
        "days": "days: {{amount}}",
        "hours": "hours: {{amount}}",
        "minutes": "minutes: {{amount}}",
        "seconds": "seconds: {{amount}}"
      }
    },
    "anyStatus": "Any status",
    "empty": "Nothing has been published on this installation.",
    "emptyFiltered": "No link has this status.",
    "emptyLongRunning": "No published trip's tracking has been running that long.",
    "emptyBoth": "No link has this status and tracking running that long.",
    "seenFrom": "This request reached the server from:",
    "seenFromExplain": "If that is your own address, the reverse-proxy settings are right. If it is the address of a reverse proxy in front of this installation — one that adds each caller's address to X-Forwarded-For itself — the stated number of proxies is too low: every reader behind that proxy is counted as one and shares one request budget, so published pages start refusing readers when it is busy. The installation guide says how to set SILEXGIS__Proxy__Hops. If it is instead a gateway that only passes connections on and writes no such header (the gateway address of a Docker network, for example), do not raise the number: no count fixes that, and counting it would let a caller choose the address they are counted under.",
    "seenFromUnknown": "The server could not tell which address this request came from.",
    "longRunning": {
      "label": "Tracking running longer than (days)",
      "any": "Any"
    },
    "watch": {
      "running": "Days running: {{days}}",
      "runningLapsed": "Tracking is still running, but this link has run out.",
      "closed": "Closed {{when}}",
      "open": "Tracking tab",
      "unknown": "Not recorded"
    },
    "unavailable": "The list of published links could not be read.",
    "failed": "That could not be completed. Refresh the list to see which links still stand.",
    "irreversible": "This cannot be undone.",
    "noCave": "No cave",
    "unnamedCave": "Unnamed cave",
    "unknownPublisher": "Account no longer shown",
    "revokedAt": "Taken back {{when}}",
    "statuses": {
      "followable": "Followed now",
      "inGrace": "Just closed",
      "inArchive": "In the archive",
      "withheld": "Withheld",
      "lapsed": "Opens nothing",
      "revoked": "Taken back"
    },
    "statusHelp": {
      "followable": "The watch is running and the link shows the party as it is reported.",
      "inGrace": "The watch has been closed. For a short while the link still opens the page, which says everybody is out.",
      "inArchive": "The trip is over. The link opens it, and the other finished trips of its cave, as history.",
      "withheld": "The link would open something were it not for its cave: the watch has lost its cave, or the cave's position is now protected. It answers like an unknown link for as long as that holds, and no longer.",
      "lapsed": "Nobody took the link back, and it opens nothing: it ran out, its watch was stood down, or the archive no longer covers its trip.",
      "revoked": "Somebody took the link back. It opens nothing and never will again."
    },
    "columns": {
      "status": "Status",
      "trip": "Trip",
      "tripDate": "Trip date",
      "cave": "Cave",
      "publishedBy": "Published by",
      "createdAt": "Published",
      "expiresAt": "Runs out",
      "watchArmedAt": "Tracking started",
      "watchArmedAtHelp": "When this trip's tracking was last started. Nothing closes tracking but a person, so tracking that has been running far longer than its trip was most likely forgotten: the party stays on the published page as still underground or, once the link has run out, is in no public list at all. Close it from the trip's Tracking tab.",
      "handle": "Log code",
      "handleHelp": "The short code the request log writes in place of a link's address, so a line in the log can be matched with a row here. It opens nothing."
    },
    "refused": {
      "title": "For full administrators only",
      "text": "This page lists every published trip of the installation, across every trip's own access rules, and can take all of them back. It is open to full administrators and to nobody else."
    },
    "bounds": {
      "tag": "Protected cave nearby?",
      "title": "A protected cave stands inside the area of a published survey",
      "explain": "The position of a protected cave other than the trip's own, or of one of its entrances, lies inside the rectangle spanned by the stations of the survey this link hands out. This is a check by position only and cannot see inside the survey file: the survey may not enter that cave at all, and a survey that does can pass unmarked. Nothing was refused — open the survey and judge whether the link should stay."
    },
    "actions": {
      "replace": "Replace link",
      "unpublishTrip": "Unpublish this trip",
      "unpublishEverything": "Unpublish everything"
    },
    "replace": {
      "title": "Replace this link?",
      "stops": "The old address stops answering at once. Wherever it has been pasted — a message, an article, a website block — it opens nothing from now on.",
      "keeps": "A fresh address is shown here, once. It runs out when the old one would have, the trip stays in its cave's list of past trips, and nobody on the trip is told."
    },
    "replaced": {
      "title": "The new address is ready",
      "once": "Copy it now — this is the only time it is shown. The old address no longer answers.",
      "expires": "It runs out on {{when}}, as the old one would have.",
      "done": "I have copied it"
    },
    "trip": {
      "title": "Unpublish this trip?",
      "stops": "Every follow link of this trip is taken back at once. Anybody holding one stops being able to open the page.",
      "leavesHistory": "The trip also leaves its cave's public list of past trips. A finished trip is published again only by starting its watch again.",
      "done": "Links taken back: {{links}}"
    },
    "everything": {
      "title": "Unpublish everything?",
      "stops": "Every follow link of this installation is taken back at once — every trip, every cave. Links still standing in this list: {{links}}. Every published page stops answering, on this installation and on any website showing one.",
      "deletedToo": "The links of deleted trips are taken back as well. A deleted trip can be restored, and its links would answer again with it, so they are withdrawn now; this list does not show them. The number of links taken back can therefore be larger than the number above.",
      "leavesHistory": "Every cave's public list of past trips empties. A finished trip is published again only by starting its watch again, one trip at a time.",
      "typeWord": "To go on, type {{word}} below.",
      "word": "UNPUBLISH",
      "done": "Links taken back: {{links}} · Trips: {{trips}}",
      "doneMoreThanListed": "Links taken back: {{links}} · Trips: {{trips}} · Links this list showed: {{listed}}. The links of deleted trips, which the list leaves out, are taken back too."
    }
  },
  "shortcuts": {
    "title": "Keyboard shortcuts",
    "open": "Keyboard shortcuts (?)",
    "keys": "Keys",
    "does": "Action",
    "context": {
      "screen": "On this screen",
      "map": "With the map focused",
      "panelHandle": "With a panel section's handle focused",
      "scene3dCallout": "In the 3D scene's selection card",
      "lightbox": "In the photo viewer",
      "passage": "On a marked passage of a text"
    },
    "action": {
      "help": "Show this list of shortcuts",
      "clearSelection": "Clear the selection",
      "toggleLeftDock": "Show or hide the left panel",
      "toggleRightDock": "Show or hide the right panel",
      "selectionBack": "Previous selection",
      "selectionForward": "Next selection",
      "pan": "Move the map",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "moveSectionUp": "Move the section up",
      "moveSectionDown": "Move the section down",
      "dismissCallout": "Close the card",
      "closeViewer": "Close the viewer",
      "previousPhoto": "Previous photo",
      "nextPhoto": "Next photo",
      "zoomInPhoto": "Zoom in on the photo",
      "zoomOutPhoto": "Zoom out of the photo",
      "resetPhoto": "Back to the whole photo",
      "followPassage": "Follow the link",
      "contextMenu": "Open the map menu at the middle of the view"
    },
    "keyCap": {
      "ctrl": "Ctrl",
      "command": "⌘ Cmd",
      "alt": "Alt",
      "option": "⌥ Option",
      "shift": "Shift",
      "escape": "Esc",
      "enter": "Enter",
      "space": "Space",
      "menu": "Menu"
    }
  },
  "a11y": {
    "skipToMain": "Skip to main content",
    "skipToMap": "Skip to map",
    "mainNav": "Main navigation",
    "mapScale": "Map scale",
    "viewName": "Name of the view to save",
    "shareView": "Share the view {{name}}",
    "deleteView": "Delete the view {{name}}",
    "map": "Map. Arrow keys move it, plus and minus zoom; press ? for all shortcuts.",
    "editEntrance": "Edit the entrance {{name}}",
    "deleteEntrance": "Delete the entrance {{name}}",
    "layerTransparency": "Transparency of {{name}}",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "previousPages": "Five pages back",
    "nextPages": "Five pages on",
    "dateFrom": "From date",
    "dateTo": "To date",
    "baseLayerChooser": "Change the base layer",
    "search": "Search"
  },
  "mapFilter": {
    "unreadableLink": "The filter in this link could not be read, so the map shows everything you can see. Ask whoever sent it for a fresh link.",
    "refused": "The map's filter could not be run with your access — it may have been deleted or changed. Its layers show nothing until you clear it.",
    "active": "Map filtered by {{name}}",
    "activeUnnamed": "Map filtered by a filter from a link or a saved view",
    "savedUnavailable": "a saved filter you cannot open",
    "clear": "Clear the map's filter",
    "edit": "Conditions…",
    "editTitle": "Map conditions",
    "applySaved": "Apply a saved filter…",
    "noSaved": "No saved filters yet",
    "saveAs": "Save as filter…",
    "saveTitle": "Save these conditions as a filter",
    "saved": "Saved “{{name}}” — the map now follows it",
    "drawHint": "Click to place the corners, double-click to finish. Press Escape to give up."
  },
  "worldFilter": {
    "advanced": "Conditions…",
    "geofileTitle": "Geodata file conditions",
    "rasterTitle": "Georeferenced map conditions",
    "on": "on",
    "applySaved": "Apply a saved filter…",
    "noSaved": "No saved filters yet",
    "saveAs": "Save as filter…",
    "manage": "Saved filters",
    "forget": "Stop naming this saved filter",
    "active": "Saved filter: {{name}}",
    "activeUnavailable": "Saved filter not available to you",
    "changed": "changed since",
    "saveTitle": "Save these conditions as a filter",
    "saved": "Saved as “{{name}}”.",
    "savedUnreadable": "That saved filter cannot be read with your access, so it was not applied.",
    "savedNotAboutThis": "That saved filter is not about this kind of list.",
    "unreadableLink": "The conditions in this link could not be read, so they were left out. Ask whoever sent it for a fresh link.",
    "refused": "These conditions could not be applied. Change them, or stop naming the saved filter."
  },
  "quickFilters": {
    "label": "Pinned saved filters",
    "none": "No pinned filters — pin one from Saved filters",
    "gone": "A pinned filter that is no longer there",
    "unreadable": "{{name}} (cannot be run)",
    "unpin": "Unpin {{name}}",
    "pin": "Pin as a quick filter",
    "unpinRow": "Unpin from the quick filters",
    "full": "{{count}} filters are pinned already — unpin one to pin another"
  },
  "filterLayers": {
    "add": "Add a layer from a saved filter…",
    "full": "The map holds {{count}} filter layers at most — remove one to add another",
    "noneToAdd": "No saved filter to add — save one from the cave registry first",
    "unavailableName": "A saved filter you cannot open",
    "unreadable": "Unreadable",
    "unreadableHint": "This filter was deleted, is no longer shared with you, or can no longer be run. The layer draws nothing until you remove it.",
    "changeColor": "Colour of {{name}}: {{color}}. Change colour",
    "changeSymbol": "Symbol of {{name}}: {{symbol}}. Change symbol",
    "remove": "Remove the layer {{name}}",
    "colors": {
      "violet": "violet",
      "magenta": "magenta",
      "indigo": "indigo",
      "green": "green",
      "gold": "gold",
      "slate": "slate grey"
    },
    "symbols": {
      "circle": "circle",
      "square": "square",
      "triangle": "triangle",
      "diamond": "diamond"
    }
  },
  "coordinates": {
    "formats": {
      "dd": "Decimal degrees",
      "ddm": "Degrees, decimal minutes",
      "dms": "Degrees, minutes, seconds",
      "utm": "UTM, with zone",
      "mgrs": "MGRS (military grid)",
      "stereo70": "Stereo 70 (Romania)",
      "lv95": "Swiss grid LV95",
      "lv03": "Swiss grid LV03 (former)",
      "pluscode": "Plus Code"
    },
    "settingLabels": {
      "decimals": "Decimal places",
      "style": "Written as",
      "minutesDecimals": "Places of the minutes",
      "secondsDecimals": "Places of the seconds",
      "zone": "Zone",
      "precisionMetres": "Precision",
      "spacing": "Spacing",
      "axes": "Axes",
      "length": "Code length"
    },
    "choices": {
      "style": {
        "letters": "With N, S, E, W",
        "signed": "Signed, latitude first"
      },
      "zone": {
        "auto": "Each position in its own zone",
        "forced": "Always zone {{zone}}"
      },
      "metres": "{{value}} m",
      "kilometres": "{{value}} km",
      "spacing": {
        "spaced": "With spaces",
        "compact": "Without spaces"
      },
      "axes": {
        "en": "E … N …",
        "xy": "X (north) … Y (east) …"
      },
      "length": {
        "8": "8 — about 275 m",
        "10": "10 — about 14 m",
        "11": "11 — about 3.5 m",
        "12": "12 — about 1 m",
        "13": "13 — about 25 cm"
      },
      "places": "{{count}} places"
    },
    "settings": {
      "title": "Coordinates",
      "intro": "How positions are written wherever one is shown or copied, and the other formats a position shown in detail is listed in. These settings follow your account.",
      "shownAs": "Coordinates shown as",
      "listed": "Also listed under “Other formats”",
      "listedHint": "A position shown in detail — a selected entrance, a cave's entrances — can be opened in these formats too, each with its own copy button. A format with no reference for a position (a national grid outside its country) is left out there.",
      "perFormat": "Settings of each format",
      "sample": "Sample point: the summit of Moldoveanu",
      "notAvailable": "Not available here",
      "reading": {
        "title": "Reading positions you type or paste",
        "intro": "How a position is read when the text itself does not say: two numbers with no hemisphere letters, and a UTM reference with no letter. A text that says it — a letter, a number over 90 — is always read as written. These settings follow your account.",
        "pairOrder": "Two bare numbers",
        "pairOrderValues": {
          "latLon": "Latitude first, then longitude (45.53, 25.44)",
          "lonLat": "Longitude first, then latitude (25.44, 45.53)"
        },
        "bareUtmHemisphere": "A UTM reference with no letter",
        "bareUtmHemisphereValues": {
          "north": "Northern hemisphere",
          "south": "Southern hemisphere"
        }
      },
      "notes": {
        "utm": "A zone chosen here is kept for positions near the zone's edge, so that a team working across it reads one grid; far from that zone, the position's own zone is used.",
        "stereo70": "Converted from WGS84 with the usual seven-parameter datum shift: good to a few metres, which suits finding a cave and not a survey. Offered only inside Romania.",
        "lv95": "Good to about a metre. Offered only in Switzerland and Liechtenstein.",
        "lv03": "Good to about a metre. Offered only in Switzerland and Liechtenstein.",
        "mgrs": "A protected position is always named by its 10 km square.",
        "pluscode": "Global codes only: a short code needs a nearby town to be read back."
      }
    },
    "others": {
      "show": "Other formats",
      "hide": "Hide other formats",
      "approximate": "Approximate position: every format is written no finer than the protection grid.",
      "openConverter": "Open in the coordinate converter"
    },
    "input": {
      "label": "Type or paste a position",
      "placeholder": "45.59944, 24.73617 · 45°35′58″N 24°44′10″E · 35T 401234 5049876",
      "anyFormat": "Any format",
      "readAs": "Read as {{format}}: {{position}}",
      "pick": "This can be read more than one way — choose one:",
      "use": "Use",
      "openConverter": "Coordinate converter"
    },
    "errors": {
      "unrecognised": "Not a position in any format this application reads.",
      "latitudeRange": "The latitude is outside −90…90.",
      "longitudeRange": "The longitude is outside −180…180.",
      "minutesRange": "Minutes must be below 60.",
      "secondsRange": "Seconds must be below 60.",
      "fractionNotLast": "Only the last part of an angle may have decimals.",
      "unitOrder": "Degrees, minutes and seconds are in the wrong order.",
      "hemisphereConflict": "Both values name the same direction (two latitudes or two longitudes).",
      "componentCount": "A position needs exactly two values.",
      "utmZoneRange": "A UTM zone is 1 to 60.",
      "utmBandUnknown": "That is not a UTM latitude band letter.",
      "utmBandMismatch": "The position does not lie in the band its letter names.",
      "utmEastingRange": "The easting is outside what a UTM zone holds.",
      "utmNorthingRange": "The northing is outside what a UTM zone holds.",
      "plusCodeShort": "A short Plus Code needs a nearby town; type the full code.",
      "plusCodeInvalid": "Not a valid Plus Code.",
      "mgrsInvalid": "Not a valid MGRS reference.",
      "gridOutsideArea": "The position lies outside the area this grid is used in."
    },
    "assumptions": {
      "latLonOrder": "Two bare numbers were read as latitude, then longitude.",
      "northernHemisphere": "No hemisphere was given: the northern one was assumed.",
      "lonLatOrder": "Two bare numbers were read as longitude, then latitude.",
      "southernHemisphere": "No hemisphere was given: the southern one was assumed.",
      "utmLetterAsBand": "The letter was read as a latitude band.",
      "utmLetterAsHemisphere": "The letter was read as a hemisphere.",
      "gridAxisOrder": "The first number was read as the easting."
    },
    "converter": {
      "title": "Coordinate converter",
      "intro": "Type or paste a position in any format this application reads and see it in every format at once. Everything is converted in this browser, and nothing typed or pasted here is saved or sent to this application's server. Showing a position on the map is the one exception to keeping it in the browser: the map fetches its background tiles for the area around the position from OpenStreetMap. Positions are written with your own settings for each format (Settings › Coordinates).",
      "single": "One position",
      "readAsFormat": "Read as",
      "copy": "Copy",
      "copied": "Copied",
      "showOnMap": "Show on a map",
      "hideMap": "Hide the map",
      "openMainMap": "Open this place on the main map",
      "mapHint": "A temporary marker, on a map of its own: nothing is added to your map or saved. The background tiles for this area are fetched from OpenStreetMap.",
      "batch": "Many positions",
      "batchHint": "Paste one position per line, or a table (CSV) and choose the column that holds the position — or two, latitude and longitude. Each line is converted on its own; a line that cannot be read says why.",
      "mode": "Pasted as",
      "modeLines": "One per line",
      "modeCsv": "A table (CSV)",
      "separator": "Column separator",
      "separators": {
        "auto": "Separator: guess",
        "comma": "Comma",
        "semicolon": "Semicolon",
        "tab": "Tab"
      },
      "header": "The first line names the columns",
      "positionColumns": "Column(s) holding the position",
      "columnN": "Column {{n}}",
      "batchInput": "Positions to convert",
      "batchPlaceholder": "45°35′58″N 24°44′10″E\n35T 401234 5049876\nE 535046 N 448044",
      "csvPlaceholder": "name;latitude;longitude\nentrance 1;45.59944;24.73617",
      "convert": "Convert",
      "download": "Download CSV",
      "summary": "Lines read: {{count}}; not converted: {{failed}}.",
      "leftOut": "Lines left unread: {{count}} — at most 5000 are converted at once.",
      "columns": {
        "line": "Line",
        "input": "Text read",
        "result": "Position",
        "error": "Not converted because"
      },
      "batchErrors": {
        "ambiguous": "This can be read as more than one position: choose the format it is written in.",
        "missingColumn": "The chosen column is empty on this line.",
        "empty": "Nothing to read."
      }
    }
  }
}
